/*
 * Copyright (c) 2016 SPORTident GmbH. All rights reserved.
 */
(function () {
  'use strict';

  angular.module('c3poFrontend', [
    'c3po.config',
    'ngAnimate',
    'ui.router',
    'ui.bootstrap.dropdown',
    'ui.bootstrap.tpls',
    'ui.bootstrap.collapse',
    'ui.bootstrap.modal',
    'ui.bootstrap.datepickerPopup',
    'ui.bootstrap.tooltip',
    'googlechart',
    'restangular',
    'ngSanitize',
    'ui.select',
  ]);
})();

/*
 * Copyright (c) 2016 SPORTident GmbH. All rights reserved.
 */
(function () {
  'use strict';

  angular
    .module('c3poFrontend')
    .factory('PersistentParamsService', PersistentParamsService);

  /** @ngInject */
  function PersistentParamsService() {
    var billParams,
      modemParams,
      processorParams,
      eventParams,
      userParams,
      monitorParams,
      subscriptionParams,
      promoCodeParams;

    var service = {
      setParamsEvents: setParamsEvents,
      setParamsModems: setParamsModems,
      setParamsProcessors: setParamsProcessors,
      setParamsEventFiles: setParamsEventFiles,
      setParamsBills: setParamsBills,
      setParamsSubscriptions: setParamsSubscriptions,
      setParamsPromoCodes: setParamsPromoCodes,
      setParamsUsers: setParamsUsers,
      setParamsMonitor: setParamsMonitor,
      getParamsEvents: getParamsEvents,
      getParamsModems: getParamsModems,
      getParamsProcessors: getParamsProcessors,
      getParamsEventFiles: getParamsEventFiles,
      getParamsBills: getParamsBills,
      getParamsSubscriptions: getParamsSubscriptions,
      getParamsPromoCodes: getParamsPromoCodes,
      getParamsUsers: getParamsUsers,
      getParamsMonitor: getParamsMonitor,
      clearAllParams: clearAllParams,
    };
    return service;

    function setParamsEvents(params) {
      var stateParamsValues = Object.keys(params).map(function (e) {
        return params[e];
      });

      var copy = [];
      stateParamsValues.forEach(function (item) {
        if (angular.isDefined(item)) {
          copy.push(item);
        }
      });

      if (eventParams !== params) {
        if (copy.length !== 0) {
          eventParams = params;
        }
      }
    }

    function getParamsEvents() {
      return eventParams;
    }

    function setParamsModems(params) {
      if (angular.isDefined(params)) {
        var stateParamsValues = Object.keys(params).map(function (e) {
          return params[e];
        });

        var copy = [];
        stateParamsValues.forEach(function (item) {
          if (angular.isDefined(item)) {
            copy.push(item);
          }
        });

        if (modemParams !== params) {
          if (copy.length !== 0) {
            modemParams = params;
          }
        }
      } else {
        params = undefined;
      }
    }

    function getParamsModems() {
      return modemParams;
    }

    function setParamsProcessors(params) {
      processorParams = params;
    }

    function getParamsProcessors() {
      return processorParams;
    }

    function setParamsEventFiles(params) {
      processorParams = params;
    }

    function getParamsEventFiles() {
      return processorParams;
    }

    function setParamsBills(params) {
      if (angular.isDefined(params)) {
        var stateParamsValues = Object.keys(params).map(function (e) {
          return params[e];
        });

        var copy = [];
        stateParamsValues.forEach(function (item) {
          if (angular.isDefined(item)) {
            copy.push(item);
          }
        });

        if (billParams !== params) {
          if (copy.length !== 0) {
            billParams = params;
          }
        }
      } else {
        params = undefined;
      }
    }

    function getParamsBills() {
      return billParams;
    }

    function setParamsUsers(params) {
      userParams = Object.assign({}, params);
    }

    function getParamsUsers() {
      return userParams;
    }

    function setParamsMonitor(params) {
      if (angular.isDefined(params)) {
        /* Unclear why the following code was originally introduced.
         * Removed for now, to be able to clear parameters (cf. TIM-645).
         * No side effects noticed so far.
        var stateParamsValues = Object.keys(params).map(function (e) {
          return params[e];
        });

        var copy = [];
        stateParamsValues.forEach(function (item) {
          if (angular.isDefined(item)) {
            copy.push(item);
          }
        });

        if (monitorParams !== params) {
          if (copy.length !== 0) {
            monitorParams = params;
          }
        }
        */
        monitorParams = params;
      } else {
        params = undefined;
      }
    }

    function getParamsMonitor() {
      return monitorParams;
    }

    function clearAllParams() {
      billParams = [];
      modemParams = [];
      processorParams = [];
      eventParams = [];
      userParams = undefined;
      monitorParams = [];
      subscriptionParams = undefined;
      promoCodeParams = undefined;
    }

    function setParamsSubscriptions(params) {
      subscriptionParams = Object.assign({}, params);
    }

    function getParamsSubscriptions() {
      return subscriptionParams;
    }

    function setParamsPromoCodes(params) {
      promoCodeParams = Object.assign({}, params);
    }

    function getParamsPromoCodes() {
      return promoCodeParams;
    }
  }
})();

/*
 * Copyright (c) 2016 SPORTident GmbH. All rights reserved.
 */
(function () {
  'use strict';

  angular.module('c3poFrontend').factory('UserStoreService', UserStoreService);

  /** @ngInject */
  function UserStoreService($q, Restangular) {
    var service = {
      /* Users */
      createEmptyUser: createEmptyUser,
      registerUser: registerUser,
      saveUser: saveUser,
      deleteUsers: deleteUsers,
      getUser: getUser,
      getAllUsers: getAllUsers,
      resetUserApiKey: resetUserApiKey,
      userAssignmentSearch: userAssignmentSearch,
      getSelectedUsers: getSelectedUsers,
      getBillingContact: getBillingContact,
      saveBillingContact: saveBillingContact,
      sendActivationEmail: sendActivationEmail,
      defaultPageSize: 20,
    };
    return service;

    function createEmptyUser() {
      var u = {
        id: 'new',
        login: '',
      };
      return u;
    }

    function registerUser(user) {
      var u = angular.copy(user);
      u.id = undefined;
      return Restangular.all('public/users').post(u);
    }

    function saveUser(user) {
      delete user.status;
      if (user.id === 'new') {
        var u = angular.copy(user);
        u.id = undefined;
        return Restangular.all('users').post(u);
      } else {
        return user.put();
      }
    }

    function deleteUsers(userArray) {
      var promises = userArray.map(function (user) {
        return Restangular.one('users', user.id).remove();
      });
      return $q.all(promises);
    }

    function getUser(user) {
      if (user === 'new') {
        var e = $q.defer();
        e.resolve(createEmptyUser());
        return e.promise;
      } else {
        return Restangular.one('users', user).get();
      }
    }

    function getAllUsers(params) {
      var page = angular.isDefined(params.page) ? params.page : 0;
      var size = angular.isDefined(params.size)
        ? params.size
        : service.defaultPageSize;
      var sort = angular.isDefined(params.sort) ? params.sort : 'login';
      if (angular.isDefined(params.user)) {
        return Restangular.one('users', params.user)
          .one('status')
          .get()
          .then(function (result) {
            return [result];
          });
      } else {
        return Restangular.all('users').getList({
          page: page,
          size: size,
          sort: sort,
          role: params.role,
          activated: params.activated,
        });
      }
    }

    function resetUserApiKey(user) {
      return Restangular.one('account', user.id).post('reset_apikey');
    }

    function userAssignmentSearch(term, activated) {
      return Restangular.all('users').get('partial-search', {
        search: term,
        activated: activated,
      });
    }

    function getSelectedUsers(term, allItems, activated) {
      var usersToList;
      if (angular.isUndefined(term) || term === '') {
        usersToList = userAssignmentSearch('', activated).then(function (
          result
        ) {
          var returnArray = result.map(function (obj) {
            obj.displayName = obj.firstName + ' ' + obj.lastName;
            return obj;
          });
          if (allItems) {
            returnArray.unshift({
              id: undefined,
              firstName: 'All',
              lastName: 'Users',
              displayName: 'All Users',
            });
          }
          return returnArray;
        });
        return usersToList;
      } else {
        usersToList = userAssignmentSearch(term, activated).then(function (
          result
        ) {
          var returnArray = result.map(function (obj) {
            obj.displayName = obj.firstName + ' ' + obj.lastName;
            return obj;
          });
          if (allItems) {
            returnArray.unshift({
              id: undefined,
              firstName: 'All',
              lastName: 'Users',
              displayName: 'All Users',
            });
          }
          return returnArray;
        });
        return usersToList;
      }
    }

    function getBillingContact(userId) {
      return Restangular.one('users', userId).one('billing-contact').get();
    }

    function saveBillingContact(userId, contact) {
      return Restangular.one('users', userId)
        .one('billing-contact')
        .customPUT(contact);
    }

    function sendActivationEmail(user) {
      return Restangular.one('users', user.id).post('send-activation-email');
    }
  }
})();

/*
 * Copyright (c) 2016-2018 SPORTident GmbH. All rights reserved.
 */
(function () {
  'use strict';

  angular
    .module('c3poFrontend')
    .factory('TimeZoneStoreService', TimeZoneStoreService);

  /** @ngInject */
  function TimeZoneStoreService(Restangular) {
    var service = {
      getAllTimeZones: getAllTimeZones,
      getAllTimeZonesGrouped: getAllTimeZonesGrouped,
    };
    return service;

    function getAllTimeZones() {
      return Restangular.all('timezones').getList({
        sort: 'olsonName',
        size: 10000,
      });
    }

    function getAllTimeZonesGrouped() {
      return getAllTimeZones().then(groupTimeZones);
    }

    function groupTimeZones(ts) {
      var groupsDict = {};
      for (var i = 0; i < ts.length; i++) {
        var t = ts[i];
        var parts = t.olsonName.split('/');
        var gmtOffset = t.gmtOffset;
        if (parts.length !== 2) {
          continue;
        }

        var continent = parts[0];
        var city = parts[1] + ' ' + gmtOffset;
        if (angular.isUndefined(groupsDict[continent])) {
          groupsDict[continent] = [];
        }
        groupsDict[continent].push(city);
      }

      return groupsDict;
    }
  }
})();

/*
 * Copyright (c) 2019 SPORTident GmbH. All rights reserved.
 */
(function () {
  'use strict';

  angular
    .module('c3poFrontend')
    .factory('SubscriptionStoreService', SubscriptionStoreService);

  /** @ngInject */
  function SubscriptionStoreService($q, Restangular) {
    var service = {
      /* SubscriptionTypes */
      getSubscriptionType: getSubscriptionType,
      getSubscriptionTypes: getSubscriptionTypes,
      /* Subscriptions */
      getSubscriptionOfUser: getSubscriptionOfUser,
      getSubscriptionStartAction: getSubscriptionStartAction,
      getSubscriptionUpgradeAction: getSubscriptionUpgradeAction,
      startSubscription: startSubscription,
      upgradeSubscription: upgradeSubscription,
      updateSubscription: updateSubscription,
      /* Users */
      getUsersWithSubscription: getUsersWithSubscription,
      /* Default page size */
      defaultPageSize: 20,
    };
    return service;

    function getSubscriptionTypes(filterFor, userId) {
      return Restangular.all('subscription-types').getList({
        filterFor: filterFor,
        userId: userId,
      });
    }

    function getSubscriptionType(id) {
      return Restangular.one('subscription-types', id).get();
    }

    function startSubscription(userId, subscriptionAction) {
      return Restangular.one('users', userId)
        .all('subscription')
        .all('start')
        .post(subscriptionAction);
    }

    function upgradeSubscription(userId, subscriptionAction) {
      return Restangular.one('users', userId)
        .all('subscription')
        .all('upgrade')
        .post(subscriptionAction);
    }

    function updateSubscription(userId, subscription) {
      if (subscription.subscriptionType) {
        subscription.subscriptionTypeId = subscription.subscriptionType.id;
      }
      return Restangular.one('users', userId)
        .all('subscription')
        .customPUT(subscription);
    }

    function getSubscriptionOfUser(userId) {
      return Restangular.one('users', userId).one('subscription').get();
    }

    function getUsersWithSubscription(params) {
      var active = angular.isDefined(params.active) ? params.active : true;
      var page = angular.isDefined(params.page) ? params.page : 0;
      var size = angular.isDefined(params.size)
        ? params.size
        : service.defaultPageSize;
      var sort = angular.isDefined(params.sort) ? params.sort : '';
      return Restangular.all('users').getList({
        subscriptionActive: active,
        page: page,
        size: size,
        sort: sort,
      });
    }

    function getSubscriptionStartAction(userId, subscriptionTypeId, promoCode) {
      return Restangular.one('users', userId)
        .one('subscription')
        .one('get-start-action')
        .get({ subscriptionTypeId: subscriptionTypeId, promoCode: promoCode });
    }

    function getSubscriptionUpgradeAction(
      userId,
      subscriptionTypeId,
      promoCode
    ) {
      return Restangular.one('users', userId)
        .one('subscription')
        .one('get-upgrade-action')
        .get({ subscriptionTypeId: subscriptionTypeId, promoCode: promoCode });
    }
  }
})();

/*
 * Copyright (c) 2016 SPORTident GmbH. All rights reserved.
 */
(function () {
  'use strict';

  angular
    .module('c3poFrontend')
    .factory('StampStoreService', StampStoreService);

  /** @ngInject */
  function StampStoreService($q, Restangular, moment) {
    var service = {
      getStamps: getStamps,
      getStampsOfLatestHour: getStampsOfLatestHour,
      getBilling: getBilling,
      getStampCount: getStampCount,
    };
    return service;

    function getStamps(filters, page, size) {
      if (angular.isUndefined(filters)) {
        filters = {};
      }
      if (angular.isUndefined(page)) {
        page = 0;
      }
      if (angular.isUndefined(size)) {
        size = 1000;
      }
      var params = {
        page: page,
        size: size,
        sort: 'stampReadoutDatetime,desc',
        stampSiid: filters.stampSiid,
        stampCode: filters.stampCode,
        eventId: filters.eventId,
        login: filters.login,
        boxId: filters.boxId,
        duplicate: filters.showDuplicates,
      };

      // Note that the backend uses >= min and <= max for the date ranges,
      // whereas we use >= min and < max
      var format = 'YYYY-MM-DD[T]HH:mm:ss';
      if (angular.isDefined(filters.afterDate)) {
        params.stampReadoutDatetimeMin = filters.afterDate.format(format);
      }
      if (angular.isDefined(filters.beforeDate)) {
        var d = filters.beforeDate.clone();
        d.subtract(1, 'seconds');
        params.stampReadoutDatetimeMax = d.format(format);
      }

      // Attach a new method 'cancel' to the promise returned by Restangular to
      // cancel an on-going http request. Not sure if this is the most elegant
      // way to solve this, but it works.
      var canceller = $q.defer();
      var cancelMethod = function () {
        canceller.resolve();
      };
      var stampsPromise = Restangular.all('stamps')
        .withHttpConfig({ timeout: canceller.promise })
        .getList(params);
      stampsPromise.cancel = cancelMethod;

      return stampsPromise;
    }

    /**
     * Retrieve stamps for display in the monitor view.
     *
     * We handle three different case:
     *
     * 1. Date and time set: Get the stamps from the hour before that specified
     *    time.
     * 2. Date set, but not time: Get stamps from the latest "active" hour on
     *    the specified day.
     * 3. Neither date nor time set: Get the stamps from the latest "active"
     *    hour overall (for the set filters).
     *
     * In addition, we always retrieve:
     *
     * 1. The total number of stamps matching the filters.
     * 2. The number of stamps on the day (irrespective of whether the date is
     *    explicitely selected or implicitely set to the day of the latest
     *    stamps).
     * 3. The number of stamps of the last hour (again irrespective of whether
     *    explicitely selected or not).
     *
     * TODO: Right now, we almost always require three round-trips to the server
     * to get all of this information together. In the future, more direct
     * support from the backend should reduce the number of required requests.
     *
     * @param {Object} filters - An object of filters
     * @param {moment|undefined} date - A Moment.js object, only the date part
     *        is used (optional)
     * @param {moment|undefined} time - A Moment.js object, only the time part
     *        is used (optional)
     * @param {number|undefined} size - Maximum number of returned stamps
     *        (optional)
     * @returns {Promise of an Object} Promise of a stampsInfo object with
     *          fields 'stampsTotalCount' (number), 'stampsOfDayCount' (number),
     *          'stampsOfHourCount' (number), and 'stamps' (array of stamps)
     */
    function getStampsOfLatestHour(filters, date, time, size) {
      if (angular.isUndefined(size)) {
        size = 1000;
      }
      if (angular.isDefined(date) && angular.isDefined(time)) {
        var dateTime = date.clone();
        dateTime.set({
          hour: time.hour(),
          minute: time.minute(),
          second: time.second(),
          millisecond: time.millisecond(),
        });
        return getStampsOLHWithExplicitDateAndTime(filters, dateTime, size);
      } else if (angular.isDefined(date) && angular.isUndefined(time)) {
        return getStampsOLHWithExplicitDate(filters, date, size);
      } else {
        return getStampsOLHNoExplicitDateOrTime(filters, size);
      }
    }

    function getStampsOLHWithExplicitDateAndTime(filters, dateTime, size) {
      var myFilters;
      var stampsTotalPromise;
      var stampsOfDayPromise;
      var stampsOfHourPromise;

      myFilters = angular.copy(filters);
      myFilters.afterDate = undefined;
      myFilters.beforeDate = undefined;
      stampsTotalPromise = getStamps(myFilters, 0, 1);

      myFilters = angular.copy(filters);
      myFilters.afterDate = dateTime.clone().startOf('day');
      myFilters.beforeDate = dateTime.clone().add(1, 'days').startOf('day');
      stampsOfDayPromise = getStamps(myFilters, 0, 1);

      myFilters = angular.copy(filters);
      myFilters.afterDate = dateTime.clone().subtract(1, 'hours');
      myFilters.beforeDate = dateTime.clone();
      stampsOfHourPromise = getStamps(myFilters, 0, size);

      var allPromise = $q
        .all({
          stampsTotal: stampsTotalPromise,
          stampsOfDay: stampsOfDayPromise,
          stampsOfHour: stampsOfHourPromise,
        })
        .then(function (o) {
          return {
            stampsTotalCount: o.stampsTotal.totalCount,
            stampsOfDayCount: o.stampsOfDay.totalCount,
            stampsOfHourCount: o.stampsOfHour.totalCount,
            stamps: o.stampsOfHour,
          };
        });
      allPromise.cancel = function () {
        cancelAllPromises([
          stampsTotalPromise,
          stampsOfDayPromise,
          stampsOfHourPromise,
        ]);
      };

      return allPromise;
    }

    function getStampsOLHWithExplicitDate(filters, dateTime, size) {
      var myFilters;
      var stampsTotalPromise;
      var stampsOfDayPromise;
      var stampsOfHourPromise;

      myFilters = angular.copy(filters);
      myFilters.afterDate = undefined;
      myFilters.beforeDate = undefined;
      stampsTotalPromise = getStamps(myFilters, 0, 1);

      myFilters = angular.copy(filters);
      myFilters.afterDate = dateTime.clone().startOf('day');
      myFilters.beforeDate = dateTime.clone().add(1, 'days').startOf('day');
      stampsOfDayPromise = getStamps(myFilters, 0, 1);

      var allPromise = $q
        .all({
          stampsTotal: stampsTotalPromise,
          stampsOfDay: stampsOfDayPromise,
        })
        .then(function (o) {
          if (o.stampsOfDay.totalCount === 0) {
            return {
              stampsTotalCount: o.stampsTotal.totalCount,
              stampsOfDayCount: 0,
              stampsOfHourCount: 0,
              stamps: [],
            };
          } else {
            // Get the time (and date) of the latest stamp and then retrieve the
            // stamps of the preceding hour
            var latestReadout = o.stampsOfDay[0].stampReadoutDatetime;
            dateTime = moment(latestReadout)
              .startOf('minute')
              .add(1, 'minutes');
            myFilters = angular.copy(filters);
            myFilters.afterDate = dateTime.clone().subtract(1, 'hours');
            myFilters.beforeDate = dateTime.clone();
            stampsOfHourPromise = getStamps(myFilters, 0, size);

            return stampsOfHourPromise.then(function (stampsOfHour) {
              o.stampsOfHour = stampsOfHour;
              return {
                stampsTotalCount: o.stampsTotal.totalCount,
                stampsOfDayCount: o.stampsOfDay.totalCount,
                stampsOfHourCount: o.stampsOfHour.totalCount,
                stamps: o.stampsOfHour,
              };
            });
          }
        });
      allPromise.cancel = function () {
        cancelAllPromises([
          stampsTotalPromise,
          stampsOfDayPromise,
          stampsOfHourPromise,
        ]);
      };

      return allPromise;
    }

    function getStampsOLHNoExplicitDateOrTime(filters, size) {
      var myFilters;
      var stampsTotalPromise;
      var stampsOfDayPromise;
      var stampsOfHourPromise;

      myFilters = angular.copy(filters);
      myFilters.afterDate = undefined;
      myFilters.beforeDate = undefined;
      stampsTotalPromise = getStamps(myFilters, 0, 1);

      var allPromise = stampsTotalPromise.then(function (stampsTotal) {
        if (stampsTotal.totalCount === 0) {
          return {
            stampsTotalCount: 0,
            stampsOfDayCount: 0,
            stampsOfHourCount: 0,
            stamps: [],
          };
        } else {
          // Get the time and date of the latest stamp and then retrieve the
          // stamps of the preceding hour
          var latestReadout = stampsTotal[0].stampReadoutDatetime;
          var dateTime = moment(latestReadout)
            .startOf('minute')
            .add(1, 'minutes');

          myFilters = angular.copy(filters);
          myFilters.afterDate = dateTime.clone().startOf('day');
          myFilters.beforeDate = dateTime.clone().add(1, 'days').startOf('day');
          stampsOfDayPromise = getStamps(myFilters, 0, 1);

          myFilters = angular.copy(filters);
          myFilters.afterDate = dateTime.clone().subtract(1, 'hours');
          myFilters.beforeDate = dateTime.clone();
          stampsOfHourPromise = getStamps(myFilters, 0, size);

          return $q
            .all({
              stampsOfDay: stampsOfDayPromise,
              stampsOfHour: stampsOfHourPromise,
            })
            .then(function (o) {
              o.stampsTotal = stampsTotal;
              return {
                stampsTotalCount: o.stampsTotal.totalCount,
                stampsOfDayCount: o.stampsOfDay.totalCount,
                stampsOfHourCount: o.stampsOfHour.totalCount,
                stamps: o.stampsOfHour,
              };
            });
        }
      });
      allPromise.cancel = function () {
        cancelAllPromises([
          stampsTotalPromise,
          stampsOfDayPromise,
          stampsOfHourPromise,
        ]);
      };

      return allPromise;
    }

    function cancelAllPromises(promises) {
      for (var i = 0; i < promises.length; i++) {
        var p = promises[i];
        if (angular.isDefined(p)) {
          p.cancel();
        }
      }
    }

    function getBilling(user, year) {
      return Restangular.all('bills').getList({ year: year, userId: user });
    }

    function getStampCount(from, to) {
      return Restangular.all('stamps').get('countpunch', {
        stampTimeMin: from,
        stampTimeMax: to,
      });
    }
  }
})();

/*
 * Copyright (c) 2019 SPORTident GmbH. All rights reserved.
 */
(function () {
  'use strict';

  angular
    .module('c3poFrontend')
    .factory('PromoCodeStoreService', PromoCodeStoreService);

  /** @ngInject */
  function PromoCodeStoreService($q, Restangular) {
    var service = {
      /* PromoCodeTypes */
      getPromoCodeTypes: getPromoCodeTypes,
      getRandomPromoCode: getRandomPromoCode,
      /* PromoCodes */
      postPromoCode: postPromoCode,
      putPromoCode: putPromoCode,
      getPromoCode: getPromoCode,
      getPromoCodes: getPromoCodes,
      defaultPageSize: 1000,
    };
    return service;

    function getPromoCodeTypes() {
      return Restangular.all('promo-code-types').getList();
    }

    function getRandomPromoCode(typeId) {
      return Restangular.one('promo-code-types', typeId)
        .one('get-random-code')
        .get();
    }

    function postPromoCode(promoCode) {
      var p = angular.copy(promoCode);
      return Restangular.all('promo-codes').post(p);
    }

    function putPromoCode(promoCode) {
      var p = angular.copy(promoCode);
      return Restangular.one('promo-codes', promoCode.id).customPUT(p);
    }

    function getPromoCode(id) {
      return Restangular.one('promo-codes', id).get();
    }

    function getPromoCodes(params) {
      var page = angular.isDefined(params.page) ? params.page : 0;
      var size = angular.isDefined(params.size)
        ? params.size
        : service.defaultPageSize;
      var sort = angular.isDefined(params.sort) ? params.sort : '';
      return Restangular.all('promo-codes').getList({
        page: page,
        size: size,
        sort: sort,
      });
    }
  }
})();

/*
 * Copyright (c) 2019 SPORTident GmbH. All rights reserved.
 */
(function () {
  'use strict';

  angular
    .module('c3poFrontend')
    .factory('ProcessorStoreService', ProcessorStoreService);

  /** @ngInject */
  function ProcessorStoreService(Restangular) {
    var service = {
      /* Processors */
      getAllProcessors: getAllProcessors,
      getProcessorFamilies: getProcessorFamilies,
    };
    return service;

    function getAllProcessors(family, event, state, last, page, sort, size) {
      var status;
      status = undefined;
      if (angular.isDefined(state)) {
        if (state === 'START') {
          status = 'RUNNING,STARTING,STOPPING';
        } else if (state === 'STOP') {
          status = 'STOPPED';
        }
      }
      if (family === 'all') {
        family = undefined;
      }
      if (angular.isUndefined(page)) {
        page = 0;
      }
      if (angular.isUndefined(sort)) {
        sort = 'id,desc';
      }
      if (angular.isUndefined(size)) {
        size = 20;
      }
      return Restangular.all('processors/status').getList({
        family: family,
        eventId: event,
        status: status,
        last: last,
        page: page,
        sort: sort,
        size: size,
      });
    }

    function getProcessorFamilies() {
      return Restangular.all('processors/families')
        .getList()
        .then(function (result) {
          return result;
        });
    }
  }
})();

/*
 * Copyright (c) 2016 SPORTident GmbH. All rights reserved.
 */
(function () {
  'use strict';

  angular
    .module('c3poFrontend')
    .factory('OrganisationStoreService', OrganisationStoreService);

  /** @ngInject */
  function OrganisationStoreService($q, Restangular) {
    var service = {
      /* Organisations */
      organisationAssignmentSearch: organisationAssignmentSearch,
      getSelectedOrganisations: getSelectedOrganisations,
      getOrganisation: getOrganisation,
      getOrganisationOfUser: getOrganisationOfUser,
    };
    return service;

    function organisationAssignmentSearch(term, userId) {
      return Restangular.all('organisations').get('partial-search', {
        search: term,
        userId: userId,
      });
    }

    function getSelectedOrganisations(term, userId, withNew) {
      var organisationsToList;
      if (angular.isUndefined(term) || term === '') {
        organisationsToList = organisationAssignmentSearch('', userId).then(
          function (result) {
            var returnArray = result.map(function (obj) {
              obj.displayName = obj.name;
              return obj;
            });
            if (withNew === true) {
              returnArray.unshift({ id: undefined, displayName: 'New' });
            }
            return returnArray;
          }
        );
        return organisationsToList;
      } else {
        organisationsToList = organisationAssignmentSearch(term, userId).then(
          function (result) {
            var returnArray = result.map(function (obj) {
              obj.displayName = obj.name;
              return obj;
            });
            returnArray.unshift({ id: undefined, displayName: 'New' });
            return returnArray;
          }
        );
        return organisationsToList;
      }
    }

    function getOrganisation(id) {
      return Restangular.one('organisations', id).get();
    }

    function getOrganisationOfUser(userId) {
      return Restangular.one('organisations/users', userId).get();
    }
  }
})();

/*
 * Copyright (c) 2016 SPORTident GmbH. All rights reserved.
 */
(function () {
  'use strict';

  angular
    .module('c3poFrontend')
    .factory('ModemStoreService', ModemStoreService);

  /** @ngInject */
  function ModemStoreService($q, Restangular, configBackendUrl) {
    var service = {
      /* Modems */
      createEmptyModem: createEmptyModem,
      saveModem: saveModem,
      deleteModems: deleteModems,
      getModem: getModem,
      getModemBySerialNumber: getModemBySerialNumber,
      getAllModems: getAllModems,
      getFreeModemsByEvent: getFreeModemsByEvent,
      assignModemsToUser: assignModemsToUser,
      assignModemsToEvent: assignModemsToEvent,
      modemAssignmentSearch: modemAssignmentSearch,
      getSelectedModems: getSelectedModems,
      substituteApostroph: substituteApostroph,
    };
    return service;

    function createEmptyModem() {
      var m = {
        id: 'new',
        externId: '',
        hardwareVer: '',
        softwareVer: '',
      };
      return m;
    }

    function saveModem(modem) {
      if (modem.id === 'new') {
        var m = angular.copy(modem);
        m.id = undefined;
        return Restangular.all('boxes').post(m);
      } else {
        var modemA = modem;
        modemA = substituteApostroph(modemA);
        return modemA.put();
      }
    }

    function deleteModems(modemArray) {
      var promises = modemArray.map(function (modem) {
        return Restangular.one('boxes', modem.id).remove();
      });
      return $q.all(promises);
    }

    function getModem(id) {
      if (id === 'new') {
        var e = $q.defer();
        e.resolve(createEmptyModem());
        return e.promise;
      } else {
        return Restangular.one('boxes', id).get();
      }
    }

    function getModemBySerialNumber(serialNumber) {
      return Restangular.oneUrl(
        'boxes',
        configBackendUrl + '/boxes/search/findBySerialNumber'
      ).get({ serialNumber: serialNumber });
    }

    function getAllModems(page, sort, active, event, user, modem, size) {
      if (angular.isUndefined(page)) {
        page = 0;
      }
      if (angular.isUndefined(sort)) {
        sort = 'externId';
      }
      if (sort === 'lastActivity') {
        sort = 'lastActivity,desc';
      }

      if (angular.isDefined(modem)) {
        return Restangular.one('boxes', modem)
          .get({ active: active })
          .then(function (result) {
            return [result];
          });
      } else {
        return Restangular.all('boxes').getList({
          page: page,
          size: size,
          sort: sort,
          active: active,
          eventId: event,
          userId: user,
        });
      }
    }

    function getFreeModemsByEvent(eventId) {
      // TODO: Backend does not implement sorting correctly
      return Restangular.allUrl(
        'boxes',
        configBackendUrl + '/boxes/search/findNotUsedByEventId'
      ).getList({ eventId: eventId, sort: 'externId' });
    }

    function assignModemsToUser(userId, modems, clearLabel) {
      return Restangular.one('users', userId).post('assign_boxes', modems, {
        clearLabel: clearLabel,
      });
    }

    function assignModemsToEvent(eventId, modems, clearLabel) {
      return Restangular.one('events', eventId).post('assign_boxes', modems, {
        clearLabel: clearLabel,
      });
    }

    function modemAssignmentSearch(term) {
      return Restangular.all('boxes').get('partial-search', { search: term });
    }

    function getSelectedModems(term, allItems) {
      var modemsToList;
      if (angular.isUndefined(term)) {
        term = '';
      }
      modemsToList = modemAssignmentSearch(term).then(function (result) {
        var returnArray = result.map(function (obj) {
          var modemObj = {
            id: obj.id,
            externId: obj.externId,
            displayName: obj.externId,
          };
          if (obj.label !== '' && obj.label !== null) {
            modemObj.displayName = obj.externId + ' ' + obj.label;
          }
          return modemObj;
        });
        if (allItems) {
          returnArray.unshift({ id: undefined, displayName: 'All Modems' });
        }
        return returnArray;
      });
      return modemsToList;
    }

    function substituteApostroph(modem) {
      if (angular.isDefined(modem.label) && modem.label !== null) {
        modem.label = modem.label.replace("'", '"');
      }
      if (angular.isDefined(modem.info) && modem.info !== null) {
        modem.info = modem.info.replace("'", '"');
      }
      return modem;
    }
  }
})();

/*
 * Copyright (c) 2016 SPORTident GmbH. All rights reserved.
 */
(function () {
  'use strict';

  angular
    .module('c3poFrontend')
    .factory('EventStoreService', EventStoreService);

  /** @ngInject */
  function EventStoreService($q, Restangular) {
    var service = {
      /* Events */
      createEmptyEvent: createEmptyEvent,
      saveEvent: saveEvent,
      deleteEvents: deleteEvents,
      getEvent: getEvent,
      getAllEvents: getAllEvents,
      deleteAllStampsFromEvent: deleteAllStampsFromEvent,
      assignEventsToUser: assignEventsToUser,
      getUsersWithAccessToEvent: getUsersWithAccessToEvent,
      eventAssignmentSearch: eventAssignmentSearch,
      getAllBoxesOfEvent: getAllBoxesOfEvent,
      getNotAssignedEventId: getNotAssignedEventId,
      getSelectedEvents: getSelectedEvents,
      getEventdef: getEventdef,
      saveEventdef: saveEventdef,
      getStartlist: getStartlist,
      saveStartlist: saveStartlist,
      getCorrection: getCorrection,
      saveCorrection: saveCorrection,
      getEventTypes: getEventTypes,
      getEventFile: getEventFile,
      putEventFile: putEventFile,
      deleteEventFiles: deleteEventFiles,
      deleteEventFile: deleteEventFile,
      getEventFilesDirectoryList: getEventFilesDirectoryList,
      getStatusResultsProcessor: getStatusResultsProcessor,
      startResultsProcessor: startResultsProcessor,
      stopResultsProcessor: stopResultsProcessor,
      getStatusSimulationProcessor: getStatusSimulationProcessor,
      startSimulationProcessor: startSimulationProcessor,
      stopSimulationProcessor: stopSimulationProcessor,
      getResultsLogs: getResultsLogs,
      getSimulationLogs: getSimulationLogs,
      getResultsLogsAws: getResultsLogsAws,
      getSimulationLogsAws: getSimulationLogsAws,
      getResultsHist: getResultsHist,
      getSimulationHist: getSimulationHist,
    };
    return service;

    function createEmptyEvent() {
      var e = {
        id: 'new',
        name: '',
        isPublic: false,
        timezone: '',
        startDate: '',
        endDate: '',
      };
      return e;
    }

    function saveEvent(ev) {
      delete ev.info;
      delete ev.hasPublishedResults;
      if (ev.id === 'new') {
        var e = angular.copy(ev);
        e.id = undefined;
        return Restangular.all('events').post(e, { projection: 'info' });
      } else {
        return ev.put();
      }
    }

    function deleteEvents(eventArray) {
      return Restangular.one('events').post('delete_events', eventArray);
    }

    function deleteAllStampsFromEvent(ev) {
      return ev.post('clear_stamps');
    }

    function getEvent(id) {
      if (id === 'new') {
        var e = $q.defer();
        e.resolve(createEmptyEvent());
        return e.promise;
      } else {
        return Restangular.one('events', id).get({ projection: 'info' });
      }
    }

    function getAllEvents(page, size, event, user, active) {
      var projection = 'info';
      // TODO: cache responses?
      if (angular.isUndefined(page)) {
        page = 0;
      }

      if (angular.isUndefined(size)) {
        size = 20;
      }

      if (angular.isDefined(event)) {
        return Restangular.one('events', event)
          .get({ projection: projection })
          .then(function (result) {
            return [result];
          });
      } else {
        return Restangular.all('events').getList({
          page: page,
          size: size,
          userId: user,
          active: active,
          projection: projection,
        });
      }
    }

    function assignEventsToUser(userId, eventsArray) {
      return Restangular.one('users', userId).post(
        'assign_eventids',
        eventsArray
      );
    }

    function getUsersWithAccessToEvent(event) {
      return Restangular.one('events', event).one('users').get();
    }

    function eventAssignmentSearch(term, user) {
      if (angular.isUndefined(user)) {
        return Restangular.all('events').get('partial-search', {
          search: term,
        });
      } else {
        return Restangular.all('events').get('partial-search', {
          search: term,
          userId: user,
        });
      }
    }

    function getAllBoxesOfEvent(event) {
      return Restangular.one('events', event).getList('boxes');
    }

    function getNotAssignedEventId() {
      var notAssignedId = 1;
      return notAssignedId;
    }

    function getSelectedEvents(term, allItems, user) {
      var eventsToList;
      if (angular.isUndefined(term) || term === '') {
        eventsToList = eventAssignmentSearch('', user).then(function (result) {
          var returnArray = result.map(function (obj) {
            obj.displayName = obj.name;
            return obj;
          });
          if (allItems) {
            returnArray.unshift({ id: undefined, displayName: 'All Events' });
          }
          return returnArray;
        });
        return eventsToList;
      } else {
        eventsToList = eventAssignmentSearch(term, user).then(function (
          result
        ) {
          var returnArray = result.map(function (obj) {
            obj.displayName = obj.name;
            return obj;
          });
          if (allItems) {
            returnArray.unshift({ id: undefined, displayName: 'All Events' });
          }
          return returnArray;
        });
        return eventsToList;
      }
    }

    function getEventdef(eventId) {
      return Restangular.one('events', eventId)
        .one('eventdef')
        .get(null, { Accept: 'text/plain' });
    }

    function saveEventdef(eventdef) {
      return Restangular.one('events', eventdef.eventId)
        .one('eventdef')
        .customPUT(eventdef.eventdefData, null, null, {
          Accept: 'text/plain',
          'Content-Type': 'text/plain',
          'X-Content-Format': eventdef.eventdefFormat,
        });
    }

    function getStartlist(eventId) {
      return Restangular.one('events', eventId)
        .one('startlist')
        .get(null, { Accept: 'text/plain' });
    }

    function saveStartlist(startlist) {
      return Restangular.one('events', startlist.eventId)
        .one('startlist')
        .customPUT(startlist.startlistData, null, null, {
          Accept: 'text/plain',
          'Content-Type': 'text/plain',
          'X-Content-Format': startlist.startlistFormat,
        });
    }

    function getCorrection(eventId) {
      return Restangular.one('events', eventId)
        .one('correction')
        .get(null, { Accept: 'text/plain' });
    }

    function saveCorrection(correction) {
      return Restangular.one('events', correction.eventId)
        .one('correction')
        .customPUT(correction.correctionData, null, null, {
          Accept: 'text/plain',
          'Content-Type': 'text/plain',
          'X-Content-Format': correction.correctionFormat,
        });
    }

    function getEventTypes() {
      return Restangular.one('events').one('event_types').get();
    }

    function getEventFile(eventId, prefix, name, revisionId) {
      if (angular.isUndefined(prefix) || prefix === '') {
        prefix = 'private/';
      }
      var slashPosition = prefix.search('/');
      var fileAccessType = 'private-files';
      if (prefix.substring(0, slashPosition) === 'public') {
        fileAccessType = 'public-files';
      }
      return Restangular.one('events', eventId)
        .one(fileAccessType + prefix.substring(slashPosition))
        .get();
    }

    function getEventFilesDirectoryList(
      eventId,
      prefix,
      name,
      revision,
      page,
      sort,
      size
    ) {
      if (angular.isUndefined(prefix) || prefix === '') {
        prefix = 'private/';
      }
      var slashPosition = prefix.search('/');
      var fileAccessType = 'private-files';
      if (
        prefix === 'public' ||
        prefix.substring(0, slashPosition) === 'public'
      ) {
        fileAccessType = 'public-files';
      }
      return Restangular.one('events', eventId)
        .one('directory')
        .one(fileAccessType)
        .get({ prefix: prefix, name: name });
    }

    function putEventFile(eventId, prefix, eventfile) {
      var slashPosition = prefix.search('/');
      var fileAccessType = 'private-files';
      if (slashPosition === -1) {
        if (prefix === 'public') {
          fileAccessType = 'public-files';
        }
        prefix = '';
      } else {
        if (prefix.substring(0, slashPosition) === 'public') {
          fileAccessType = 'public-files';
        }
        prefix = prefix.substring(slashPosition);
      }
      return Restangular.one('events', eventId)
        .one(fileAccessType + prefix + '/' + eventfile.name)
        .customPUT(eventfile.content, null, null, {
          Accept: 'application/json',
          'Content-Type': eventfile.contentType,
          'X-File-Source': eventfile.name,
          'X-File-Modification-Date-Time': eventfile.modificationDateTime,
          'X-File-MD5': eventfile.md5,
          'X-File-Version-Hash': eventfile.versionHash,
        });
    }

    function deleteEventFiles(eventId, prefix) {
      var slashPosition = prefix.search('/');
      var fileAccessType = 'private-files';
      if (prefix.substring(0, slashPosition) === 'public') {
        fileAccessType = 'public-files';
      }
      prefix = prefix.substring(slashPosition + 1);
      return Restangular.one('events', eventId)
        .one(fileAccessType)
        .customDELETE(null, { prefix: prefix });
    }

    function deleteEventFile(eventId, prefix, eventfile, revisionId) {
      var slashPosition = prefix.search('/');
      var fileAccessType = 'private-files';
      if (slashPosition === -1) {
        if (prefix === 'public') {
          fileAccessType = 'public-files';
        }
        prefix = '';
      } else {
        if (prefix.substring(0, slashPosition) === 'public') {
          fileAccessType = 'public-files';
        }
        prefix = prefix.substring(slashPosition);
      }
      return Restangular.one('events', eventId).customDELETE(
        fileAccessType + prefix + '/' + eventfile,
        {
          revisionId: revisionId,
        }
      );
    }

    function getStatusResultsProcessor(eventId) {
      return Restangular.one('events', eventId)
        .one('resultsprocessor')
        .one('status')
        .get()
        .then(function (result) {
          return [result];
        });
    }

    function getResultsLogs(eventId) {
      return Restangular.one('events', eventId)
        .one('resultsprocessor')
        .one('logs')
        .get()
        .then(function (result) {
          return [result];
        });
    }

    function getResultsLogsAws(eventId, taskAwsId) {
      return Restangular.one('events', eventId)
        .one('resultsprocessor')
        .one('logs', taskAwsId)
        .get()
        .then(function (result) {
          return [result];
        });
    }

    function getResultsHist(eventId) {
      return Restangular.one('events', eventId)
        .one('resultsprocessor')
        .one('hist')
        .get()
        .then(function (result) {
          return [result];
        });
    }

    function startResultsProcessor(eventId, restart) {
      return Restangular.one('events', eventId)
        .one('resultsprocessor')
        .post('start', '', { restart: restart })
        .then(function (result) {
          return [result];
        });
    }

    function stopResultsProcessor(eventId) {
      return Restangular.one('events', eventId)
        .one('resultsprocessor')
        .one('stop')
        .post()
        .then(function (result) {
          return [result];
        });
    }

    function getStatusSimulationProcessor(eventId) {
      return Restangular.one('events', eventId)
        .one('simulationprocessor')
        .one('status')
        .get()
        .then(function (result) {
          return [result];
        });
    }

    function getSimulationLogs(eventId) {
      return Restangular.one('events', eventId)
        .one('simulationprocessor')
        .one('logs')
        .get()
        .then(function (result) {
          return [result];
        });
    }

    function getSimulationLogsAws(eventId, taskAwsId) {
      return Restangular.one('events', eventId)
        .one('simulationprocessor')
        .one('logs', taskAwsId)
        .get()
        .then(function (result) {
          return [result];
        });
    }

    function getSimulationHist(eventId) {
      return Restangular.one('events', eventId)
        .one('simulationprocessor')
        .one('hist')
        .get()
        .then(function (result) {
          return [result];
        });
    }

    function startSimulationProcessor(eventId, fileName, speedFactor, restart) {
      return Restangular.one('events', eventId)
        .one('simulationprocessor')
        .post('start', '', {
          fileName: fileName,
          speedFactor: speedFactor,
          restart: restart,
        })
        .then(function (result) {
          return [result];
        });
    }

    function stopSimulationProcessor(eventId) {
      return Restangular.one('events', eventId)
        .one('simulationprocessor')
        .one('stop')
        .post()
        .then(function (result) {
          return [result];
        });
    }
  }
})();

/*
 * Copyright (c) 2019 SPORTident GmbH. All rights reserved.
 */
(function () {
  'use strict';

  angular
    .module('c3poFrontend')
    .factory('CompetitorDbStoreService', CompetitorDbStoreService);

  /** @ngInject */
  function CompetitorDbStoreService(Restangular, $http, configBackendUrl) {
    var service = {
      getCompetitorDatabases: getCompetitorDatabases,
      uploadCompetitorDatabase: uploadCompetitorDatabase,
      deleteCompetitorDatabase: deleteCompetitorDatabase,
    };
    return service;

    function getCompetitorDatabases(userId) {
      return Restangular.one('users', userId).all('competitordbs').getList();
    }

    function uploadCompetitorDatabase(userId, formData, keepExistingRecords) {
      /* Despite some web resources claiming the contrary, the following Restangular code
         does not work. It uses 'application/json' instead of 'multipart/form-data' as the
         content-type. Forcing the content type to 'multipart/form-data' also does not
         work since then the boundary is not added. */
      /*
      return Restangular.one('users', userId).all('competitordbs')
        .withHttpConfig({transformRequest: angular.identity, timeout: 0})
        .customPOST(formData, undefined, undefined, {'Content-Type': undefined}); */

      // Instead we use $http as a workaround:
      return $http.post(
        configBackendUrl +
          '/users/' +
          userId +
          '/competitordbs?keepExistingRecords=' +
          (keepExistingRecords ? '1' : '0'),
        formData,
        {
          transformRequest: angular.identity,
          headers: { 'Content-Type': undefined },
        }
      );
    }

    function deleteCompetitorDatabase(userId, uuid) {
      return Restangular.one('users', userId)
        .one('competitordbs', uuid)
        .customDELETE();
    }
  }
})();

/*
 * Copyright (c) 2016 SPORTident GmbH. All rights reserved.
 */
(function () {
  'use strict';

  angular.module('c3poFrontend').factory('BillStoreService', BillStoreService);

  /** @ngInject */
  function BillStoreService($q, Restangular, configBackendUrl, moment) {
    var service = {
      /* Bills */
      createEmptyBill: createEmptyBill,
      saveBill: saveBill,
      deleteBills: deleteBills,
      getBill: getBill,
      getAllBills: getAllBills,
      getAllSaldos: getAllSaldos,
      getAmountSum: getAmountSum,
    };
    return service;

    function createEmptyBill() {
      var m = {
        id: 'new',
      };
      return m;
    }

    function saveBill(bill) {
      var m = angular.copy(bill);
      m.amount = m.amountReverse;
      delete m.amountReverse;

      if (bill.id === 'new') {
        // create
        m.id = undefined;
        m.invoiceDate = moment(m.invoiceDate).format('YYYY-MM-DD');
        m.transactionDate = moment(m.transactionDate).format('YYYY-MM-DD');
        if (angular.isUndefined(m.amount)) {
          m.amount = '0.00';
        } else {
          if (typeof m.amount === 'string') {
            m.amount = m.amount.replace(',', '.');
          }
        }
        return Restangular.all('invoice-items').post(m);
      } else {
        // update with put
        m = Restangular.stripRestangular(m);
        m.invoiceDate = moment(m.invoiceDate).format('YYYY-MM-DD');
        m.transactionDate = moment(m.transactionDate).format('YYYY-MM-DD');
        if (angular.isUndefined(m.amount)) {
          m.amount = '0.00';
        } else {
          if (typeof m.amount === 'string') {
            m.amount = m.amount.replace(',', '.');
          }
        }
        return Restangular.one('invoice-items', m.id).customPUT(m);
      }
    }

    function deleteBills(billArray) {
      var m = [];
      billArray.map(function (bill) {
        m.push(bill.id);
      });
      return Restangular.one('invoice-items/delete-by-id').customPOST(m);
      // var promises = billArray.map(function (bill) {
      //  return Restangular.one('invoice-items', bill.id).remove();
      // });
      // return $q.all(promises);
    }

    function getBill(id) {
      if (id === 'new') {
        var e = $q.defer();
        e.resolve(createEmptyBill());
        return e.promise;
      } else {
        return Restangular.one('invoice-items', id).get();
      }
    }

    function getAmountSum(user, sTransactionDate, eTransactionDate) {
      return Restangular.one('invoice-items/calculate-time-amount').get({
        userId: user,
        sTransactionDate: moment(sTransactionDate).format('YYYY-MM-DD'),
        eTransactionDate: moment(eTransactionDate).format('YYYY-MM-DD'),
      });
    }

    function getAllBills(page, size, user, year) {
      if (angular.isUndefined(page)) {
        page = 0;
      }
      if (angular.isUndefined(size)) {
        size = 20;
      }
      if (angular.isDefined(user)) {
        if (angular.isUndefined(year)) {
          return Restangular.all('invoice-items').getList({
            userId: user,
            page: page,
            size: size,
          });
        } else {
          return Restangular.all('invoice-items').getList({
            userId: user,
            page: page,
            size: size,
            year: year,
          });
        }
      }
    }

    function getAllSaldos(page, size, year, sort) {
      if (angular.isUndefined(page)) {
        page = 0;
      }
      if (angular.isUndefined(size)) {
        size = 20;
      }
      if (angular.isUndefined(year)) {
        return Restangular.all('invoice-items/last').getList({
          page: page,
          size: size,
          sort: sort,
        });
      } else {
        return Restangular.all('invoice-items/last').getList({
          page: page,
          size: size,
          year: year,
          sort: sort,
        });
      }
    }
  }
})();

/*
 * Copyright (c) 2016 SPORTident GmbH. All rights reserved.
 */
/**
 * Extend ui-router's $state service.
 *
 * We use Angular $provide's decorator method to monkey patch the original
 * $state service.
 */
(function () {
  'use strict';

  angular.module('c3poFrontend').config(configDecorator);

  /** @ngInject */
  function configDecorator($provide) {
    $provide.decorator('$state', decorateState);
  }

  /**
   * Decorate ui-router's $state service.
   *
   * We add two features to the $state service: redirecting and storing and
   * retrieving the upcoming state.
   *
   * 1. A state (as configured with the $stateProvider) can have a 'redirectTo'
   *    property to redirect to a different state. This is useful for e.g.
   *    "abstract" parent states forwarding to one of their children.
   *
   * 2. We provide methods to store and retrieve the "to" state (i.e. the
   *    upcoming state). We use this to redirect back to the original state/url
   *    after going through the login page, for example.
   *
   * @ngInject
   */
  function decorateState($delegate, $rootScope) {
    // Store next / upcoming state
    var toState = {};

    // Add / overwrite these methods
    $delegate.getToState = getToState;

    activate();

    return $delegate;

    function activate() {
      // Maybe there is a better (i.e. non-$rootScope) way to hook into the
      // state change start and success events here in the $state service
      // itself; but the $rootScope approach definitely works.
      var deregStart = $rootScope.$on(
        '$stateChangeStart',
        handleStateChangeStart
      );
      $rootScope.$on('$destroy', deregStart);
    }

    function handleStateChangeStart(event, to, params) {
      // Always store the to state --- we use this to redirect back to the
      // original state/url after going through the login page, for example
      setToState({ to: to.name, params: params });

      // Implementes redirectTo for states
      if (to.redirectTo) {
        event.preventDefault();
        $delegate.go(to.redirectTo, params, { location: 'replace' });
      }
    }

    function setToState(toState_) {
      toState = toState_;
    }

    function getToState() {
      return toState;
    }
  }
})();

/*
 * Copyright (c) 2016 SPORTident GmbH. All rights reserved.
 */
(function () {
  'use strict';

  angular.module('c3poFrontend').factory('simpleMessaging', simpleMessaging);

  /** @ngInject */
  function simpleMessaging() {
    var service = {
      put: put,
      get: get,
    };
    var channels = {};
    return service;

    function put(channel, msg) {
      initChannel(channel);
      channels[channel].unshift(msg);
    }

    function get(channel) {
      initChannel(channel);
      return channels[channel].pop();
    }

    function initChannel(channel) {
      if (angular.isUndefined(channels[channel])) {
        channels[channel] = [];
      }
    }
  }
})();

/*
 * Copyright (c) 2016 SPORTident GmbH. All rights reserved.
 */
(function () {
  'use strict';

  angular.module('c3poFrontend').directive('signalIndicator', signalIndicator);

  function signalIndicator() {
    var directive = {
      restrict: 'E',
      templateUrl:
        'app/components/signal-indicator/signal-indicator.directive.html',
      scope: {
        signalLevel: '=signal',
        size: '=size',
      },
      controller: signalIndicatorCtrl,
      controllerAs: 'vm',
      bindToController: true,
    };
    return directive;

    /** @ngInject */
    function signalIndicatorCtrl() {
      var vm = this;

      vm.$onInit = onInit;

      function onInit() {
        vm.signalLevelTooltip = vm.signalLevel;
        var signal = vm.signalLevel;
        signal = signal < 0 ? 0 : signal > 100 ? 100 : signal;
        vm.signalLevelTooltip = signal;

        if (signal === null) {
          vm.signalDisplay = 6;
        } else if (signal >= 80 && signal <= 100) {
          vm.signalDisplay = 5;
        } else if (signal >= 60 && signal < 80) {
          vm.signalDisplay = 4;
        } else if (signal >= 40 && signal < 60) {
          vm.signalDisplay = 3;
        } else if (signal >= 10 && signal < 40) {
          vm.signalDisplay = 2;
        } else if (signal >= 0 && signal < 10) {
          vm.signalDisplay = 1;
        }
      }
    }
  }
})();

/*
 * Copyright (c) 2016 SPORTident GmbH. All rights reserved.
 */
(function () {
  'use strict';

  angular.module('c3poFrontend').directive('siSidebar', siSidebar);

  /** @ngInject */
  function siSidebar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/sidebar/sidebar.directive.html',
      scope: {
        eventId: '=',
      },
      controller: SiSidebarController,
      controllerAs: 'vm',
      bindToController: true,
    };

    return directive;

    /** @ngInject */
    function SiSidebarController($scope, $state) {
      var vm = this;

      vm.$onInit = onInit;

      function onInit() {
        vm.pages = [
          {
            title: 'Definition',
            state: 'event.edit',
            forStates: ['event.edit'],
            active: false,
            disabled: false,
          },
          // {
          //   title: 'Modems',
          //   state: 'event.modems',
          //   forStates: ['event.modems','event.editModems'],
          //   active: false,
          //   disabled: false
          // },
          {
            title: 'Delete',
            state: 'event.delete',
            forStates: ['event.delete'],
            active: false,
            disabled: false,
          },
        ];

        var isNewEvent = vm.eventId === 'new';
        for (var i in vm.pages) {
          var page = vm.pages[i];
          if (isNewEvent && Number(i) !== 0) {
            page.disabled = true;
          }
        }

        $scope.$on('$stateChangeSuccess', handleStateChange);
        handleStateChange();
      }

      function handleStateChange() {
        for (var i in vm.pages) {
          var page = vm.pages[i];
          page.active = false;
          for (var j in page.forStates) {
            if ($state.includes(page.forStates[j])) {
              page.active = true;
              break;
            }
          }
        }
      }
    }
  }
})();

/*
 * Copyright (c) 2016 SPORTident GmbH. All rights reserved.
 */
(function () {
  'use strict';

  angular.module('c3poFrontend').directive('settings', settings);

  function settings() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/settings/settings.directive.html',
      scope: {
        principal: '=',
      },
      controller: SettingsController,
      controllerAs: 'vm',
      bindToController: true,
    };
    return directive;

    /** @ngInject */
    function SettingsController(
      OrganisationStoreService,
      UserStoreService,
      Account,
      toastr,
      $state
    ) {
      var vm = this;

      vm.$onInit = onInit;
      vm.getLoadedUserOrganisation = getLoadedUserOrganisation;
      vm.selectedOrganisationChanged = selectedOrganisationChanged;
      vm.getOrganisations = getOrganisations;
      vm.isNotOrgAdmin = isNotOrgAdmin;
      vm.slugPlaceholder = 'Choose a unique string for URL';
      vm.showSlugPlaceholder = showSlugPlaceholder;

      function onInit() {
        vm.user = {};
        vm.oldPassword = '';
        vm.newPassword = '';
        vm.save = save;
        vm.changePassword = changePassword;
        vm.regenerateToken = regenerateToken;
        // for redirect issue
        if (vm.principal.getAccount() === null) {
          $state.go('login');
        } else {
          UserStoreService.getUser(vm.principal.getAccount().id).then(function (
            result
          ) {
            vm.user = result;
            if (vm.user === null) {
              $state.go('login');
            }
            var i;
            for (i = 0; i < vm.user.userOrganisations.length; i++) {
              if (
                vm.user.userOrganisations.length === 1 ||
                vm.user.userOrganisations[i].organisationId !== 1
              ) {
                vm.shownUserOrganisation = JSON.parse(
                  JSON.stringify(vm.user.userOrganisations[i])
                );
                if (vm.isNotOrgAdmin(vm.shownUserOrganisation)) {
                  vm.disableOrganisation = true;
                } else {
                  vm.disableOrganisation = false;
                }
              }
            }
          });
        }
      }

      function save() {
        var i;
        var isOrgSet = false;
        if (
          vm.shownUserOrganisation.organisation.slug === null ||
          vm.shownUserOrganisation.organisation.slug === ''
        ) {
          vm.shownUserOrganisation.organisation.slug = vm.shownUserOrganisation.organisation.name
            .toLowerCase()
            .replace(new RegExp(' |\\.|_', 'g'), '-')
            .replace(new RegExp('[^a-z0-9-]+', 'g'), '');
        } else {
          vm.shownUserOrganisation.organisation.slug = vm.shownUserOrganisation.organisation.slug
            .toLowerCase()
            .replace(new RegExp(' |\\.|_', 'g'), '-')
            .replace(new RegExp('[^a-z0-9-]+', 'g'), '');
        }
        for (i = 0; i < vm.user.userOrganisations.length; i++) {
          // delete if not assigned is selected
          if (
            vm.shownUserOrganisation.organisationId === 1 ||
            isOrgSet === true
          ) {
            if (vm.user.userOrganisations[i].organisationId !== 1) {
              vm.user.userOrganisations.splice(i, 1);
            }
          } else {
            if (
              vm.user.userOrganisations[i].organisationId !== 1 ||
              vm.shownUserOrganisation.organisationId === null
            ) {
              vm.user.userOrganisations[i] = JSON.parse(
                JSON.stringify(vm.shownUserOrganisation)
              );
              isOrgSet = true;
            } else {
              if (
                vm.user.userOrganisations.length === 1 &&
                vm.user.userOrganisations[i].organisationId === 1
              ) {
                vm.user.userOrganisations[i] = JSON.parse(
                  JSON.stringify(vm.shownUserOrganisation)
                );
              }
            }
          }
        }
        UserStoreService.saveUser(vm.user)
          .then(function (result) {
            vm.user = result;
            for (i = 0; i < result.userOrganisations.length; i++) {
              if (
                vm.user.userOrganisations.length === 1 ||
                result.userOrganisations[i].organisationId !== 1
              ) {
                vm.shownUserOrganisation = JSON.parse(
                  JSON.stringify(result.userOrganisations[i])
                );
                vm.selectedOrganisation = JSON.parse(
                  JSON.stringify(vm.shownUserOrganisation.organisation)
                );
                if (vm.isNotOrgAdmin(vm.shownUserOrganisation)) {
                  vm.disableOrganisation = true;
                } else {
                  vm.disableOrganisation = false;
                }
              }
            }
            toastr.success('Changes saved');
          })
          .catch(function (error) {
            var msgs = error.data.errorMessages.join('<br>');
            toastr.error(
              'Could not save the changes' +
                (msgs.length > 0 ? ': <br>' + msgs : '')
            );
          });
      }

      function changePassword() {
        // TODO: validate and reject weak passwords (strength <= 1)
        Account.changePassword(vm.oldPassword, vm.newPassword)
          .then(function () {
            toastr.success('Password changed');
          })
          .catch(function (error) {
            var msgs = error.data.errorMessages.join('<br>');
            toastr.error(
              'Could not change password' +
                (msgs.length > 0 ? ': <br>' + msgs : '')
            );
          })
          .finally(function () {
            vm.oldPassword = '';
            vm.newPassword = '';
          });
      }

      function regenerateToken() {
        Account.resetApiKey().then(
          function (obj) {
            vm.user.apiKey = obj.apiKey;
            toastr.success('API key reset successfully');
          },
          function () {
            toastr.error('Error resetting API key');
          }
        );
      }

      function isNotOrgAdmin(userOrganisation) {
        if (vm.userIsAdmin) return false;
        var isNotAdmin = true;
        userOrganisation.authorities.forEach(function (a) {
          if (typeof a === 'string' && a.indexOf('ROLE_ORG_ADMIN') > -1) {
            isNotAdmin = false;
          }
        });
        return isNotAdmin;
      }

      function getOrganisations(term) {
        vm.term = term;
        return OrganisationStoreService.getSelectedOrganisations(
          term,
          null,
          true
        );
      }

      function selectedOrganisationChanged(id) {
        if (angular.isUndefined(id) || id === null) {
          vm.shownUserOrganisation.organisation.name = vm.term;
          if (vm.term == null || vm.term === '') {
            vm.shownUserOrganisation.organisation.slug = '';
          } else {
            vm.shownUserOrganisation.organisation.slug = vm.term
              .replace(' ', '-')
              .replace('_', '-')
              .toLowerCase()
              .concat('-slug');
          }
          vm.shownUserOrganisation.id = null;
          vm.shownUserOrganisation.organisationId = null;
          vm.shownUserOrganisation.organisation.id = null;
          vm.disableOrganisation = false;
        } else {
          var i = vm.getLoadedUserOrganisation(id);
          if (i < 0) {
            vm.shownUserOrganisation.organisation = JSON.parse(
              JSON.stringify(vm.selectedOrganisation)
            );
            vm.shownUserOrganisation.organisationId = id;
            vm.shownUserOrganisation.authorities = ['ROLE_ORG_MEMBER'];
            vm.disableOrganisation = true;
          } else {
            // this saves the existing authorities and relations
            vm.shownUserOrganisation = JSON.parse(
              JSON.stringify(vm.user.userOrganisations[i])
            );
            if (vm.isNotOrgAdmin(vm.shownUserOrganisation)) {
              vm.disableOrganisation = true;
            } else {
              vm.disableOrganisation = false;
            }
          }
        }
      }

      function getLoadedUserOrganisation(id) {
        var i;
        for (i = 0; i < vm.user.userOrganisations.length; i++) {
          if (vm.user.userOrganisations[i].organisationId === id) return i;
        }
        return -1;
      }

      function showSlugPlaceholder() {
        vm.slugPlaceholder = vm.shownUserOrganisation.organisation.name
          .toLowerCase()
          .replace(new RegExp(' |\\.|_', 'g'), '-')
          .replace(new RegExp('[^a-z0-9-]+', 'g'), '');
      }
    }
  }
})();

/*
 * Copyright (c) 2016 SPORTident GmbH. All rights reserved.
 */
(function () {
  'use strict';

  angular.module('c3poFrontend').directive('siSearch', siSearch);

  function siSearch() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/search/search.directive.html',
      scope: {
        placeholder: '=',
        searchFunction: '=',
        initialSearchString: '=',
      },
      controller: SiSearchCtrl,
      controllerAs: 'vm',
      bindToController: true,
    };
    return directive;

    /** @ngInject */
    function SiSearchCtrl() {
      var vm = this;

      vm.$onInit = onInit;

      function onInit() {
        vm.searchString = '';
        vm.clear = clear;
        vm.submit = submit;

        vm.searchString = vm.initialSearchString;
        if (angular.isUndefined(vm.placeholder)) {
          vm.placeholder = 'Search';
        }
      }

      function clear() {
        vm.searchString = '';
        submit();
      }

      function submit() {
        vm.searchFunction(vm.searchString);
      }
    }
  }
})();

/*
 * Copyright (c) 2018 SPORTident GmbH. All rights reserved.
 */
(function () {
  'use strict';

  angular.module('c3poFrontend').directive('registerRequest', registerRequest);

  function registerRequest() {
    var directive = {
      restrict: 'E',
      templateUrl:
        'app/components/register-request/register-request.directive.html',
      scope: {},
      controller: RegisterRequestController,
      controllerAs: 'vm',
      bindToController: true,
    };
    return directive;

    /** @ngInject */
    function RegisterRequestController(
      Account,
      UserStoreService,
      toastr,
      $state
    ) {
      var vm = this;
      vm.$onInit = onInit;

      function onInit() {
        vm.registerTitle = 'Register';
        vm.email = '';
        vm.saveUser = saveUser;
        vm.user = {};
        vm.user.password = '';
        vm.lang = 'en';
        vm.captchaToken = undefined;
        vm.site = '';
        Account.getSiteToken().then(function (promise) {
          vm.site = promise.site;
          registerReCaptchaCallback();
          addScript();
        });
      }

      function registerReCaptchaCallback() {
        window.reCaptchaLoad = function () {
          /* global grecaptcha */
          grecaptcha
            .execute(vm.site, { action: 'homepage' })
            .then(function (captchaToken) {
              vm.captchaToken = captchaToken;
            });
        };
      }

      function addScript() {
        var script = document.createElement('script');
        script.src =
          'https://www.google.com/recaptcha/api.js?onload=reCaptchaLoad&render=' +
          vm.site;
        script.async = true;
        script.defer = true;
        document.body.appendChild(script);
      }

      function saveUser() {
        if (vm.user.repeatPassword === vm.user.password) {
          vm.user.activated = false;
          vm.user.language = 'en';
          vm.user.activationKey = null;
          vm.user.resetKey = null;
          vm.user.resetDate = null;
          vm.user.authorities = ['ROLE_USER'];
          vm.authorityClass = 'user';
          vm.user.id = undefined;
          if (angular.isUndefined(vm.captchaToken)) {
            grecaptcha
              .execute(vm.site, { action: 'homepage' })
              .then(function (captchaToken) {
                vm.captchaToken = captchaToken;
                vm.user.captchaToken = vm.captchaToken;
                UserStoreService.registerUser(vm.user)
                  .then(saveUserSucceeded)
                  .catch(saveUserFailed);
              });
          } else {
            vm.user.captchaToken = vm.captchaToken;
            UserStoreService.registerUser(vm.user)
              .then(saveUserSucceeded)
              .catch(saveUserFailed);
          }
        } else {
          toastr.error('repeated password differ form password');
        }
      }

      function saveUserSucceeded() {
        vm.captchaToken = undefined;
        toastr.success('Registration initiated. Please check your mail.');
        $state.go('activate', { login: vm.user.login });
      }

      function saveUserFailed(error) {
        vm.captchaToken = undefined;
        var msg = 'Could not create user "' + vm.user.login + '"';
        var ms = error.data.errorMessages;
        if (angular.isDefined(ms) && ms.length > 0) {
          msg += ': <br />' + ms.join(', <br />');
        }
        toastr.error(msg);
      }
    }
  }
})();

/*
 * Copyright (c) 2018 SPORTident GmbH. All rights reserved.
 */
(function () {
  'use strict';

  angular.module('c3poFrontend').directive('register', register);

  function register() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/register/register.directive.html',
      scope: {},
      controller: RegisterController,
      controllerAs: 'vm',
      bindToController: true,
    };
    return directive;

    /** @ngInject */
    function RegisterController(
      Account,
      $state,
      toastr,
      PersistentParamsService,
      $location,
      $stateParams
    ) {
      var vm = this;
      vm.$onInit = onInit;

      function onInit() {
        vm.userId = null;
        vm.message =
          'Thank you. Your registration was successful. Please check your email and click on the provided link to complete the activation of your account.';
        vm.success = false;
        vm.change = false;
        vm.activationKey = undefined;
        register();
      }

      function register() {
        var currentUrl = $location.search();
        if (currentUrl === undefined) {
          vm.message =
            'Sorry, there was a problem on your account registration.';
          toastr.error(vm.message);
          return;
        }
        if (angular.isDefined(currentUrl.key) && vm.change === false) {
          vm.activationKey = currentUrl.key;
          vm.change = true;
        }
        if (angular.isDefined(currentUrl.userId)) {
          vm.userId = currentUrl.userId;
        }
        if (angular.isDefined(vm.activationKey)) {
          Account.register(vm.activationKey, vm.userId)
            .then(function () {
              vm.success = true;
              vm.message =
                'You registered and activated SPORTident center sucessfully.';
              toastr.success(vm.message);
            })
            .catch(function () {
              vm.message =
                'Sorry, there was a problem with your account activation.';
              vm.success = false;
              toastr.error(vm.message);
            });
        }
      }
    }
  }
})();

/*
 * Copyright (c) 2016 SPORTident GmbH. All rights reserved.
 */
(function () {
  'use strict';

  angular.module('c3poFrontend').factory('PasswordStrength', PasswordStrength);

  /*
   * Combined rule-based and entropy-based password strength calculation.
   *
   * Entropy code based on https://github.com/subarroca/ng-password-strength/,
   * written by Salvador Subarroca.
   */
  /** @ngInject */
  function PasswordStrength() {
    var sets = [];

    var service = {
      getStrength: getStrength,
    };

    init();

    return service;

    function init() {
      add('ASCII Lowercase', /[a-z]/, 26);
      add('ASCII Uppercase', /[A-Z]/, 26);
      add('ASCII Numbers', /\d/, 10);
      add('ASCII Top Row Symbols', /[!@£#$%^&*()\-_=+]/, 15);
      add('ASCII Other Symbols', /[?/.>,<`~\\|"';:\]}[{\s]/, 19);

      // Unicode Latin Subset
      add('Unicode Latin 1 Supplement', /[\u00A1-\u00FF]/, 94);
      add('Unicode Latin Extended A', /[\u0100-\u017F]/, 128);
      add('Unicode Latin Extended B', /[\u0180-\u024F]/, 208);
      add('Unicode Latin Extended C', /[\u2C60-\u2C7F]/, 32);
      add('Unicode Latin Extended D', /[\uA720-\uA7FF]/, 29);

      // Unicode Cyrillic Subset
      add('Unicode Cyrillic Uppercase', /[\u0410-\u042F]/, 32);
      add('Unicode Cyrillic Lowercase', /[\u0430-\u044F]/, 32);
    }

    function add(label, regexp, score) {
      sets.push({
        label: label,
        regex: regexp,
        score: score,
      });
    }

    /*
     * Returns password strength as a value between 0 and 3, corresponding to
     * empty, weak, fair, and good password.
     *
     * A password that does not meet the minimum rules is always classified as
     * weak (1).
     */
    function getStrength(password) {
      if (!angular.isString(password) || password.length === 0) {
        return 0;
      }

      if (!passesMinimumStrengthRules(password)) {
        return 1;
      }

      var entropy = calculateEntropy(password);
      if (entropy < 50) {
        return 1;
      } else if (entropy < 100) {
        return 2;
      } else {
        return 3;
      }
    }

    /*
     * For a password to pass it needs to contain one digit, one lower case
     * character, one upper case character and a minimum of eight characters
     * overall.
     */
    function passesMinimumStrengthRules(password) {
      var re = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[^\s]{8,}$/;
      if (password.match(re)) {
        return true;
      } else {
        return false;
      }
    }

    function calculateEntropy(password) {
      var score = 0;
      for (var i = 0; i < sets.length; i++) {
        var match = password.match(sets[i].regex);
        if (match) {
          score += sets[i].score;
        }
      }

      var entropy = (Math.log(score) / Math.log(2)) * password.length;

      return entropy;
    }
  }
})();

/*
 * Copyright (c) 2016 SPORTident GmbH. All rights reserved.
 */
(function () {
  'use strict';

  angular
    .module('c3poFrontend')
    .directive('passwordStrengthIndicator', passwordStrengthIndicator);

  function passwordStrengthIndicator() {
    var directive = {
      restrict: 'E',
      templateUrl:
        'app/components/password-strength-indicator/password-strength-indicator.directive.html',
      scope: {
        password: '<',
      },
      controller: PasswordStrengthIndicatorController,
      controllerAs: 'vm',
      bindToController: true,
    };
    return directive;

    /** @ngInject */
    function PasswordStrengthIndicatorController($scope, PasswordStrength) {
      var vm = this;

      var strengthClasses = [
        '',
        'password-indicator-weak',
        'password-indicator-fair',
        'password-indicator-good',
      ];

      vm.$onInit = onInit;
      vm.$onChanges = onChanges;

      function onInit() {
        vm.strengthClass = strengthClasses[0];
      }

      function onChanges(changes) {
        if (changes.password && !changes.password.isFirstChange()) {
          updateIndicator();
        }
      }

      function updateIndicator() {
        var strength = PasswordStrength.getStrength(vm.password);
        vm.strengthClass = strengthClasses[strength];
      }
    }
  }
})();

/*
 * Copyright (c) 2016 SPORTident GmbH. All rights reserved.
 */
(function () {
  'use strict';

  angular
    .module('c3poFrontend')
    .directive('passwordResetRequest', passwordResetRequest);

  function passwordResetRequest() {
    var directive = {
      restrict: 'E',
      templateUrl:
        'app/components/password-reset-request/password-reset-request.directive.html',
      scope: {},
      controller: PasswordResetRequestController,
      controllerAs: 'vm',
      bindToController: true,
    };
    return directive;

    /** @ngInject */
    function PasswordResetRequestController(Account, toastr, $state) {
      var vm = this;

      vm.$onInit = onInit;

      function onInit() {
        vm.email = '';
        vm.requestReset = requestReset;
      }

      function requestReset() {
        Account.requestPasswordReset(vm.email)
          .then(function () {
            toastr.success('Passwort reset initiated. Please check your mail.');
            $state.go('home');
          })
          .catch(function (error) {
            var msgs = error.data.errorMessages.join('<br>');
            toastr.error(
              'Could not initiate password reset' +
                (msgs.length > 0 ? ': <br>' + msgs : '')
            );
          });
      }
    }
  }
})();

/*
 * Copyright (c) 2016 SPORTident GmbH. All rights reserved.
 */
(function () {
  'use strict';

  angular.module('c3poFrontend').directive('passwordReset', passwordReset);

  function passwordReset() {
    var directive = {
      restrict: 'E',
      templateUrl:
        'app/components/password-reset/password-reset.directive.html',
      scope: {},
      controller: PasswordResetController,
      controllerAs: 'vm',
      bindToController: true,
    };
    return directive;

    /** @ngInject */
    function PasswordResetController(Account, toastr, $state, $stateParams) {
      var vm = this;
      var key = '';

      vm.$onInit = onInit;

      function onInit() {
        vm.newPassword = '';
        vm.reset = reset;

        var re = /^\d+$/;
        key = $stateParams.key;
        if (!re.test(key)) {
          toastr.error('Invalid password reset link');
          $state.go('home');
        }
      }

      function reset() {
        // TODO: validate and reject weak passwords (strength <= 1)
        Account.resetPassword(key, vm.newPassword)
          .then(function () {
            toastr.success('Password reset successful');
            $state.go('login');
          })
          .catch(function (error) {
            var msgs = error.data.errorMessages.join('<br>');
            toastr.error(
              'Could not reset password' +
                (msgs.length > 0 ? ': <br>' + msgs : '')
            );
          })
          .finally(function () {
            vm.newPassword = '';
          });
      }
    }
  }
})();

/*
 * Copyright (c) 2016 SPORTident GmbH. All rights reserved.
 */
(function () {
  'use strict';

  angular.module('c3poFrontend').directive('siPagination', siPagination);

  // TODO: The break point where we switch from list to dropdown needs to be configurable
  function siPagination() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/pagination/pagination.directive.html',
      scope: {
        sref: '=',
        pagination: '<',
        goToPageCallback: '=?',
      },
      controller: SiPaginationController,
      controllerAs: 'vm',
      bindToController: true,
    };
    return directive;

    /** @ngInject */
    function SiPaginationController($state, $scope) {
      var vm = this;

      vm.$onInit = onInit;
      vm.$onChanges = onChanges;

      function onInit() {
        vm.pages = [];
        vm.currentPage = 1;
        vm.selectedPage = 1;
        vm.goToPage = goToPage;
        initPagination();
      }

      function onChanges(changes) {
        if (changes.pagination && !changes.pagination.isFirstChange()) {
          initPagination();
        }
      }

      function initPagination() {
        if (angular.isUndefined(vm.pagination)) {
          return;
        }

        // Handle an out-of-bounds page
        if (vm.pagination.current < 0) {
          goToPage(0);
        } else if (vm.pagination.current > vm.pagination.last) {
          goToPage(vm.pagination.last);
        }

        // Prepare pages list for template
        vm.currentPage = vm.pagination.current;
        vm.selectedPage = vm.pagination.current;
        vm.pages = [];
        for (var i = 0; i <= vm.pagination.last; i++) {
          vm.pages.push(i);
        }
      }

      function goToPage(page) {
        if (vm.goToPageCallback) {
          vm.goToPageCallback(page);
        } else if (vm.sref) {
          // Removes '?page=0' from the URL, which makes for a nicer URL.
          if (page === 0) {
            page = undefined;
          }
          $state.go(vm.sref, { page: page });
        }
      }
    }
  }
})();

/*
 * Copyright (c) 2016 SPORTident GmbH. All rights reserved.
 */
(function () {
  'use strict';

  angular.module('c3poFrontend').factory('PaginationHeader', PaginationHeader);

  /*
   * This is taken directly from JHipster
   */
  function PaginationHeader() {
    var service = {
      getPagination: getPagination,
    };

    return service;

    function getPagination(header) {
      if (header.length === 0) {
        throw new Error('input must not be of zero length');
      }

      // Split parts by comma
      var parts = header.split(',');
      var links = {};
      // Parse each part into a named link
      angular.forEach(parts, function (p) {
        var section = p.split(';');
        if (section.length !== 2) {
          throw new Error('section could not be split on ";"');
        }
        var url = section[0].replace(/<(.*)>/, '$1').trim();
        var queryString = {};
        url.replace(new RegExp('([^?=&]+)(=([^&]*))?', 'g'), function (
          $0,
          $1,
          $2,
          $3
        ) {
          queryString[$1] = $3;
        });
        var page = queryString.page;
        if (angular.isString(page)) {
          page = parseInt(page);
        }
        var name = section[1].replace(/rel="(.*)"/, '$1').trim();
        links[name] = page;
      });

      return links;
    }
  }
})();

/*
 * Copyright (c) 2016 SPORTident GmbH. All rights reserved.
 */
(function () {
  'use strict';

  angular.module('c3poFrontend').directive('siNavbar', siNavbar);

  function siNavbar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/navbar/navbar.directive.html',
      scope: {
        principal: '=',
      },
      controller: SiNavbarController,
      controllerAs: 'vm',
      bindToController: true,
    };
    return directive;

    /** @ngInject */
    function SiNavbarController($scope, $state) {
      var vm = this;

      vm.$onInit = onInit;

      function onInit() {
        vm.isCollapsed = true;
        vm.pages = [
          {
            title: 'Events',
            state: 'events',
            requiredRole: 'ROLE_USER',
            forStates: ['event', 'events'],
            active: false,
          },
          {
            title: 'Modems',
            state: 'modems',
            requiredRole: 'ROLE_USER',
            forStates: ['modem', 'modems'],
            active: false,
          },
          {
            title: 'Billing',
            state: 'billing',
            requiredRole: 'ROLE_USER',
            forStates: ['billing', 'billing.payment'],
            active: false,
          },
          {
            title: 'Subscription',
            titleIfAdmin: 'Subscriptions',
            state: 'subscription',
            requiredRole: 'ROLE_USER',
            forStates: ['subscription'],
            active: false,
          },
          {
            title: 'Users',
            state: 'users',
            requiredRole: 'ROLE_ADMIN',
            forStates: ['user', 'users'],
            active: false,
          },
        ];
        vm.toggleCollapse = toggleCollapse;

        $scope.$on('$stateChangeSuccess', handleStateChange);
        handleStateChange();
      }

      function handleStateChange() {
        for (var i in vm.pages) {
          var page = vm.pages[i];
          page.active = false;
          for (var j in page.forStates) {
            if ($state.includes(page.forStates[j])) {
              page.active = true;
              break;
            }
          }
        }
      }

      function toggleCollapse() {
        vm.isCollapsed = !vm.isCollapsed;
      }
    }
  }
})();

/*
 * Copyright (c) 2016 - 2017 SPORTident GmbH. All rights reserved.
 */
/*
 * TODO: add user filter
 *
 * TODO: It should be possible to sort and query by either readout time (what we
 * do right now) or stamp punch time
 *
 * TODO: in calendar popup, indicate which dates have more than zero stamps for
 *       current filter settings (needs backend support)
 *
 * TODO: if an event is selected, highlight the modems used in the event in the
 *       modem dropdown (or only show modems used in the event)
 */
(function () {
  'use strict';

  angular.module('c3poFrontend').directive('monitor', monitor);

  function monitor() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/monitor/monitor.directive.html',
      scope: {},
      controller: MonitorController,
      controllerAs: 'vm',
      bindToController: true,
    };
    return directive;

    /** @ngInject */
    function MonitorController(
      $timeout,
      $scope,
      $state,
      $stateParams,
      ModemStoreService,
      EventStoreService,
      StampStoreService,
      PersistentParamsService,
      moment,
      Account,
      $location
    ) {
      var vm = this;
      var loadStampsPromise;
      var fullDateTime;
      var refreshTimer;
      var autoRefreshTimeoutInMs = 30000;
      var stampCountForPeriod = [];
      var parameters;
      var unassigned;

      vm.$onInit = onInit;
      vm.$onDestroy = onDestroy;

      function onInit() {
        unassigned = EventStoreService.getNotAssignedEventId();
        vm.stamps = [];
        vm.stampsTotalCount = undefined;
        vm.stampsOfDayCount = undefined;
        vm.stampsOfHourCount = undefined;
        vm.getEvents = getEvents;
        vm.getModems = getModems;
        vm.selectedModemChanged = selectedModemChanged;
        vm.selectedEventChanged = selectedEventChanged;
        vm.selectedEvent = null;
        vm.selectedModem = null;
        vm.selectedCard = undefined;
        vm.selectedControl = undefined;
        vm.viewDateObject = undefined;
        vm.viewDateString = undefined;
        vm.viewTime = undefined;
        vm.viewTimeMinusOneHour = undefined;
        vm.dateSelectionActive = false;
        vm.timeSelectionActive = false;
        vm.referenceDate = undefined;
        vm.$stateParams = $stateParams;
        vm.isDatepickerOpen = false;
        vm.showToolbar = false;
        vm.displayLoadingIcon = false;
        vm.showDuplicates = false;

        vm.openDatepicker = openDatepicker;
        vm.getStampCountTooltipHtml = getStampCountTooltipHtml;
        vm.formatDate = formatDate;
        vm.formatDateLocal = formatDateLocal;
        vm.makeDateAndTimeSelectionInactive = makeDateAndTimeSelectionInactive;
        vm.makeTimeSelectionInactive = makeTimeSelectionInactive;
        vm.viewDateChanged = viewDateChanged;
        vm.viewTimeChanged = viewTimeChanged;
        vm.nextDay = nextDay;
        vm.previousDay = previousDay;
        vm.nextHour = nextHour;
        vm.previousHour = previousHour;
        vm.applyFilters = applyFilters;
        vm.toggleActive = toggleActive;
        vm.refreshMonitor = refreshMonitor;
        vm.getStampCountForDay = getStampCountForDay;
        vm.clearParams = clearParams;
        vm.setShowDuplicates = setShowDuplicates;

        vm.principal = undefined;
        vm.userIsAdmin = false;
        Account.getPrincipal().then(function (promise) {
          vm.principal = promise;
          var account = vm.principal.getAccount();
          vm.userIsAdmin = account.authorities.indexOf('ROLE_ADMIN') !== -1;
        });

        // Only continously update the list if we are on the first page
        // if (angular.isUndefined($stateParams.page) || $stateParams.page==0) {
        //   var reloadPromise = $timeout(reload, 5000);
        //   $scope.$on('$destroy', function() {$timeout.cancel(reloadPromise);});
        //   vm.isLive = true;
        // }

        // Overwrite persistent parameters if parameters are specified in the URL.
        if (Object.keys($location.search()).length !== 0) {
          PersistentParamsService.setParamsMonitor($stateParams);
        }

        parameters = PersistentParamsService.getParamsMonitor();
        var date, time;
        if (angular.isDefined(parameters)) {
          var formattedDate, formattedTime;
          fullDateTime = moment(parameters.date, 'YYYY-MM-DD');
          date = moment(parameters.date, 'YYYY-MM-DD');
          time = moment(parameters.time, 'HH:mm:ss.SSS');
          if (date.isValid()) {
            formattedDate = date.format('YYYY-MM-DD');
          }
          if (time.isValid()) {
            formattedTime = time.format('HH:mm:ss.SSS');
          }
          if (angular.isDefined(parameters.event)) {
            EventStoreService.getEvent(parameters.event).then(function (
              result
            ) {
              vm.selectedEvents = {
                id: result.id,
                name: result.name,
                displayName: result.name,
                noReload: true,
              };
            });
          }
          if (angular.isDefined(parameters.modem)) {
            ModemStoreService.getModem(parameters.modem).then(function (
              result
            ) {
              vm.selectedModems = {
                id: result.id,
                displayName: result.externId,
                noReload: true,
              };
            });
          }
          if (angular.isDefined(parameters.duplicates)) {
            vm.showDuplicates = parameters.duplicates === 1;
          }
          $location
            .path('/monitor')
            .search('event', parameters.event)
            .search('modem', parameters.modem)
            .search('card', parameters.card)
            .search('control', parameters.control)
            .search('date', formattedDate)
            .search('time', formattedTime)
            .search('duplicates', parameters.duplicates ? 1 : undefined);
        }

        // Update our data when the url params change
        $scope.$watch(
          '[vm.$stateParams.event,vm.$stateParams.modem,vm.$stateParams.card,' +
            ' vm.$stateParams.control,vm.$stateParams.date,vm.$stateParams.time,vm.$stateParams.duplicates]',
          stateParamsChanged
        );
      }

      function getEvents(term) {
        return EventStoreService.getSelectedEvents(term, true).then(function (
          result
        ) {
          var reformattedArray = result.map(function (obj) {
            if (vm.userIsAdmin) {
              return obj;
            } else if (obj.id !== unassigned) {
              return obj;
            }
          });
          return reformattedArray;
        });
      }

      function getModems(term) {
        return ModemStoreService.getSelectedModems(term, true);
      }

      function onDestroy() {
        // Abort any on-going http request
        if (loadStampsPromise) {
          loadStampsPromise.cancel();
        }
        clearRefreshTimer();
      }

      function openDatepicker() {
        vm.isDatepickerOpen = true;
      }

      function getStampCountTooltipHtml() {
        return (
          '' +
          vm.stampsTotalCount.toString() +
          ' stamps in total<br />' +
          vm.stampsOfDayCount.toString() +
          ' stamps on this day<br />' +
          vm.stampsOfHourCount.toString() +
          ' stamps in this hour'
        );
      }

      function formatDate(dateString) {
        var reference = moment(vm.referenceDate);
        var d = moment(dateString);
        if (d.isSame(reference, 'day')) {
          return d.format('HH:mm:ss');
        } else {
          return d.format('YYYY-MM-DD HH:mm:ss');
        }
      }

      function formatDateLocal(dateString) {
        var reference = moment(vm.referenceDate);
        var offset = moment().utcOffset();
        var local = moment.utc(dateString).utcOffset(offset);
        if (local.isSame(reference, 'day')) {
          return local.format('HH:mm:ss');
        } else {
          return local.format('YYYY-MM-DD HH:mm:ss');
        }
      }

      function makeDateAndTimeSelectionInactive() {
        vm.dateSelectionActive = false;
        vm.timeSelectionActive = false;
        updateViewFromFullDateTime();
        applyFilters();
      }

      function makeTimeSelectionInactive() {
        vm.timeSelectionActive = false;
        updateViewFromFullDateTime();
        applyFilters();
      }

      function viewDateChanged() {
        // TODO: the parsing with the format string is nonsensical, because this is a JS date object
        var d = moment(vm.viewDateObject, 'DD.MM.YYYY', true);
        if (d.isValid()) {
          fullDateTime.year(d.year());
          fullDateTime.month(d.month());
          fullDateTime.date(d.date());
          vm.dateSelectionActive = true;
          applyFilters();
        }
      }

      function viewTimeChanged() {
        var d = moment(vm.viewTime, 'HH:mm', true);
        if (d.isValid()) {
          fullDateTime.hour(d.hour() - moment().utcOffset() / 60);
          fullDateTime.minute(d.minute());
          vm.dateSelectionActive = true;
          vm.timeSelectionActive = true;
          updateViewFromFullDateTime();
          applyFilters();
        }
      }

      function nextDay() {
        fullDateTime.add(1, 'days');
        vm.dateSelectionActive = true;
        applyFilters();
      }

      function previousDay() {
        fullDateTime.subtract(1, 'days');
        vm.dateSelectionActive = true;
        applyFilters();
      }

      function nextHour() {
        fullDateTime.add(1, 'hours');
        fullDateTime.startOf('hour');
        vm.dateSelectionActive = true;
        vm.timeSelectionActive = true;
        applyFilters();
      }

      function previousHour() {
        if (fullDateTime.minute() === 0) {
          fullDateTime.subtract(1, 'hours');
        }
        fullDateTime.startOf('hour');
        vm.dateSelectionActive = true;
        vm.timeSelectionActive = true;
        applyFilters();
      }

      function updateViewFromFullDateTime() {
        getStampCount(fullDateTime);
        if (angular.isDefined(fullDateTime)) {
          vm.viewDateObject = fullDateTime.toDate();
          vm.viewDateString = fullDateTime.format('DD.MM.YYYY');
          // UTC to Local changes
          var offset = moment().utcOffset();
          var fdtstring = fullDateTime
            .format('YYYY-MM-DD HH:mm:ss.SSS')
            .toString();
          var local = moment.utc(fdtstring).utcOffset(offset);
          vm.viewTime = local.format('HH:mm');
          vm.viewTimeMinusOneHour = local
            .clone()
            .subtract(1, 'hours')
            .format('HH:mm');
        }
      }

      function setShowDuplicates(showDuplicates) {
        vm.showDuplicates = showDuplicates;
        applyFilters();
      }

      function applyFilters() {
        // $state.go('monitor', params());
        parameters = params();
        PersistentParamsService.setParamsMonitor(parameters);
        // Update location
        if (angular.isDefined(params)) {
          $location
            .path('/monitor')
            .search('event', parameters.event)
            .search('modem', parameters.modem)
            .search('card', parameters.card)
            .search('control', parameters.control)
            .search('date', parameters.date)
            .search('time', parameters.time)
            .search('duplicates', parameters.duplicates ? 1 : undefined);
        }
      }

      function selectedModemChanged(id) {
        vm.selectedModem = id;
        applyFilters();
      }

      function selectedEventChanged(id) {
        vm.selectedEvent = id;
        applyFilters();
      }

      function params() {
        var date;
        var time;
        if (vm.dateSelectionActive && angular.isDefined(fullDateTime)) {
          date = moment(fullDateTime).format('YYYY-MM-DD');
        }
        if (vm.timeSelectionActive && angular.isDefined(fullDateTime)) {
          time = moment(fullDateTime).format('HH:mm:ss.SSS');
        }

        var ps = {
          event: vm.selectedEvent || undefined,
          modem: vm.selectedModem || undefined,
          card: vm.selectedCard || undefined,
          control: vm.selectedControl || undefined,
          date: date,
          time: time,
          duplicates: vm.showDuplicates ? 1 : undefined,
        };

        return ps;
      }

      function stateParamsChanged() {
        // This function is also triggered when navigating away from the monitor
        // page. Apparently, the page's scope still exists. This hack avoids
        // dispatching another http request when leaving the monitor page.
        if ($state.current.name !== 'monitor') {
          return;
        }

        // We always load the filter settings from the state params
        vm.selectedEvent = $stateParams.event;
        vm.selectedModem = $stateParams.modem;
        vm.selectedCard = $stateParams.card;
        vm.selectedControl = $stateParams.control;
        vm.showDuplicates = $stateParams.duplicates === 1;

        // Validate the date and time parameters
        if (
          (angular.isDefined($stateParams.date) &&
            !moment($stateParams.date, 'YYYY-MM-DD', true).isValid()) ||
          (angular.isDefined($stateParams.time) &&
            !moment($stateParams.time, 'HH:mm:ss.SSS', true).isValid())
        ) {
          // This will remove the date and time parameters and do a redirect
          vm.dateSelectionActive = false;
          vm.timeSelectionActive = false;
          applyFilters();
        }

        // Process the date and time parameters
        if (
          angular.isDefined($stateParams.date) &&
          angular.isDefined($stateParams.time)
        ) {
          // If both date and time are set, the fullDateTime is determined by
          // those two parameters
          fullDateTime = moment($stateParams.date + 'T' + $stateParams.time);
          updateViewFromFullDateTime();
          vm.dateSelectionActive = true;
          vm.timeSelectionActive = true;
        } else if (
          angular.isDefined($stateParams.date) &&
          angular.isUndefined($stateParams.time)
        ) {
          // If only date is set, ideally keep the old time and only update the
          // date for fullDateTime; the time is then adjusted for display in
          // processLoadedStamps
          if (angular.isUndefined(fullDateTime)) {
            fullDateTime = moment().endOf('day');
          }
          var newDate = moment($stateParams.date);
          fullDateTime.set({
            year: newDate.year(),
            month: newDate.month(),
            day: newDate.day(),
          });

          updateViewFromFullDateTime();
          vm.dateSelectionActive = true;
          vm.timeSelectionActive = false;
        } else {
          // If neither date nor time is set, fullDateTime remains untouched; it
          // is then updated for display in processLoadedStamps
          vm.dateSelectionActive = false;
          vm.timeSelectionActive = false;
        }

        loadStamps();
      }

      function clearParams() {
        parameters = params();
        if (angular.isDefined(parameters)) {
          parameters.event = undefined;
          parameters.modem = undefined;
          parameters.card = undefined;
          parameters.control = undefined;
          parameters.date = undefined;
          parameters.time = undefined;
          parameters.duplicates = undefined;
          vm.showDuplicates = false;
          vm.selectedEvents = undefined;
          vm.selectedModems = undefined;
          PersistentParamsService.setParamsMonitor(parameters);
          $location
            .path('/monitor')
            .search('event', undefined)
            .search('modem', undefined)
            .search('card', undefined)
            .search('control', undefined)
            .search('date', undefined)
            .search('time', undefined)
            .search('duplicates', undefined);
        }
      }

      function loadStamps() {
        var filters = {
          eventId: vm.selectedEvent,
          boxId: vm.selectedModem,
          stampSiid: vm.selectedCard,
          stampCode: vm.selectedControl,
          showDuplicates: vm.showDuplicates,
        };

        var date;
        var time;

        if (vm.dateSelectionActive) {
          date = fullDateTime.clone();
        }
        if (vm.timeSelectionActive) {
          time = fullDateTime.clone();
        }
        // If a previous http request is still pending, abort it
        if (loadStampsPromise) {
          loadStampsPromise.cancel();
        }
        loadStampsPromise = StampStoreService.getStampsOfLatestHour(
          filters,
          date,
          time
        );
        loadStampsPromise.then(processLoadedStamps).catch(function (error) {
          vm.displayLoadingIcon = false;
          // Ignore error if request has been aborted.
          if (error.xhrStatus === 'abort');
          else if (error.status === 403 || error.status === 401);
          else throw error;
        });
      }

      function processLoadedStamps(stampsInfo) {
        vm.stampsTotalCount = stampsInfo.stampsTotalCount;
        vm.stampsOfDayCount = stampsInfo.stampsOfDayCount;
        vm.stampsOfHourCount = stampsInfo.stampsOfHourCount;
        vm.stamps = stampsInfo.stamps;

        if (
          vm.stamps.length > 0 &&
          !(vm.dateSelectionActive && vm.timeSelectionActive)
        ) {
          // If there is no explicit date and/or time selection, then set the
          // (implicit) date and time to the date/time of the latest stamp
          // matching the filter criteria
          var latestReadout = vm.stamps[0].stampReadoutDatetime;
          fullDateTime = moment(latestReadout)
            .startOf('minute')
            .add(1, 'minutes');
        } else if (
          vm.stamps.length === 0 &&
          vm.dateSelectionActive &&
          !vm.timeSelectionActive
        ) {
          // No results match the filter criteria and no explicit time set:
          // Set the (implicit) time to the end of the day
          fullDateTime.endOf('day');
        } else if (
          vm.stamps.length === 0 &&
          !vm.dateSelectionActive &&
          !vm.timeSelectionActive
        ) {
          // No results match the filter criteria and no explicit date and
          // time set: Set the (implicit) date and time to now
          fullDateTime = moment().startOf('minute');
        }

        updateViewFromFullDateTime();
        vm.referenceDate = vm.viewDateObject;

        // Hiding the loading icon is done with a delay to make sure that icon is visible
        // for at least a short time. This way the user has a visual indication that
        // the refresh action was actually performed.
        $timeout(function () {
          vm.displayLoadingIcon = false;
        }, 200);

        // Whenever we finish loading and viewing stamps, start the timer for
        // auto refresh. Make sure to clear potentially active timer first.
        clearRefreshTimer();
        refreshTimer = $timeout(refreshMonitor, autoRefreshTimeoutInMs);
      }

      function toggleActive(variable) {
        var buttonName = variable;
        vm.toggleState = buttonName;
        if (buttonName === 'showfilters') {
          if (vm.showToolbar === false) {
            vm.showToolbar = true;
            vm.toggleState = 'all';
          } else {
            vm.showToolbar = false;
            vm.toggleState = 'all';
          }
        }
      }

      /**
       * Manual refresh refreshes the stamps, cancelling the current timeout.
       *
       * And launches a new timeout (in processLoadedStamps function).
       */
      function refreshMonitor() {
        vm.displayLoadingIcon = true;
        clearRefreshTimer();
        loadStamps();
      }

      function clearRefreshTimer() {
        if (refreshTimer) {
          $timeout.cancel(refreshTimer);
        }
      }

      function getStampCount(date) {
        var referencdeDate = moment(date).format('YYYY-MM');
        var startDate = moment(referencdeDate)
          .subtract(12, 'months')
          .format('YYYY-MM');
        var endDate = moment(referencdeDate)
          .add(2, 'months')
          .endOf('month')
          .format('YYYY-MM-DD');
        StampStoreService.getStampCount(
          startDate + '-01T00:00:00',
          endDate + 'T23:59:59'
        ).then(function (result) {
          stampCountForPeriod = result;
        });
      }

      function getStampCountForDay(data) {
        var date = data.date;
        return stampCountForPeriod.find(function findDate(thisdate) {
          var formatedDate = moment(date).format('YYYY-MM-DD');
          if (thisdate.stampDate === formatedDate) {
            return 'success';
          }
        });
      }
    }
  }
})();

/*
 * Copyright (c) 2016 SPORTident GmbH. All rights reserved.
 */
(function () {
  'use strict';

  angular.module('c3poFrontend').directive('logout', logout);

  function logout() {
    var directive = {
      restrict: 'E',
      template: '<div></div>',
      scope: {},
      controller: LogoutController,
      controllerAs: 'vm',
      bindToController: true,
    };
    return directive;

    /** @ngInject */
    function LogoutController(
      Account,
      $state,
      toastr,
      PersistentParamsService
    ) {
      var vm = this;

      vm.$onInit = onInit;

      function onInit() {
        logout();
      }

      function logout() {
        Account.logout()
          .then(function () {
            toastr.success('You have been signed out');
            $state.go('login');
          })
          .catch(function () {
            toastr.error('Sorry, there was a problem signing you out');
          });
        PersistentParamsService.clearAllParams();
      }
    }
  }
})();

/*
 * Copyright (c) 2016 SPORTident GmbH. All rights reserved.
 */
(function () {
  'use strict';

  angular.module('c3poFrontend').directive('login', login);

  function login() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/login/login.directive.html',
      scope: {},
      controller: LoginController,
      controllerAs: 'vm',
      bindToController: true,
    };
    return directive;

    /** @ngInject */
    function LoginController(Account, $state, $stateParams, toastr) {
      var vm = this;

      vm.$onInit = onInit;

      function onInit() {
        vm.username = '';
        vm.password = '';
        vm.login = login;

        Account.getPrincipal().then(function (principal) {
          if (principal.isAuthenticated()) {
            toastr.success('Already signed in');
            $state.go('events');
          }
        });
      }

      function login() {
        // TODO: Show validation errors and do not send to server if form is not
        // valid, e.g. username, password cannot be empty
        // TODO: focus user input field in case of error
        Account.login(vm.username, vm.password)
          .then(function () {
            Account.getPrincipal()
              .then(function () {
                toastr.success('Sign in successful');

                if ($stateParams.redirectTo && $stateParams.redirectParams) {
                  $state.go(
                    $stateParams.redirectTo,
                    $stateParams.redirectParams
                  );
                } else {
                  $state.go('events');
                }
              })
              .catch(function () {
                // Try to logout
                Account.logout();
                toastr.error('Sign in failed. Sorry, something went wrong.');
                vm.password = '';
              });
          })
          .catch(function () {
            toastr.error('Sign in failed: Invalid username or password.');
            vm.password = '';
          });
      }
    }
  }
})();

/*
 * Copyright (c) 2016 SPORTident GmbH. All rights reserved.
 */
(function () {
  'use strict';

  angular
    .module('c3poFrontend')
    .directive('siLoadingIndicator', siLoadingIndicator);

  function siLoadingIndicator() {
    var directive = {
      restrict: 'E',
      templateUrl:
        'app/components/loading-indicator/loading-indicator.directive.html',
      scope: {
        isLoadingUser: '<loading',
      },
      controller: SiLoadingIndicatorCtrl,
      controllerAs: 'vm',
      bindToController: true,
    };
    return directive;

    /*
     * TODO: Could do with more practical testing (but this is difficult to test,
     * ideally we need a server with very slow responses). Right now the events (e.g.
     * requests started) are counted locally for each spinning wheel; we could also
     * count globally by moving the counting to a global service.
    /** @ngInject */
    function SiLoadingIndicatorCtrl($scope, $timeout) {
      var vm = this;
      var restRequestsStarted = 0;

      vm.$onInit = onInit;
      vm.$onChanges = onChanges;

      function onInit() {
        vm.isLoading = false;

        $scope.$on('restRequestStart', increaseRestRequestsStarted);
        $scope.$on('restRequestSuccess', decreaseRestRequestsStarted);
        $scope.$on('restRequestError', decreaseRestRequestsStarted);

        updateIsLoading();
      }

      function onChanges(changes) {
        if (changes.isLoadingUser && !changes.isLoadingUser.isFirstChange()) {
          updateIsLoading();
        }
      }

      function increaseRestRequestsStarted() {
        restRequestsStarted += 1;
        updateIsLoading();
      }

      function decreaseRestRequestsStarted() {
        restRequestsStarted -= 1;
        if (restRequestsStarted < 0) {
          restRequestsStarted = 0;
        }
        updateIsLoading();
      }

      function updateIsLoading() {
        // Display the spinning wheel only when the request takes more than
        // 500ms. If it's user initiated via the loading parameter then we
        // display the spinning wheel almost immediately.
        if (isLoading()) {
          var delayForStart = vm.isLoadingUser ? 50 : 500;
          $timeout(function () {
            vm.isLoading = isLoading();
          }, delayForStart);
        } else {
          vm.isLoading = false;
        }

        // $log.debug(isLoading(), restRequestsStarted);
      }

      function isLoading() {
        return restRequestsStarted > 0 || vm.isLoadingUser;
      }
    }
  }
})();

/*
 * Copyright (c) 2016 SPORTident GmbH. All rights reserved.
 */
(function () {
  'use strict';

  angular
    .module('c3poFrontend')
    .factory('RestangularInterceptors', RestangularInterceptors);

  /** @ngInject */
  function RestangularInterceptors($rootScope, PaginationHeader) {
    var service = {
      requestInterceptor: requestInterceptor,
      responseInterceptor: responseInterceptor,
      errorInterceptor: errorInterceptor,
    };

    return service;

    function requestInterceptor(element) {
      $rootScope.$broadcast('restRequestStart');
      return element;
    }

    function responseInterceptor(data, operation, what, url, response) {
      $rootScope.$broadcast('restRequestSuccess');

      var extractedData;
      var hs = response.headers();
      if (operation === 'getList') {
        // Some parts of the REST API have not been updated to the new format
        // yet. Therefore we need to handle the old format (with _embedded)
        // here.
        if (
          angular.isDefined(data._embedded) &&
          angular.isArray(data._embedded[Object.keys(data._embedded)[0]])
        ) {
          extractedData = data._embedded[Object.keys(data._embedded)[0]];

          // This is the new (much simpler) format
        } else if (angular.isArray(data)) {
          extractedData = data;
        } else {
          extractedData = [];
        }

        var pagination = {};
        // Old format pagination
        if (angular.isObject(data.page)) {
          pagination.first = 0;
          pagination.last =
            data.page.totalPages > 0 ? data.page.totalPages - 1 : 0;
          pagination.current = data.page.number;

          // New format pagination
        } else if (angular.isDefined(hs['link'])) {
          pagination = PaginationHeader.getPagination(hs['link']);
          if (angular.isNumber(pagination.next)) {
            pagination.current = pagination.next - 1;
          } else if (angular.isNumber(pagination.prev)) {
            pagination.current = pagination.prev + 1;
          } else {
            pagination.current = 0;
          }
        }
        extractedData.pagination = pagination;

        // Total number of returned items
        if (
          angular.isString(hs['x-count']) &&
          hs['x-count'].match(/^[0-9]+$/)
        ) {
          extractedData.totalCount = parseInt(hs['x-count']);
        }
      } else {
        if (operation === 'get' && angular.isString(hs['x-revision'])) {
          extractedData = {};
          extractedData.revision = parseInt(hs['x-revision']);
          if (angular.isString(hs['x-content-format'])) {
            extractedData.contentFormat = hs['x-content-format'];
          }
          if (angular.isObject(data)) {
            extractedData.data = JSON.stringify(data);
          } else {
            extractedData.data = data;
          }
        } else {
          extractedData = data;
        }
      }
      return extractedData;
    }

    function errorInterceptor(response, deferred) {
      $rootScope.$broadcast('restRequestError');

      // Parse our JSON error format and populate errorMessages for use in
      // controllers, etc
      var ms = [];
      if (response.data && angular.isObject(response.data.errors)) {
        for (var i in response.data.errors) {
          var e = response.data.errors[i];
          if (angular.isString(e.message)) {
            ms.push(e.message);
          }
        }
      }

      if (!angular.isObject(response.data)) {
        response.data = {};
      }
      response.data.errorMessages = ms;
      deferred.reject(response);

      return true;
    }
  }
})();

/*
 * Copyright (c) 2016 SPORTident GmbH. All rights reserved.
 */
(function () {
  'use strict';

  angular
    .module('c3poFrontend')
    .factory('HttpErrorInterceptor', HttpErrorInterceptor);

  /** @ngInject */
  function HttpErrorInterceptor($q, toastr, $injector) {
    // The interceptor is set up via $httpProvider.interceptors in the
    // index.config.js.
    var service = {
      responseError: handleResponseError,
    };

    return service;

    function handleResponseError(response) {
      var messages = {
        401: 'Please log in to access this resource',
        403: 'You are not allowed to access this resource',
        404: 'The requested resource is not available',
      };

      // We ignore errors when accessing '/account' or '/login'
      if (
        (response.config.url.indexOf('/account') === -1 ||
          response.config.method !== 'GET') &&
        response.config.url.indexOf('/login') === -1
      ) {
        // For simplicity we directly use toastr. In the future we might want to
        // use a dedicated messaging service and message display directive.
        if (messages[response.status]) {
          toastr.error(messages[response.status]);
        }

        // We need to get $state and Account via $injector to avoid a circular
        // dependency...
        var $state = $injector.get('$state');
        var Account = $injector.get('Account');

        // If we are not authenticated: First force a logout (and set the
        // principal to null), so that the whole application knows that we are
        // not authenticated anymore. Then redirect to login page, passing the
        // original route ("to" state) as a parameter to the login page so that
        // we can get redirected there after the successful login.
        if (response.status === 401) {
          Account.logout().then(function () {
            var toState = $state.getToState();
            // Avoid redirecting to login multiple times when multiple requests
            // fail at the same time
            if (toState.to !== 'login') {
              $state.go('login', {
                redirectTo: toState.to,
                redirectParams: toState.params,
              });
            }
          });

          // If we do not have permission to access a resource or the resource
          // does not exist --- directly after login (i.e. following the redirect
          // from the login page) --- then go to the start page
        } else if (
          (response.status === 403 || response.status === 404) &&
          $state.current.name === 'login'
        ) {
          $state.go('home');
        }
      }

      return $q.reject(response);
    }
  }
})();

/*
 * Copyright (c) 2016 SPORTident GmbH. All rights reserved.
 */
(function () {
  'use strict';

  angular.module('c3poFrontend').directive('hasAuthority', hasAuthority);

  /** @ngInject */
  function hasAuthority() {
    var directive = {
      restrict: 'A',
      scope: {
        principal: '=',
        hasAuthority: '=',
      },
      link: linkHasAuthority,
    };
    return directive;

    function linkHasAuthority(scope, element) {
      // Scope is not bound immediately (i.e. initially principal is null),
      // that's why we need a watch
      scope.$watch('principal', updateElementVisibility);

      function updateElementVisibility() {
        if (scope.principal && scope.hasAuthority) {
          var role = scope.hasAuthority;
          element.toggleClass('hidden', !scope.principal.hasAuthority(role));
        }
      }
    }
  }
})();

/*
 * Copyright (c) 2016 SPORTident GmbH. All rights reserved.
 */
(function () {
  'use strict';

  angular.module('c3poFrontend').directive('siFocusMe', siFocusMe);

  /** @ngInject */
  function siFocusMe() {
    var directive = {
      restrict: 'A',
      link: linkSiFocusMe,
    };
    return directive;

    function linkSiFocusMe(scope, element) {
      element[0].focus();
    }
  }
})();

/*
 * Copyright (c) 2018 SPORTident GmbH. All rights reserved.
 */
(function () {
  'use strict';

  angular.module('c3poFrontend').directive('fileInput', [
    function () {
      return {
        require: 'ngModel',
        link: function (scope, element, attrs, ctrl) {
          function createFileInputElement() {
            var fileInput = document.createElement('input');
            fileInput.type = 'file';
            if (attrs.id !== undefined) fileInput.setAttribute('id', attrs.id);
            if (attrs.name !== undefined) fileInput.name = attrs.name;
            if (attrs.class !== undefined) fileInput.className = attrs.class;
            angular.element(fileInput).on('change', function (event) {
              var files = event.target.files;
              ctrl.$setViewValue(files);
              /* Note: File input is removed and created again to ensure that
               * the change event will be triggered anew if the user selects
               * the same file again (after changing the file content).
               */
              fileInput.remove();
              createFileInputElement();
            });
            element.append(fileInput);
          }
          createFileInputElement();
        },
      };
    },
  ]);
})();

/*
 * Copyright (c) 2016 SPORTident GmbH. All rights reserved.
 */

// In the view:
// <dropdown-component model="vm.selectedUser" format="vm.users"></dropdown-component>
// model = the variable to which the value is tied to for communication
// callback = a callback function to pass the data to the directive e.g.
/*
    function callback(requestName) {
      if (requestName === 'events') {
        vm.events = getAllEventsService;
        return vm.events;
      } else if (requestName === 'users') {
        vm.users = getAllUsersService;
        return vm.users;
      }
    }
*/
// placeholder = right now the simplest way is to just specify the placeholder in the call
(function () {
  'use strict';

  angular
    .module('c3poFrontend')
    .directive('dropdownComponent', dropdownComponent);

  function dropdownComponent() {
    var directive = {
      restrict: 'E',
      templateUrl:
        'app/components/dropdown-component/dropdown-component.directive.html',
      scope: {
        model: '=',
        callback: '=',
        localCallback: '=',
        placeholder: '=',
        onSelectItem: '=?',
      },
      controller: DropdownComponentController,
      controllerAs: 'vm',
      bindToController: true,
    };
    return directive;

    /** @ngInject */
    function DropdownComponentController($timeout) {
      var vm = this;
      var mytimeout = null;

      vm.$onInit = onInit;

      function onInit() {
        vm.displayData = [];
        vm.tooltipIsOpen = false;
        vm.refreshResults = refreshResults;
        vm.setTimeout = setTimeout;
        vm.focusOnThis = focusOnThis;
        vm.selectItem = selectItem;
        vm.getSelect = getSelect;
        vm.getHighlightDisplayName = getHighlightDisplayName;
        // RefreshResults is called immediately when the template is first rendered.
        // Therefore, the following call is not needed and thus commented out.
        // vm.callback('').then(function (result) { vm.displayData = result; });
      }

      function selectItem(id) {
        if (angular.isUndefined(id)) {
          if (angular.isDefined(vm.localCallback)) {
            if (
              angular.isDefined(vm.displayData) ||
              !angular.isDefined(vm.displayData)
            ) {
              if (vm.displayData.length > 0) {
                id = vm.displayData[0].id;
              }
            }
          } else {
            if (angular.isDefined(vm.model)) {
              id = vm.model.bid;
            }
          }
        }
        if (angular.isDefined(vm.onSelectItem)) {
          vm.onSelectItem(id);
        }
      }

      function setTimeout(action, term) {
        if (action === 'start') {
          if (angular.isDefined(vm.localCallback)) {
            vm.displayData = vm.localCallback(term);
            if (vm.displayData.length === 0 && term !== '') {
              vm.tooltipIsOpen = true;
            } else {
              vm.tooltipIsOpen = false;
            }
          } else {
            mytimeout = $timeout(function () {
              vm.callback(term).then(function (result) {
                var returnArray = result.map(function (obj) {
                  if (angular.isDefined(obj)) {
                    if (angular.isDefined(obj.id)) {
                      obj.bid = obj.id;
                    }
                  }
                  return obj;
                });
                vm.displayData = returnArray;
                if (vm.displayData.length === 0 && term !== '') {
                  vm.tooltipIsOpen = true;
                } else {
                  vm.tooltipIsOpen = false;
                }
              });
            }, 350);
          }
        } else if (action === 'stop') {
          $timeout.cancel(mytimeout);
          mytimeout = null;
        }
      }

      function refreshResults($select) {
        var search = $select.search;
        vm.tooltipIsOpen = false;
        if (!search) {
          search = '';
        }
        if (mytimeout !== null) {
          vm.setTimeout('stop');
        }
        vm.setTimeout('start', search);
      }

      function getSelect($select) {
        var search = $select.search;
        if (!search) {
          search = '';
        }
        search = search.replace(/ /g, '.*');
        search = search.replace(/-/g, '.*');
        search = search.replace(/_/g, '.*');
        return new RegExp(search, 'i');
      }

      function getHighlightDisplayName(displayName, $select) {
        var search = $select.search;
        if (!search) {
          return displayName;
        }
        search = search.toLocaleLowerCase();
        search = search.replace(/ /g, '-');
        search = search.replace(/_/g, '-');
        var arrayOfSearch = search.split(new RegExp('[-]'));
        var pos2 = 0;
        var displayNameBold = '';
        if (arrayOfSearch.length === 0) {
          displayNameBold = displayName;
        } else {
          for (var word in arrayOfSearch) {
            var pos1 = displayName
              .toLocaleLowerCase()
              .substring(pos2)
              .search(arrayOfSearch[word]);
            if (pos1 === -1) {
              return displayName;
            }
            pos1 = pos1 + pos2;
            displayNameBold =
              displayNameBold + displayName.substring(pos2, pos1);
            pos2 = pos1 + arrayOfSearch[word].length;
            displayNameBold =
              displayNameBold +
              '<span class="ui-select-highlight">' +
              displayName.substring(pos1, pos2) +
              '</span>';
          }
          if (pos2 < displayName.length) {
            displayNameBold = displayNameBold + displayName.substring(pos2);
          }
        }
        return displayNameBold;
      }

      function focusOnThis(element) {
        $timeout(function () {
          var parent = element.currentTarget;
          var child = angular.element(parent.getElementsByTagName('INPUT'));
          child[0].focus();
        }, 80);
      }
    }
  }
})();

/*
 * Copyright (c) 2016 SPORTident GmbH. All rights reserved.
 */
(function () {
  'use strict';

  angular.module('c3poFrontend').directive('dateInput', dateInput);

  function dateInput() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/date-input/date-input.directive.html',
      scope: {
        ngModel: '=',
        format: '=',
        notenabled: '=',
      },
      controller: DateInputController,
      controllerAs: 'vm',
      bindToController: true,
      require: 'ngModel',
      link: function (scope, element, attrs, ctrl) {
        scope.updateModel = function (item) {
          ctrl.$setViewValue(item);
        };
      },
    };
    return directive;

    /** @ngInject */
    function DateInputController() {
      var vm = this;
      vm.$onInit = onInit;
      vm.disabled = false;

      function onInit() {
        vm.open = open;
        vm.popup = {
          opened: false,
        };
        if (angular.isUndefined(vm.notenabled)) {
          vm.disabled = false;
        } else {
          vm.disabled = vm.notenabled;
        }

        if (angular.isUndefined(vm.format)) {
          vm.formatDisplay = 'dd.MM.yyyy HH:mm';
        } else {
          vm.formatDisplay = vm.format;
        }
        vm.dateOptions = {
          formatYear: 'yy',
          maxDate: new Date(2220, 5, 22),
          minDate: new Date(2012, 1, 1),
          startingDay: 1,
        };
      }

      function open() {
        if (!vm.disabled) {
          vm.popup.opened = true;
        }
      }
    }
  }
})();

/*
 * Copyright (c) 2016 SPORTident GmbH. All rights reserved.
 *

 Example usage of this directive:
 In the controller of the view where you want this dialog to be displayed - add the lines below:
    // dialogProperties defines the display options
    // title - title of the dialog box
    // message - question or message to display in the dialog box
    // firstButtonText - the text to show on the confirmation button
    // firstButtonClass - class of the first button - use bootstrap button classes
    // secondButtonText - text of the second (by default - cancel) button

    vm.dialogProperties = {
      title: "Delete modems?",
      message: "Are you sure you want to delete selected modems?",
      firstButtonText: "Delete",
      firstButtonClass: "btn-danger",
      secondButtonText: "Cancel"};

    // open function is used to launch the dialog, this is to be added as an ng-click event
    // component - include the directive name name which is static
    // include the dialogProperties to be passed to the dialog controller
    // add functionality to then argument to determine what happens after the modal closes

    function open () {
        $uibModal.open({
            component: 'confirmationDialog',
            resolve: {
              dialogProperties: function () {
                return vm.dialogProperties;
              }
            }
          }).result.then(function () {
          // what to do after the modal is closed with the first button
        }, function () {
          // what to do if cancel is pressed - usually nothing
        });

    }

 */
(function () {
  'use strict';

  angular
    .module('c3poFrontend')
    .directive('confirmationDialog', confirmationDialog);

  function confirmationDialog() {
    var directive = {
      restrict: 'E',
      templateUrl:
        'app/components/confirmation-dialog/confirmation-dialog.directive.html',
      scope: {
        resolve: '=',
        close: '&',
        dismiss: '&',
      },
      controller: ConfirmationDialogController,
      controllerAs: 'vm',
      bindToController: true,
    };
    return directive;
  }

  function ConfirmationDialogController() {
    var vm = this;

    vm.$onInit = onInit;

    function onInit() {
      vm.title = vm.resolve.dialogProperties.title;
      vm.message = vm.resolve.dialogProperties.message;
      vm.firstButtonClass = vm.resolve.dialogProperties.firstButtonClass;
      vm.firstButtonText = vm.resolve.dialogProperties.firstButtonText;
      vm.secondButtonText = vm.resolve.dialogProperties.secondButtonText;
      vm.ok = function () {
        vm.close();
      };
      vm.cancel = function () {
        vm.dismiss({ $value: 'cancel' });
      };
    }
  }
})();

/**
 * Configure $uibModel.open to use 'static' backdrop to prevent modal dialogs from
 * closing when the user clicks outside the dialog box.
 *
 * Note: To prevent the user from closing the dialog by pressing the Esc key, the
 * option 'keyboard' would have to be set to false.
 *
 * We use Angular's $provide.decorator method to change the default behavior globally.
 *
 */
(function () {
  'use strict';

  angular.module('c3poFrontend').config(configUibModal);

  function configUibModal($provide) {
    $provide.decorator('$uibModal', decorateUibModal);
  }

  function decorateUibModal($delegate) {
    var open = $delegate.open;
    $delegate.open = function (options) {
      if (options.backdrop === undefined) {
        options = angular.extend(options || {}, {
          backdrop: 'static',
        });
      }
      return open(options);
    };
    return $delegate;
  }
})();

/*
 * Copyright (c) 2016 SPORTident GmbH. All rights reserved.
 */
(function () {
  'use strict';

  angular
    .module('c3poFrontend')
    .directive('billingAddressForm', billingAddressForm);

  function billingAddressForm() {
    var directive = {
      restrict: 'E',
      templateUrl:
        'app/components/billing-address-form/billing-address-form.directive.html',
      scope: {
        userId: '<',
        panelTitle: '@',
        saveButtonLabel: '@',
        onSave: '&?',
        cancelButtonLabel: '@',
        onCancel: '&?',
      },
      controller: BillingAddressFormController,
      controllerAs: 'vm',
      bindToController: true,
    };
    return directive;

    /** @ngInject */
    function BillingAddressFormController(UserStoreService, toastr) {
      var vm = this;

      vm.$onInit = onInit;
      vm.$onChanges = onChanges;

      function onInit() {
        vm.contact = null;
        vm.selectedCountry = null;
        vm.save = save;
        vm.cancel = cancel;
        vm.getCountries = getCountries;
        vm.selectedCountryChanged = selectedCountryChanged;
        vm.countryCodes = getCountryCodes();

        if (vm.userId !== undefined) {
          getBillingContact();
        }
      }

      function onChanges() {
        if (vm.userId !== undefined) {
          getBillingContact();
        }
      }

      function getBillingContact() {
        UserStoreService.getBillingContact(vm.userId).then(function (result) {
          vm.contact = result;
          vm.selectedCountry = getCountry(vm.contact.country);
        });
      }

      function save() {
        UserStoreService.saveBillingContact(vm.userId, vm.contact)
          .then(function (result) {
            vm.contact = result;
            if (vm.onSave) {
              vm.onSave();
            } else {
              toastr.success('Changes saved.');
            }
          })
          .catch(function (error) {
            var msgs = error.data.errorMessages.join('<br>');
            toastr.error(
              'Could not save the changes' +
                (msgs.length > 0 ? ': <br>' + msgs : '')
            );
          });
      }

      function cancel() {
        if (vm.onCancel) {
          vm.onCancel();
        }
      }

      function getCountry(id) {
        var displayName = vm.countryCodes[id];
        if (displayName !== undefined) {
          return { id: id, displayName: vm.countryCodes[id] };
        } else {
          return null;
        }
      }

      function getCountries(term) {
        var countryList = Object.keys(vm.countryCodes).map(function (key) {
          return { id: key, displayName: vm.countryCodes[key] };
        });
        countryList.sort(function (a, b) {
          return a.displayName > b.displayName
            ? 1
            : b.displayName > a.displayName
            ? -1
            : 0;
        });
        countryList = countryList.filter(function (a) {
          return a.displayName.toLowerCase().includes(term.toLowerCase());
        });
        return countryList;
      }

      function selectedCountryChanged(id) {
        vm.selectedCountry = getCountry(id);
        if (vm.selectedCountry != null) {
          vm.contact.country = id;
        } else {
          vm.contact.country = null;
        }
      }

      function getCountryCodes() {
        return {
          AD: 'Andorra',
          AE: 'United Arab Emirates',
          AF: 'Afghanistan',
          AG: 'Antigua and Barbuda',
          AI: 'Anguilla',
          AL: 'Albania',
          AM: 'Armenia',
          AO: 'Angola',
          AQ: 'Antarctica',
          AR: 'Argentina',
          AS: 'American Samoa',
          AT: 'Austria',
          AU: 'Australia',
          AW: 'Aruba',
          AX: 'Åland Islands',
          AZ: 'Azerbaijan',
          BA: 'Bosnia and Herzegovina',
          BB: 'Barbados',
          BD: 'Bangladesh',
          BE: 'Belgium',
          BF: 'Burkina Faso',
          BG: 'Bulgaria',
          BH: 'Bahrain',
          BI: 'Burundi',
          BJ: 'Benin',
          BL: 'Saint Barthélemy',
          BM: 'Bermuda',
          BN: 'Brunei Darussalam',
          BO: 'Bolivia (Plurinational State of)',
          BQ: 'Bonaire, Sint Eustatius and Saba',
          BR: 'Brazil',
          BS: 'Bahamas',
          BT: 'Bhutan',
          BV: 'Bouvet Island',
          BW: 'Botswana',
          BY: 'Belarus',
          BZ: 'Belize',
          CA: 'Canada',
          CC: 'Cocos (Keeling) Islands',
          CD: 'Congo, Democratic Republic of the',
          CF: 'Central African Republic',
          CG: 'Congo',
          CH: 'Switzerland',
          CI: "Côte d'Ivoire",
          CK: 'Cook Islands',
          CL: 'Chile',
          CM: 'Cameroon',
          CN: 'China',
          CO: 'Colombia',
          CR: 'Costa Rica',
          CU: 'Cuba',
          CV: 'Cabo Verde',
          CW: 'Curaçao',
          CX: 'Christmas Island',
          CY: 'Cyprus',
          CZ: 'Czechia',
          DE: 'Germany',
          DJ: 'Djibouti',
          DK: 'Denmark',
          DM: 'Dominica',
          DO: 'Dominican Republic',
          DZ: 'Algeria',
          EC: 'Ecuador',
          EE: 'Estonia',
          EG: 'Egypt',
          EH: 'Western Sahara',
          ER: 'Eritrea',
          ES: 'Spain',
          ET: 'Ethiopia',
          FI: 'Finland',
          FJ: 'Fiji',
          FK: 'Falkland Islands (Malvinas)',
          FM: 'Micronesia (Federated States of)',
          FO: 'Faroe Islands',
          FR: 'France',
          GA: 'Gabon',
          GB: 'United Kingdom of Great Britain and Northern Ireland',
          GD: 'Grenada',
          GE: 'Georgia',
          GF: 'French Guiana',
          GG: 'Guernsey',
          GH: 'Ghana',
          GI: 'Gibraltar',
          GL: 'Greenland',
          GM: 'Gambia',
          GN: 'Guinea',
          GP: 'Guadeloupe',
          GQ: 'Equatorial Guinea',
          GR: 'Greece',
          GS: 'South Georgia and the South Sandwich Islands',
          GT: 'Guatemala',
          GU: 'Guam',
          GW: 'Guinea-Bissau',
          GY: 'Guyana',
          HK: 'Hong Kong',
          HM: 'Heard Island and McDonald Islands',
          HN: 'Honduras',
          HR: 'Croatia',
          HT: 'Haiti',
          HU: 'Hungary',
          ID: 'Indonesia',
          IE: 'Ireland',
          IL: 'Israel',
          IM: 'Isle of Man',
          IN: 'India',
          IO: 'British Indian Ocean Territory',
          IQ: 'Iraq',
          IR: 'Iran (Islamic Republic of)',
          IS: 'Iceland',
          IT: 'Italy',
          JE: 'Jersey',
          JM: 'Jamaica',
          JO: 'Jordan',
          JP: 'Japan',
          KE: 'Kenya',
          KG: 'Kyrgyzstan',
          KH: 'Cambodia',
          KI: 'Kiribati',
          KM: 'Comoros',
          KN: 'Saint Kitts and Nevis',
          KP: "Korea (Democratic People's Republic of)",
          KR: 'Korea, Republic of',
          KW: 'Kuwait',
          KY: 'Cayman Islands',
          KZ: 'Kazakhstan',
          LA: "Lao People's Democratic Republic",
          LB: 'Lebanon',
          LC: 'Saint Lucia',
          LI: 'Liechtenstein',
          LK: 'Sri Lanka',
          LR: 'Liberia',
          LS: 'Lesotho',
          LT: 'Lithuania',
          LU: 'Luxembourg',
          LV: 'Latvia',
          LY: 'Libya',
          MA: 'Morocco',
          MC: 'Monaco',
          MD: 'Moldova, Republic of',
          ME: 'Montenegro',
          MF: 'Saint Martin (French part)',
          MG: 'Madagascar',
          MH: 'Marshall Islands',
          MK: 'Macedonia, the former Yugoslav Republic of',
          ML: 'Mali',
          MM: 'Myanmar',
          MN: 'Mongolia',
          MO: 'Macao',
          MP: 'Northern Mariana Islands',
          MQ: 'Martinique',
          MR: 'Mauritania',
          MS: 'Montserrat',
          MT: 'Malta',
          MU: 'Mauritius',
          MV: 'Maldives',
          MW: 'Malawi',
          MX: 'Mexico',
          MY: 'Malaysia',
          MZ: 'Mozambique',
          NA: 'Namibia',
          NC: 'New Caledonia',
          NE: 'Niger',
          NF: 'Norfolk Island',
          NG: 'Nigeria',
          NI: 'Nicaragua',
          NL: 'Netherlands',
          NO: 'Norway',
          NP: 'Nepal',
          NR: 'Nauru',
          NU: 'Niue',
          NZ: 'New Zealand',
          OM: 'Oman',
          PA: 'Panama',
          PE: 'Peru',
          PF: 'French Polynesia',
          PG: 'Papua New Guinea',
          PH: 'Philippines',
          PK: 'Pakistan',
          PL: 'Poland',
          PM: 'Saint Pierre and Miquelon',
          PN: 'Pitcairn',
          PR: 'Puerto Rico',
          PS: 'Palestine, State of',
          PT: 'Portugal',
          PW: 'Palau',
          PY: 'Paraguay',
          QA: 'Qatar',
          RE: 'Réunion',
          RO: 'Romania',
          RS: 'Serbia',
          RU: 'Russian Federation',
          RW: 'Rwanda',
          SA: 'Saudi Arabia',
          SB: 'Solomon Islands',
          SC: 'Seychelles',
          SD: 'Sudan',
          SE: 'Sweden',
          SG: 'Singapore',
          SH: 'Saint Helena, Ascension and Tristan da Cunha',
          SI: 'Slovenia',
          SJ: 'Svalbard and Jan Mayen',
          SK: 'Slovakia',
          SL: 'Sierra Leone',
          SM: 'San Marino',
          SN: 'Senegal',
          SO: 'Somalia',
          SR: 'Suriname',
          SS: 'South Sudan',
          ST: 'Sao Tome and Principe',
          SV: 'El Salvador',
          SX: 'Sint Maarten (Dutch part)',
          SY: 'Syrian Arab Republic',
          SZ: 'Eswatini',
          TC: 'Turks and Caicos Islands',
          TD: 'Chad',
          TF: 'French Southern Territories',
          TG: 'Togo',
          TH: 'Thailand',
          TJ: 'Tajikistan',
          TK: 'Tokelau',
          TL: 'Timor-Leste',
          TM: 'Turkmenistan',
          TN: 'Tunisia',
          TO: 'Tonga',
          TR: 'Turkey',
          TT: 'Trinidad and Tobago',
          TV: 'Tuvalu',
          TW: 'Taiwan, Province of China',
          TZ: 'Tanzania, United Republic of',
          UA: 'Ukraine',
          UG: 'Uganda',
          UM: 'United States Minor Outlying Islands',
          US: 'United States of America',
          UY: 'Uruguay',
          UZ: 'Uzbekistan',
          VA: 'Holy See',
          VC: 'Saint Vincent and the Grenadines',
          VE: 'Venezuela (Bolivarian Republic of)',
          VG: 'Virgin Islands (British)',
          VI: 'Virgin Islands (U.S.)',
          VN: 'Viet Nam',
          VU: 'Vanuatu',
          WF: 'Wallis and Futuna',
          WS: 'Samoa',
          YE: 'Yemen',
          YT: 'Mayotte',
          ZA: 'South Africa',
          ZM: 'Zambia',
          ZW: 'Zimbabwe',
        };
      }
    }
  }
})();

/*
 * Copyright (c) 2016 SPORTident GmbH. All rights reserved.
 */
(function () {
  'use strict';

  angular
    .module('c3poFrontend')
    .directive('batteryIndicator', batteryIndicator);

  function batteryIndicator() {
    var directive = {
      restrict: 'E',
      templateUrl:
        'app/components/battery-indicator/battery-indicator.directive.html',
      scope: {
        batteryLevel: '=battery',
        hoverValue: '=hover',
      },
      controller: BatteryIndicatorController,
      controllerAs: 'vm',
      bindToController: true,
    };
    return directive;

    /** @ngInject */
    function BatteryIndicatorController() {
      var vm = this;

      vm.$onInit = onInit;

      function onInit() {
        var battery = vm.batteryLevel;
        var batteryVoltage = vm.hoverValue;
        battery = battery < 0 ? 0 : battery > 100 ? 100 : battery;
        vm.batteryDisplay = battery;

        if (battery === null || batteryVoltage <= 2.5) {
          vm.returnBattery = -1;
        } else if (battery >= 80 && battery <= 100) {
          vm.returnBattery = 4;
        } else if (battery >= 60 && battery < 80) {
          vm.returnBattery = 3;
        } else if (battery >= 40 && battery < 60) {
          vm.returnBattery = 2;
        } else if (battery >= 10 && battery < 40) {
          vm.returnBattery = 1;
        } else if (battery >= 0 && battery < 10) {
          vm.returnBattery = 0;
        }
      }
    }
  }
})();

/*
 * Copyright (c) 2016 SPORTident GmbH. All rights reserved.
 */
(function () {
  'use strict';

  angular.module('c3poFrontend').factory('Account', Account);

  /*
   * Class Principal
   */
  function Principal(account) {
    // Account is / should be immutable
    this.account = angular.copy(account);
  }

  Principal.prototype.isAuthenticated = function () {
    return this.account !== null;
  };
  Principal.prototype.hasAuthority = function (authority) {
    if (!this.isAuthenticated()) {
      return false;
    } else {
      var id = this.getAccount();
      return id.authorities && id.authorities.indexOf(authority) !== -1;
    }
  };

  Principal.prototype.getAccount = function () {
    return this.account;
  };

  /*
   * Account service
   */
  /** @ngInject */
  function Account(Restangular, $http, $q, $rootScope) {
    var account = null;

    var service = {
      getPrincipal: getPrincipal,
      save: save,
      login: login,
      logout: logout,
      changePassword: changePassword,
      requestPasswordReset: requestPasswordReset,
      resetPassword: resetPassword,
      resetApiKey: resetApiKey,
      register: register,
      getSiteToken: getSiteToken,
    };

    return service;

    function get(force) {
      var deferred = $q.defer();

      if (force === true) {
        account = null;
      }

      if (account !== null) {
        deferred.resolve(account);
      } else {
        Restangular.one('account')
          .get()
          .then(getAccountSucceeded)
          .catch(getAccountFailed);
      }

      return deferred.promise;

      function getAccountSucceeded(account_) {
        if (account !== account_) {
          account = account_;
          $rootScope.$broadcast('principalChanged');
        }
        deferred.resolve(account);
      }

      function getAccountFailed() {
        if (account !== null) {
          account = null;
          $rootScope.$broadcast('principalChanged');
        }
        deferred.resolve(account);
      }
    }

    function getPrincipal() {
      var deferred = $q.defer();

      get().then(function (account) {
        deferred.resolve(new Principal(account));
      });

      return deferred.promise;
    }

    function save(a_) {
      var a = {
        login: a_.login,
        firstName: a_.firstName,
        lastName: a_.lastName,
        email: a_.email,
      };
      for (var k in a) {
        if (angular.isUndefined(a[k]) || a[k] === null) {
          a[k] = '';
        }
      }
      return Restangular.one('account')
        .customPUT(a)
        .then(function () {
          get(true);
        });
    }

    function login(username, password) {
      var credentials =
        'username=' +
        encodeURIComponent(username) +
        '&password=' +
        encodeURIComponent(password) +
        '&submit=Login';

      return $http.post('/login', credentials, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      });
    }

    function logout() {
      var promise = $http.post('/logout');
      promise.finally(function () {
        if (account !== null) {
          account = null;
          $rootScope.$broadcast('principalChanged');
        }
      });
      return promise;
    }

    function changePassword(oldPassword, newPassword) {
      var o = { oldPassword: oldPassword, newPassword: newPassword };
      return Restangular.one('account').post('change_password', o);
    }

    function requestPasswordReset(email) {
      return Restangular.one('account')
        .one('reset_password')
        .post('init', { email: email });
    }

    function resetPassword(key, newPassword) {
      return Restangular.one('account')
        .one('reset_password')
        .post('finish', { key: key, newPassword: newPassword });
    }

    function resetApiKey() {
      return Restangular.one('account')
        .post('reset_apikey')
        .then(function () {
          return get(true).then(function (account) {
            return account;
          });
        });
    }

    function register(activationKey, userId) {
      return Restangular.one('public/account')
        .post('activate', { activationKey: activationKey, userId: userId })
        .then(function () {
          return get(true).then(function (account) {
            return account;
          });
        });
    }

    function getSiteToken() {
      return Restangular.one('public').one('account').one('site').get();
    }
  }
})();

/*
 * Copyright (c) 2016 SPORTident GmbH. All rights reserved.
 */
(function () {
  'use strict';

  angular
    .module('c3poFrontend')
    .controller('UserListController', UserListController);

  /** @ngInject */
  function UserListController(
    $timeout,
    moment,
    UserStoreService,
    PersistentParamsService,
    $state,
    toastr,
    $uibModal
  ) {
    var vm = this;

    vm.$onInit = onInit;

    function onInit() {
      vm.initialLoading = true;

      vm.toggleState = 'all';
      vm.showToolbar = false;
      vm.activatedFilter = true;

      vm.dialogProperties = {
        title: 'Delete users',
        message: 'Are you sure you want to delete the selected users?',
        firstButtonText: 'Delete',
        firstButtonClass: 'btn-danger',
        secondButtonText: 'Cancel',
      };

      // Functions
      vm.confirmDeleteDialog = confirmDeleteDialog;
      vm.toggleActive = toggleActive;
      vm.toggleSort = toggleSort;
      vm.toggleRoleFilter = toggleRoleFilter;
      vm.toggleActivatedFilter = toggleActivatedFilter;
      vm.editView = editView;
      vm.getUsers = getUsers;
      vm.clearParams = clearParams;
      vm.selectedUserChanged = selectedUserChanged;
      vm.getUserCountTooltipHtml = getUserCountTooltipHtml;
      vm.gotToPage = goToPage;

      checkStateParams();

      if (angular.isDefined($state.params.activated)) {
        vm.activatedFilter = $state.params.activated;
      }

      if (angular.isDefined($state.params.user)) {
        if (angular.isDefined($state.params.role)) {
          $state.params.role = undefined;
          setPersistentParamsAndReload();
        }
        UserStoreService.getUser($state.params.user).then(function (result) {
          vm.selectedUser = {
            id: result.id,
            displayName: result.firstName + ' ' + result.lastName,
            noReload: true,
          };
        });
      }

      getAllUsers();
    }

    function getAllUsers() {
      vm.displayLoadingIcon = true;
      UserStoreService.getAllUsers($state.params)
        .then(function (result) {
          vm.users = result;
          adjustUsers();
          vm.initialLoading = false;
          // Hiding the loading icon is done with a delay to make sure that icon is visible
          // for at least a short time. This way the user has a visual indication that
          // the refresh action was actually performed.
          $timeout(function () {
            vm.displayLoadingIcon = false;
          }, 200);
        })
        .catch(function () {
          vm.displayLoadingIcon = false;
        });
    }

    function selectedUserChanged(id) {
      if (angular.isUndefined(id)) {
        if ($state.params.activated === false) {
          $state.params.user = undefined;
          $state.params.page = undefined;
          $state.params.sort = undefined;
          $state.params.role = undefined;
          setPersistentParamsAndReload();
        } else {
          clearParams();
        }
      } else {
        $state.params.user = id;
        $state.params.page = undefined;
        $state.params.sort = undefined;
        $state.params.role = undefined;
        setPersistentParamsAndReload();
      }
    }

    function confirmDeleteDialog() {
      var selected = getSelectedUsers();
      if (selected.length === 0) {
        toastr.error('Select users to delete');
      } else {
        $uibModal
          .open({
            component: 'confirmationDialog',
            resolve: {
              dialogProperties: function () {
                return vm.dialogProperties;
              },
            },
          })
          .result.then(
            function () {
              deleteUsers();
            },
            function () {}
          );
      }
    }

    function getSelectedUsers() {
      return vm.users.filter(function (u) {
        return u.selected === true;
      });
    }

    function toggleActive(pathName) {
      var buttonName = pathName;
      vm.toggleState = buttonName;
      vm.editing = true;
      if (buttonName === 'closeall') {
        vm.editing = false;
        var selected = vm.users.filter(function (u) {
          return u.selected === true;
        });
        selected.map(function (obj) {
          obj.selected = false;
        });
        vm.toggleState = 'all';
      } else if (buttonName === 'showfilters') {
        if (vm.showToolbar === false) {
          vm.showToolbar = true;
          vm.toggleState = 'all';
        } else {
          vm.showToolbar = false;
          vm.toggleState = 'all';
        }
      }
    }

    function toggleSort(sortValue) {
      if (vm.activesort !== sortValue) {
        $state.params.sort = sortValue;
        $state.params.page = undefined;
        setPersistentParamsAndReload();
      }
    }

    function toggleRoleFilter(filterValue) {
      if (angular.isDefined($state.params.user)) {
        return;
      }
      vm.activefilter = filterValue;
      if (filterValue === 'allroles') {
        $state.params.role = undefined;
        $state.params.page = undefined;
        setPersistentParamsAndReload();
      } else {
        $state.params.role = filterValue;
        $state.params.page = undefined;
        setPersistentParamsAndReload();
      }
    }

    function toggleActivatedFilter() {
      if (angular.isDefined($state.params.user)) {
        return;
      }
      vm.activatedFilter = !vm.activatedFilter;
      $state.params.activated = vm.activatedFilter;
      setPersistentParamsAndReload();
    }

    function editView(user) {
      var currentuser = user;
      if (vm.toggleState !== 'all') {
        if (currentuser.selected === false) {
          currentuser.selected = true;
        } else if (currentuser.selected === true) {
          currentuser.selected = false;
        }
      }
    }

    function deleteUsers() {
      var selected = getSelectedUsers();
      if (selected.length > 0) {
        UserStoreService.deleteUsers(selected).then(
          function () {
            clearParams();
            if (selected.length === 1) {
              toastr.success(selected.length + ' user was deleted');
            } else {
              toastr.success(selected.length + ' users were deleted');
            }
          },
          function (error) {
            toastr.error(
              'There was an error deleting users: <br>' +
                error.data.errorMessages[0]
            );
          }
        );
      } else {
        toastr.error('Select users to delete');
      }
    }

    function adjustUsers() {
      for (var i = 0; i < vm.users.length; i++) {
        var u = vm.users[i];
        u.selected = false;
        if (u.status.lastLogin !== null) {
          u.status.lastLoginDisplay = moment
            .utc(u.status.lastLogin)
            .local()
            .fromNow();
          u.status.lastLoginHover = moment
            .utc(u.status.lastLogin)
            .local()
            .format('MMMM D, YYYY HH:mm:ss');
        }
        if (u.status.lastStampActivity !== null) {
          u.status.lastStampActivityDisplay = moment
            .utc(u.status.lastStampActivity)
            .local()
            .fromNow();
          u.status.lastStampActivityHover = moment
            .utc(u.status.lastStampActivity)
            .local()
            .format('MMMM D, YYYY HH:mm:ss');
        }
        u.getAuthority = u.authorities.indexOf('ROLE_ADMIN');
      }
    }

    function getUsers(term) {
      return UserStoreService.getSelectedUsers(
        term,
        true,
        $state.params.activated
      );
    }

    function getUserCountTooltipHtml() {
      return (
        '' +
        vm.users.totalCount.toString() +
        ' users in total<br />' +
        vm.users.length.toString() +
        ' users in this list'
      );
    }

    function goToPage(page) {
      if (page === 0) {
        $state.params.page = undefined;
      } else {
        $state.params.page = page;
      }
      setPersistentParamsAndReload();
    }

    function setPersistentParamsAndReload() {
      PersistentParamsService.setParamsUsers($state.params);
      $state.go($state.current, $state.params, { reload: true });
    }

    function checkStateParams() {
      if (hasAtLeastOneDefinedStateParam()) {
        PersistentParamsService.setParamsUsers($state.params);
      } else {
        var params = PersistentParamsService.getParamsUsers();
        if (params) {
          $state.params = params;
        }
        if (hasAtLeastOneDefinedStateParam()) {
          $state.go($state.current, $state.params, { reload: true });
        }
      }
    }

    function hasAtLeastOneDefinedStateParam() {
      for (var k in $state.params) {
        if (angular.isDefined($state.params[k])) {
          return true;
        }
      }
      return false;
    }

    function clearParams() {
      for (var k in $state.params) {
        $state.params[k] = undefined;
      }
      setPersistentParamsAndReload();
    }
  }
})();

/*
 * Copyright (c) 2016 SPORTident GmbH. All rights reserved.
 */
(function () {
  'use strict';

  angular
    .module('c3poFrontend')
    .controller('UserEditController', UserEditController);

  /** @ngInject */
  function UserEditController(
    UserStoreService,
    OrganisationStoreService,
    $state,
    toastr,
    moment,
    Account,
    $stateParams
  ) {
    var vm = this;

    vm.$onInit = onInit;
    vm.isNotOrgAdmin = isNotOrgAdmin;
    vm.getOrganisations = getOrganisations;
    vm.selectedOrganisationChanged = selectedOrganisationChanged;
    vm.getLoadedUserOrganisation = getLoadedUserOrganisation;

    function onInit() {
      vm.userTitle = 'New User';
      vm.saveButtonText = 'Create';
      vm.saveUser = saveUser;
      vm.resetApiKey = resetApiKey;
      vm.sendActivationEmail = sendActivationEmail;
      vm.selectedOrganisation = '';
      vm.disableOrganisation = false;
      vm.slugPlaceholder = 'Choose a unique string for URL';
      vm.showSlugPlaceholder = showSlugPlaceholder;

      Account.getPrincipal().then(function (principal) {
        vm.principal = principal.getAccount();
        vm.userIsAdmin = vm.principal.authorities.indexOf('ROLE_ADMIN') !== -1;
      });
      UserStoreService.getUser($stateParams.userId).then(function (result) {
        vm.user = result;
        var i;
        if (vm.user.id === 'new') {
          vm.userTitle = 'New User';
          vm.saveButtonText = 'Create';
          vm.setAuthority('user');
          vm.user.userOrganisations = [
            {
              authorities: null,
              userId: null,
              organisationId: 1,
              organisation: { id: 1, name: 'Not assigned', slug: 'org' },
            },
          ];
          vm.user.userOrganisations[0].authorities = ['ROLE_ORG_MEMBER'];
        } else {
          vm.userTitle = 'User ' + vm.user.login;
          vm.saveButtonText = 'Save';
          var getAuthority = vm.user.authorities.indexOf('ROLE_ADMIN');
          if (getAuthority === 1) {
            vm.authorityClass = 'admin';
          } else {
            vm.authorityClass = 'user';
          }
        }
        for (i = 0; i < vm.user.userOrganisations.length; i++) {
          if (
            vm.user.userOrganisations.length === 1 ||
            vm.user.userOrganisations[i].organisationId !== 1
          ) {
            vm.shownUserOrganisation = JSON.parse(
              JSON.stringify(vm.user.userOrganisations[i])
            );
            if (vm.isNotOrgAdmin(vm.shownUserOrganisation)) {
              vm.disableOrganisation = true;
            } else {
              vm.disableOrganisation = false;
            }
          }
        }
      });
      vm.setAuthority = setAuthority;
    }

    function setAuthority(authority) {
      if (authority === 'user') {
        vm.user.authorities = ['ROLE_USER'];
        vm.authorityClass = 'user';
      } else if (authority === 'admin') {
        vm.user.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        vm.authorityClass = 'admin';
      }
    }

    function saveUser() {
      if (vm.user.id === 'new') {
        vm.user.activated = true;
        vm.user.language = 'en';
        vm.user.resetKey = null;
        vm.user.resetDate = null;
      }
      var i;
      var isOrgSet = false;
      if (
        vm.shownUserOrganisation.organisation.slug === null ||
        vm.shownUserOrganisation.organisation.slug === ''
      ) {
        vm.shownUserOrganisation.organisation.slug = vm.shownUserOrganisation.organisation.name
          .toLowerCase()
          .replace(new RegExp(' |\\.|_', 'g'), '-')
          .replace(new RegExp('[^a-z0-9-]+', 'g'), '');
      } else {
        vm.shownUserOrganisation.organisation.slug = vm.shownUserOrganisation.organisation.slug
          .toLowerCase()
          .replace(new RegExp(' |\\.|_', 'g'), '-')
          .replace(new RegExp('[^a-z0-9-]+', 'g'), '');
      }
      for (i = 0; i < vm.user.userOrganisations.length; i++) {
        // delete if not assigned is selected
        if (
          vm.shownUserOrganisation.organisationId === 1 ||
          isOrgSet === true
        ) {
          if (vm.user.userOrganisations[i].organisationId !== 1) {
            vm.user.userOrganisations.splice(i, 1);
          }
        } else {
          if (
            vm.user.userOrganisations[i].organisationId !== 1 ||
            vm.shownUserOrganisation.organisationId === null
          ) {
            vm.user.userOrganisations[i] = JSON.parse(
              JSON.stringify(vm.shownUserOrganisation)
            );
            isOrgSet = true;
          } else {
            if (
              vm.user.userOrganisations.length === 1 &&
              vm.user.userOrganisations[i].organisationId === 1
            ) {
              vm.user.userOrganisations[i] = JSON.parse(
                JSON.stringify(vm.shownUserOrganisation)
              );
            }
          }
        }
      }
      UserStoreService.saveUser(vm.user)
        .then(saveUserSucceeded)
        .catch(saveUserFailed);
    }

    function saveUserSucceeded() {
      // TODO: behaviour is not consistent with e.g. adding an athlete
      if (vm.user.id === 'new') {
        toastr.success('Created user "' + vm.user.login + '"');
      } else {
        toastr.success('Changes saved');
      }
      $state.go('users');
    }

    function saveUserFailed(error) {
      var msg;
      if (vm.user.id === 'new') {
        msg = 'Could not create user "' + vm.user.login + '"';
      } else {
        msg = 'Could not save changes';
      }
      var ms = error.data.errorMessages;
      if (ms.length > 0) {
        msg += ': <br />' + ms.join(', <br />');
      }

      toastr.error(msg);
    }

    function resetApiKey() {
      UserStoreService.resetUserApiKey(vm.user).then(
        function successCallback() {
          $state.go($state.current, {}, { reload: true });
          toastr.success('API key reset successfully');
        },
        function errorCallback() {
          toastr.error('Error resetting API key');
        }
      );
    }

    function isNotOrgAdmin(userOrganisation) {
      if (vm.userIsAdmin) return false;
      var isNotAdmin = true;
      userOrganisation.authorities.forEach(function (a) {
        if (typeof a === 'string' && a.indexOf('ROLE_ORG_ADMIN') > -1) {
          isNotAdmin = false;
        }
      });
      return isNotAdmin;
    }

    function getOrganisations(term) {
      vm.term = term;
      return OrganisationStoreService.getSelectedOrganisations(
        term,
        null,
        true
      );
    }

    function selectedOrganisationChanged(id) {
      if (angular.isUndefined(id) || id === null) {
        vm.shownUserOrganisation.organisation.name = vm.term;
        if (vm.term == null || vm.term === '') {
          vm.shownUserOrganisation.organisation.slug = '';
        } else {
          vm.shownUserOrganisation.organisation.slug = vm.term
            .replace(' ', '-')
            .replace('_', '-')
            .toLowerCase()
            .concat('-slug');
        }
        vm.shownUserOrganisation.id = null;
        vm.shownUserOrganisation.organisationId = null;
        vm.shownUserOrganisation.organisation.id = null;
        vm.disableOrganisation = false;
      } else {
        var i = vm.getLoadedUserOrganisation(id);
        if (i < 0) {
          vm.shownUserOrganisation.organisation = JSON.parse(
            JSON.stringify(vm.selectedOrganisation)
          );
          vm.shownUserOrganisation.organisationId = id;
          vm.shownUserOrganisation.authorities = ['ROLE_ORG_MEMBER'];
          vm.disableOrganisation = true;
        } else {
          // this saves the existing authorities and relations
          vm.shownUserOrganisation = JSON.parse(
            JSON.stringify(vm.user.userOrganisations[i])
          );
          if (vm.isNotOrgAdmin(vm.shownUserOrganisation)) {
            vm.disableOrganisation = true;
          } else {
            vm.disableOrganisation = false;
          }
        }
      }
    }

    function getLoadedUserOrganisation(id) {
      var i;
      for (i = 0; i < vm.user.userOrganisations.length; i++) {
        if (vm.user.userOrganisations[i].organisationId === id) return i;
      }
      return -1;
    }

    function showSlugPlaceholder() {
      vm.slugPlaceholder = vm.shownUserOrganisation.organisation.name
        .toLowerCase()
        .replace(new RegExp(' |\\.|_', 'g'), '-')
        .replace(new RegExp('[^a-z0-9-]+', 'g'), '');
    }

    function sendActivationEmail() {
      UserStoreService.sendActivationEmail(vm.user).then(
        function successCallback() {
          toastr.success('Activation email sent.');
        },
        function errorCallback() {
          toastr.error('Failed to send activation email.');
        }
      );
    }
  }
})();

/*
 * Copyright (c) 2019 SPORTident GmbH. All rights reserved.
 */
(function () {
  'use strict';

  angular
    .module('c3poFrontend')
    .controller('SubscriptionNewController', SubscriptionNewController);

  /** @ngInject */
  function SubscriptionNewController(
    $state,
    moment,
    toastr,
    Account,
    SubscriptionStoreService,
    UserStoreService
  ) {
    var vm = this;
    vm.$onInit = onInit;

    function onInit() {
      // Action is either start/renew or upgrade.
      vm.isUpgradeAction = false;

      // Logged in user is admin.
      vm.userIsAdmin = false;

      // User for which the subscription is started/upgraded. Not necessarily the same as the logged in user.
      // We need a separate field userId because user object is lazy loaded.
      vm.selectedUserId = undefined;
      vm.selectedUser = null;
      vm.billingEmail = null;
      vm.billingContact = null;

      // For all modes we need to know if the user has an active subscription.
      // We also load additional information such as if a trial subscription is still available.
      vm.existingSubscription = {};
      vm.trialAvailable = false;
      vm.billingContact = {};

      // For the overview we need to load all available subscription types.
      // For the form we just need to load the selected subscription type.
      vm.subscriptionTypes = [];
      vm.subscriptionType = null;

      // The subscription action hold all parameters required for the POST request to start, renew or upgrade a subscription.
      vm.subscriptionAction = null;

      // For the start/renew/upgrade form, there are three steps.
      vm.step = 1;
      vm.termsAccepted = false;
      vm.autoRenew = undefined;

      // Entered promotion code is validated by get-action request.
      vm.promoCode = null;
      vm.isValidPromoCode = null;

      // Methods accessible from the template.
      vm.changeAutoRenew = changeAutoRenew;
      vm.changeTermsAccepted = changeTermsAccepted;
      vm.updateSubscriptionAction = updateSubscriptionAction;
      vm.continueToStep2 = continueToStep2;
      vm.continueToStep3 = continueToStep3;
      vm.backToStep1 = backToStep1;
      vm.backToStep2 = backToStep2;
      vm.confirmSubscription = confirmSubscription;

      // We distinguish between admin users and regular users.
      Account.getPrincipal().then(function (promise) {
        // Determine if the controll has been accessed to start/renew or upgrade a subscription.
        vm.isUpgradeAction = $state.current.name === 'subscription.upgrade';
        // User needs to be logged in to load display view.
        vm.principal = promise;
        const user = vm.principal.getAccount();
        if (!user) {
          $state.go('login');
          return;
        }
        vm.userIsAdmin = user.authorities.indexOf('ROLE_ADMIN') !== -1;
        // Admins may start or upgrade the subscription of another user. In this case userId is set.
        if ($state.params.user) {
          getUser($state.params.user);
        } else {
          vm.selectedUserId = user.id;
          vm.selectedUser = user;
        }
        // Load existing subscription information.
        // Then continue loading information depending on the type of action.
        SubscriptionStoreService.getSubscriptionOfUser(vm.selectedUserId)
          .then(function (result) {
            vm.existingSubscription = result;
            vm.existingSubscription.endDateDisplayText = moment
              .utc(vm.existingSubscription.endDate)
              .format('MMMM D, YYYY');
            if (vm.existingSubscription.subscriptionType) {
              vm.autoRenew = vm.existingSubscription.autoRenew;
            }
            if (!vm.isUpgradeAction) {
              initializeSubscriptionStart();
            } else {
              initializeSubscriptionUpgrade();
            }
          })
          .catch(function () {
            console.error('Failed to load subscription.');
            $state.go('subscription');
          });
      });
    }

    function getUser(userId) {
      vm.selectedUserId = userId;
      UserStoreService.getUser(userId)
        .then(function (result) {
          vm.selectedUser = result;
        })
        .catch(function () {
          // Ignore. Information is only required to display the user name.
          // If the data is not avilable, the starting/upgrading functionality is not affected.
        });
    }

    function initializeSubscriptionStart() {
      if (!$state.params.type) {
        // User has not yet selected a subscription type. Show overview.
        getAvailableSubscriptionTypes('start');
      } else {
        // User has selected a specific subscription type. Load type and action. Show form.
        getSubscriptionTypeForStartAction($state.params.type);
      }
    }

    function initializeSubscriptionUpgrade() {
      if (!$state.params.type) {
        // User has not yet selected a subscription type. Show overview.
        getAvailableSubscriptionTypes('upgrade');
      } else {
        // User has selected a specific subscription type. Load type and action. Show form.
        getSubscriptionTypeForUpgradeAction($state.params.type);
      }
    }

    function getAvailableSubscriptionTypes(action) {
      SubscriptionStoreService.getSubscriptionTypes(action, vm.selectedUserId)
        .then(function (result) {
          vm.trialAvailable = false;
          vm.subscriptionTypes = [];
          result.forEach(function (st) {
            st.isAvailable = true;
          });
          if (action === 'upgrade' && vm.existingSubscription) {
            result.unshift(vm.existingSubscription.subscriptionType);
          }
          processSubscriptionTypes(result);
        })
        .catch(function () {
          console.error('Failed to load subscription types.');
          $state.go('subscription');
        });
    }

    function processSubscriptionTypes(subscriptionTypes) {
      subscriptionTypes.forEach(function (st) {
        if (!st.isTrial) {
          st.featureList = [
            'OCAD import',
            'Competitor database',
            'Publish results online',
            'Export results',
          ];
          // Add the corresponding trial subscription, if it exists
          var t = subscriptionTypes.find(function (e) {
            return e.isTrial && e.renewTo === st.id;
          });
          if (t !== undefined) {
            st.trialId = t.id;
          }
          vm.subscriptionTypes.push(st);
        } else {
          // Set flag for determining the appropriate classes for uniform box height in the template.
          vm.trialAvailable = true;
        }
      });
    }

    function getSubscriptionTypeForStartAction(subscriptionTypeId) {
      SubscriptionStoreService.getSubscriptionType(subscriptionTypeId)
        .then(function (result) {
          vm.subscriptionType = result;
          getSubscriptionStartAction();
        })
        .catch(function () {
          console.error('Failed to load subscription type.');
          $state.go('subscription');
        });
    }

    function getSubscriptionStartAction() {
      SubscriptionStoreService.getSubscriptionStartAction(
        vm.selectedUserId,
        vm.subscriptionType.id,
        vm.promoCode
      )
        .then(function (result) {
          vm.subscriptionAction = result;
          onSubscriptionActionChanged();
        })
        .catch(function () {
          console.error('Failed to load subscription action.');
          $state.go('subscription');
        });
    }

    function getSubscriptionTypeForUpgradeAction(subscriptionTypeId) {
      SubscriptionStoreService.getSubscriptionType(subscriptionTypeId)
        .then(function (result) {
          vm.subscriptionType = result;
          getSubscriptionUpgradeAction();
        })
        .catch(function () {
          console.error('Failed to load subscription type.');
          $state.go('subscription');
        });
    }

    function getSubscriptionUpgradeAction() {
      SubscriptionStoreService.getSubscriptionUpgradeAction(
        vm.selectedUserId,
        vm.subscriptionType.id,
        vm.promoCode
      )
        .then(function (result) {
          vm.subscriptionAction = result;
          onSubscriptionActionChanged();
        })
        .catch(function () {
          console.error('Failed to load subscription action.');
          $state.go('subscription');
        });
    }

    function changeAutoRenew() {
      vm.autoRenew = !vm.autoRenew;
      vm.subscriptionAction.autoRenew = vm.autoRenew;
    }

    function changeTermsAccepted() {
      vm.termsAccepted = !vm.termsAccepted;
    }

    function updateSubscriptionAction() {
      if (vm.isUpgradeAction) {
        getSubscriptionUpgradeAction();
      } else {
        getSubscriptionStartAction();
      }
    }

    function onSubscriptionActionChanged() {
      vm.subscriptionAction.startDateDisplayText = moment
        .utc(vm.subscriptionAction.startDate)
        .format('MMMM D, YYYY');
      vm.subscriptionAction.endDateDisplayText = moment
        .utc(vm.subscriptionAction.endDate)
        .format('MMMM D, YYYY');
      vm.subscriptionAction.subscriptionPeriodMonths = moment
        .utc(vm.subscriptionAction.endDate)
        .clone()
        .add(1, 'days')
        .diff(moment.utc(vm.subscriptionAction.startDate), 'months');
      vm.subscriptionAction.subscriptionPeriodDays = moment
        .utc(vm.subscriptionAction.endDate)
        .clone()
        .add(1, 'days')
        .diff(moment.utc(vm.subscriptionAction.startDate), 'days');
      vm.subscriptionAction.subscriptionPeriodDaysDisplayText =
        vm.subscriptionAction.subscriptionPeriodDays +
        (vm.subscriptionAction.subscriptionPeriodDays === 1 ? ' day' : ' days');
      vm.subscriptionAction.priceDisplayText = vm.subscriptionAction.price;
      vm.isValidPromoCode = vm.subscriptionAction.promoCode !== null;
      // As long as the user has not set an option for the autoRenew flag, the default value is taken
      // from the get-action response. As soon as the user has selcted an option, the user selection
      // overwrites the value of the action.
      if (vm.autoRenew === undefined) {
        vm.autoRenew = vm.subscriptionAction.autoRenew;
      } else {
        vm.subscriptionAction.autoRenew = vm.autoRenew;
      }
      // Update price display text.
      onPriceChanged();
    }

    function onPriceChanged() {
      vm.subscriptionAction.priceDisplayText = '';
      const totalAmount =
        vm.subscriptionAction.price - vm.subscriptionAction.refund;
      if (totalAmount > 0.0) {
        if (!vm.isUpgradeAction) {
          vm.subscriptionAction.priceDisplayText =
            parseFloat(totalAmount).toFixed(2) +
            ' € (for the whole subscription period)';
        } else {
          vm.subscriptionAction.priceDisplayText =
            parseFloat(totalAmount).toFixed(2) +
            ' € (upgrade for the remaining ' +
            vm.subscriptionAction.subscriptionPeriodDaysDisplayText +
            ')';
        }
      } else {
        vm.subscriptionAction.priceDisplayText = 'free';
      }
      if (vm.promoCode && vm.isValidPromoCode) {
        vm.subscriptionAction.priceDisplayText += ' (with promo code)';
      }
    }

    function continueToStep2() {
      if (vm.promoCode && !vm.isValidPromoCode) {
        toastr.error('The promo code is not valid.');
      } else {
        vm.step = 2;
      }
    }

    function backToStep1() {
      vm.step = 1;
    }

    function backToStep2() {
      vm.step = 2;
    }

    function continueToStep3() {
      UserStoreService.getBillingContact(vm.selectedUserId)
        .then(function (result) {
          vm.billingContact = result;
          vm.step = 3;
        })
        .catch(function (err) {
          // Ignore for now.
          console.log('Error', err);
        });
    }

    function confirmSubscription() {
      if (!vm.termsAccepted) {
        toastr.error(
          'Please read and accept the terms and conditions and privacy policy.'
        );
        return;
      }
      if (vm.isUpgradeAction) {
        upgradeSubscription();
      } else {
        startSubscription();
      }
    }

    function startSubscription() {
      SubscriptionStoreService.startSubscription(
        vm.selectedUserId,
        vm.subscriptionAction
      )
        .then(function (result) {
          toastr.success('Subscription confirmed.');
          $state.go('subscription');
        })
        .catch(function (error) {
          var msgs = error.data.errorMessages.join('<br>');
          toastr.error(
            'Could not create the subscription' +
              (msgs.length > 0 ? ': <br>' + msgs : '')
          );
        });
    }

    function upgradeSubscription() {
      SubscriptionStoreService.upgradeSubscription(
        vm.selectedUserId,
        vm.subscriptionAction
      )
        .then(function (result) {
          toastr.success('Subscription confirmed.');
          $state.go('subscription');
        })
        .catch(function (error) {
          var msgs = error.data.errorMessages.join('<br>');
          toastr.error(
            'Could not upgrade the subscription' +
              (msgs.length > 0 ? ': <br>' + msgs : '')
          );
        });
    }
  }
})();

/*
 * Copyright (c) 2019 SPORTident GmbH. All rights reserved.
 */
(function () {
  'use strict';

  angular
    .module('c3poFrontend')
    .controller('SubscriptionListController', SubscriptionListController);

  /** @ngInject */
  function SubscriptionListController(
    moment,
    $state,
    toastr,
    Account,
    SubscriptionStoreService,
    UserStoreService,
    PersistentParamsService
  ) {
    var vm = this;
    vm.$onInit = onInit;

    function onInit() {
      vm.initialLoading = true;
      vm.userIsAdmin = false;
      vm.hidePagination = false;
      vm.subscriptionTypes = [];
      vm.subscriptions = [];
      vm.users = [];
      vm.selectedUser = null;
      vm.subscription = {};
      vm.upgradeAvailable = false;
      vm.activeState = undefined;

      vm.getUsers = getUsers;
      vm.selectedUserChanged = selectedUserChanged;
      vm.goToPage = goToPage;
      vm.clearParams = clearParams;
      vm.disableAutoRenew = disableAutoRenew;
      vm.enableAutoRenew = enableAutoRenew;
      vm.setActiveState = setActiveState;

      checkStateParams();
      vm.activeState = $state.params.active ? $state.params.active : 'true';

      Account.getPrincipal().then(function (promise) {
        vm.principal = promise;
        var account = vm.principal.getAccount();
        vm.userIsAdmin = account.authorities.indexOf('ROLE_ADMIN') !== -1;
        if (!vm.userIsAdmin) {
          vm.selectedUser = {
            id: account.id,
            displayName: account.firstName + ' ' + account.lastName,
          };
          getSubscriptionOfUser(vm.selectedUser.id);
        } else if (!$state.params.user) {
          getUsersWithSubscription();
        } else {
          UserStoreService.getUser($state.params.user)
            .then(function (result) {
              vm.selectedUser = result;
              vm.selectedUser.displayName =
                result.firstName + ' ' + result.lastName;
              getSubscriptionOfUser(vm.selectedUser.id);
            })
            .catch(function () {
              vm.displayLoadingIcon = false;
            });
        }
      });
    }

    function getUsersWithSubscription() {
      SubscriptionStoreService.getSubscriptionTypes()
        .then(function (result) {
          vm.subscriptionTypes = result;
          SubscriptionStoreService.getUsersWithSubscription($state.params)
            .then(function (result) {
              vm.users = result;
              var pageSize = $state.params.size
                ? $state.params.size
                : SubscriptionStoreService.defaultPageSize;
              if (vm.users.totalCount > pageSize) {
                vm.hidePagination = false;
              } else {
                vm.hidePagination = true;
              }
              for (var i = 0; i < vm.users.length; i++) {
                vm.users[
                  i
                ].subscription.subscriptionTypeDisplayText = getSubscriptionTypeName(
                  vm.users[i].subscription.subscriptionTypeId
                );
                vm.users[i].subscription.endDateDisplayText = moment
                  .utc(vm.users[i].subscription.endDate)
                  .format('MMMM D, YYYY');
              }
              vm.initialLoading = false;
            })
            .catch(function () {
              vm.users = [];
              vm.initialLoading = false;
              vm.displayLoadingIcon = false;
            });
        })
        .catch(function () {
          vm.displayLoadingIcon = false;
        });
    }

    function getSubscriptionTypeName(typeId) {
      for (var i = 0; i < vm.subscriptionTypes.length; i++) {
        if (typeId === vm.subscriptionTypes[i].id) {
          return 'Orienteering ' + vm.subscriptionTypes[i].prettyName;
        }
      }
      return '';
    }

    function getSubscriptionOfUser(userId) {
      SubscriptionStoreService.getSubscriptionOfUser(userId)
        .then(function (result) {
          vm.subscription = result;
          checkIfUpgradeIsAvailable(vm.selectedUser.id);
          onSubscriptionChanged();
          vm.initialLoading = false;
        })
        .catch(function () {
          vm.displayLoadingIcon = false;
        });
    }

    function checkIfUpgradeIsAvailable(userId) {
      vm.upgradeAvailable =
        vm.subscription.active && !vm.subscription.subscriptionType.isTrial;
      /*
      SubscriptionStoreService.getSubscriptionTypes('upgrade', userId)
        .then(function (result) {
          const availableSubscriptionTypesForUpgrade = result;
          if (availableSubscriptionTypesForUpgrade.length > 0) {
            vm.upgradeAvailable = true;
          }
        }).catch(function () {
          // Ignored. The only effect if this request fails is that upgrade button will not be enabled.
        });
      */
    }

    function onSubscriptionChanged() {
      if (vm.subscription.subscriptionType) {
        vm.subscription.startDateDisplayText = moment
          .utc(vm.subscription.startDate)
          .format('MMMM D, YYYY');
        vm.subscription.endDateDisplayText = moment
          .utc(vm.subscription.endDate)
          .format('MMMM D, YYYY');
        vm.subscription.endsInLessThanAYear = moment
          .utc(vm.subscription.endDate)
          .subtract(1, 'year')
          .isBefore(moment.utc().startOf('day'));
      } else if (!vm.userIsAdmin) {
        $state.go('subscription.new', {}, { reload: true });
      }
    }

    function getUsers(term) {
      return UserStoreService.getSelectedUsers(term, false, true);
    }

    function selectedUserChanged(id) {
      $state.params.user = id;
      PersistentParamsService.setParamsSubscriptions($state.params);
      $state.go($state.current, $state.params, { reload: true });
    }

    function goToPage(page) {
      if (page === 0) {
        $state.params.page = undefined;
      } else {
        $state.params.page = page;
      }
      PersistentParamsService.setParamsSubscriptions($state.params);
      $state.go($state.current, $state.params, { reload: true });
    }

    function checkStateParams() {
      if (hasAtLeastOneDefinedStateParam()) {
        PersistentParamsService.setParamsSubscriptions($state.params);
      } else {
        var params = PersistentParamsService.getParamsSubscriptions();
        if (params) {
          $state.params = params;
        }
        if (hasAtLeastOneDefinedStateParam()) {
          $state.go($state.current, $state.params, { reload: true });
        }
      }
    }

    function hasAtLeastOneDefinedStateParam() {
      for (var k in $state.params) {
        if (angular.isDefined($state.params[k])) {
          return true;
        }
      }
      return false;
    }

    function clearParams() {
      for (var k in $state.params) {
        $state.params[k] = undefined;
      }
      PersistentParamsService.setParamsSubscriptions($state.params);
      $state.go($state.current, $state.params, { reload: true });
    }

    function disableAutoRenew() {
      setAutoRenew(false);
    }

    function enableAutoRenew() {
      setAutoRenew(true);
    }

    function setAutoRenew(value) {
      vm.subscription.autoRenew = value;
      SubscriptionStoreService.updateSubscription(
        vm.selectedUser.id,
        vm.subscription
      )
        .then(function (result) {
          vm.subscription = result;
          onSubscriptionChanged();
          if (vm.subscription.autoRenew) {
            toastr.success('Automatic renewal enabled.');
          } else {
            toastr.success('Automatic renewal disabled.');
          }
        })
        .catch(function (error) {
          vm.subscription.autoRenew = !value;
          var msgs = error.data.errorMessages.join('<br>');
          toastr.error(
            'Could not update subscription' +
              (msgs.length > 0 ? ': <br>' + msgs : '')
          );
        });
    }

    function setActiveState(value) {
      if (vm.selectedUser) {
        // Filter buttons are deactivated if a user is selected.
        return;
      }
      $state.params.active = value;
      PersistentParamsService.setParamsSubscriptions($state.params);
      $state.go($state.current, $state.params, { reload: true });
    }
  }
})();

/*
 * Copyright (c) 2019 SPORTident GmbH. All rights reserved.
 */
(function () {
  'use strict';

  angular
    .module('c3poFrontend')
    .controller('SubscriptionEditController', SubscriptionEditController);

  /** @ngInject */
  function SubscriptionEditController(
    $state,
    moment,
    toastr,
    Account,
    SubscriptionStoreService
  ) {
    var vm = this;
    vm.$onInit = onInit;

    vm.changeAutoRenew = changeAutoRenew;
    vm.changeActivated = changeActivated;
    vm.startDateChanged = startDateChanged;
    vm.endDateChanged = endDateChanged;
    vm.save = save;

    function onInit() {
      vm.userIsAdmin = false;
      vm.subscription = null;
      vm.startDate = null;
      vm.endDate = null;
      vm.subscriptionTypes = [];

      Account.getPrincipal().then(function (promise) {
        const userIsAdmin =
          promise.getAccount().authorities.indexOf('ROLE_ADMIN') !== -1;
        if (!userIsAdmin) {
          $state.go('subscription');
          return;
        }
        getSubscription();
        getSubscriptionTypes();
      });
    }

    function getSubscription() {
      SubscriptionStoreService.getSubscriptionOfUser($state.params.user)
        .then(function (result) {
          vm.subscription = result;
          vm.startDate = moment.utc(vm.subscription.startDate).toDate();
          vm.endDate = moment.utc(vm.subscription.endDate).toDate();
        })
        .catch(function () {
          console.error('Failed to get subscription.');
          $state.go('subscription');
        });
    }

    function getSubscriptionTypes() {
      SubscriptionStoreService.getSubscriptionTypes()
        .then(function (result) {
          vm.subscriptionTypes = result;
          for (var i = 0; i < vm.subscriptionTypes.length; i++) {
            vm.subscriptionTypes[i].prettyName =
              'Orienteering ' + vm.subscriptionTypes[i].prettyName;
          }
        })
        .catch(function () {
          console.error('Failed to get subscription types.');
          $state.go('subscription');
        });
    }

    function changeAutoRenew() {
      if (vm.subscription.isPastSubscription) {
        return;
      }
      vm.subscription.autoRenew = !vm.subscription.autoRenew;
    }

    function changeActivated() {
      if (vm.subscription.isPastSubscription) {
        return;
      }
      vm.subscription.activated = !vm.subscription.activated;
    }

    function startDateChanged() {
      vm.subscription.startDate = moment(vm.startDate)
        .local()
        .format('YYYY-MM-DD');
    }

    function endDateChanged() {
      vm.subscription.endDate = moment(vm.endDate).local().format('YYYY-MM-DD');
    }

    function save() {
      vm.subscription.subscriptionType = vm.subscriptionTypes.filter(function (
        subscriptionType
      ) {
        return subscriptionType.id === vm.subscription.subscriptionTypeId;
      })[0];
      SubscriptionStoreService.updateSubscription(
        $state.params.user,
        vm.subscription
      )
        .then(function () {
          toastr.success('Subscription updated.');
          $state.go('subscription');
        })
        .catch(function (error) {
          var msgs = error.data.errorMessages.join('<br>');
          toastr.error(
            'Could not update subscription' +
              (msgs.length > 0 ? ': <br>' + msgs : '')
          );
        });
    }
  }
})();

/*
 * Copyright (c) 2019 SPORTident GmbH. All rights reserved.
 */
(function () {
  'use strict';

  angular
    .module('c3poFrontend')
    .controller('PromoCodeListController', PromoCodeListController);

  /** @ngInject */
  function PromoCodeListController(
    moment,
    $state,
    $location,
    Account,
    PromoCodeStoreService,
    PersistentParamsService
  ) {
    var vm = this;
    vm.$onInit = onInit;

    function onInit() {
      vm.initialLoading = true;
      vm.userIsAdmin = false;
      vm.promoCodes = [];
      vm.hidePagination = false;

      vm.goToPage = goToPage;
      vm.clearParams = clearParams;

      checkStateParams();

      Account.getPrincipal()
        .then(function (promise) {
          vm.principal = promise;
          var account = vm.principal.getAccount();
          vm.userIsAdmin = account
            ? account.authorities.indexOf('ROLE_ADMIN') !== -1
            : false;
          if (!vm.userIsAdmin) {
            $state.go('login');
            return;
          }
          getAllPromoCodes();
        })
        .catch(function (error) {
          console.log('Error', error);
        });
    }

    function getAllPromoCodes() {
      PromoCodeStoreService.getPromoCodes($state.params)
        .then(function (result) {
          vm.promoCodes = result;
          var pageSize = $state.params.size
            ? $state.params.size
            : PromoCodeStoreService.defaultPageSize;
          if (vm.promoCodes.totalCount > pageSize) {
            vm.hidePagination = false;
          } else {
            vm.hidePagination = true;
          }
          for (var i = 0; i < vm.promoCodes.length; i++) {
            vm.promoCodes[i].issuanceDateDisplayValue = moment(
              vm.promoCodes[i].issuanceDateTime
            ).format('MMMM D, YYYY');
            vm.promoCodes[i].expirationDateDisplayValue = moment(
              vm.promoCodes[i].expirationDateTime
            ).format('MMMM D, YYYY');
            vm.promoCodes[i].redeemedDateDisplayValue = moment(
              vm.promoCodes[i].redeemedDateTime
            ).format('MMMM D, YYYY');
          }
          vm.initialLoading = false;
        })
        .catch(function (error) {
          vm.displayLoadingIcon = false;
          console.log('Error', error);
        });
    }

    function goToPage(page) {
      if (page === 0) {
        $state.params.page = undefined;
      } else {
        $state.params.page = page;
      }
      PersistentParamsService.setParamsPromoCodes($state.params);
      $state.go($state.current, $state.params, { reload: true });
    }

    function checkStateParams() {
      if (hasAtLeastOneDefinedStateParam()) {
        PersistentParamsService.setParamsPromoCodes($state.params);
      } else {
        var params = PersistentParamsService.getParamsPromoCodes();
        if (params) {
          $state.params = params;
        }
        if (hasAtLeastOneDefinedStateParam()) {
          $state.go($state.current, $state.params, { reload: true });
        }
      }
    }

    function hasAtLeastOneDefinedStateParam() {
      for (var k in $state.params) {
        if (angular.isDefined($state.params[k])) {
          return true;
        }
      }
      return false;
    }

    function clearParams() {
      for (var k in $state.params) {
        $state.params[k] = undefined;
      }
      PersistentParamsService.setParamsPromoCodes($state.params);
      $state.go($state.current, $state.params, { reload: true });
    }
  }
})();

/*
 * Copyright (c) 2019 SPORTident GmbH. All rights reserved.
 */
(function () {
  'use strict';

  angular
    .module('c3poFrontend')
    .controller('PromoCodeEditController', PromoCodeEditController);

  /** @ngInject */
  function PromoCodeEditController(
    $state,
    $stateParams,
    moment,
    toastr,
    Account,
    PromoCodeStoreService,
    $location
  ) {
    var vm = this;
    vm.$onInit = onInit;

    function onInit() {
      vm.params = {};
      vm.addNew = false;
      vm.promoCode = null;
      vm.promoCodeType = null;
      vm.promoCodeTypes = null;
      vm.expirationDate = null;

      vm.expirationDateChanged = expirationDateChanged;
      vm.insert = insert;
      vm.update = update;

      vm.promoCodeId = $stateParams.promoCodeId;
      if (vm.promoCodeId === 'new') {
        vm.addNew = true;
        checkUrlParams();
        if (!vm.params.type) {
          goToPromoCodeList();
          return;
        }
      }

      Account.getPrincipal()
        .then(function (promise) {
          vm.principal = promise;
          var account = vm.principal.getAccount();
          vm.userIsAdmin = account
            ? account.authorities.indexOf('ROLE_ADMIN') !== -1
            : false;
          if (!vm.userIsAdmin) {
            $state.go('login');
            return;
          }
          getPromoCodeTypes();
        })
        .catch(function () {
          vm.displayLoadingIcon = false;
          toastr.error('Failed to load account information.');
        });
    }

    function getPromoCodeTypes() {
      PromoCodeStoreService.getPromoCodeTypes()
        .then(function (result) {
          vm.promoCodeTypes = result;
          if (vm.addNew) {
            vm.promoCodeType = getPromoCodeType(vm.params.type);
            if (vm.promoCodeType) {
              createPromoCode();
            } else {
              toastr.error('Promo code type does not exist.');
              goToPromoCodeList();
            }
          } else {
            loadPromoCode();
          }
        })
        .catch(function () {
          vm.displayLoadingIcon = false;
          toastr.error('Failed to load promo code types.');
        });
    }

    function loadPromoCode() {
      PromoCodeStoreService.getPromoCode(vm.promoCodeId)
        .then(function (result) {
          vm.promoCode = result;
          vm.promoCodeType = getPromoCodeType(vm.promoCode.typeId);
          vm.expirationDate = moment(vm.promoCode.expirationDateTime)
            .local()
            .toDate();
        })
        .catch(function () {
          vm.displayLoadingIcon = false;
          toastr.error('Failed to load promo code.');
        });
    }

    function createPromoCode() {
      PromoCodeStoreService.getRandomPromoCode(vm.promoCodeType.id)
        .then(function (result) {
          vm.promoCodeType = vm.promoCodeType;
          vm.promoCode = {
            typeId: vm.promoCodeType.id,
            code: result.code,
            customerName: '',
            customerEmail: '',
            comment: '',
          };
          vm.expirationDate = moment()
            .add(vm.promoCodeType.defaultLifetime, 'days')
            .local()
            .toDate();
          expirationDateChanged();
        })
        .catch(function () {
          vm.displayLoadingIcon = false;
          toastr.error('Failed to initialise promo code.');
        });
    }

    function checkUrlParams() {
      vm.params = {};
      var currentUrl = $location.search();
      if (Object.keys(currentUrl).length !== 0) {
        if (angular.isDefined(currentUrl.type)) {
          vm.params.type = currentUrl.type;
        }
      }
    }

    function expirationDateChanged() {
      vm.promoCode.expirationDateTime =
        moment(vm.expirationDate).local().format('YYYY-MM-DD') + 'T23:59:59Z';
    }

    function getPromoCodeType(typeId) {
      for (var i = 0; i < vm.promoCodeTypes.length; i++) {
        if (vm.promoCodeTypes[i].id.toString() === typeId.toString()) {
          return vm.promoCodeTypes[i];
        }
      }
      return null;
    }

    function insert() {
      PromoCodeStoreService.postPromoCode(vm.promoCode)
        .then(function () {
          toastr.success('Promotion code created.');
          goToPromoCodeList();
        })
        .catch(function (error) {
          var msg = 'Could not create promotion code';
          var ms = error.data.errorMessages;
          if (ms.length > 0) {
            msg += ': <br />' + ms.join(', <br />');
          }
          toastr.error(msg);
        });
    }

    function update() {
      PromoCodeStoreService.putPromoCode(vm.promoCode)
        .then(function () {
          toastr.success('Promotion code updated.');
          goToPromoCodeList();
        })
        .catch(function (error) {
          var msg = 'Could not save changes';
          var ms = error.data.errorMessages;
          if (ms.length > 0) {
            msg += ': <br />' + ms.join(', <br />');
          }
          toastr.error(msg);
        });
    }

    function goToPromoCodeList() {
      $state.go('subscription.promocodes.list');
    }
  }
})();

/*
 * Copyright (c) 2019 SPORTident GmbH. All rights reserved.
 */
(function () {
  'use strict';

  angular
    .module('c3poFrontend')
    .controller('ProcessorListController', ProcessorListController);

  /** @ngInject */
  function ProcessorListController(
    $state,
    Account,
    ProcessorStoreService,
    EventStoreService,
    PersistentParamsService
  ) {
    var vm = this;
    vm.$onInit = onInit;

    function onInit() {
      vm.initialLoading = true;
      vm.showToolbar = false;
      vm.unassigned = EventStoreService.getNotAssignedEventId();
      vm.toggleState = 'all';
      // Functions
      vm.clearParams = clearParams;
      vm.selectedFamilyChanged = selectedFamilyChanged;
      vm.selectedEventChanged = selectedEventChanged;
      vm.showProcessors = showProcessors;
      vm.navigationChange = navigationChange;
      vm.refreshProcessors = refreshProcessors;
      vm.reloadSiteWithParams = reloadSiteWithParams;
      vm.checkStateParams = checkStateParams;
      vm.toggleActive = toggleActive;
      vm.showHistory = showHistory;
      vm.getEvents = getEvents;
      vm.stateVisibility = stateVisibility;

      Account.getPrincipal().then(function (promise) {
        vm.principal = promise;
        var account = vm.principal.getAccount();
        vm.userIsAdmin = account.authorities.indexOf('ROLE_ADMIN') !== -1;
      });
      checkStateParams();
      // Update location and selection (filter) boxes
      if (angular.isDefined($state.params)) {
        if (angular.isDefined($state.params.event)) {
          EventStoreService.getEvent($state.params.event).then(function (
            result
          ) {
            vm.selectedEvent = {
              id: result.id,
              name: result.name,
              displayName: result.name,
              noReload: true,
            };
          });
        }
      }
      if ($state.params.family === undefined) {
        vm.processorFamily = 'all';
      } else {
        vm.processorFamily = $state.params.family;
      }
      ProcessorStoreService.getProcessorFamilies()
        .then(function (result) {
          vm.processorFamilys = result;
          vm.processorFamilys.splice(0, 0, 'all');
        })
        .catch(function () {
          vm.displayLoadingIcon = false;
        });
      getAllProcessors();
    }

    function getAllProcessors() {
      ProcessorStoreService.getAllProcessors(
        $state.params.family,
        $state.params.event,
        $state.params.state,
        true,
        $state.params.page,
        $state.params.sort,
        $state.params.size
      )
        .then(function (result) {
          vm.processors = result;
          vm.processors.forEach(function (m) {
            m.selected = false;
          });
          vm.initialLoading = false;
        })
        .catch(function () {
          vm.displayLoadingIcon = false;
        });
    }

    // Manually triggered refresh of processor list.
    function refreshProcessors() {
      getAllProcessors();
    }

    function selectedFamilyChanged(id) {
      $state.params.family = id;
      reloadSiteWithParams();
    }

    function selectedEventChanged(id) {
      $state.params.event = id;
      reloadSiteWithParams();
    }

    function showProcessors(state) {
      $state.params.state = state;
      reloadSiteWithParams();
    }

    function stateVisibility(state) {
      if (
        state === 'ALL' &&
        (angular.isUndefined($state.params.state) ||
          $state.params.state === 'ALL')
      ) {
        return true;
      }
      if (state === 'START' && $state.params.state === 'START') return true;
      if (state === 'STOP' && $state.params.state === 'STOP') return true;
      return false;
    }

    function navigationChange(page) {
      if (page === 0) {
        $state.params.page = undefined;
      } else {
        $state.params.page = page;
      }
      reloadSiteWithParams();
    }

    function checkStateParams() {
      if (hasAtLeastOneDefinedStateParam()) {
        PersistentParamsService.setParamsProcessors($state.params);
      } else {
        var params = PersistentParamsService.getParamsProcessors();
        if (angular.isDefined(params)) {
          $state.params = params;
        }
        if (hasAtLeastOneDefinedStateParam()) {
          $state.go($state.current, $state.params, { reload: true });
        }
      }
    }

    function hasAtLeastOneDefinedStateParam() {
      for (var k in $state.params) {
        if (angular.isDefined($state.params[k])) {
          return true;
        }
      }
      return false;
    }

    function clearParams() {
      for (var k in $state.params) {
        $state.params[k] = undefined;
      }
      reloadSiteWithParams();
    }

    function reloadSiteWithParams() {
      PersistentParamsService.setParamsProcessors($state.params);
      $state.go($state.current, $state.params, { reload: true });
    }

    function toggleActive(variable) {
      var buttonName = variable;
      vm.toggleState = buttonName;
      if (buttonName === 'showfilters') {
        if (vm.showToolbar === false) {
          vm.showToolbar = true;
          vm.toggleState = 'all';
        } else {
          vm.showToolbar = false;
          vm.toggleState = 'all';
        }
      }
    }
    function showHistory(m1) {
      if (!m1.selected) {
        vm.processors.forEach(function (m) {
          m.selected = false;
        });
      }
      m1.selected = !m1.selected;
      ProcessorStoreService.getAllProcessors(
        m1.family,
        m1.event,
        undefined,
        false,
        $state.params.page,
        $state.params.sort,
        $state.params.size
      )
        .then(function (result) {
          vm.displayLoadingIcon = false;
          vm.processorsHist = result;
          vm.processorsHist.shift();
        })
        .catch(function () {
          vm.displayLoadingIcon = false;
        });
    }

    function getEvents(term) {
      return EventStoreService.getSelectedEvents(term, true);
    }
  }
})();

/*
 * Copyright (c) 2016 SPORTident GmbH. All rights reserved.
 */
(function () {
  'use strict';

  angular
    .module('c3poFrontend')
    .controller('ModemListController', ModemListController);

  /** @ngInject */
  function ModemListController(
    $timeout,
    $q,
    moment,
    $state,
    toastr,
    Account,
    ModemStoreService,
    EventStoreService,
    UserStoreService,
    PersistentParamsService,
    $uibModal,
    $location
  ) {
    var vm = this;
    var displayLoadingIconTimer;
    var autoRefreshTimeoutInMs = 30000;
    var params;

    vm.$onInit = onInit;

    function onInit() {
      vm.initialLoading = true;
      vm.showToolbar = false;
      vm.unassigned = EventStoreService.getNotAssignedEventId();
      vm.toggleState = 'all';
      vm.deleteDialogProperties = {
        title: 'Delete modems',
        message: 'Are you sure you want to delete the selected modems?',
        firstButtonText: 'Delete',
        firstButtonClass: 'btn-danger',
        secondButtonText: 'Cancel',
      };
      vm.ownershipDialogPropertiesEvent = {
        title: 'Modem ownership',
        message:
          'An event and its modems must have the same owner. ' +
          'Not all of the modems have the same owner as the event you are assigning them to. ' +
          'Change the owner of these modems to the owner of the event?',
        firstButtonText: 'Change owner',
        firstButtonClass: 'btn-danger',
        secondButtonText: 'Cancel',
      };
      vm.ownershipDialogPropertiesUser = {
        title: 'Modem ownership',
        message:
          'An event and its modems must have the same owner. Some of the selected modems are ' +
          'assigned to events with a different owner than the newly selected one. ' +
          'Unassign modems from events with different owners than the newly selected one?',
        firstButtonText: 'Unassign modems',
        firstButtonClass: 'btn-danger',
        secondButtonText: 'Cancel',
      };
      vm.clearLabelsDialogProperties = {
        title: 'Clear Labels',
        message: 'Would you like to clear the labels of the selected modems?',
        firstButtonText: 'Yes: Clear labels',
        firstButtonClass: 'btn-danger',
        secondButtonText: 'No: Keep labels',
      };

      // Functions
      vm.confirmDeleteDialog = confirmDeleteDialog;
      vm.confirmOwnershipEvents = confirmOwnershipEvents;
      vm.confirmOwnershipUser = confirmOwnershipUser;
      vm.getUsers = getUsers;
      vm.getEvents = getEvents;
      vm.getModems = getModems;
      vm.getUsersForAssignment = getUsersForAssignment;
      vm.getEventsForAssignment = getEventsForAssignment;
      vm.toggleActive = toggleActive;
      vm.editView = editView;
      vm.clearParams = clearParams;
      vm.getModemCountTooltipHtml = getModemCountTooltipHtml;
      /* sticky header
      $window.onscroll = function(){
        //vm.scrollPos = $document[0].body.scrollTop || $document[0].documentElement.scrollTop || 0;
        $scope.$apply(); //or simply $scope.$digest();
        if ($document[0].body.scrollTop > 133) {
          vm.stickHeader = true;
        } else {
          vm.stickHeader = false;
        }
      };
      */
      vm.selectedUserChanged = selectedUserChanged;
      vm.selectedModemChanged = selectedModemChanged;
      vm.selectedEventChanged = selectedEventChanged;
      vm.showAllModems = showAllModems;
      vm.showOnlineModems = showOnlineModems;
      vm.showOfflineModems = showOfflineModems;
      vm.sortLastActivity = sortLastActivity;
      vm.sortExternalId = sortExternalId;
      vm.sortLabel = sortLabel;
      vm.navigationChange = navigationChange;
      vm.refreshModems = refreshModems;

      Account.getPrincipal().then(function (promise) {
        vm.principal = promise;
        var account = vm.principal.getAccount();
        vm.userIsAdmin = account.authorities.indexOf('ROLE_ADMIN') !== -1;
      });
      params = PersistentParamsService.getParamsModems();
      checkUrlParams();
      if (angular.isUndefined(params)) {
        undefineAllParams();
      }
      // Update location and selection (filter) boxes
      if (angular.isDefined(params)) {
        if (angular.isDefined(params.user)) {
          UserStoreService.getUser(params.user).then(function (result) {
            vm.selectedUser = {
              id: result.id,
              firstName: result.firstName,
              lastName: result.lastName,
              displayName: result.firstName + ' ' + result.lastName,
              noReload: true,
            };
          });
        }
        if (angular.isDefined(params.event)) {
          EventStoreService.getEvent(params.event).then(function (result) {
            vm.selectedEvent = {
              id: result.id,
              name: result.name,
              displayName: result.name,
              noReload: true,
            };
          });
        }
        if (angular.isDefined(params.modem)) {
          ModemStoreService.getModem(params.modem).then(function (result) {
            vm.selectedModem = {
              id: result.id,
              displayName: result.externId,
              noReload: true,
            };
          });
        }
        clearRefreshTimer();
        $location
          .path('/modems')
          .search('user', params.user)
          .search('event', params.event)
          .search('modem', params.modem)
          .search('active', params.active)
          .search('sort', params.sort)
          .search('page', params.page);
      }
      getAllModems();
    }

    function getAllModems() {
      vm.activesort = params.sort;
      vm.activestate = params.active;
      ModemStoreService.getAllModems(
        params.page,
        params.sort,
        params.active,
        params.event,
        params.user,
        params.modem
      )
        .then(function (result) {
          vm.modems = result;
          adjustModems();
          vm.initialLoading = false;
          // Hiding the loading icon is done with a delay to make sure that icon is visible
          // for at least a short time. This way the user has a visual indication that
          // the refresh action was actually performed.
          clearDisplayLoadingIconTimer();
          displayLoadingIconTimer = $timeout(clearDisplayLoadingIcon, 200);
          clearRefreshTimer();
          params.refreshTimer = $timeout(refreshModems, autoRefreshTimeoutInMs);
          PersistentParamsService.setParamsModems(params);
        })
        .catch(function () {
          vm.displayLoadingIcon = false;
        });
    }

    // Manually triggered refresh of modem list.
    function refreshModems() {
      clearRefreshTimer();
      // If the page changed don't load
      if ($location.path() === '/modems') {
        $timeout.cancel(clearDisplayLoadingIcon);
        vm.displayLoadingIcon = true;
        getAllModems();
      }
    }

    function clearRefreshTimer() {
      var resistensParams = PersistentParamsService.getParamsModems();
      if (angular.isDefined(resistensParams) && resistensParams.refreshTimer) {
        $timeout.cancel(resistensParams.refreshTimer);
      }
      if (params.refreshTimer) {
        if (
          angular.isDefined(resistensParams) &&
          resistensParams.refreshTimer &&
          resistensParams.refreshTimer !== params.refreshTimer
        ) {
          $timeout.cancel(params.refreshTimer);
        }
        // params.refreshTimer = null;
        PersistentParamsService.setParamsModems(params);
      }
    }

    function clearDisplayLoadingIcon() {
      if (displayLoadingIconTimer) {
        vm.displayLoadingIcon = false;
      }
    }

    function clearDisplayLoadingIconTimer() {
      if (displayLoadingIconTimer) {
        $timeout.cancel(params.refreshTimer);
      }
    }

    function selectedUserChanged(id) {
      var changed = false;
      params = PersistentParamsService.getParamsModems();
      if (params.user !== id) {
        changed = true;
      }
      if (angular.isUndefined(id)) {
        clearParams();
        return;
      }

      if (changed === true) {
        undefineFilterParams();
        params.user = id;
        clearRefreshTimer();
        $location
          .path('/modems')
          .search('user', params.user)
          .search('event', undefined)
          .search('modem', undefined);
      }
    }

    function selectedModemChanged(id) {
      var changed = false;
      params = PersistentParamsService.getParamsModems();
      if (params.modem !== id) {
        changed = true;
      }
      if (angular.isUndefined(id)) {
        clearParams();
        return;
      }
      if (changed === true) {
        undefineFilterParams();
        params.modem = id;
        clearRefreshTimer();
        $location
          .path('/modems')
          .search('user', undefined)
          .search('event', undefined)
          .search('modem', params.modem);
      }
    }

    function selectedEventChanged(id) {
      var changed = false;
      params = PersistentParamsService.getParamsModems();
      if (params.event !== id) {
        changed = true;
      }
      if (angular.isUndefined(id)) {
        clearParams();
        return;
      }
      if (changed === true) {
        undefineFilterParams();
        params.event = id;
        clearRefreshTimer();
        $location
          .path('/modems')
          .search('user', undefined)
          .search('event', params.event)
          .search('modem', undefined);
      }
    }

    function showAllModems() {
      if (angular.isDefined(params.active)) {
        params.active = undefined;
        clearRefreshTimer();
        $location.path('/modems').search('active', params.active);
      }
    }

    function showOnlineModems() {
      if (angular.isUndefined(params.modem) && params.active !== 'true') {
        params.active = 'true';
        clearRefreshTimer();
        $location.path('/modems').search('active', params.active);
      }
    }

    function showOfflineModems() {
      if (angular.isUndefined(params.modem) && params.active !== 'false') {
        params.active = 'false';
        clearRefreshTimer();
        $location.path('/modems').search('active', params.active);
      }
    }

    function sortLastActivity() {
      if (params.sort !== 'lastActivity') {
        params.sort = 'lastActivity';
        clearRefreshTimer();
        $location.path('/modems').search('sort', params.sort);
      }
    }

    function sortExternalId() {
      if (params.sort !== 'externId') {
        params.sort = 'externId';
        clearRefreshTimer();
        $location.path('/modems').search('sort', params.sort);
      }
    }

    function sortLabel() {
      if (params.sort !== 'label') {
        params.sort = 'label';
        clearRefreshTimer();
        $location.path('/modems').search('sort', params.sort);
      }
    }

    function navigationChange(page) {
      var changed = false;
      if (page === 0) {
        if (angular.isDefined(params.page)) {
          changed = true;
        }
        params.page = undefined;
      } else {
        if (params.page !== page) {
          changed = true;
        }
        params.page = page;
      }
      if (changed === true) {
        clearRefreshTimer();
        $location.path('/modems').search('page', params.page);
      }
    }

    function confirmDeleteDialog() {
      var selected = getSelectedModems();
      if (selected.length === 0) {
        toastr.error('Select modems to delete');
      } else {
        $uibModal
          .open({
            component: 'confirmationDialog',
            resolve: {
              dialogProperties: function () {
                return vm.deleteDialogProperties;
              },
            },
          })
          .result.then(
            function () {
              deleteModems();
            },
            function () {}
          );
      }
    }

    function confirmOwnershipEvents() {
      var selected = getSelectedModems();
      if (selected.length === 0) {
        toastr.error('Select modems to assign');
      } else if (angular.isUndefined(vm.assignedEvent)) {
        toastr.error('Select an event to assign modems to');
      } else if (vm.assignedEvent.id !== vm.unassigned) {
        var notOwnedModems = selected.filter(function (m) {
          return m.user.id !== vm.assignedEvent.ownerId;
        });
        var modemSerials = notOwnedModems.map(function (obj) {
          return obj.externId;
        });
        var modemIds = notOwnedModems.map(function (obj) {
          return obj.id;
        });
        if (modemSerials.length !== 0) {
          $uibModal
            .open({
              component: 'confirmationDialog',
              resolve: {
                dialogProperties: function () {
                  return vm.ownershipDialogPropertiesEvent;
                },
              },
            })
            .result.then(
              function () {
                changeOwnerOfModems(
                  modemIds,
                  modemSerials,
                  vm.assignedEvent.ownerId
                );
              },
              function () {}
            );
        } else {
          assignModemToEvent();
        }
      } else {
        assignModemToEvent();
      }
    }

    function confirmOwnershipUser() {
      var selected = getSelectedModems();
      if (selected.length === 0) {
        toastr.error('Select modems to assign');
      } else if (angular.isUndefined(vm.assignedUser)) {
        toastr.error('Select a user to assign modems to');
      } else {
        // needs to check for owner id of box event against new box owner
        var notOwnedModems = selected.filter(function (m) {
          if (m.event.id !== vm.unassigned) {
            return m.event.ownerId !== vm.assignedUser.id;
          } else {
            return false;
          }
        });
        var modemSerials = notOwnedModems.map(function (obj) {
          return obj.externId;
        });
        var modemIds = notOwnedModems.map(function (obj) {
          return obj.id;
        });
        if (modemSerials.length !== 0) {
          $uibModal
            .open({
              component: 'confirmationDialog',
              resolve: {
                dialogProperties: function () {
                  return vm.ownershipDialogPropertiesUser;
                },
              },
            })
            .result.then(
              function () {
                // Assign modems to 'Not assigned'
                ModemStoreService.assignModemsToEvent(
                  vm.unassigned,
                  modemIds
                ).then(function () {
                  assignModemToUser();
                });
              },
              function () {}
            );
        } else {
          assignModemToUser();
        }
      }
    }

    function getSelectedModems() {
      return vm.modems.filter(function (m) {
        return m.selected === true;
      });
    }

    function getUsers(term) {
      return UserStoreService.getSelectedUsers(term, true, true);
    }

    function getEvents(term) {
      return EventStoreService.getSelectedEvents(term, true);
    }

    function getModems(term) {
      return ModemStoreService.getSelectedModems(term, true);
    }

    function getUsersForAssignment(term) {
      return UserStoreService.getSelectedUsers(term, false, true);
    }

    function getEventsForAssignment(term) {
      return EventStoreService.getSelectedEvents(term, false);
    }

    function toggleActive(variable) {
      clearRefreshTimer();
      var buttonName = variable;
      vm.toggleState = buttonName;
      if (buttonName === 'closeall') {
        var selected = getSelectedModems();
        selected.map(function (obj) {
          obj.selected = false;
        });
        vm.toggleState = 'all';
        // reset selected user/event on cancel
        vm.assignedUser = undefined;
        vm.assignedEvent = undefined;
        if (!params.refreshTimer) {
          params.refreshTimer = $timeout(refreshModems, autoRefreshTimeoutInMs);
        }
      } else if (buttonName === 'showfilters') {
        if (vm.showToolbar === false) {
          vm.showToolbar = true;
          vm.toggleState = 'all';
        } else {
          vm.showToolbar = false;
          vm.toggleState = 'all';
        }
      }
    }

    function editView(modem) {
      var currentmodem = modem;
      if (vm.toggleState !== 'all') {
        if (currentmodem.selected === false) {
          currentmodem.selected = true;
        } else if (currentmodem.selected === true) {
          currentmodem.selected = false;
        }
      }
    }

    function deleteModems() {
      var selected = getSelectedModems();
      ModemStoreService.deleteModems(selected).then(
        function () {
          clearRefreshTimer();
          $location.path('/modems');
          toggleActive('closeall');
          if (selected.length === 1) {
            toastr.success(selected.length + ' modem was deleted');
          } else {
            toastr.success(selected.length + ' modems were deleted');
          }
        },
        function () {
          toastr.error('There was an error deleting modems');
        }
      );
    }

    function checkIfAllLabelsAreNullOrEmpty(modems) {
      for (var i = 0; i < modems.length; i++) {
        if (modems[i].label !== null && modems[i].label !== '') {
          return false;
        }
      }
      return true;
    }

    function assignModemToUser() {
      var selected = getSelectedModems();
      var selectedIds = selected.map(function (key) {
        return key.id;
      });
      if (angular.isUndefined(vm.assignedUser) || vm.assignedUser === null) {
        toastr.error('Choose user to assign modems to');
        return;
      } else if (selectedIds.length === 0) {
        toastr.error('Choose modems to assign to user');
        return;
      }
      var assignModemsToUserAndRefreshView = function (modemIds, clearLabels) {
        ModemStoreService.assignModemsToUser(
          vm.assignedUser.id,
          modemIds,
          clearLabels
        ).then(
          function () {
            toastr.success(
              modemIds.length +
                ' modems assigned to user <b>' +
                vm.assignedUser.firstName +
                ' ' +
                vm.assignedUser.lastName
            );
            clearRefreshTimer();
            $location.path('/modems');
            toggleActive('closeall');
          },
          function () {
            toastr.error('There was an error assigning modems');
            clearRefreshTimer();
            $location.path('/modems');
            toggleActive('closeall');
          }
        );
      };
      if (checkIfAllLabelsAreNullOrEmpty(selected)) {
        assignModemsToUserAndRefreshView(selectedIds, false);
      } else {
        $uibModal
          .open({
            component: 'confirmationDialog',
            // Aborting is not possible at this point. Therefore, the user is prevented
            // from closing the dialog by pressing Esc with option 'keyboard': false.
            // Note: User is also prevented from closing the dialog by clicking outside
            // the box. This behavior is configured in confirmation-dialog.config.js.
            keyboard: false,
            resolve: {
              dialogProperties: function () {
                return vm.clearLabelsDialogProperties;
              },
            },
          })
          .result.then(
            function () {
              assignModemsToUserAndRefreshView(selectedIds, true);
            },
            function () {
              assignModemsToUserAndRefreshView(selectedIds, false);
            }
          );
      }
    }

    function assignModemToEvent() {
      var selected = getSelectedModems();
      var selectedIds = selected.map(function (key) {
        return key.id;
      });
      if (angular.isUndefined(vm.assignedEvent) || vm.assignedEvent === null) {
        toastr.error('Choose event to assign modems to');
        return;
      } else if (selectedIds.length === 0) {
        toastr.error('Choose modems to assign to event');
        return;
      }
      var assignModemsToEventAndRefreshView = function (modemIds, clearLabels) {
        ModemStoreService.assignModemsToEvent(
          vm.assignedEvent.id,
          modemIds,
          clearLabels
        ).then(
          function () {
            toastr.success(
              modemIds.length +
                ' modems assigned to event <b>' +
                vm.assignedEvent.name
            );
            clearRefreshTimer();
            $location.path('/modems');
            toggleActive('closeall');
          },
          function () {
            toastr.error('There was an error assigning modems');
            clearRefreshTimer();
            $location.path('/modems');
            toggleActive('closeall');
          }
        );
      };
      if (checkIfAllLabelsAreNullOrEmpty(selected)) {
        assignModemsToEventAndRefreshView(selectedIds, false);
      } else {
        $uibModal
          .open({
            component: 'confirmationDialog',
            // Aborting is not possible at this point. Therefore, the user is prevented
            // from closing the dialog by pressing Esc with option 'keyboard': false.
            // Note: User is also prevented from closing the dialog by clicking outside
            // the box. This behavior is configured in confirmation-dialog.config.js.
            keyboard: false,
            resolve: {
              dialogProperties: function () {
                return vm.clearLabelsDialogProperties;
              },
            },
          })
          .result.then(
            function () {
              assignModemsToEventAndRefreshView(selectedIds, true);
            },
            function () {
              assignModemsToEventAndRefreshView(selectedIds, false);
            }
          );
      }
    }

    function changeOwnerOfModems(modemIds, modemSerials, newOwnerId) {
      ModemStoreService.assignModemsToUser(newOwnerId, modemIds).then(
        function () {
          if (modemSerials.length > 1) {
            toastr.success(
              'Owner of modems ' + modemSerials.toString() + ' changed'
            );
          } else {
            toastr.success(
              'Owner of modem ' + modemSerials.toString() + ' changed'
            );
          }
          // When owner of modems changed - assign modems to event
          assignModemToEvent();
        }
      );
    }

    function clearParams() {
      if (angular.isDefined(params)) {
        if (
          angular.isDefined(params.event) ||
          angular.isDefined(params.user) ||
          angular.isDefined(params.modem) ||
          angular.isDefined(params.active) ||
          angular.isDefined(params.page) ||
          angular.isDefined(vm.selectedUser) ||
          angular.isDefined(vm.selectedEvent) ||
          angular.isDefined(vm.selectedModem)
        ) {
          params.event = undefined;
          params.user = undefined;
          params.modem = undefined;
          params.active = undefined;
          params.sort = undefined;
          params.page = undefined;
          vm.selectedUser = undefined;
          vm.selectedEvent = undefined;
          vm.selectedModem = undefined;
          clearRefreshTimer();
          $location
            .path('/modems')
            .search('page', undefined)
            .search('user', undefined)
            .search('event', undefined)
            .search('modem', undefined)
            .search('active', undefined)
            .search('sort', undefined);
        }
      }
    }

    function undefineAllParams() {
      params = {};
      params.page = undefined;
      params.sort = undefined;
      params.active = undefined;
      params.event = undefined;
      params.user = undefined;
      params.modem = undefined;
    }

    function undefineParams() {
      params = {};
      params.event = undefined;
      params.user = undefined;
      params.modem = undefined;
      params.active = undefined;
      params.sort = undefined;
      params.page = undefined;
      vm.selectedUser = undefined;
      vm.selectedEvent = undefined;
      vm.selectedModem = undefined;
    }

    function undefineFilterParams() {
      var e = $q.defer();
      e.resolve(undefineParams());
      return e.promise;
    }

    function adjustModems() {
      for (var i = 0; i < vm.modems.length; i++) {
        var m = vm.modems[i];
        if (m.status.lastActivity == null) {
          m.isnull = true;
        } else {
          m.isnull = false;
        }
        m.selected = false;
        m.lastUpdateDisplay = moment
          .utc(m.status.lastActivity)
          .local()
          .fromNow();
        m.runtimeDisplay = moment
          .duration(m.status.runtime, 'seconds')
          .humanize();
        var date = new Date(1970, 0, 1);
        date.setSeconds(m.status.runtime);
        m.runtimeTooltip = date
          .toTimeString()
          .replace(/.*(\d{2}:\d{2}:\d{2}).*/, '$1');
        m.status.lastActivity = moment
          .utc(m.status.lastActivity)
          .local()
          .format('MMMM D, YYYY HH:mm');
      }
    }

    function getModemCountTooltipHtml() {
      return (
        '' +
        vm.modems.totalCount.toString() +
        ' modems in total<br />' +
        vm.modems.length.toString() +
        ' modems in this list'
      );
    }

    function checkUrlParams() {
      var currentUrl = $location.search();
      if (Object.keys(currentUrl).length !== 0) {
        undefineFilterParams();
        if (angular.isDefined(currentUrl.user)) {
          params.user = currentUrl.user;
        } else if (angular.isDefined(currentUrl.event)) {
          params.event = currentUrl.event;
        } else if (angular.isDefined(currentUrl.modem)) {
          params.modem = currentUrl.modem;
        }
        if (angular.isDefined(currentUrl.active)) {
          params.active = currentUrl.active;
        }
        if (angular.isDefined(currentUrl.sort)) {
          params.sort = currentUrl.sort;
        }
        if (angular.isDefined(currentUrl.page)) {
          params.page = currentUrl.page === 0 ? undefined : currentUrl.page;
        }
        PersistentParamsService.setParamsModems(params);
      }
    }
  }
})();

/*
 * Copyright (c) 2016 SPORTident GmbH. All rights reserved.
 */
(function () {
  'use strict';

  angular
    .module('c3poFrontend')
    .controller('ModemEditController', ModemEditController);

  /** @ngInject */
  function ModemEditController(
    ModemStoreService,
    $state,
    toastr,
    moment,
    Account,
    $stateParams
  ) {
    var vm = this;

    vm.$onInit = onInit;

    function onInit() {
      vm.modemTypes = [
        { id: 'simodem', name: 'GSM Modem' },
        { id: 'roc', name: 'Connector' },
        { id: 'sistation', name: 'Modem Simulator' },
      ];
      vm.modemTitle = 'New Modem';
      vm.saveButtonText = 'Create';

      ModemStoreService.getModem($stateParams.modemId).then(function (result) {
        vm.modem = result;
        Account.getPrincipal().then(function (principal) {
          vm.user = principal.getAccount();
          if (angular.isUndefined(vm.modem.userId)) {
            vm.modem.userId = vm.user.id;
          }
          vm.userIsAdmin = vm.user.authorities.indexOf('ROLE_ADMIN') !== -1;
        });
        if (vm.modem.id === 'new') {
          vm.modemTitle = 'New Modem';
          vm.modem.eventId = undefined;
          vm.modem.type = 'simodem';
          vm.saveButtonText = 'Create';
        } else {
          vm.modemTitle = 'Modem ' + vm.modem.externId.toString();
          vm.saveButtonText = 'Save';
          delete vm.modem.status;
          vm.modem.eventId = vm.modem.event.id;
          vm.modem.userId = vm.modem.user.id;
        }
      });
      vm.saveModem = saveModem;
    }

    function saveModem() {
      ModemStoreService.saveModem(vm.modem)
        .then(saveModemSucceeded)
        .catch(saveModemFailed);
    }

    function saveModemSucceeded() {
      // TODO: behaviour is not consistent with e.g. adding an athlete
      if (vm.modem.id === 'new') {
        toastr.success('Created modem "' + vm.modem.externId + '"');
      } else {
        toastr.success('Changes saved');
      }
      $state.go('modems');
    }

    function saveModemFailed(error) {
      var msg;
      if (vm.modem.id === 'new') {
        msg = 'Could not create modem "' + vm.modem.externId + '"';
      } else {
        msg = 'Could not save changes';
      }
      var ms = error.data.errorMessages;
      if (ms.length > 0) {
        msg += ': <br />' + ms.join(', <br />');
      }

      toastr.error(msg);
    }
  }
})();

/*
 * Copyright (c) 2016 SPORTident GmbH. All rights reserved.
 */
(function () {
  'use strict';

  angular
    .module('c3poFrontend')
    .controller('EventListController', EventListController);

  /** @ngInject */
  function EventListController(
    $timeout,
    moment,
    $state,
    $uibModal,
    EventStoreService,
    UserStoreService,
    ModemStoreService,
    PersistentParamsService,
    toastr,
    Account,
    $q,
    $location,
    $window
  ) {
    var vm = this;
    var unassigned;
    var params;

    vm.$onInit = onInit;

    function onInit() {
      vm.initialLoading = true;
      vm.activeState = undefined;
      vm.hidePagination = false;
      unassigned = EventStoreService.getNotAssignedEventId();
      vm.toggleSelect = toggleSelect;
      vm.toggleState = 'all';
      vm.toggleActive = toggleActive;
      vm.showToolbar = false;
      vm.getUsers = getUsers;
      vm.getUsersForAssignment = getUsersForAssignment;
      vm.getEvents = getEvents;
      vm.principal = undefined;
      vm.assignedUser = undefined;
      // TODO: this is nonfunctional; needs additional stuff implemented in the backend
      vm.filterOptions = [
        { filter: '', title: 'All' },
        { filter: 'active', title: 'Active' },
        { filter: 'upcoming', title: 'Upcoming' },
        { filter: 'past', title: 'Past' },
      ];
      vm.confirmDeleteDialog = confirmDeleteDialog;
      vm.confirmOwnership = confirmOwnership;
      vm.ownershipDialogProperties = {
        title: 'Modem ownership',
        message:
          'An event and its modems must have the same owner. Not all of the modems of the selected events belong to the new owner.',
        firstButtonText: 'Assign modems to new owner',
        firstButtonClass: 'btn-danger',
        secondButtonText: 'Cancel',
      };
      vm.dialogProperties = {
        title: 'Delete events',
        message: 'Are you sure you want to delete the selected events?',
        firstButtonText: 'Delete',
        firstButtonClass: 'btn-danger',
        secondButtonText: 'Cancel',
      };
      vm.clearParams = clearParams;
      vm.selectedUserChanged = selectedUserChanged;
      vm.selectedEventChanged = selectedEventChanged;
      vm.getEventCountTooltipHtml = getEventCountTooltipHtml;
      vm.showActiveEvents = showActiveEvents;
      vm.showAllEvents = showAllEvents;
      vm.selectedUserChanged = selectedUserChanged;
      vm.navigationChange = navigationChange;
      vm.refreshEvents = refreshEvents;
      vm.buildFullResultsURL = buildFullResultsURL;

      buildFullResultsURL();

      Account.getPrincipal().then(function (promise) {
        vm.principal = promise;
        var account = vm.principal.getAccount();
        vm.userIsAdmin = account.authorities.indexOf('ROLE_ADMIN') !== -1;
      });
      checkUrlParams();
      params = PersistentParamsService.getParamsEvents();
      if (angular.isUndefined(params)) {
        undefineAllParams();
      }
      if (angular.isDefined(params)) {
        if (params.event === unassigned && !vm.userIsAdmin) {
          $location.path('/events').search('event', undefined);
        }
        $location
          .path('/events')
          .search('active', params.active)
          .search('user', params.user)
          .search('event', params.event)
          .search('page', params.page);
        if (angular.isDefined(params.user)) {
          UserStoreService.getUser(params.user).then(function (result) {
            vm.selectedUser = {
              id: result.id,
              firstName: result.firstName,
              lastName: result.lastName,
              displayName: result.firstName + ' ' + result.lastName,
              noReload: true,
            };
          });
        }

        if (angular.isDefined(params.event)) {
          EventStoreService.getEvent(params.event).then(function (result) {
            vm.selectedEvent = {
              id: result.id,
              displayName: result.name,
              noReload: true,
            };
          });
        }
      }
      refreshEvents();
    }

    function getAllEvents() {
      vm.activesort = params.sort;
      vm.activestate = params.active;
      EventStoreService.getAllEvents(
        params.page,
        params.size,
        params.event,
        params.user,
        params.active
      )
        .then(function (result) {
          vm.events = result;
          adjustEvents();
          vm.initialLoading = false;
          // Hiding the loading icon is done with a delay to make sure that icon is visible
          // for at least a short time. This way the user has a visual indication that
          // the refresh action was actually performed.
          $timeout(function () {
            vm.displayLoadingIcon = false;
          }, 200);
        })
        .catch(function () {
          vm.displayLoadingIcon = false;
        });
    }

    // Manually triggered refresh of event list.
    function refreshEvents() {
      vm.displayLoadingIcon = true;
      getAllEvents();
    }

    function selectedUserChanged(id) {
      if (angular.isUndefined(id)) {
        clearParams();
      } else {
        undefineFilterParams();
      }
      params.user = id;
      PersistentParamsService.setParamsEvents(params);
      $location
        .path('/events')
        .search('user', params.user)
        .search('event', undefined)
        .search('active', undefined);
    }

    function selectedEventChanged(id) {
      if (angular.isUndefined(id)) {
        clearParams();
      } else {
        undefineFilterParams();
      }
      params.event = id;
      PersistentParamsService.setParamsEvents(params);
      $location
        .path('/events')
        .search('user', undefined)
        .search('event', params.event)
        .search('active', undefined);
    }

    function navigationChange(page) {
      if (page === 0) {
        params.page = undefined;
      } else {
        params.page = page;
      }
      PersistentParamsService.setParamsEvents(params);
      $location.path('/events').search('page', params.page);
    }

    function getUsers(term) {
      return UserStoreService.getSelectedUsers(term, true, true);
    }

    function getEvents(term) {
      return EventStoreService.getSelectedEvents(term, true).then(function (
        result
      ) {
        var reformattedArray = result.map(function (obj) {
          if (vm.userIsAdmin) {
            return obj;
          } else if (obj.id !== unassigned) {
            return obj;
          }
        });
        return reformattedArray;
      });
    }

    function getUsersForAssignment(term) {
      return UserStoreService.getSelectedUsers(term, false, true);
    }

    function confirmDeleteDialog() {
      var selected = getSelectedEvents();
      if (selected.length === 0) {
        toastr.error('Select events to delete');
      } else {
        $uibModal
          .open({
            component: 'confirmationDialog',
            resolve: {
              dialogProperties: function () {
                return vm.dialogProperties;
              },
            },
          })
          .result.then(
            function () {
              deleteEvents();
            },
            function () {}
          );
      }
    }

    function confirmOwnership() {
      var arrayOfModems = [];
      var arrayOfModemSerials = [];
      var selected = getSelectedEvents();
      if (selected.length === 0) {
        toastr.error('Select events to assign');
      } else if (angular.isUndefined(vm.assignedUser)) {
        toastr.error('Select user to assign events to');
      } else {
        var withModems = selected.filter(function (e) {
          return e.info.boxCount !== 0;
        });
        var containsUnassigned = withModems.filter(function (e) {
          return e.id === unassigned;
        });
        if (withModems.length !== 0) {
          // If we have modems for events
          var promises = [];
          for (var i = 0; i < withModems.length; i++) {
            if (withModems[i].id !== unassigned) {
              var promise = EventStoreService.getAllBoxesOfEvent(
                withModems[i].id
              ).then(function (result) {
                for (var j = 0; j < result.length; j++) {
                  if (result[j].user.id !== vm.assignedUser.id) {
                    arrayOfModems.push(result[j].id);
                    arrayOfModemSerials.push(result[j].externId);
                  }
                }
              });
              promises.push(promise);
            }
          }
          $q.all(promises).then(function () {
            // after checking each event for modems, if there are modems with different owners, launch the dialog
            if (arrayOfModems.length !== 0 && containsUnassigned.length === 0) {
              $uibModal
                .open({
                  component: 'confirmationDialog',
                  resolve: {
                    dialogProperties: function () {
                      return vm.ownershipDialogProperties;
                    },
                  },
                })
                .result.then(
                  function () {
                    // assign modems to new owner
                    ModemStoreService.assignModemsToUser(
                      vm.assignedUser.id,
                      arrayOfModems
                    ).then(function () {
                      toastr.success('Modems assigned to new owner');
                      assignEventToUser();
                    });
                  },
                  function () {
                    // on cancel press, clear array and message variables
                    arrayOfModems = undefined;
                    arrayOfModemSerials = undefined;
                  }
                );
              // if on the list there is a Not Asigned event
            } else if (containsUnassigned.length !== 0) {
              toastr.options.timeOut = 4000;
              toastr.error(
                "The owner of the event 'Not assigned' cannot be changed!"
              );
              // if there are no modems with different owners - continue assignment
            } else {
              assignEventToUser();
            }
          });
          // if there are no modems assigned to selected events - continue assignment
        } else {
          assignEventToUser();
        }
      }
    }

    function adjustEvents() {
      for (var i = 0; i < vm.events.length; i++) {
        var e = vm.events[i];
        e.selected = false;
        e.startDate = moment.utc(e.startDate).format('MMMM D, YYYY');
        e.endDate = moment.utc(e.endDate).format('MMMM D, YYYY');
        e.active = isEventActive(e);
        e.cssClasses = {
          'event-active': e.active,
          'event-inactive': !e.active,
        };
      }
    }

    function toggleActive(variable) {
      var buttonName = variable;
      vm.toggleState = buttonName;
      if (buttonName === 'closeall') {
        var selected = getSelectedEvents();
        selected.map(function (obj) {
          obj.selected = false;
        });
        vm.toggleState = 'all';
        vm.assignedUser = undefined;
      } else if (buttonName === 'showfilters') {
        if (vm.showToolbar === false) {
          vm.showToolbar = true;
          vm.toggleState = 'all';
        } else {
          vm.showToolbar = false;
          vm.toggleState = 'all';
        }
      }
    }

    function getSelectedEvents() {
      return vm.events.filter(function (e) {
        return e.selected === true;
      });
    }

    function toggleSelect(event) {
      var currentevent = event;
      if (vm.toggleState !== 'all') {
        currentevent.selected = !currentevent.selected;
      }
    }

    function showActiveEvents() {
      vm.activeState = 'active';
      $location
        .path('/events', false)
        .search('user', undefined)
        .search('event', undefined)
        .search('active', 'true')
        .search('page', undefined);
    }

    function showAllEvents() {
      vm.activeState = undefined;
      params.active = undefined;
      PersistentParamsService.setParamsEvents(params);
      $location
        .path('/events')
        .search('active', undefined)
        .search('page', undefined);
      PersistentParamsService.setParamsEvents(params);
    }

    function assignEventToUser() {
      var selected = getSelectedEvents();
      var length = selected.length;
      var arrOfEvents = selected.map(function (key) {
        return key.id;
      });

      if (angular.isUndefined(vm.assignedUser) || vm.assignedUser === null) {
        toastr.error('Choose user to assign events to');
      } else if (arrOfEvents.length === 0) {
        toastr.error('Choose events to assign to user');
      } else {
        EventStoreService.assignEventsToUser(
          vm.assignedUser.id,
          arrOfEvents
        ).then(
          function () {
            var assignedUser = vm.assignedUser;
            getAllEvents();
            $location.path('/events', false);
            toggleActive('closeall');
            if (length === 1) {
              toastr.success(
                length +
                  ' event assigned to user <b>' +
                  assignedUser.firstName +
                  ' ' +
                  assignedUser.lastName
              );
            } else {
              toastr.success(
                length +
                  ' events assigned to user <b>' +
                  assignedUser.firstName +
                  ' ' +
                  assignedUser.lastName
              );
            }
          },
          function () {
            $location.path('/events', false);
            toggleActive('closeall');
            toastr.error('There was an error assigning events');
          }
        );
      }
    }

    function deleteEvents() {
      var selected = getSelectedEvents();
      var arrOfEvents = selected.map(function (key) {
        return key.id;
      });
      EventStoreService.deleteEvents(arrOfEvents).then(
        function () {
          getAllEvents();
          $location.path('/events', false);
          toggleActive('closeall');
          if (selected.length === 1) {
            toastr.success(selected.length + ' event was deleted');
          } else {
            toastr.success(selected.length + ' events were deleted');
          }
        },
        function () {
          toastr.error('There was an error deleting events');
        }
      );
    }

    function isEventActive(event) {
      // TODO: ideally it should consider the event's timezone
      var a = moment.utc(
        event.startDate.concat(' 00:00:00'),
        'YYYY-MM-DD HH:mm:ss'
      );
      var b = moment.utc(
        event.endDate.concat(' 23:59:59'),
        'YYYY-MM-DD HH:mm:ss'
      );
      var c = moment.utc().toDate();
      return a <= c && c <= b;
    }

    function clearParams() {
      if (angular.isDefined(params)) {
        params.event = undefined;
        params.user = undefined;
        params.modem = undefined;
        params.page = undefined;
        params.active = undefined;
        vm.selectedUser = undefined;
        vm.selectedEvent = undefined;
        $location
          .path('/events')
          .search('active', undefined)
          .search('page', undefined)
          .search('user', undefined)
          .search('event', undefined)
          .search('sort', undefined);
      }
    }

    function undefineAllParams() {
      params = {};
      params.page = undefined;
      params.sort = undefined;
      params.event = undefined;
      params.user = undefined;
      params.active = undefined;
    }

    function undefineParams() {
      params = {};
      params.event = undefined;
      params.user = undefined;
      params.sort = undefined;
      params.page = undefined;
      params.active = undefined;
      vm.selectedUser = undefined;
      vm.selectedEvent = undefined;
    }

    function undefineFilterParams() {
      var e = $q.defer();
      e.resolve(undefineParams());
      return e.promise;
    }

    function getEventCountTooltipHtml() {
      return (
        '' +
        vm.events.totalCount.toString() +
        ' events in total<br />' +
        vm.events.length.toString() +
        ' events in this list'
      );
    }

    function checkUrlParams() {
      var currentUrl = $location.search();
      if (Object.keys(currentUrl).length !== 0) {
        undefineFilterParams();
        if (angular.isDefined(currentUrl.user)) {
          params.user = currentUrl.user;
        } else if (angular.isDefined(currentUrl.event)) {
          params.event = currentUrl.event;
        }
        if (angular.isDefined(currentUrl.page)) {
          params.page = currentUrl.page === 0 ? undefined : currentUrl.page;
        }
        if (angular.isDefined(currentUrl.active)) {
          params.active = currentUrl.active;
          vm.activeState = 'active';
        }
        PersistentParamsService.setParamsEvents(params);
      }
    }

    function buildFullResultsURL() {
      var locationPort = $location.port();
      if (locationPort === 80 || locationPort === 443) {
        locationPort = '';
      } else {
        locationPort = ':' + locationPort;
      }

      vm.resultPath = $location
        .protocol()
        .concat('://', $location.host(), locationPort, '/results/');
    }
  }
})();

/*
 * Copyright (c) 2019 SPORTident GmbH. All rights reserved.
 */
(function () {
  'use strict';

  angular
    .module('c3poFrontend')
    .controller('EventFilesController', EventFilesController);

  /** @ngInject */
  function EventFilesController(
    $state,
    Account,
    EventStoreService,
    PersistentParamsService,
    configBackendUrl,
    $uibModal,
    toastr
  ) {
    var vm = this;
    vm.$onInit = onInit;

    function onInit() {
      vm.initialLoading = true;
      vm.showToolbar = false;
      vm.unassigned = EventStoreService.getNotAssignedEventId();
      vm.toggleState = 'all';
      // Functions
      vm.clearParams = clearParams;
      vm.showEventFiles = showEventFiles;
      vm.navigationChange = navigationChange;
      vm.refreshEventFiles = refreshEventFiles;
      vm.reloadSiteWithParams = reloadSiteWithParams;
      vm.checkStateParams = checkStateParams;
      vm.toggleActive = toggleActive;
      vm.showRevisions = showRevisions;
      vm.getDownloadLink = getDownloadLink;
      vm.getRevisionMarkedAsLatest = getRevisionMarkedAsLatest;
      vm.toggleSelection = toggleSelection;
      vm.toggleSelectionAll = toggleSelectionAll;
      vm.toggleRevisionSelectionAll = toggleRevisionSelectionAll;
      vm.confirmDeleteDialog = confirmDeleteDialog;
      vm.configBackendUrl = configBackendUrl;
      vm.getSizeString = getSizeString;

      vm.title = 'Event files';
      vm.hideDeleteAllBox = false;
      /*
      vm.userAllowedPrefixes = [
        {
          prefix: 'private/rp',
          title: 'Result files'
        }
      ];
      */

      Account.getPrincipal().then(function (promise) {
        vm.principal = promise;
        var account = vm.principal.getAccount();
        vm.userIsAdmin = account.authorities.indexOf('ROLE_ADMIN') !== -1;
        checkStateParams();
        getAllEventFiles();
      });
      vm.displayLoadingIcon = true;
      vm.selected = false;
      vm.selectedRevisions = false;
      vm.eventFileRevisions = [];
      vm.dialogProperties = {
        title: 'Delete event files',
        message:
          'Are you sure you want to delete all of the selected files from event ' +
          $state.params.eventId +
          ' ?',
        firstButtonText: 'Delete',
        firstButtonClass: 'btn-danger',
        secondButtonText: 'Cancel',
      };
    }

    function getAllEventFiles() {
      vm.hideDeleteAllBox = false;
      if ($state.params.prefix === '') {
        vm.eventFiles = [
          {
            directory: true,
            lastModification: null,
            name: 'private',
            prefix: '..',
            revisionId: null,
            size: null,
            selected: false,
            showRevision: false,
          },
          {
            directory: true,
            lastModification: null,
            name: 'public',
            prefix: '..',
            revisionId: null,
            size: null,
            selected: false,
            showRevision: false,
          },
        ];
        vm.hideDeleteAllBox = true;
        vm.initialLoading = false;
        vm.displayLoadingIcon = false;
      } else {
        EventStoreService.getEventFilesDirectoryList(
          $state.params.eventId,
          $state.params.prefix,
          $state.params.Revision,
          $state.params.page,
          $state.params.sort,
          $state.params.size
        )
          .then(function (result) {
            vm.eventFiles = result;
            if (vm.eventFiles.length > 0) {
              var namesArray = vm.eventFiles[0].prefix.split('/');
              vm.prefixArray = [];
              var path = '';
              for (var k in namesArray) {
                if (path !== '') {
                  path = path + '/';
                }
                path = path + namesArray[k];
                var Prefix = { name: namesArray[k], prefix: path };
                vm.prefixArray.push(Prefix);
              }
              vm.eventFiles.forEach(function (m) {
                m.selected = false;
                m.showRevision = false;
                if (
                  angular.isUndefined(m.revisionId) ||
                  m.revisionId == null ||
                  m.revisionId === 'null'
                ) {
                  m.revisionId = 'latest';
                }
              });
              /*
              if (!vm.userIsAdmin && vm.eventFiles.length > 0) {
                var isTop = false;
                for (var i in vm.userAllowedPrefixes) {
                  if (
                    vm.eventFiles[0].prefix === vm.userAllowedPrefixes[i].prefix
                  ) {
                    isTop = true;
                    break;
                  }
                }
                if (isTop === false) {
                  var eventFile = {
                    directory: true,
                    lastModification: null,
                    name: '..',
                    prefix: vm.eventFiles[0].prefix.substring(
                      0,
                      vm.eventFiles[0].prefix.lastIndexOf('/')
                    ),
                    revisionId: null,
                    size: null,
                    selected: false,
                    showRevision: false
                  };
                  vm.eventFiles.unshift(eventFile);
                }
              }
              */
            }
            vm.initialLoading = false;
            vm.displayLoadingIcon = false;
          })
          .catch(function () {
            vm.displayLoadingIcon = false;
          });
      }
    }

    // Manually triggered refresh of eventFile list.
    function refreshEventFiles() {
      getAllEventFiles();
    }

    function showEventFiles(Revision) {
      $state.params.Revision = Revision;
      reloadSiteWithParams();
    }

    function navigationChange(page) {
      if (page === 0) {
        $state.params.page = undefined;
      } else {
        $state.params.page = page;
      }
      reloadSiteWithParams();
    }

    function checkStateParams() {
      if (hasAtLeastOneDefinedStateParam()) {
        if (angular.isUndefined($state.params.prefix) /* && vm.userIsAdmin */) {
          $state.params.prefix = '';
          PersistentParamsService.setParamsEventFiles($state.params);
        }
        /*
        else {
          for (var k in vm.userAllowedPrefixes) {
            if (
              $state.params.prefix.substring(
                0,
                vm.userAllowedPrefixes[k].prefix.length
              ) === vm.userAllowedPrefixes[k].prefix
            ) {
              vm.title = vm.userAllowedPrefixes[k].title;
              return;
            }
          }
          vm.title = 'Event files';
          if (vm.userIsAdmin) return;
          $state.go('event.edit', $state.params.eventId, { reload: true });
        }
        */
      } else {
        var params = PersistentParamsService.getParamsEventFiles();
        if (angular.isDefined(params)) {
          $state.params = params;
          if (angular.isUndefined($state.params.prefix)) {
            // if (vm.userIsAdmin) {
            $state.params.prefix = '';
            PersistentParamsService.setParamsEventFiles($state.params);
            // } else {
            //  $state.go('event.edit', $state.params.eventId, { reload: true });
            // }
          }
        }
        if (hasAtLeastOneDefinedStateParam()) {
          $state.go($state.current, $state.params, { reload: true });
        }
      }
    }

    function hasAtLeastOneDefinedStateParam() {
      for (var k in $state.params) {
        if (angular.isDefined($state.params[k])) {
          return true;
        }
      }
      return false;
    }

    function clearParams() {
      for (var k in $state.params) {
        $state.params[k] = undefined;
      }
      reloadSiteWithParams();
    }

    function reloadSiteWithParams() {
      PersistentParamsService.setParamsEventFiles($state.params);
      $state.go($state.current, $state.params, { reload: true });
    }

    function toggleActive(variable) {
      var buttonName = variable;
      vm.toggleState = buttonName;
      if (buttonName === 'showfilters') {
        if (vm.showToolbar === false) {
          vm.showToolbar = true;
          vm.toggleState = 'all';
        } else {
          vm.showToolbar = false;
          vm.toggleState = 'all';
        }
      }
    }

    function showRevisions(m) {
      if (m.directory) {
        if (m.prefix === '..') {
          $state.params.prefix = m.name;
        } else {
          if (m.name === '..') {
            $state.params.prefix = m.prefix;
          } else {
            $state.params.prefix = m.prefix + '/' + m.name;
          }
        }
        reloadSiteWithParams();
      } else {
        if (!m.showRevision) {
          vm.eventFiles.forEach(function (m) {
            m.showRevision = false;
            if (angular.isUndefined(m.revisionId) || m.revisionId == null) {
              m.revisionId = 'latest';
            }
          });
        }
        m.showRevision = !m.showRevision;
        if (m.showRevision === true) {
          EventStoreService.getEventFilesDirectoryList(
            $state.params.eventId,
            m.prefix,
            m.name
          )
            .then(function (result) {
              vm.displayLoadingIcon = false;
              vm.selectedRevisions = false;
              m.selected = false;
              vm.eventFileRevisions = result;
              vm.eventFileRevisions.forEach(function (mv) {
                mv.selected = false;
                if (
                  angular.isUndefined(mv.revisionId) ||
                  mv.revisionId == null ||
                  mv.revisionId === 'null'
                ) {
                  mv.revisionId = 'latest';
                }
              });
            })
            .catch(function () {
              vm.displayLoadingIcon = false;
            });
        } else {
          vm.eventFileRevisions = [];
        }
      }
    }

    function toggleSelection(m) {
      m.selected = !m.selected;
    }

    function toggleSelectionAll() {
      vm.selected = !vm.selected;
      vm.eventFiles.forEach(function (m) {
        if (m.prefix === '..') {
          vm.selected = false;
          return;
        }
        if (vm.selected) {
          if (!m.showRevision) {
            m.selected = true;
          }
        } else {
          m.selected = false;
        }
      });
    }

    function toggleRevisionSelectionAll() {
      vm.selectedRevisions = !vm.selectedRevisions;
      vm.eventFileRevisions.forEach(function (mv) {
        if (vm.selectedRevisions) {
          mv.selected = true;
        } else {
          mv.selected = false;
        }
      });
    }

    function getDownloadLink(mv) {
      var slashPosition = mv.prefix.search('/');
      var fileAccessType = 'private-files';
      if (mv.prefix.substring(0, slashPosition) === 'public') {
        fileAccessType = 'public-files';
      }
      var revisionId = '';
      if (mv.revisionId !== 'latest') {
        revisionId = '?revisionId=' + mv.revisionId;
      }
      return (
        vm.configBackendUrl +
        '/events/' +
        $state.params.eventId +
        '/' +
        fileAccessType +
        mv.prefix.substring(slashPosition) +
        '/' +
        mv.name +
        revisionId
      );
    }

    function getRevisionMarkedAsLatest(mv) {
      if (mv.latest === true && mv.revisionId !== 'latest') {
        return 'latest:' + mv.revisionId;
      } else {
        return mv.revisionId;
      }
    }

    function confirmDeleteDialog() {
      $uibModal
        .open({
          component: 'confirmationDialog',
          resolve: {
            dialogProperties: function () {
              return vm.dialogProperties;
            },
          },
        })
        .result.then(
          function () {
            deleteFiles();
          },
          function () {}
        );
    }

    function deleteFiles() {
      var selectCount = 0;
      if (vm.eventFileRevisions.length > 0) {
        vm.eventFileRevisions.forEach(function (mv) {
          if (mv.selected) {
            selectCount++;
          }
        });
        if (vm.eventFileRevisions.length === selectCount) {
          EventStoreService.deleteEventFile(
            $state.params.eventId,
            vm.eventFileRevisions[0].prefix,
            vm.eventFileRevisions[0].name
          )
            .then(function (result) {
              toastr.success(
                'deleted file:' +
                  vm.eventFileRevisions[0].prefix +
                  '/' +
                  vm.eventFileRevisions[0].name
              );
              vm.eventFiles.forEach(function (m) {
                if (m.showRevision) {
                  vm.eventFiles.splice(vm.eventFiles.indexOf(m), 1);
                }
              });
              vm.eventFileRevisions = [];
            })
            .catch(function () {
              toastr.error(
                'error on delete file:' +
                  vm.eventFileRevisions[0].prefix +
                  '/' +
                  vm.eventFileRevisions[0].name
              );
            });
        } else {
          if (selectCount > 0) {
            // delete revisions
            vm.eventFileRevisions.forEach(function (mv) {
              if (mv.selected) {
                EventStoreService.deleteEventFile(
                  $state.params.eventId,
                  mv.prefix,
                  mv.name,
                  mv.revisionId
                )
                  .then(function (result) {
                    toastr.success(
                      'delete revision file:' +
                        mv.prefix +
                        '/' +
                        mv.name +
                        ' revision:' +
                        mv.revisionId
                    );
                    vm.eventFileRevisions.splice(
                      vm.eventFileRevisions.indexOf(mv),
                      1
                    );
                  })
                  .catch(function () {
                    toastr.error(
                      'error on delete revision file:' +
                        mv.prefix +
                        '/' +
                        mv.name +
                        ' revision:' +
                        mv.revisionId
                    );
                  });
              }
            });
          }
        }
      }
      selectCount = 0;
      if (vm.eventFiles.length > 0) {
        vm.eventFiles.forEach(function (m) {
          if (m.selected) {
            selectCount++;
          }
        });
        if (
          vm.eventFiles.length === selectCount &&
          vm.eventFiles[0].prefix !== 'public' &&
          vm.eventFiles[0].prefix !== 'private'
        ) {
          EventStoreService.deleteEventFiles(
            $state.params.eventId,
            vm.eventFiles[0].prefix
          )
            .then(function (result) {
              toastr.success('deleted directory:' + vm.eventFiles[0].prefix);
              $state.params.prefix = vm.eventFiles[0].prefix.substring(
                0,
                vm.eventFiles[0].prefix.lastIndexOf('/')
              );
              reloadSiteWithParams();
            })
            .catch(function () {
              toastr.error('error on delete file:' + vm.eventFiles[0].prefix);
            });
        } else {
          if (selectCount > 0) {
            // delete revisions
            vm.eventFiles.forEach(function (m) {
              if (m.selected) {
                if (m.directory) {
                  EventStoreService.deleteEventFiles(
                    $state.params.eventId,
                    m.prefix + '/' + m.name
                  )
                    .then(function (result) {
                      toastr.success(
                        'deleted directory:' + m.prefix + '/' + m.name
                      );
                      vm.eventFiles.splice(vm.eventFiles.indexOf(m), 1);
                    })
                    .catch(function () {
                      toastr.error(
                        'error on delete  directory:' + m.prefix + '/' + m.name
                      );
                    });
                } else {
                  EventStoreService.deleteEventFile(
                    $state.params.eventId,
                    m.prefix,
                    m.name
                  )
                    .then(function (result) {
                      toastr.success('deleted file:' + m.prefix + '/' + m.name);
                      vm.eventFiles.splice(vm.eventFiles.indexOf(m), 1);
                    })
                    .catch(function () {
                      toastr.error(
                        'error on delete file:' + m.prefix + '/' + m.name
                      );
                    });
                }
              }
            });
          }
        }
      }
    }

    function getSizeString(size) {
      if (size > 1024 * 1024 * 1024) {
        return (size / (1024 * 1024 * 1024)).toFixed(1) + ' GB';
      }
      if (size > 1024 * 1024) {
        return (size / (1024 * 1024)).toFixed(1) + ' MB';
      }
      if (size > 1024) {
        return (size / 1024).toFixed(1) + ' kB';
      }
      return size + ' B';
    }
  }
})();

/*
 * Copyright (c) 2016-2018 SPORTident GmbH. All rights reserved.
 */
(function () {
  'use strict';

  angular
    .module('c3poFrontend')
    .controller('EventEditController', EventEditController);

  // TODO: validate date range and event name
  // TODO: need JS date picker (e.g. Firefox does not implement its own date
  // picker for our datetime-local inputs)
  /** @ngInject */
  function EventEditController(
    EventStoreService,
    OrganisationStoreService,
    TimeZoneStoreService,
    $state,
    toastr,
    moment,
    Account,
    $uibModal,
    $location,
    $stateParams,
    $scope,
    $timeout,
    configBackendUrl
  ) {
    var vm = this;
    var event;
    var unassigned;

    vm.$onInit = onInit;
    vm.getOrganisations = getOrganisations;
    vm.selectedOrganisationChanged = selectedOrganisationChanged;
    vm.changePublic = changePublic;
    vm.showSlugPlaceholder = showSlugPlaceholder;
    vm.namegPlaceholder = 'Search for organisation';

    vm.configBackendUrl = configBackendUrl;

    vm.getResultsProcessorStatus = getResultsProcessorStatus;
    vm.startResultsProcessor = startResultsProcessor;
    vm.stopResultsProcessor = stopResultsProcessor;

    vm.getSimulationProcessorStatus = getSimulationProcessorStatus;
    vm.startSimulationProcessor = startSimulationProcessor;
    vm.stopSimulationProcessor = stopSimulationProcessor;

    vm.simulationFilesChanged = simulationFilesChanged;

    $scope.$on('$destroy', function () {
      $timeout.cancel(vm.refreshTimerSimulationProcessor);
      $timeout.cancel(vm.refreshTimerResultsProcessor);
    });

    function onInit() {
      unassigned = EventStoreService.getNotAssignedEventId();
      vm.statusRefreshTimeoutInMs = 5000;
      vm.isStoppingResultsProcessor = false;
      vm.isStoppingSimulation = false;
      vm.continent = '';
      vm.city = '';
      vm.continents = [];
      vm.selectedOrganisation = '';
      vm.speedFactor = 1;
      vm.event = {
        id: '',
        name: '',
        guid: '',
        startDate: '',
        endDate: '',
        timezone: '',
        info: '',
        statusNotifications: ['NONE'],
      };

      TimeZoneStoreService.getAllTimeZonesGrouped().then(function (result) {
        vm.timezones = result;
        vm.continents = Object.keys(vm.timezones).sort();
        loadEvent();
      });

      vm.startDateChanged = startDateChanged;
      vm.continentChanged = continentChanged;
      vm.changeStatus = changeStatus;
      vm.checkStatus = checkStatus;
      vm.updateSlugLink = updateSlugLink;
      vm.updateSlug = updateSlug;
      vm.save = save;
      vm.showSlugPlaceholder = showSlugPlaceholder;
      vm.nameChanged = nameChanged;
      vm.splitEventSlug = splitEventSlug;
      vm.eventTypeChanged = eventTypeChanged;
      vm.speedFactorChanged = speedFactorChanged;
      vm.changeResultsProcessorRestart = changeResultsProcessorRestart;
      vm.changeSimulationProcessorRestart = changeSimulationProcessorRestart;

      vm.saveButtonText = 'Save';
      vm.startButtonText = 'Start';
      vm.stopButtonText = 'Stop';
      vm.resultsStatusText = 'Status?';
      vm.simulationStatusText = 'Status?';
      vm.nameSlugPlaceholder = 'Choose a unique string for URL';
      vm.noResultsMessage = 'No results published.';
      vm.simulationProcessorRestart = false;
      vm.resultsProcessorRestart = false;

      vm.showEventFilesPanel = false;
      vm.simulationFiles = [];
      vm.simulationFile = {
        source: 'no file selected',
      };
    }
    function loadEvent() {
      vm.event.slug = '-/-/-';
      vm.splitEventSlug();
      EventStoreService.getEventTypes().then(function (result) {
        vm.eventTypes = result;
      });
      EventStoreService.getEvent($stateParams.eventId)
        .then(function (result) {
          event = result;
          Account.getPrincipal().then(function (principal) {
            vm.user = principal.getAccount();
            vm.userIsAdmin = vm.user.authorities.indexOf('ROLE_ADMIN') !== -1;
            if (vm.event.id === unassigned && !vm.userIsAdmin) {
              $state.go('events', { event: undefined }, { reload: true });
            }
            if (
              vm.userIsAdmin &&
              !angular.isUndefined(event.info) &&
              !angular.isUndefined(event.info.owner)
            ) {
              vm.event.owner = {
                displayName:
                  event.info.owner.firstName +
                  ' ' +
                  event.info.owner.lastName +
                  ' (' +
                  event.info.owner.login +
                  ')',
                apiKey: event.info.owner.apiKey,
              };
            }
            if (vm.event.id === 'new') {
              vm.event.ownerId = vm.user.id;
              OrganisationStoreService.getOrganisationOfUser(vm.user.id).then(
                function (result) {
                  if (result != null) {
                    vm.term = result.name;
                    vm.orgPlaceholder = result.name;
                    vm.event.organisationId = result.id;
                    vm.event.slugorg = result.slug;
                    vm.updateSlugLink();
                  }
                }
              );
            }
            showEventFilesButton();
          });
          vm.event.id = event.id;
          vm.event.name = event.name;
          vm.event.guid = event.guid;
          vm.event.organisationId = event.organisationId;
          vm.event.ownerId = event.ownerId;
          vm.event.shortUrl = event.shortUrl;
          vm.event.isPublic = event.isPublic;
          vm.event.eventType = event.eventType;
          vm.updateSlugLink();
          if (vm.event.id === 'new') {
            vm.eventTitle = 'New Event';
            vm.saveButtonText = 'Create';
            var newDate = new Date();
            vm.event.startDateViewValue = new Date(
              newDate.getFullYear(),
              newDate.getMonth(),
              newDate.getDate()
            );
            vm.event.endDateViewValue = new Date(
              newDate.getFullYear(),
              newDate.getMonth(),
              newDate.getDate()
            );
            vm.event.statusNotifications = ['NONE'];
            vm.event.isPublic = true;
            vm.event.slugyear = vm.event.startDateViewValue.getFullYear();
            vm.updateSlugLink();
            vm.event.hasPublishedResults = false;
            var localTimezone = Intl.DateTimeFormat().resolvedOptions()
              .timeZone;
            if (
              localTimezone !== undefined &&
              localTimezone.split('/').length === 2
            ) {
              vm.continent = localTimezone.split('/')[0];
              vm.city = findCityLabel(
                vm.continent,
                localTimezone.split('/')[1]
              );
            } else {
              // Set default values if the browser's timezone could not be determined.
              vm.continent = 'Europe';
              vm.city = findCityLabel(vm.continent, 'Berlin');
            }
          } else {
            vm.event.slug = event.slug;
            vm.eventTitle = vm.event.name;
            vm.event.startDateViewValue = moment(event.startDate).toDate();
            vm.event.endDateViewValue = moment(event.endDate).toDate();
            vm.event.statusNotifications = event.statusNotifications;
            vm.event.hasPublishedResults = event.hasPublishedResults;
            var splitter = event.timezone.split('/');
            vm.continent = splitter[0];
            vm.city = findCityLabel(vm.continent, splitter[1]);
            OrganisationStoreService.getOrganisation(event.organisationId).then(
              function (result) {
                vm.term = result.name;
                vm.orgPlaceholder = result.name;
                vm.slugorg = result.slug;
              }
            );
            vm.confirmDeleteDialog = confirmDeleteDialog;
            vm.dialogProperties = {
              title: 'Delete event punches',
              message:
                'Are you sure you want to delete all of the punches from ' +
                vm.event.name +
                ' event?',
              firstButtonText: 'Delete',
              firstButtonClass: 'btn-danger',
              secondButtonText: 'Cancel',
            };
          }
          vm.splitEventSlug();
          vm.updateSlugLink();
          if (vm.event.eventType === 'trail') {
            getResultsProcessorStatus();
            getSimulationProcessorStatus();
          }
        })
        .catch(function (error) {
          // Redirect to event list if user is not allowed to acccess selected event.
          if (error.status === 403) {
            $state.go('events', { event: undefined }, { reload: true });
          }
        });
    }

    function findCityLabel(continent, city) {
      var continentTimezones;
      Object.keys(vm.timezones).map(function (e) {
        if (e === continent) {
          continentTimezones = vm.timezones[e];
        }
      });
      // Find current city in vm.event.statusNotifications.
      var cityLabel = continentTimezones.find(function (element) {
        return element.substring(0, element.length - 13) === city; // 13 = length of GMT offset string, e.g. " (GMT +01:00)".
      });
      return cityLabel;
    }

    function confirmDeleteDialog() {
      $uibModal
        .open({
          component: 'confirmationDialog',
          resolve: {
            dialogProperties: function () {
              return vm.dialogProperties;
            },
          },
        })
        .result.then(
          function () {
            deleteStamps();
          },
          function () {}
        );
    }

    function deleteStamps() {
      EventStoreService.deleteAllStampsFromEvent(event)
        .then(function () {
          toastr.success('All punches deleted');
        })
        .catch(function () {
          toastr.error('Something went wrong: Could not delete the punches');
        });
    }

    function startDateChanged() {
      var a = vm.event.startDateViewValue;
      var b = vm.event.endDateViewValue;
      if (a !== undefined && a > b) {
        vm.event.endDateViewValue = new Date(a);
      }
      vm.event.slugyear = a.getFullYear();
      vm.updateSlugLink();
    }

    function nameChanged() {
      if (vm.event.slugevent === '-') {
        vm.event.slugevent = '';
      }
      updateSlugLink();
    }
    function continentChanged() {
      vm.city = vm.timezones[vm.continent][0];
    }

    function changePublic() {
      vm.event.isPublic = !vm.event.isPublic;
    }

    function save() {
      if (
        angular.isUndefined(vm.event.slugevent) ||
        vm.event.slugevent.trim() === ''
      ) {
        vm.event.slugevent = vm.nameSlugPlaceholder;
      }

      if (vm.event.startDateViewValue === undefined) {
        saveEventFailed({
          data: { errorMessages: ['Please enter a valid start date.'] },
        });
        return;
      } else if (vm.event.endDateViewValue === undefined) {
        saveEventFailed({
          data: { errorMessages: ['Please enter a valid end date.'] },
        });
        return;
      }
      event.name = vm.event.name;
      event.startDate = moment(vm.event.startDateViewValue).format(
        'YYYY-MM-DD'
      );
      event.endDate = moment(vm.event.endDateViewValue).format('YYYY-MM-DD');
      event.statusNotifications = vm.event.statusNotifications;
      event.info = '';
      event.organisationId = vm.event.organisationId;
      event.ownerId = vm.event.ownerId;
      event.isPublic = vm.event.isPublic;
      event.slug = vm.event.slug;
      event.eventType = vm.event.eventType;
      var city = vm.city.slice(0, -13);
      event.timezone = vm.continent + '/' + city;
      EventStoreService.saveEvent(event)
        .then(saveEventSucceeded)
        .catch(saveEventFailed);
    }

    function saveEventSucceeded() {
      if (vm.event.id === 'new') {
        toastr.success('Created event "' + vm.event.name + '"');
      } else {
        toastr.success('Changes saved');
      }
      $state.go('events', {}, { reload: true });
    }

    function saveEventFailed(error) {
      var msg;
      if (vm.event.id === 'new') {
        msg = 'Could not create event "' + vm.event.name + '"';
      } else {
        msg = 'Could not save changes';
      }
      var ms = error.data.errorMessages;
      if (ms.length > 0) {
        msg += ': <br />' + ms.join(', <br />');
      }

      toastr.error(msg);
    }

    function changeStatus(status) {
      if (checkStatus(status)) {
        for (var i = vm.event.statusNotifications.length - 1; i >= 0; i--) {
          if (vm.event.statusNotifications[i] === status) {
            vm.event.statusNotifications.splice(i, 1);
            break;
          }
        }
      } else {
        vm.event.statusNotifications.push(status);
      }
    }

    function checkStatus(status) {
      if (new RegExp(vm.event.statusNotifications.join('|')).test(status)) {
        return true;
      }
      return false;
    }

    function getOrganisations(term) {
      vm.term = term;
      return OrganisationStoreService.getSelectedOrganisations(
        term,
        vm.event.ownerId
      );
    }

    function selectedOrganisationChanged(id) {
      vm.event.organisationId = id;
      if (id === vm.selectedOrganisation.id) {
        vm.event.slugorg = vm.selectedOrganisation.slug;
      }
      vm.updateSlugLink();
    }

    function updateSlugLink() {
      vm.updateSlug();
      var locationPort = $location.port();
      if (locationPort === 80 || locationPort === 443) {
        locationPort = '';
      } else {
        locationPort = ':' + locationPort;
      }
      var resultURL = $location
        .protocol()
        .concat('://', $location.host(), locationPort, '/results/');
      vm.event.sluglink = resultURL.concat(
        vm.event.eventType,
        '/',
        vm.event.slug
      );
    }

    function updateSlug() {
      if (
        angular.isUndefined(vm.event.slugevent) ||
        vm.event.slugevent.trim() === ''
      ) {
        showSlugPlaceholder();
        vm.event.slug = vm.event.slugorg.concat(
          '/',
          vm.event.slugyear,
          '/',
          vm.nameSlugPlaceholder
        );
      } else {
        vm.event.slug = vm.event.slugorg.concat(
          '/',
          vm.event.slugyear,
          '/',
          vm.event.slugevent
        );
      }
    }

    function showSlugPlaceholder() {
      vm.nameSlugPlaceholder = vm.event.name
        .toLowerCase()
        .replace(new RegExp(' |\\.|_', 'g'), '-')
        .replace(new RegExp('[^a-z0-9-]+', 'g'), '');
    }

    function splitEventSlug() {
      var slugArray = vm.event.slug.split('/');
      vm.event.slugorg = slugArray[0];
      vm.event.slugyear = slugArray[1];
      vm.event.slugevent = slugArray[2];
    }

    function eventTypeChanged(eventType) {
      vm.updateSlugLink();
    }

    function showEventFilesButton() {
      if (vm.event.id === 'new') {
        vm.showEventFilesPanel = false;
      } else {
        if (vm.event.eventType === 'trail' && vm.userIsAdmin) {
          vm.showEventFilesPanel = true;
        }
      }
    }

    function getResultsProcessorStatus() {
      if (vm.isStoppingResultsProcessor === false) {
        vm.resultsStatusText = 'STATUS?...';
        EventStoreService.getStatusResultsProcessor(vm.event.id)
          .then(function (result) {
            vm.resultsStatusText = result[0].status;
            if (vm.resultsStatusText !== 'STOPPED') {
              vm.refreshTimerResultsProcessor = $timeout(
                getResultsProcessorStatus,
                vm.statusRefreshTimeoutInMs
              );
            } else {
              $timeout.cancel(vm.refreshTimerResultsProcessor);
            }
          })
          .catch(function () {
            vm.displayLoadingIcon = false;
            vm.resultsStatusText = 'STOPPED';
          });
      }
    }

    function startResultsProcessor() {
      if (vm.userIsAdmin) {
        if (vm.resultsStatusText === 'STOPPED') {
          vm.resultsStatusText = 'STARTING...';
          vm.displayLoadingIcon = true;
          EventStoreService.startResultsProcessor(
            vm.event.id,
            vm.resultsProcessorRestart
          )
            .then(function (result) {
              vm.displayLoadingIcon = false;
              vm.resultsStatusText = result[0].status;
              vm.resultsProcessorRestart = result[0].restart;
              vm.refreshTimerResultsProcessor = $timeout(
                getResultsProcessorStatus,
                vm.statusRefreshTimeoutInMs
              );
            })
            .catch(function () {
              vm.displayLoadingIcon = false;
              vm.resultsStatusText = 'STOPPED';
            });
        }
      }
    }

    function stopResultsProcessor() {
      if (vm.userIsAdmin) {
        vm.resultsStatusText = 'STOPPING...';
        vm.displayLoadingIcon = true;
        vm.isStoppingResultsProcessor = true;
        EventStoreService.stopResultsProcessor(vm.event.id)
          .then(function (result) {
            vm.displayLoadingIcon = false;
            vm.isStoppingResultsProcessor = false;
            vm.resultsStatusText = result[0].status;
            vm.refreshTimerResultsProcessor = $timeout(
              getResultsProcessorStatus,
              vm.statusRefreshTimeoutInMs
            );
          })
          .catch(function () {
            vm.displayLoadingIcon = false;
            vm.isStoppingResultsProcessor = false;
            vm.resultsStatusText = 'STOPPED';
          });
      }
    }

    function getSimulationProcessorStatus() {
      if (vm.isStoppingSimulation === false) {
        vm.simulationStatusText = 'STATUS?...';
        EventStoreService.getStatusSimulationProcessor(vm.event.id)
          .then(function (result) {
            vm.simulationStatusText = result[0].status;
            vm.simulationProcessorRestart = result[0].restart;
            if (vm.simulationStatusText !== 'STOPPED') {
              vm.refreshTimerSimulationProcessor = $timeout(
                getSimulationProcessorStatus,
                vm.statusRefreshTimeoutInMs
              );
            } else {
              $timeout.cancel(vm.refreshTimerSimulationProcessor);
            }
          })
          .catch(function () {
            vm.displayLoadingIcon = false;
            vm.simulationStatusText = 'STOPPED';
          });
      }
    }

    function startSimulationProcessor() {
      if (
        angular.isDefined(vm.simulationFile.source) &&
        vm.simulationFile.size > 0
      ) {
        EventStoreService.deleteEventFiles(vm.event.id, 'private/simulation')
          .then(function (result) {
            EventStoreService.putEventFile(
              vm.event.id,
              'private/simulation',
              vm.simulationFile
            )
              .then(function (result) {
                toastr.info(
                  'Simulation data saved to s3 "' + vm.simulationFile.name + '"'
                );
                if (vm.simulationStatusText === 'STOPPED') {
                  vm.simulationStatusText = 'STARTING...';
                  vm.displayLoadingIcon = true;
                  if (angular.isUndefined(vm.speedFactor)) {
                    vm.speedFactor = 1;
                  }
                  EventStoreService.startSimulationProcessor(
                    vm.event.id,
                    vm.simulationFile.name,
                    vm.speedFactor,
                    vm.simulationProcessorRestart
                  )
                    .then(function (result) {
                      vm.displayLoadingIcon = false;
                      vm.simulationStatusText = result[0].status;
                      vm.refreshTimerSimulationProcessor = $timeout(
                        getSimulationProcessorStatus,
                        vm.statusRefreshTimeoutInMs
                      );
                    })
                    .catch(function () {
                      vm.displayLoadingIcon = false;
                      vm.simulationStatusText = 'STOPPED';
                    });
                }
              })
              .catch(function () {
                toastr.error(
                  'Error on save simulation data saved to s3 "' +
                    vm.simulationFile.name +
                    '"'
                );
              });
          })
          .catch(function () {
            toastr.error('Error on delete simulation data saved to s3');
          });
      } else {
        toastr.error('No simulation data selected');
      }
    }

    function stopSimulationProcessor() {
      vm.simulationStatusText = 'STOPPING...';
      vm.displayLoadingIcon = true;
      vm.isStoppingSimulation = true;
      EventStoreService.stopSimulationProcessor(vm.event.id)
        .then(function (result) {
          vm.displayLoadingIcon = false;
          vm.isStoppingSimulation = false;
          vm.simulationStatusText = result[0].status;
          vm.refreshTimerSimulationProcessor = $timeout(
            getSimulationProcessorStatus,
            vm.statusRefreshTimeoutInMs
          );
        })
        .catch(function () {
          vm.displayLoadingIcon = false;
          vm.isStoppingSimulation = false;
          vm.simulationStatusText = 'STOPPED';
        });
    }

    function simulationFilesChanged() {
      var fileReader = new FileReader();
      if (!vm.simulationFiles || vm.simulationFiles < 1) {
        toastr.error('No file selected.');
        return;
      }
      // In this moment we only read the first file
      vm.simulationFile = vm.simulationFiles[0];
      vm.simulationFile.source = vm.simulationFile.name;
      fileReader.onload = function (event) {
        vm.simulationFile.content = fileReader.result;
        // Note: The following line is required to trigger the update of the textarea
        // that is bound to vm.simulationFile.content.
        $scope.$apply();
        toastr.info(
          'Simulation data imported from file "' + vm.simulationFile.name + '"'
        );
        vm.simulationFile.contentType = 'text/csv';
        vm.simulationFile.md5 = '0';
      };
      fileReader.onerror = function (event) {
        toastr.error('Could not import file.');
      };
      fileReader.readAsText(vm.simulationFile, 'UTF-8');
    }

    function speedFactorChanged() {
      if (angular.isDefined(vm.speedFactor)) {
        if (isNaN(vm.speedFactor)) {
          vm.speedFactor = 1;
        }
      }
    }

    function changeResultsProcessorRestart() {
      vm.resultsProcessorRestart = !vm.resultsProcessorRestart;
    }

    function changeSimulationProcessorRestart() {
      vm.simulationProcessorRestart = !vm.simulationProcessorRestart;
    }
  }
})();

/*
 * Copyright (c) 2018 SPORTident GmbH. All rights reserved.
 */
(function () {
  'use strict';

  angular
    .module('c3poFrontend')
    .controller('EventEditStartlistController', EventEditStartlistController);

  /** @ngInject */
  function EventEditStartlistController(
    EventStoreService,
    $state,
    toastr,
    $stateParams,
    $scope
  ) {
    var vm = this;
    var startlist;
    var unassigned;

    vm.$onInit = onInit;

    function onInit() {
      unassigned = EventStoreService.getNotAssignedEventId();

      vm.event = {
        id: '',
        name: '',
      };
      loadEvent();

      vm.importFileChanged = importFileChanged;
      vm.save = save;
    }

    function loadEvent() {
      var eventId = $stateParams.eventId;
      if (eventId === 'new' || eventId === unassigned) {
        $state.go('event', { event: eventId }, { reload: true });
      }
      EventStoreService.getStartlist(eventId)
        .then(function (result) {
          startlist = result;
          vm.event.id = eventId;
          if (angular.isDefined(startlist)) {
            vm.startlistFormat = startlist.contentFormat;
            vm.startlistData = startlist.data;
            vm.revision = startlist.revision;
          } else {
            vm.startlistData = '';
            vm.startlistFormat = 'default';
            vm.revision = 0;
          }
          EventStoreService.getEvent(eventId).then(function (event) {
            vm.event.name = event.name;
          });
        })
        .catch(function () {
          // Redirect to the event list if the user is not allowed to access the startlist
          // (e.g. if the event is not found or access is denied).
          $state.go('events', { event: undefined }, { reload: true });
        });
    }

    function importFileChanged() {
      var fileReader = new FileReader();
      if (!vm.importFile || vm.importFile.length < 1) {
        toastr.error('No file selected.');
        return;
      }
      var file = vm.importFile[0];
      fileReader.onload = function (event) {
        vm.startlistData = fileReader.result;
        // Note: The following line is required to trigger the update of the textarea
        // that is bound to vm.startlistData.
        $scope.$apply();
        toastr.info(
          'Start list imported from file "' +
            file.name +
            '".<br />Press "Save" to confirm changes.'
        );
      };
      fileReader.onerror = function (event) {
        toastr.error('Could not import file.');
      };
      fileReader.readAsText(file, 'UTF-8');
    }

    function save() {
      startlist.startlistData = vm.startlistData;
      startlist.startlistFormat = vm.startlistFormat;
      startlist.eventId = vm.event.id;
      EventStoreService.saveStartlist(startlist)
        .then(saveStartlistSucceeded)
        .catch(saveStartlistFailed);
    }

    function saveStartlistSucceeded() {
      toastr.success('Start list for event "' + vm.event.name + '" saved');
      $state.go('event', { event: vm.event.id }, { reload: true });
    }

    function saveStartlistFailed(error) {
      var msg;
      msg = 'Could not save start list for event "' + vm.event.name + '"';
      var ms = error.data.errorMessages;
      if (ms.length > 0) {
        msg += ': <br />' + ms.join(', <br />');
      }
      toastr.error(msg);
    }
  }
})();

/*
 * Copyright (c) 2019 SPORTident GmbH. All rights reserved.
 */
(function () {
  'use strict';

  angular
    .module('c3poFrontend')
    .controller(
      'EventEditSimulationLogsController',
      EventEditSimulationLogsController
    );

  /** @ngInject */
  function EventEditSimulationLogsController(
    EventStoreService,
    $state,
    toastr,
    $stateParams,
    $scope,
    configBackendUrl
  ) {
    var vm = this;
    var SimulationLogs;
    var unassigned;

    vm.$onInit = onInit;
    vm.loadEvent = loadEvent;
    vm.getHist = getHist;
    vm.loadHist = loadHist;
    vm.selectedHistChanged = selectedHistChanged;
    vm.reload = reload;
    vm.histList = [{ id: undefined, displayName: 'No history' }];
    vm.selectedHist = undefined;

    function onInit() {
      unassigned = EventStoreService.getNotAssignedEventId();

      vm.event = {
        id: '',
        name: '',
      };
      vm.SimulationHist = '';
      loadEvent();
      vm.configBackendUrl = configBackendUrl;
      vm.save = save;
    }

    function loadEvent() {
      var eventId = $stateParams.eventId;
      if (eventId === 'new' || eventId === unassigned) {
        $state.go('event', { event: eventId }, { reload: true });
      }
      loadHist(eventId);
      EventStoreService.getEvent(eventId)
        .then(function (event) {
          vm.event.name = event.name;
          vm.event.id = event.id;
        })
        .catch(function () {
          // Redirect to the event list if the user is not allowed to access the SimulationLogs
          // (e.g. if the event is not found or access is denied).
          $state.go('events', { event: undefined }, { reload: true });
        });
    }

    function save() {
      EventStoreService.saveSimulationLogs(SimulationLogs)
        .then(saveSimulationLogsSucceeded)
        .catch(saveSimulationLogsFailed);
    }

    function saveSimulationLogsSucceeded() {
      toastr.success('SimulationLogs for event "' + vm.event.name + '" saved');
      $state.go('event', { event: vm.event.id }, { reload: true });
    }

    function saveSimulationLogsFailed(error) {
      var msg;
      msg = 'Could not save simulation-logs for event "' + vm.event.name + '"';
      var ms = error.data.errorMessages;
      if (ms.length > 0) {
        msg += ': <br />' + ms.join(', <br />');
      }
      toastr.error(msg);
    }

    function loadHist(eventId) {
      EventStoreService.getSimulationHist(eventId).then(function (result) {
        if (angular.isDefined(result)) {
          vm.histList = result[0].map(function (obj) {
            obj.displayName = obj.startDateTime;
            return obj;
          });
        } else {
          vm.histList = [{ id: undefined, displayName: 'No history' }];
          EventStoreService.getSimulationLogs(eventId).then(function (result) {
            SimulationLogs = result;
            vm.event.id = eventId;
            if (angular.isDefined(SimulationLogs)) {
              vm.SimulationLogsData = SimulationLogs;
            } else {
              vm.SimulationLogsData = '';
            }
          });
        }
        vm.selectedHist = vm.histList[0];
        selectedHistChanged();
      });
    }

    function getHist() {
      return vm.histList;
    }

    function reload() {
      if (angular.isDefined(vm.selectedHist) && vm.selectedHist.id !== null) {
        vm.selectedHistChanged();
      } else {
        vm.loadHist();
      }
    }

    function selectedHistChanged() {
      toastr.success('Selected task:\n' + vm.selectedHist.taskAwsId);
      EventStoreService.getSimulationLogsAws(
        vm.selectedHist.eventId,
        vm.selectedHist.taskAwsId
      )
        .then(function (result) {
          SimulationLogs = result;
          if (angular.isDefined(SimulationLogs)) {
            vm.SimulationLogsData = SimulationLogs;
          } else {
            vm.SimulationLogsData = 'No logs available';
          }
        })
        .catch(function () {
          vm.SimulationLogsData = 'No logs available';
        });
    }
  }
})();

/*
 * Copyright (c) 2019 SPORTident GmbH. All rights reserved.
 */
(function () {
  'use strict';

  angular
    .module('c3poFrontend')
    .controller(
      'EventEditResultsLogsController',
      EventEditResultsLogsController
    );

  /** @ngInject */
  function EventEditResultsLogsController(
    EventStoreService,
    $state,
    toastr,
    $stateParams,
    $scope,
    configBackendUrl
  ) {
    var vm = this;
    var ResultsLogs;
    var unassigned;

    vm.$onInit = onInit;
    vm.loadEvent = loadEvent;
    vm.getHist = getHist;
    vm.loadHist = loadHist;
    vm.selectedHistChanged = selectedHistChanged;
    vm.reload = reload;
    vm.histList = [{ id: undefined, displayName: 'No history' }];
    vm.selectedHist = undefined;

    function onInit() {
      unassigned = EventStoreService.getNotAssignedEventId();

      vm.event = {
        id: '',
        name: '',
      };
      vm.ResultsHist = '';
      loadEvent();
      vm.configBackendUrl = configBackendUrl;
      vm.save = save;
    }

    function loadEvent() {
      var eventId = $stateParams.eventId;
      if (eventId === 'new' || eventId === unassigned) {
        $state.go('event', { event: eventId }, { reload: true });
      }
      loadHist(eventId);
      EventStoreService.getEvent(eventId)
        .then(function (event) {
          vm.event.name = event.name;
          vm.event.id = event.id;
        })
        .catch(function () {
          // Redirect to the event list if the user is not allowed to access the ResultsLogs
          // (e.g. if the event is not found or access is denied).
          $state.go('events', { event: undefined }, { reload: true });
        });
    }

    function save() {
      EventStoreService.saveResultsLogs(ResultsLogs)
        .then(saveResultsLogsSucceeded)
        .catch(saveResultsLogsFailed);
    }

    function saveResultsLogsSucceeded() {
      toastr.success('ResultsLogs for event "' + vm.event.name + '" saved');
      $state.go('event', { event: vm.event.id }, { reload: true });
    }

    function saveResultsLogsFailed(error) {
      var msg;
      msg = 'Could not save results logs for event "' + vm.event.name + '"';
      var ms = error.data.errorMessages;
      if (ms.length > 0) {
        msg += ': <br />' + ms.join(', <br />');
      }
      toastr.error(msg);
    }

    function loadHist(eventId) {
      EventStoreService.getResultsHist(eventId).then(function (result) {
        if (angular.isDefined(result)) {
          vm.histList = result[0].map(function (obj) {
            obj.displayName = obj.startDateTime;
            return obj;
          });
        } else {
          vm.histList = [{ id: undefined, displayName: 'No history' }];
          EventStoreService.getResultsLogs(eventId).then(function (result) {
            ResultsLogs = result;
            vm.event.id = eventId;
            if (angular.isDefined(ResultsLogs)) {
              vm.ResultsLogsData = ResultsLogs;
            } else {
              vm.ResultsLogsData = '';
            }
          });
        }
        vm.selectedHist = vm.histList[0];
        selectedHistChanged();
      });
    }

    function getHist() {
      return vm.histList;
    }

    function reload() {
      if (angular.isDefined(vm.selectedHist) && vm.selectedHist.id !== null) {
        vm.selectedHistChanged();
      } else {
        vm.loadHist();
      }
    }

    function selectedHistChanged() {
      toastr.success('Selected task:\n' + vm.selectedHist.taskAwsId);
      EventStoreService.getResultsLogsAws(
        vm.selectedHist.eventId,
        vm.selectedHist.taskAwsId
      )
        .then(function (result) {
          ResultsLogs = result;
          if (angular.isDefined(ResultsLogs)) {
            vm.ResultsLogsData = ResultsLogs;
          } else {
            vm.ResultsLogsData = 'No logs available';
          }
        })
        .catch(function () {
          vm.ResultsLogsData = 'No logs available';
        });
    }
  }
})();

/*
 * Copyright (c) 2018 SPORTident GmbH. All rights reserved.
 */
(function () {
  'use strict';

  angular
    .module('c3poFrontend')
    .controller('EventEditEventdefController', EventEditEventdefController);

  /** @ngInject */
  function EventEditEventdefController(
    EventStoreService,
    $state,
    toastr,
    $stateParams,
    $scope
  ) {
    var vm = this;
    var eventdef;
    var unassigned;

    vm.$onInit = onInit;

    function onInit() {
      unassigned = EventStoreService.getNotAssignedEventId();

      vm.event = {
        id: '',
        name: '',
      };
      loadEvent();

      vm.importFileChanged = importFileChanged;
      vm.save = save;
    }

    function loadEvent() {
      var eventId = $stateParams.eventId;
      if (eventId === 'new' || eventId === unassigned) {
        $state.go('event', { event: eventId }, { reload: true });
      }
      EventStoreService.getEventdef(eventId)
        .then(function (result) {
          eventdef = result;
          vm.event.id = eventId;
          if (angular.isDefined(eventdef)) {
            vm.eventdefData = eventdef.data;
            vm.eventdefFormat = eventdef.contentFormat;
            vm.revision = eventdef.revision;
          } else {
            vm.eventdefData = '';
            vm.eventdefFormat = 'default';
            vm.revision = 0;
          }
          EventStoreService.getEvent(eventId).then(function (event) {
            vm.event.name = event.name;
          });
        })
        .catch(function () {
          // Redirect to the event list if the user is not allowed to access the event definition
          // (e.g. if the event is not found or access is denied).
          $state.go('events', { event: undefined }, { reload: true });
        });
    }

    function importFileChanged() {
      var fileReader = new FileReader();
      if (!vm.importFile || vm.importFile.length < 1) {
        toastr.error('No file selected.');
        return;
      }
      var file = vm.importFile[0];
      fileReader.onload = function (event) {
        vm.eventdefData = fileReader.result;
        // Note: The following line is required to trigger the update of the textarea
        // that is bound to vm.eventdefData.
        $scope.$apply();
        toastr.info(
          'Event definition imported from file "' +
            file.name +
            '".<br />Press "Save" to confirm changes.'
        );
      };
      fileReader.onerror = function (event) {
        toastr.error('Could not import file.');
      };
      fileReader.readAsText(file, 'UTF-8');
    }

    function save() {
      eventdef.eventdefData = vm.eventdefData;
      eventdef.eventdefFormat = vm.eventdefFormat;
      eventdef.eventId = vm.event.id;
      EventStoreService.saveEventdef(eventdef)
        .then(saveEventdefSucceeded)
        .catch(saveEventdefFailed);
    }

    function saveEventdefSucceeded() {
      toastr.success(
        'Event definition for event "' + vm.event.name + '" saved'
      );
      $state.go('event', { event: vm.event.id }, { reload: true });
    }

    function saveEventdefFailed(error) {
      var msg;
      msg = 'Could not save event definition for event "' + vm.event.name + '"';
      var ms = error.data.errorMessages;
      if (ms.length > 0) {
        msg += ': <br />' + ms.join(', <br />');
      }
      toastr.error(msg);
    }
  }
})();

/*
 * Copyright (c) 2018 SPORTident GmbH. All rights reserved.
 */
(function () {
  'use strict';

  angular
    .module('c3poFrontend')
    .controller('EventEditCorrectionController', EventEditCorrectionController);

  /** @ngInject */
  function EventEditCorrectionController(
    EventStoreService,
    $state,
    toastr,
    $stateParams,
    $scope
  ) {
    var vm = this;
    var correction;
    var unassigned;

    vm.$onInit = onInit;

    function onInit() {
      unassigned = EventStoreService.getNotAssignedEventId();

      vm.event = {
        id: '',
        name: '',
      };
      loadEvent();

      vm.importFileChanged = importFileChanged;
      vm.save = save;
    }

    function loadEvent() {
      var eventId = $stateParams.eventId;
      if (eventId === 'new' || eventId === unassigned) {
        $state.go('event', { event: eventId }, { reload: true });
      }
      EventStoreService.getCorrection(eventId)
        .then(function (result) {
          correction = result;
          vm.event.id = eventId;
          if (angular.isDefined(correction)) {
            vm.correctionFormat = correction.contentFormat;
            vm.correctionData = correction.data;
            vm.revision = correction.revision;
          } else {
            vm.correctionData = '';
            vm.correctionFormat = 'default';
            vm.revision = 0;
          }
          EventStoreService.getEvent(eventId).then(function (event) {
            vm.event.name = event.name;
          });
        })
        .catch(function () {
          // Redirect to the event list if the user is not allowed to access the correction
          // (e.g. if the event is not found or access is denied).
          $state.go('events', { event: undefined }, { reload: true });
        });
    }

    function importFileChanged() {
      var fileReader = new FileReader();
      if (!vm.importFile || vm.importFile.length < 1) {
        toastr.error('No file selected.');
        return;
      }
      var file = vm.importFile[0];
      fileReader.onload = function (event) {
        vm.correctionData = fileReader.result;
        // Note: The following line is required to trigger the update of the textarea
        // that is bound to vm.correctionData.
        $scope.$apply();
        toastr.info(
          'Correction imported from file "' +
            file.name +
            '".<br />Press "Save" to confirm changes.'
        );
      };
      fileReader.onerror = function (event) {
        toastr.error('Could not import file.');
      };
      fileReader.readAsText(file, 'UTF-8');
    }

    function save() {
      correction.correctionData = vm.correctionData;
      correction.correctionFormat = vm.correctionFormat;
      correction.eventId = vm.event.id;
      EventStoreService.saveCorrection(correction)
        .then(saveCorrectionSucceeded)
        .catch(saveCorrectionFailed);
    }

    function saveCorrectionSucceeded() {
      toastr.success('Correction for event "' + vm.event.name + '" saved');
      $state.go('event', { event: vm.event.id }, { reload: true });
    }

    function saveCorrectionFailed(error) {
      var msg;
      msg = 'Could not save correction for event "' + vm.event.name + '"';
      var ms = error.data.errorMessages;
      if (ms.length > 0) {
        msg += ': <br />' + ms.join(', <br />');
      }
      toastr.error(msg);
    }
  }
})();

/*
 * Copyright (c) 2019 SPORTident GmbH. All rights reserved.
 */
(function () {
  'use strict';

  angular
    .module('c3poFrontend')
    .controller('CompetitorDbUploadController', CompetitorDbUploadController);

  /** @ngInject */
  function CompetitorDbUploadController(
    $state,
    $scope,
    $uibModal,
    Account,
    toastr,
    PersistentParamsService,
    UserStoreService,
    CompetitorDbStoreService,
    configBackendUrl
  ) {
    var vm = this;
    vm.$onInit = onInit;

    vm.configBackendUrl = configBackendUrl;

    vm.getUsers = getUsers;
    vm.selectedUserChanged = selectedUserChanged;
    vm.clearParams = clearParams;
    vm.importFileChanged = importFileChanged;
    vm.upload = upload;
    vm.confirmDeleteCompetitorDatabase = confirmDeleteCompetitorDatabase;

    function onInit() {
      vm.userId = undefined;
      vm.userIsAdmin = false;
      vm.users = [];
      vm.selectedUser = null;
      vm.importFile = undefined;
      vm.importFileSelectedMessage = '';
      vm.databaseName = 'My competitor database';
      vm.fileFormat = 'csv-compact';
      vm.fileFormatDetected = false;
      vm.importMode = 'replace';
      vm.databases = [];
      vm.database = undefined; // For now we only display one database.
      vm.isUploading = false;
      vm.isDeleting = false;

      // Server settings currently allow MultipartFile uploads of up to 10 MB.
      vm.maxFileSizeMB = 10;

      vm.fileFormats = [
        { label: 'Orienteering App (CSV)', value: 'csv-compact' },
        { label: 'IOF XML 3.0 (XML)', value: 'xml-iof30' },
        { label: 'SportSoftware OE10 (CSV)', value: 'csv-oe10' },
        { label: 'SportSoftware OE11 (CSV)', value: 'csv-oe11' },
        { label: 'VELPOZ Schweiz / ORware (CSV)', value: 'csv-velpoz' },
      ];

      vm.importModes = [
        { label: 'Replace', value: 'replace' },
        { label: 'Update and add', value: 'update-and-add' },
      ];

      checkStateParams();

      Account.getPrincipal().then(function (promise) {
        vm.principal = promise;
        var account = vm.principal.getAccount();
        vm.userIsAdmin = account.authorities.indexOf('ROLE_ADMIN') !== -1;
        if (!$state.params.user) {
          vm.userId = account.id;
          vm.selectedUser = {
            id: account.id,
            displayName: account.firstName + ' ' + account.lastName,
          };
        } else {
          vm.userId = $state.params.user;
          UserStoreService.getUser(vm.userId)
            .then(function (result) {
              vm.selectedUser = result;
              vm.selectedUser.displayName =
                result.firstName + ' ' + result.lastName;
            })
            .catch(function () {
              vm.displayLoadingIcon = false;
            });
        }
        loadCompetitorDatabase();
      });
    }

    function loadCompetitorDatabase() {
      CompetitorDbStoreService.getCompetitorDatabases(vm.userId)
        .then(function (result) {
          vm.databases = result;
          if (vm.databases.length > 0) {
            vm.database = vm.databases[0];
            vm.databaseName = vm.database.name;
          }
        })
        .catch(function () {
          // Ignore.
        });
    }

    function importFileChanged() {
      var fileReader = new FileReader();
      if (!vm.importFile || vm.importFile.length < 1) {
        return;
      }
      var file = vm.importFile[0];
      if (file.size > vm.maxFileSizeMB * 1024 * 1024) {
        vm.importFileSelectedMessage =
          'Maximum allowed file size of ' + vm.maxFileSizeMB + ' MB exceeded.';
        return;
      }
      fileReader.onload = function (event) {
        vm.fileContent = fileReader.result;
        vm.importFileSelectedMessage = "File selected: '" + file.name + "'";
        tryToDetectFileFormat();
        // Note: The following line is required to trigger an update of the UI.
        $scope.$apply();
      };
      fileReader.onerror = function (event) {
        toastr.error('Could not import file.');
        vm.importFileSelectedMessage = 'Error reading file.';
        $scope.$apply();
      };
      fileReader.readAsText(file, 'UTF-8');
    }

    function tryToDetectFileFormat() {
      vm.fileFormatDetected = false;
      if (vm.fileContent.startsWith('<?xml')) {
        if (vm.fileContent.indexOf('iofVersion="3.0"') > 0) {
          vm.fileFormat = 'xml-iof30';
          vm.fileFormatDetected = true;
          return;
        }
      }
      var indexOfFirstLineBreak = vm.fileContent.indexOf('\n');
      if (indexOfFirstLineBreak > 0) {
        var firstLine = vm.fileContent.substring(0, indexOfFirstLineBreak);
        var arr = firstLine.split('\t');
        if (arr.length > 0 && firstLine.toLowerCase().startsWith('solv-nr')) {
          vm.fileFormat = 'csv-velpoz';
          vm.fileFormatDetected = true;
        } else {
          var arr1 = firstLine.split(',');
          var arr2 = firstLine.split(';');
          if (arr1.length === 8 || arr2.length === 8) {
            vm.fileFormat = 'csv-compact';
            vm.fileFormatDetected = true;
          } else if (arr1.length === 28 || arr2.length === 28) {
            vm.fileFormat = 'csv-oe10';
            vm.fileFormatDetected = true;
          } else if (arr1.length === 37 || arr2.length === 37) {
            vm.fileFormat = 'csv-oe11';
            vm.fileFormatDetected = true;
          }
        }
      }
    }

    function upload() {
      if (vm.isUploading || vm.isDeleting) {
        return;
      }
      if (!vm.importFile || vm.importFile.length < 1) {
        toastr.error('No file selected.');
        return;
      }
      var file = vm.importFile[0];
      if (file.size > vm.maxFileSizeMB * 1024 * 1024) {
        toastr.error('File exceeds maximum allowed size.');
        return;
      }
      if (!vm.databaseName || !vm.databaseName.trim()) {
        toastr.error('Please provide a database name.');
        return;
      }
      vm.isUploading = true;
      var formData = new FormData();
      formData.append('file', file);
      formData.append('databaseName', vm.databaseName);
      formData.append('fileFormat', vm.fileFormat);
      CompetitorDbStoreService.uploadCompetitorDatabase(
        vm.userId,
        formData,
        vm.database && vm.importMode === 'update-and-add'
      )
        .then(function (result) {
          vm.database = result.data;
          if (vm.database.competitorsTotalCount > 0) {
            toastr.success(
              'Import completed: ' +
                vm.database.competitorsTotalCount +
                ' competitors listed in database.'
            );
          } else {
            toastr.info('No competitors imported.');
          }
          vm.importFileSelectedMessage = '';
          vm.importFile = [];
          vm.isUploading = false;
          vm.fileFormatDetected = false;
          vm.fileContent = undefined;
        })
        .catch(function (error) {
          var msgs = '';
          if (error.data && error.data.errorMessages) {
            msgs = error.data.errorMessages.join('<br>');
          } else if (
            error.data &&
            error.data.errors &&
            error.data.errors.length > 0
          ) {
            if (
              error.status === 500 &&
              error.data.errors[0].message &&
              error.data.errors[0].message.startsWith(
                'Maximum upload size exceeded'
              )
            ) {
              msgs = 'Maximum allowed file size exceeded.';
            } else if (error.data.errors[0].error) {
              msgs = error.data.errors[0].error;
            } else if (error.data.errors[0].message) {
              msgs = error.data.errors[0].message;
            } else if (error.data.errors[0].detailMessage) {
              msgs = error.data.errors[0].detailMessage;
            }
          }
          toastr.error(
            'Could not import competitor database' +
              (msgs.length > 0 ? ': <br>' + msgs : '')
          );
          vm.isUploading = false;
        });
    }

    function confirmDeleteCompetitorDatabase(database) {
      if (vm.isUploading || vm.isDeleting) {
        return;
      }
      var dialogProperties = {
        title: 'Delete competitor database',
        message:
          'Are you sure you want to delete the competitor database "' +
          database.name +
          '"? Deleted data cannot be restored.',
        firstButtonText: 'Delete',
        firstButtonClass: 'btn-danger',
        secondButtonText: 'Cancel',
      };
      $uibModal
        .open({
          component: 'confirmationDialog',
          resolve: {
            dialogProperties: function () {
              return dialogProperties;
            },
          },
        })
        .result.then(
          function () {
            deleteCompetitorDatabase(database.uuid);
          },
          function () {}
        );
    }

    function deleteCompetitorDatabase(uuid) {
      vm.isDeleting = true;
      CompetitorDbStoreService.deleteCompetitorDatabase(vm.userId, uuid)
        .then(function () {
          toastr.success('Competitor database deleted.');
          vm.database = null;
          loadCompetitorDatabase();
          vm.isDeleting = false;
        })
        .catch(function () {
          toastr.error(
            'Something went wrong: Could not delete competitor database.'
          );
          vm.isDeleting = false;
        });
    }

    function getUsers(term) {
      return UserStoreService.getSelectedUsers(term, false, true);
    }

    function selectedUserChanged(id) {
      $state.params.user = id;
      PersistentParamsService.setParamsSubscriptions($state.params);
      $state.go($state.current, $state.params, { reload: true });
    }

    function checkStateParams() {
      if (hasAtLeastOneDefinedStateParam()) {
        PersistentParamsService.setParamsSubscriptions($state.params);
      } else {
        var params = PersistentParamsService.getParamsSubscriptions();
        if (params) {
          $state.params = params;
        }
        if (hasAtLeastOneDefinedStateParam()) {
          $state.go($state.current, $state.params, { reload: true });
        }
      }
    }

    function hasAtLeastOneDefinedStateParam() {
      for (var k in $state.params) {
        if (angular.isDefined($state.params[k])) {
          return true;
        }
      }
      return false;
    }

    function clearParams() {
      for (var k in $state.params) {
        $state.params[k] = undefined;
      }
      PersistentParamsService.setParamsSubscriptions($state.params);
      $state.go($state.current, $state.params, { reload: true });
    }
  }
})();

/*
 * Copyright (c) 2016 SPORTident GmbH. All rights reserved.
 */
(function () {
  'use strict';

  angular
    .module('c3poFrontend')
    .controller('BillSumController', BillSumController);

  /** @ngInject */
  function BillSumController(
    $timeout,
    $q,
    moment,
    $state,
    toastr,
    Account,
    BillStoreService,
    UserStoreService,
    PersistentParamsService,
    $uibModal,
    $location
  ) {
    var vm = this;
    var params;

    vm.$onInit = onInit;

    function onInit() {
      vm.initialLoading = true;
      vm.billDayAmount = 0.03;
      vm.defaultSize = 15;
      vm.showToolbar = false;
      vm.toggleState = 'all';
      vm.sumsort = undefined;

      vm.deleteDialogProperties = {
        title: 'Delete payments',
        message: 'Are you sure you want to delete the selected payment?',
        firstButtonText: 'Delete',
        firstButtonClass: 'btn-danger',
        secondButtonText: 'Cancel',
      };
      vm.currentYear = new Date().getFullYear();
      vm.yearToShow = undefined;
      // Functions
      vm.getUsers = getUsers;
      vm.clearParams = clearParams;
      vm.getBillCountTooltipHtml = getBillCountTooltipHtml;
      vm.sortSums = sortSums;
      vm.toggleActive = toggleActive;
      vm.selectedUserChanged = selectedUserChanged;
      vm.showAllBills = showAllBills;
      vm.navigationChange = navigationChange;
      vm.hidePagination = true;
      vm.showYear = showYear;
      vm.getAllBills = getAllBills;
      vm.checkUrlParams = checkUrlParams;

      Account.getPrincipal().then(function (promise) {
        vm.principal = promise;
        var account = vm.principal.getAccount();
        vm.userIsAdmin = account.authorities.indexOf('ROLE_ADMIN') !== -1;

        checkUrlParams();
        params = PersistentParamsService.getParamsBills();
        if (angular.isUndefined(params)) {
          undefineAllParams();
          PersistentParamsService.setParamsBills(params);
        }
        // Update location and selection (filter) boxes
        if (angular.isDefined(params)) {
          if (vm.principal.account.authorities.indexOf('ROLE_ADMIN') > -1) {
            vm.selectedUser = {
              firstName: 'All',
              lastName: 'Users',
              displayName: 'All Users',
            };
          } else {
            params.user = vm.principal.account.id;
            selectedUserChanged(params.user);
            return;
          }
          if (angular.isUndefined(params.year)) {
            params.year = vm.yearToShow;
          } else {
            vm.yearToShow = params.year;
          }
        }
        vm.getAllBills();
      });
    }

    function getAllBills() {
      if (
        angular.isUndefined(vm.selectedUser) &&
        angular.isUndefined(params.user) &&
        !(vm.principal.account.authorities.indexOf('ROLE_ADMIN') > -1)
      ) {
        params.user = vm.principal.account.id;
      }
      params.selectedUser = undefined;
      BillStoreService.getAllSaldos(
        params.page,
        params.size,
        params.year,
        params.sort
      )
        .then(function (result) {
          vm.bills = result;
          vm.initialLoading = false;
          adjustBills();
          params = PersistentParamsService.getParamsBills();
          if (
            angular.isDefined(vm.bills.totalCount) &&
            vm.bills.totalCount > params.size
          ) {
            vm.hidePagination = false;
          } else {
            vm.hidePagination = true;
          }
          // Hiding the loading icon is done with a delay to make sure that icon is visible
          // for at least a short time. This way the user has a visual indication that
          // the refresh action was actually performed.
          $timeout(function () {
            vm.displayLoadingIcon = false;
          }, 200);
        })
        .catch(function () {
          vm.displayLoadingIcon = false;
        });
    }

    function selectedUserChanged(id) {
      if (angular.isDefined(id)) {
        undefineFilterParams();
        params.user = id;
        PersistentParamsService.setParamsBills(params);
        $location
          .path('/billing/list')
          .search('user', params.user)
          .search('year', params.year)
          .search('page', params.page)
          .search('size', params.size)
          .search('sort', params.sort);
      }
    }

    function showAllBills() {
      PersistentParamsService.setParamsBills(params);
      $location
        .path('/billing/sum')
        .search('user', params.user)
        .search('year', params.year)
        .search('page', params.page)
        .search('size', params.size)
        .search('sort', params.sort);
      vm.getAllBills();
    }

    function navigationChange(page) {
      if (page === 0) {
        params.page = undefined;
      } else {
        params.page = page;
      }
      if (angular.isUndefined(params.selectedUser)) {
        PersistentParamsService.setParamsBills(params);
        $location
          .path('/billing/sum')
          .search('year', params.year)
          .search('page', params.page)
          .search('size', params.size);
        vm.getAllBills();
      }
    }

    function getUsers(term) {
      return UserStoreService.getSelectedUsers(term, true, true);
    }

    function clearParams() {
      if (angular.isDefined(params)) {
        params.user = undefined;
        params.year = undefined;
        params.bill = undefined;
        params.page = 0;
        params.size = vm.defaultSize;
        params.selectedUser = undefined;
        vm.selectedUser = undefined;
        vm.selectedBill = undefined;
        params.sort = undefined;
      }
    }

    function undefineAllParams() {
      params = {};
      params.page = 0;
      params.size = vm.defaultSize;
      params.user = undefined;
      params.bill = undefined;
      params.selectedUser = undefined;
      params.year = vm.yearToShow;
      params.sort = undefined;
    }

    function undefineParams() {
      params = {};
      params.user = undefined;
      params.bill = undefined;
      params.page = 0;
      params.size = vm.defaultSize;
      vm.selectedUser = undefined;
      vm.selectedBill = undefined;
      params.selectedUser = undefined;
      params.year = vm.yearToShow;
      params.sort = undefined;
    }

    function undefineFilterParams() {
      var e = $q.defer();
      e.resolve(undefineParams());
      return e.promise;
    }

    function adjustBills() {
      for (var i = 0; i < vm.bills.length; i++) {
        var m = vm.bills[i];
        m.amount = (0 - Number(m.amount)).toFixed(2);
        m.balance = (0 - Number(m.balance)).toFixed(2);
        m.selected = false;
      }
    }

    function getBillCountTooltipHtml() {
      return (
        '' +
        vm.bills.totalCount.toString() +
        ' bills in total<br />' +
        vm.bills.length.toString() +
        ' bills in this list'
      );
    }

    function checkUrlParams() {
      var currentUrl = $location.search();
      if (Object.keys(currentUrl).length !== 0) {
        undefineFilterParams();
        if (angular.isDefined(currentUrl.user)) {
          params.user = currentUrl.user;
        } else if (angular.isDefined(currentUrl.bill)) {
          params.bill = currentUrl.bill;
        }
        if (angular.isDefined(currentUrl.page)) {
          params.page = currentUrl.page === 0 ? undefined : currentUrl.page;
        }
        if (angular.isDefined(currentUrl.year)) {
          params.year =
            currentUrl.year === 0 ? undefined : parseInt(currentUrl.year);
        }
        if (angular.isDefined(currentUrl.sort)) {
          params.sort = currentUrl.sort;
          vm.sumsort = params.sort;
        } else {
          vm.sumsort = undefined;
        }
        PersistentParamsService.setParamsBills(params);
      }
    }

    function toggleActive(variable) {
      var buttonName = variable;
      vm.toggleState = buttonName;
      if (buttonName === 'showfilters') {
        if (vm.showToolbar === false) {
          vm.showToolbar = true;
          vm.toggleState = 'all';
        } else {
          vm.showToolbar = false;
          vm.toggleState = 'all';
        }
      }
    }

    function showYear(diff) {
      if (angular.isUndefined(diff)) {
        vm.yearToShow = diff;
      } else {
        vm.yearToShow = vm.currentYear - diff;
      }
      params.page = 0;
      params.year = vm.yearToShow;
      PersistentParamsService.setParamsBills(params);
      $location
        .path('/billing/sum')
        .search('user', params.selectedUser)
        .search('year', params.year)
        .search('page', params.page)
        .search('size', params.size);
    }

    function sortSums(sort) {
      if (sort === 'date') {
        params.sort = undefined;
      } else {
        params.sort = sort;
      }
      vm.sumsort = params.sort;
      PersistentParamsService.setParamsBills(params);
      $location
        .path('/billing/sum')
        .search('user', params.selectedUser)
        .search('year', params.year)
        .search('page', params.page)
        .search('size', params.size)
        .search('sort', params.sort);
    }
  }
})();

/*
 * Copyright (c) 2018 SPORTident GmbH. All rights reserved.
 */
(function () {
  'use strict';

  angular
    .module('c3poFrontend')
    .controller('BillListController', BillListController);

  /** @ngInject */
  function BillListController(
    $timeout,
    $q,
    moment,
    $state,
    toastr,
    Account,
    BillStoreService,
    UserStoreService,
    PersistentParamsService,
    $uibModal,
    $location
  ) {
    var vm = this;
    var params;

    vm.$onInit = onInit;

    function onInit() {
      vm.initialLoading = true;
      vm.billDayAmount = 0.03;
      vm.showToolbar = true;
      vm.defaultSize = 15;
      vm.toggleState = 'all';
      vm.deleteDialogProperties = {
        title: 'Delete payments',
        message: 'Are you sure you want to delete the selected payments?',
        firstButtonText: 'Delete',
        firstButtonClass: 'btn-danger',
        secondButtonText: 'Cancel',
      };
      vm.currentYear = new Date().getFullYear();
      vm.yearToShow = vm.currentYear;
      // Functions
      vm.getUsers = getUsers;
      vm.getBills = getBills;
      vm.editView = editView;
      vm.clearParams = clearParams;
      vm.getBillCountTooltipHtml = getBillCountTooltipHtml;
      vm.getSelectedBills = getSelectedBills;
      vm.deleteBills = deleteBills;
      vm.confirmDeleteDialog = confirmDeleteDialog;
      vm.toggleActive = toggleActive;
      vm.selectedUserChanged = selectedUserChanged;
      vm.showAllBills = showAllBills;
      vm.showGraphic = showGraphic;
      vm.navigationChange = navigationChange;
      vm.hidePagination = true;
      vm.refreshBills = refreshBills;
      vm.showUserYear = showUserYear;
      vm.checkUrlParams = checkUrlParams;
      vm.getEventName = getEventName;
      vm.getEventNameTitle = getEventNameTitle;

      Account.getPrincipal().then(function (promise) {
        vm.principal = promise;
        var account = vm.principal.getAccount();
        vm.userIsAdmin = account.authorities.indexOf('ROLE_ADMIN') !== -1;

        vm.checkUrlParams();
        params = PersistentParamsService.getParamsBills();
        if (angular.isUndefined(params)) {
          undefineAllParams();
        }
        // Update location and selection (filter) boxes
        if (angular.isDefined(params)) {
          if (angular.isUndefined(params.user)) {
            if (vm.principal.account.authorities.indexOf('ROLE_ADMIN') > -1) {
              $state.go('billing.sum');
              return;
            } else {
              params.user = vm.principal.account.id;
            }
          }
          if (angular.isDefined(params.user)) {
            UserStoreService.getUser(params.user).then(function (result) {
              vm.selectedUser = {
                id: result.id,
                firstName: result.firstName,
                lastName: result.lastName,
                displayName: result.firstName + ' ' + result.lastName,
                noReload: true,
              };
            });
          }
          vm.yearToShow = params.year;
        }
        getAllBills();
      });
    }

    function getAllBills() {
      if (
        angular.isUndefined(vm.selectedUser) &&
        angular.isUndefined(params.user) &&
        !(vm.principal.account.authorities.indexOf('ROLE_ADMIN') > -1)
      ) {
        params.user = vm.principal.account.id;
      }
      if (angular.isUndefined(params.year)) {
        params.year = vm.currentYear;
      }
      BillStoreService.getAllBills(
        params.page,
        params.size,
        params.user,
        params.year
      )
        .then(function (result) {
          vm.bills = result;
          adjustBills();
          vm.initialLoading = false;
          if (vm.bills.totalCount > params.size) {
            vm.hidePagination = false;
          } else {
            vm.hidePagination = true;
          }
          vm.yearToShow = params.year;
          // Hiding the loading icon is done with a delay to make sure that icon is visible
          // for at least a short time. This way the user has a visual indication that
          // the refresh action was actually performed.
          $timeout(function () {
            vm.displayLoadingIcon = false;
          }, 200);
        })
        .catch(function () {
          vm.displayLoadingIcon = false;
        });
    }

    // Manually triggered refresh of bill list.
    function refreshBills() {
      vm.displayLoadingIcon = true;
      getAllBills();
    }

    function selectedUserChanged(id) {
      if (angular.isUndefined(id)) {
        clearParams();
      } else {
        undefineFilterParams();
      }
      params.user = id;
      vm.selectedUser = undefined;
      PersistentParamsService.setParamsBills(params);
      if (angular.isUndefined(id)) {
        $location
          .path('/billing/sum')
          .search('user', params.user)
          .search('year', params.year)
          .search('page', params.page)
          .search('size', params.size)
          .search('sort', params.sort);
      } else {
        $location
          .path('/billing/list')
          .search('user', params.user)
          .search('year', params.year)
          .search('page', params.page)
          .search('size', params.size)
          .search('sort', params.sort);
      }
    }

    function showAllBills() {
      params.active = undefined;
      PersistentParamsService.setParamsBills(params);
      $location
        .path('/billing/list')
        .search('user', params.user)
        .search('year', params.year)
        .search('page', params.page)
        .search('size', params.size)
        .search('sort', params.sort);
    }

    function navigationChange(page) {
      if (page === 0) {
        params.page = undefined;
      } else {
        params.page = page;
      }
      if (angular.isUndefined(params.selectedUser)) {
        PersistentParamsService.setParamsBills(params);
        $location
          .path('/billing/list')
          .search('year', params.year)
          .search('page', params.page)
          .search('size', params.size);
      } else {
        PersistentParamsService.setParamsBills(params);
        $location
          .path('/billing/list')
          .search('user', params.user)
          .search('year', params.year)
          .search('page', params.page)
          .search('size', params.size)
          .search('sort', params.sort);
      }
    }

    function getUsers(term) {
      return UserStoreService.getSelectedUsers(term, true, true);
    }

    function getBills(term) {
      return BillStoreService.getSelectedBills(term, true);
    }

    function editView(bill) {
      if (vm.toggleState === 'all') {
        return;
      }
      var currentbill = bill;
      if (currentbill.type === 'invoice' || currentbill.type === 'adjustment') {
        currentbill.selected = !currentbill.selected;
      }
    }

    function getSelectedBills() {
      return vm.bills.filter(function (m) {
        return m.selected === true;
      });
    }

    function clearParams() {
      if (angular.isDefined(params)) {
        params.user = undefined;
        params.year = undefined;
        params.bill = undefined;
        params.page = 0;
        params.size = vm.defaultSize;
        params.selectedUser = undefined;
        vm.selectedUser = undefined;
        vm.selectedBill = undefined;
      }
    }

    function undefineAllParams() {
      params = {};
      params.page = 0;
      params.size = vm.defaultSize;
      params.user = undefined;
      params.bill = undefined;
      params.selectedUser = undefined;
      params.year = vm.yearToShow;
    }

    function undefineParams() {
      params = {};
      params.user = undefined;
      params.bill = undefined;
      params.page = 0;
      params.size = vm.defaultSize;
      vm.selectedUser = undefined;
      vm.selectedBill = undefined;
      params.selectedUser = undefined;
      params.year = vm.yearToShow;
    }

    function undefineFilterParams() {
      var e = $q.defer();
      e.resolve(undefineParams());
      return e.promise;
    }

    function adjustBills() {
      for (var i = 0; i < vm.bills.length; i++) {
        var m = vm.bills[i];
        m.amount = (0 - Number(m.amount)).toFixed(2);
        m.balance = (0 - Number(m.balance)).toFixed(2);
        m.selected = false;
      }
    }

    function getBillCountTooltipHtml() {
      return (
        '' +
        vm.bills.totalCount.toString() +
        ' bills in total<br />' +
        vm.bills.length.toString() +
        ' bills in this list'
      );
    }

    function checkUrlParams() {
      var currentUrl = $location.search();
      if (Object.keys(currentUrl).length !== 0) {
        undefineFilterParams();
        if (angular.isDefined(currentUrl.user)) {
          params.user = currentUrl.user;
        } else if (angular.isDefined(currentUrl.bill)) {
          params.bill = currentUrl.bill;
        }
        if (angular.isDefined(currentUrl.page)) {
          params.page = currentUrl.page === 0 ? undefined : currentUrl.page;
        }
        if (angular.isDefined(currentUrl.year)) {
          params.year =
            currentUrl.year === 0 ? undefined : parseInt(currentUrl.year);
        }

        PersistentParamsService.setParamsBills(params);
      }
    }

    function toggleActive(variable) {
      var buttonName = variable;
      vm.toggleState = buttonName;
      if (buttonName === 'closeall') {
        var selected = getSelectedBills();
        selected.map(function (obj) {
          obj.selected = false;
        });
        vm.toggleState = 'all';
      } else if (buttonName === 'showfilters') {
        if (vm.showToolbar === false) {
          vm.showToolbar = true;
          vm.toggleState = 'all';
        } else {
          vm.showToolbar = false;
          vm.toggleState = 'all';
        }
      }
    }

    function confirmDeleteDialog() {
      var selected = getSelectedBills();
      if (selected.length === 0) {
        toastr.error('Select payments to delete');
      } else {
        $uibModal
          .open({
            component: 'confirmationDialog',
            resolve: {
              dialogProperties: function () {
                return vm.deleteDialogProperties;
              },
            },
          })
          .result.then(
            function () {
              deleteBills();
            },
            function () {}
          );
      }
    }

    function deleteBills() {
      var selected = getSelectedBills();
      BillStoreService.deleteBills(selected).then(
        function () {
          getAllBills();
          $location
            .path('/billing/list')
            .search('user', params.user)
            .search('year', params.year)
            .search('page', params.page)
            .search('size', params.size)
            .search('sort', params.sort);
          if (selected.length === 1) {
            toastr.success(selected.length + ' payment was deleted');
          } else {
            toastr.success(selected.length + ' payments were deleted');
          }
          vm.toggleActive('all');
        },
        function () {
          toastr.error('There was an error deleting payments');
        }
      );
    }

    function showUserYear(diff) {
      if (angular.isUndefined(diff)) {
        vm.yearToShow = undefined;
      } else {
        vm.yearToShow = vm.currentYear - diff;
      }
      params.page = 0;
      params.year = vm.yearToShow;
      PersistentParamsService.setParamsBills(params);
      $location
        .path('/billing/list')
        .search('user', params.user)
        .search('year', params.year)
        .search('page', params.page)
        .search('size', params.size)
        .search('sort', params.sort);
      vm.refreshBills();
    }

    function showGraphic() {
      $location
        .path('/billing/statistics')
        .search('user', params.user)
        .search('year', params.year)
        .search('page', params.page)
        .search('size', params.size)
        .search('sort', params.sort);
    }

    function getEventNameTitle(m) {
      if (m.eventName == null) {
        return '';
      }
      if (m.currentEventName == null) {
        return m.eventName;
      }

      return m.eventName + ' now ' + m.currentEventName;
    }

    function getEventName(m) {
      if (m.eventName == null) {
        return '';
      }
      if (m.currentEventName == null) {
        return m.eventName;
      }

      return m.eventName + ' (' + m.currentEventName + ')';
    }
  }
})();

/*
 * Copyright (c) 2018 SPORTident GmbH. All rights reserved.
 */
(function () {
  'use strict';

  angular
    .module('c3poFrontend')
    .controller('BillGraphicController', BillGraphicController);

  /** @ngInject */
  function BillGraphicController(
    PersistentParamsService,
    StampStoreService,
    UserStoreService,
    $state,
    toastr,
    moment,
    Account,
    $stateParams,
    $location
  ) {
    var vm = this;

    // Functions
    vm.$onInit = onInit;
    vm.closeGraphic = closeGraphic;
    vm.createYearChart = createYearChart;
    vm.createEventChart = createEventChart;
    vm.getBillingData = getBillingData;

    function onInit() {
      vm.billDayAmount = 0.03;
      vm.params = {};
      var currentUrl = $location.search();
      if (angular.isDefined(currentUrl.user)) {
        vm.params.user = currentUrl.user;
      }
      if (angular.isDefined(currentUrl.year)) {
        vm.params.year =
          currentUrl.year === 0 ? undefined : parseInt(currentUrl.year);
      }
      if (angular.isUndefined(vm.params.user)) {
        $location.path('/billing');
      } else {
        UserStoreService.getUser(vm.params.user).then(function (result) {
          if (angular.isDefined(vm.params.year)) {
            vm.selectedYear = vm.params.year;
          }
          vm.selectedUser = {
            id: result.id,
            firstName: result.firstName,
            lastName: result.lastName,
            displayName: result.firstName + ' ' + result.lastName,
            noReload: true,
          };
          vm.billtext = 'graphic for ' + vm.selectedUser.displayName;
          vm.userid = vm.selectedUser.id;
          if (vm.userid !== undefined) {
            getBillingData();
          }
        });
      }
    }

    function closeGraphic() {
      $location
        .path('/billing')
        .search('user', vm.params.user)
        .search('year', vm.params.year)
        .search('page', vm.params.page)
        .search('size', vm.params.size)
        .search('sort', vm.params.sort);
    }

    function getBillingData() {
      StampStoreService.getBilling(vm.userid, vm.selectedYear).then(function (
        result
      ) {
        if (result.length !== 0) {
          var billing = result[0];
          vm.billing = billing;
          createYearChart(billing);
          createEventChart(billing);
        } else {
          vm.billing = null;
        }
      });
    }
    function createYearChart(billing) {
      /*
       * Create a normalised array indexed 0 to 11 with the athlete days
       * returned from the backend
       */
      var d = new Date();
      var months, month;
      var currentMonth = d.getMonth() + 1;
      var currentYear = d.getFullYear();
      if (currentYear === vm.selectedYear) {
        months = Array(currentMonth).fill(0);
        for (var i = 0; i < billing.perMonth.length; i++) {
          month = moment(
            billing.perMonth[i].month.toString(),
            'YYYYMM'
          ).month();
          if (month <= currentMonth) {
            months[month] = billing.perMonth[i].athleteDays;
          }
        }
      } else {
        months = Array(12).fill(0);
        for (var j = 0; j < billing.perMonth.length; j++) {
          month = moment(
            billing.perMonth[j].month.toString(),
            'YYYYMM'
          ).month();
          months[month] = billing.perMonth[j].athleteDays;
        }
      }

      /*
       * Calculate the total (cumulative), the total for the stacked chart,
       * and fill the array for the chart
       */
      var totals = months.reduce(function (ts, m) {
        var last = ts.length > 0 ? ts[ts.length - 1] : 0;
        return ts.concat([last + m]);
      }, []);

      var totalsForChart = totals.map(function (t, i) {
        return t - months[i];
      });

      var arrOfMonthsForChart = months.map(function (m, i) {
        return {
          c: [
            { v: moment().month(i).format('MMMM') },
            { v: m, f: m.toString() },
            {
              v:
                moment().month(i).format('MMMM') +
                '\n' +
                m.toString() +
                ' (' +
                String(parseFloat((m * vm.billDayAmount).toFixed(2))) +
                ' €)',
            },
            { v: totalsForChart[i], f: totals[i].toString() },
            {
              v:
                'Total ' +
                totals[i].toString() +
                ' (' +
                String(parseFloat((totals[i] * vm.billDayAmount).toFixed(2))) +
                ' €)',
            },
          ],
        };
      });

      /*
       * Create the chart
       */
      vm.yearChart = {
        type: 'ColumnChart',
        displayed: false,
        data: {
          cols: [
            { id: 'month', label: 'Month', type: 'string', p: {} },
            { id: 'month-id', label: 'Month', type: 'number', p: {} },
            { id: 'month-id', type: 'string', role: 'tooltip' },
            { id: 'total-id', label: 'Total', type: 'number', p: {} },
            { id: 'total-id', type: 'string', role: 'tooltip' },
          ],
          rows: arrOfMonthsForChart,
        },
        options: {
          title: 'Athlete days per month',
          isStacked: 'true',
          fill: 20,
          displayExactValues: true,
          vAxis: {
            title: 'Athlete days',
            gridlines: {
              count: 10,
            },
          },
          hAxis: {
            title: 'Month',
          },
        },
        formatters: {},
      };
    }

    function createEventChart(billing) {
      var sumOfEvents = 0;
      for (var i in billing.perEvent) {
        sumOfEvents = sumOfEvents + billing.perEvent[i].athleteDays;
      }
      var arrOfEvents = billing.perEvent.map(function (event) {
        var e = {
          c: [
            { v: event.event.name },
            { v: event.athleteDays },
            {
              v:
                event.event.name +
                ' (' +
                parseFloat((event.athleteDays * 100) / sumOfEvents).toFixed(1) +
                ' %)\n' +
                event.athleteDays +
                ' (' +
                String(
                  parseFloat((event.athleteDays * vm.billDayAmount).toFixed(2))
                ) +
                ' €)',
            },
          ],
        };
        return e;
      });

      var chart = {
        type: 'PieChart',
        data: {
          cols: [
            { id: 'e', label: 'Event', type: 'string' },
            { id: 'ad', label: 'Athlete days', type: 'number' },
            { id: 'e', type: 'string', role: 'tooltip' },
          ],
          rows: arrOfEvents,
        },
        options: {
          title: 'Athlete days per event',
        },
      };

      vm.eventChart = chart;
    }
  }
})();

/*
 * Copyright (c) 2016 SPORTident GmbH. All rights reserved.
 */
(function () {
  'use strict';

  angular
    .module('c3poFrontend')
    .controller('BillEditController', BillEditController);

  /** @ngInject */
  function BillEditController(
    PersistentParamsService,
    BillStoreService,
    EventStoreService,
    UserStoreService,
    $state,
    toastr,
    moment,
    Account,
    $stateParams,
    $location
  ) {
    var vm = this;

    vm.$onInit = onInit;

    function onInit() {
      vm.billDayAmount = 0.03;
      vm.billTitle = 'New Bill';
      vm.saveButtonText = 'Create';
      vm.showInvoice = true;
      vm.noDate = '';

      // Functions to define
      vm.getEvents = getEvents;
      vm.selectedEventChanged = selectedEventChanged;
      vm.saveBill = saveBill;
      vm.checkBookedClick = checkBookedClick;
      vm.calculateBill = calculateBill;
      vm.setlastMonthDays = setlastMonthDays;
      vm.invoiceItemTypeChanged = invoiceItemTypeChanged;

      vm.invoiceItemTypes = [
        { label: 'Invoice', value: 'invoice' },
        { label: 'Adjustment', value: 'adjustment' },
      ];

      vm.params = PersistentParamsService.getParamsBills();
      if (
        angular.isUndefined(vm.params) ||
        angular.isUndefined(vm.params.user)
      ) {
        $location.path('/billing');
      } else {
        UserStoreService.getUser(vm.params.user).then(function (result) {
          vm.selectedUser = {
            id: result.id,
            firstName: result.firstName,
            lastName: result.lastName,
            displayName: result.firstName + ' ' + result.lastName,
            noReload: true,
          };
        });

        BillStoreService.getBill($stateParams.billId).then(function (result) {
          vm.bill = result;
          Account.getPrincipal().then(function (principal) {
            vm.user = principal.getAccount();
            if (angular.isUndefined(vm.bill.userId)) {
              vm.bill.userId = vm.params.user;
            }
            vm.userIsAdmin = vm.user.authorities.indexOf('ROLE_ADMIN') !== -1;
          });
          var newDate = new Date();
          vm.setlastMonthDays();
          if (vm.bill.id === 'new') {
            vm.billTitle = 'New Invoice Item';
            vm.bill.eventId = null;
            vm.bill.userId = vm.params.user;
            vm.bill.type = 'invoice';
            vm.bill.pendingTransaction = true;
            vm.bill.appliedDiscount = 0;
            vm.saveButtonText = 'Create';
            vm.calculateBill();
          } else {
            vm.billTitle = 'Edit Invoice Item ' + vm.bill.id.toString();
            vm.saveButtonText = 'Save';
            vm.bill.amount = (0 - Number(vm.bill.amount)).toFixed(2);
            vm.bill.amountNumber = Number(vm.bill.amount);
            if (vm.bill.eventName && vm.bill.eventName !== '') {
              vm.selectedEvent = {
                id: vm.bill.eventId,
                name: vm.bill.eventName,
                displayName: vm.bill.eventName,
              };
            }
          }
          if (vm.bill.transactionDate === undefined) {
            vm.bill.transactionDate = newDate;
            vm.bill.invoiceDate = newDate;
          } else {
            vm.bill.transactionDate = new Date(vm.bill.transactionDate);
            vm.bill.invoiceDate = new Date(vm.bill.invoiceDate);
          }
        });
      }
    }

    function getEvents(term) {
      if (
        angular.isUndefined(vm.params) ||
        angular.isUndefined(vm.params.user)
      ) {
        vm.params = PersistentParamsService.getParamsBills();
      }
      return EventStoreService.getSelectedEvents(term, true, vm.params.user);
    }

    function selectedEventChanged(id) {
      vm.bill.eventId = id;
    }

    function saveBill() {
      vm.bill.amountReverse = (0 - Number(vm.bill.amountNumber)).toFixed(2);
      if (vm.bill.pendingTransaction) {
        vm.bill.transactionDate = vm.bill.invoiceDate;
      }
      BillStoreService.saveBill(vm.bill)
        .then(saveBillSucceeded)
        .catch(saveBillFailed);
    }

    function saveBillSucceeded() {
      // TODO: behaviour is not consistent with e.g. adding an athlete
      if (vm.bill.id === 'new') {
        toastr.success('Created bill "' + vm.bill.id + '"');
      } else {
        toastr.success('Saved bill "' + vm.bill.id + '"');
      }
      $location
        .path('/billing/list')
        .search('user', vm.params.user)
        .search('page', vm.params.page)
        .search('size', vm.params.size);
    }

    function saveBillFailed(error) {
      var msg;
      if (vm.bill.id === 'new') {
        msg = 'Could not create bill "' + vm.bill.id + '"';
      } else {
        msg = 'Could not save bill "' + vm.bill.id + '"';
        // msg = error.data.errors["0"].detailMessage;
      }
      var ms = error.data.errorMessages;
      if (ms.length > 0) {
        msg += ': <br />' + ms.join(', <br />');
      }

      toastr.error(msg);
    }

    function checkBookedClick() {
      if (vm.bill.type !== 'invoice') {
        return;
      }
      if (vm.bill.pendingTransaction) {
        vm.setlastMonthDays();
      } else {
        vm.bill.transactionDate = new Date();
      }
    }

    function calculateBill() {
      if (vm.bill.pendingTransaction || vm.bill.id === 'new') {
        BillStoreService.getAmountSum(
          vm.params.user,
          vm.billStart,
          vm.billEnd
        ).then(function (result) {
          vm.bill.amount = (0 - Number(result.amountSum)).toFixed(2);
          vm.bill.amountNumber = Number(result.amountSum);
          var startDateTxt = moment(vm.billStart).format('DD.MM.YY');
          var endDateTxt = moment(vm.billEnd).format('DD.MM.YY');
          vm.bill.bookingText =
            'Invoice for ' + startDateTxt + ' to ' + endDateTxt;
        });
      }
    }

    function setlastMonthDays() {
      vm.billStart = moment().subtract(1, 'M').date(1).toDate();
      vm.billEnd = moment().date(1).subtract(1, 'd').toDate();
    }

    function invoiceItemTypeChanged() {
      if (vm.bill.type === 'adjustment') {
        vm.bill.pendingTransaction = false;
        if (vm.bill.bookingText.startsWith('Invoice for')) {
          vm.bill.bookingText = '';
        }
      }
    }
  }
})();

/*
 * Copyright (c) 2016 SPORTident GmbH. All rights reserved.
 */
(function () {
  'use strict';

  angular.module('c3poFrontend').controller('HomeController', HomeController);

  /** @ngInject */
  function HomeController(Account, $state) {
    Account.getPrincipal().then(function (principal) {
      if (!principal.isAuthenticated()) {
        $state.go('login', {}, { reload: true });
      }
    });
  }
})();

/*
 * Copyright (c) 2016 SPORTident GmbH. All rights reserved.
 */
(function () {
  'use strict';

  angular.module('c3poFrontend').controller('AboutController', AboutController);

  /** @ngInject */
  function AboutController(Account, appVersion) {
    var vm = this;

    vm.$onInit = onInit;

    function onInit() {
      vm.appVersion = appVersion;

      vm.isAuthenticated = false;
      Account.getPrincipal().then(function (principal) {
        if (principal.isAuthenticated()) {
          vm.isAuthenticated = true;
        }
      });
    }
  }
})();

/*
 * Copyright (c) 2016 SPORTident GmbH. All rights reserved.
 */
(function () {
  'use strict';

  angular.module('c3poFrontend').controller('RootController', RootController);

  /** @ngInject */
  function RootController(Account, $scope, appVersion) {
    var vm = this;

    vm.$onInit = onInit;

    function onInit() {
      vm.principal = null;
      vm.appVersion = appVersion;
      updatePrincipal();
      $scope.$on('principalChanged', updatePrincipal);
    }

    function updatePrincipal() {
      Account.getPrincipal().then(function (principal) {
        vm.principal = principal;
      });
    }
  }
})();

/*
 * Copyright (c) 2016 SPORTident GmbH. All rights reserved.
 */
(function () {
  'use strict';

  angular.module('c3poFrontend').run(runBlock);

  /** @ngInject */
  function runBlock(
    Restangular,
    RestangularInterceptors,
    configBackendUrl,
    $rootScope,
    $anchorScroll
  ) {
    /*
     * Configure Restangular
     */
    Restangular.setBaseUrl(configBackendUrl);
    Restangular.addRequestInterceptor(
      RestangularInterceptors.requestInterceptor
    );
    Restangular.addResponseInterceptor(
      RestangularInterceptors.responseInterceptor
    );
    Restangular.setErrorInterceptor(RestangularInterceptors.errorInterceptor);

    /*
     * On route change *always* scroll to the top.
     *
     * For what it's worth, using ui-view's autoscroll parameter does not work
     * when updating a child ui-view and also does not scroll to the top, but to
     * the position of the ui-view.
     */
    var deregStateChangeSuccess = $rootScope.$on(
      '$stateChangeSuccess',
      function () {
        $anchorScroll();
      }
    );
    $rootScope.$on('$destroy', deregStateChangeSuccess);
  }
})();

/*
 * Copyright (c) 2016 SPORTident GmbH. All rights reserved.
 */
(function () {
  'use strict';

  angular.module('c3poFrontend').config(routeConfig);

  /** @ngInject */
  function routeConfig(
    $stateProvider,
    $urlRouterProvider,
    $urlMatcherFactoryProvider
  ) {
    $urlMatcherFactoryProvider.strictMode(false);
    $urlRouterProvider.otherwise('/login');
    $stateProvider
      .state('root', {
        abstract: true,
        templateUrl: 'app/root.view.html',
        controller: 'RootController',
        controllerAs: 'vm',
      })
      .state('about', {
        parent: 'root',
        url: '/about',
        templateUrl: 'app/admin/about.view.html',
        controller: 'AboutController',
        controllerAs: 'vm',
      })
      .state('events', {
        parent: 'root',
        url: '/events?{page:int}&{event:int}&{user:int}&{active:string}',
        templateUrl: 'app/admin/event/event-list.view.html',
        controller: 'EventListController',
        controllerAs: 'vm',
      })
      .state('event', {
        parent: 'root',
        redirectTo: 'event.edit',
        url: '/events/{eventId:[0-9]+|new}',
        template: '<div ui-view></div>',
        controller: 'EventEditController',
        controllerAs: 'vm',
      })
      .state('event.edit', {
        url: '/edit',
        templateUrl: 'app/admin/event/event-edit.view.html',
        controller: 'EventEditController',
        controllerAs: 'vm',
      })
      .state('event.files', {
        url: '/files?{prefix:string}',
        templateUrl: 'app/admin/event/event-files.view.html',
        controller: 'EventFilesController',
        controllerAs: 'vm',
      })
      .state('event.edit-eventdef', {
        url: '/edit/eventdef',
        templateUrl: 'app/admin/event/event-edit-eventdef.view.html',
        controller: 'EventEditEventdefController',
        controllerAs: 'vm',
      })
      .state('event.edit-startlist', {
        url: '/edit/startlist',
        templateUrl: 'app/admin/event/event-edit-startlist.view.html',
        controller: 'EventEditStartlistController',
        controllerAs: 'vm',
      })
      .state('event.edit-correction', {
        url: '/edit/correction',
        templateUrl: 'app/admin/event/event-edit-correction.view.html',
        controller: 'EventEditCorrectionController',
        controllerAs: 'vm',
      })
      .state('event.edit-simulation-logs', {
        url: '/edit/simulation-logs',
        templateUrl: 'app/admin/event/event-edit-simulation-logs.view.html',
        controller: 'EventEditSimulationLogsController',
        controllerAs: 'vm',
      })
      .state('event.edit-results-logs', {
        url: '/edit/results-logs',
        templateUrl: 'app/admin/event/event-edit-results-logs.view.html',
        controller: 'EventEditResultsLogsController',
        controllerAs: 'vm',
      })
      .state('billing', {
        parent: 'root',
        url: '/billing',
        redirectTo: 'billing.list',
        template: '<div ui-view></div>',
      })
      .state('billing.payment', {
        parent: 'root',
        url: '/billing/{billId:[0-9]+|new}',
        redirectTo: 'billing.payment.edit',
        template: '<div ui-view></div>',
      })
      .state('billing.payment.edit', {
        url: '/edit',
        templateUrl: 'app/admin/bill/bill-edit.view.html',
        controller: 'BillEditController',
        controllerAs: 'vm',
      })
      .state('billing.list', {
        url: '/list?{page:int}&{sort:string}&{user:int}&{bill:int}&{year:int}',
        templateUrl: 'app/admin/bill/bill-list.view.html',
        controller: 'BillListController',
        controllerAs: 'vm',
      })
      .state('billing.sum', {
        url: '/sum?{page:int}&{sort:string}&{user:int}&{bill:int}&{year:int}',
        templateUrl: 'app/admin/bill/bill-sum.view.html',
        controller: 'BillSumController',
        controllerAs: 'vm',
      })
      .state('billing.statistics', {
        url:
          '/statistics?{page:int}&{sort:string}&{user:int}&{bill:int}&{year:int}',
        templateUrl: 'app/admin/bill/bill-graphic.view.html',
        controller: 'BillGraphicController',
        controllerAs: 'vm',
      })
      .state('modems', {
        parent: 'root',
        url:
          '/modems?{page:int}&{sort:string}&{active:string}&{event:int}&{user:int}&{modem:int}',
        templateUrl: 'app/admin/modem/modem-list.view.html',
        controller: 'ModemListController',
        controllerAs: 'vm',
      })
      .state('modem', {
        parent: 'root',
        url: '/modem/{modemId:[0-9]+|new}',
        redirectTo: 'modem.edit',
        template: '<div ui-view></div>',
      })
      .state('modem.edit', {
        url: '/edit',
        templateUrl: 'app/admin/modem/modem-edit.view.html',
        controller: 'ModemEditController',
        controllerAs: 'vm',
      })
      .state('processors', {
        parent: 'root',
        url:
          '/processors?{event:int}&{family:string}&{state:string}&{page:int}&{sort:string}&{size:int}',
        templateUrl: 'app/admin/processors/processor-list.view.html',
        controller: 'ProcessorListController',
        controllerAs: 'vm',
        resolve: {
          security: function (Account, $state) {
            Account.getPrincipal().then(function (result) {
              var account = result.getAccount();
              var userAuthorised =
                account.authorities.indexOf('ROLE_ADMIN') !== -1;
              if (!userAuthorised) {
                $state.go('login', {}, {});
              }
            });
          },
        },
      })
      .state('subscription', {
        parent: 'root',
        url: '/subscription',
        redirectTo: 'subscription.list',
        template: '<div ui-view></div>',
      })
      .state('subscription.list', {
        url:
          '/list?{active:string}&{user:int}&{subscription:int}&{page:int}&{size:int}&{sort}',
        templateUrl: 'app/admin/subscription/subscription-list.view.html',
        controller: 'SubscriptionListController',
        controllerAs: 'vm',
      })
      .state('subscription.new', {
        url: '/new?{user:int}&{type:int}',
        templateUrl: 'app/admin/subscription/subscription-new.view.html',
        controller: 'SubscriptionNewController',
        controllerAs: 'vm',
      })
      .state('subscription.edit', {
        url: '/edit?{user:int}',
        templateUrl: 'app/admin/subscription/subscription-edit.view.html',
        controller: 'SubscriptionEditController',
        controllerAs: 'vm',
      })
      .state('subscription.upgrade', {
        url: '/upgrade?{user:int}&{type:int}',
        templateUrl: 'app/admin/subscription/subscription-new.view.html',
        controller: 'SubscriptionNewController',
        controllerAs: 'vm',
      })
      .state('subscription.promocodes', {
        url: '/promo-codes',
        redirectTo: 'subscription.promocodes.list',
        template: '<div ui-view></div>',
      })
      .state('subscription.promocodes.list', {
        url: '/list?{page:int}&{size:int}&{sort}',
        templateUrl: 'app/admin/subscription/promo-code-list.view.html',
        controller: 'PromoCodeListController',
        controllerAs: 'vm',
      })
      .state('subscription.promocodes.edit', {
        url: '/{promoCodeId:[0-9]+|new}?{type:[0-9]*}',
        templateUrl: 'app/admin/subscription/promo-code-edit.view.html',
        controller: 'PromoCodeEditController',
        controllerAs: 'vm',
      })
      .state('users', {
        parent: 'root',
        url:
          '/users?{page:int}&{size:int}&{sort:string}&{user:int}&{role:string}&{activated:bool}',
        templateUrl: 'app/admin/user/user-list.view.html',
        controller: 'UserListController',
        controllerAs: 'vm',
        resolve: {
          security: function (Account, $state) {
            Account.getPrincipal().then(function (result) {
              var account = result.getAccount();
              var userAuthorised =
                account.authorities.indexOf('ROLE_ADMIN') !== -1;
              if (!userAuthorised) {
                $state.go('login', {}, {});
              }
            });
          },
        },
      })
      .state('user', {
        parent: 'root',
        url: '/user/{userId:[0-9]+|new}',
        redirectTo: 'user.edit',
        template: '<div ui-view></div>',
      })
      .state('user.edit', {
        url: '/edit',
        templateUrl: 'app/admin/user/user-edit.view.html',
        controller: 'UserEditController',
        controllerAs: 'vm',
        resolve: {
          security: function (Account, $state) {
            Account.getPrincipal().then(function (result) {
              var account = result.getAccount();
              var userAuthorised =
                account.authorities.indexOf('ROLE_ADMIN') !== -1;
              if (!userAuthorised) {
                $state.go('login', {}, {});
              }
            });
          },
        },
      })
      .state('monitor', {
        parent: 'root',
        url:
          '/monitor?{event:int}&{modem:int}&{card:int}&{control:int}&{date:string}&{time:string}&{duplicates:int}',
        template: '<monitor></monitor>',
        reloadOnSearch: false,
      })
      .state('competitordbs', {
        parent: 'root',
        url: '/competitordbs',
        redirectTo: 'competitordbs.upload',
        template: '<div ui-view></div>',
      })
      .state('competitordbs.upload', {
        url: '/upload?{user:int}',
        templateUrl: 'app/admin/competitor-dbs/competitor-db-upload.view.html',
        controller: 'CompetitorDbUploadController',
        controllerAs: 'vm',
      })
      .state('login', {
        // TODO: Ideally we would somehow pass the redirectTo and redirectParams
        // route parameters as attributes to the login component --- I don't
        // know if or how this can be done easily.
        parent: 'root',
        url: '/login',
        template: '<login></login>',
        params: {
          redirectTo: {
            value: undefined,
          },
          redirectParams: {
            value: {},
          },
        },
      })
      .state('logout', {
        parent: 'root',
        url: '/logout',
        template: '<logout></logout>',
      })
      .state('settings', {
        parent: 'root',
        url: '/settings',
        template: '<settings principal="vm.principal"></settings>',
        /** @ngInject */
        controller: function (principal) {
          var vm = this;
          vm.principal = principal;
        },
        controllerAs: 'vm',
        resolve: {
          /** @ngInject */
          principal: function (Account) {
            return Account.getPrincipal();
          },
        },
      })
      .state('password-reset-request', {
        parent: 'root',
        url: '/password-reset-request',
        template: '<password-reset-request></password-reset-request>',
      })
      .state('password-reset', {
        parent: 'root',
        url: '/password-reset?{key:string}',
        template: '<password-reset></password-reset>',
      })
      .state('register-request', {
        parent: 'root',
        url: '/register',
        template: '<register-request></register-request>',
      })
      .state('activate', {
        parent: 'root',
        url: '/activate?{login:string}&{key:string}',
        template: '<register></register>',
      });
  }
})();

/*
 * Copyright (c) 2016 SPORTident GmbH. All rights reserved.
 */
/* global toastr:false, moment:false, localStorage:false */
(function () {
  'use strict';

  angular
    .module('c3poFrontend')
    .constant('toastr', toastr)
    .constant('moment', moment)
    .constant('localStorage', localStorage);
})();

/*
 * Copyright (c) 2016 SPORTident GmbH. All rights reserved.
 */
(function () {
  'use strict';

  angular.module('c3poFrontend').config(config);

  /*
   * See also components/state/state.service.js where we extend the ui-router's $state
   * service via a config method.
   *
   * See also components/confirmation-dialog/confirmation-dialog.config.js where we
   * change the default behavior of Bootstrap's modal dialogs.
   *
   */
  /** @ngInject */
  function config(
    $logProvider,
    $httpProvider,
    toastr,
    uiSelectConfig,
    RestangularProvider,
    $locationProvider
  ) {
    /*
     * Enable log
     */
    $logProvider.debugEnabled(true);

    /*
     * Setup our http error handler
     */
    $httpProvider.interceptors.push('HttpErrorInterceptor');
    RestangularProvider.setDefaultHeaders({
      'Content-Type': 'application/json',
    });

    /*
     * Set options for toastr
     */
    toastr.options.timeOut = 3000;
    toastr.options.positionClass = 'toast-top-right';
    toastr.options.preventDuplicates = false;
    toastr.options.progressBar = false;

    /*
     * ui-select
     */
    uiSelectConfig.theme = 'bootstrap';

    /*
     *
     */
    $locationProvider.hashPrefix('');
    $locationProvider.html5Mode({
      enabled: true,
      requireBase: true,
      rewriteLinks: true,
    });
  }
})();

/*
 * Copyright (c) 2016 SPORTident GmbH. All rights reserved.
 */
(function () {
  'use strict';

  /*
   * Configuration settings for C3PO, most importantly the address of the
   * backend.
   *
   * The correct program version will be set here by the build script (i.e. the
   * build script modifies and overwrites this file).
   */
  const APP_NAME = 'SPORTident Center Administration Classic';
  const APP_VERSION = '10.4.0+3e18d08.20200722140139';
  angular
    .module('c3po.config', [])
    .value('configBackendUrl', '/api/rest/v1')
    .value('appName', APP_NAME)
    .value('appVersion', APP_VERSION);
})();

angular.module("c3poFrontend").run(["$templateCache", function($templateCache) {$templateCache.put("app/root.view.html","<header class=header><si-navbar principal=vm.principal></si-navbar></header><main class=container><div ui-view></div></main><footer><span class=hidden>Version: {{vm.appVersion}}</span></footer>");
$templateCache.put("app/admin/about.view.html","<div class=row><div class=col-md-12><div class=about-container><p class=lead>About</p><p>SPORTident Center enables live updates and results for your sport event. As the hub for your athletes\' SPORTident records, SPORTident Center offers flexible routing and provides monitoring and metrics for your event.</p><p>Please <a href=mailto:center@sportident.com>contact us</a> if you have any questions.</p><p class=application-version>SPORTident Center version {{vm.appVersion}}</p></div></div></div>");
$templateCache.put("app/admin/home.view.html","<div class=row><div class=col-md-12><div class=home-container><p class=lead>Welcome to the SPORTident Center administration panel.</p></div></div></div>");
$templateCache.put("app/admin/bill/bill-edit.view.html","<div class=bill-view><div class=row><div class=col-md-12><h1 class=page-header>{{vm.billTitle}} <small><si-loading-indicator></si-loading-indicator></small></h1></div></div><div class=\"panel panel-default\"><div class=panel-heading><h3 class=panel-title>Transaction for {{vm.selectedUser.firstName}} {{vm.selectedUser.lastName}}</h3></div><div class=panel-body><div class=row><div class=col-md-6><form><div class=form-group><label for=start-date>Type</label><select id=invoiceItemType class=form-control ng-model=vm.bill.type ng-options=\"invoiceItemType.value as invoiceItemType.label for invoiceItemType in vm.invoiceItemTypes\" ng-click=vm.invoiceItemTypeChanged()></select></div><div ng-if=\"vm.bill.type === \'invoice\'\"><div class=form-group><label for=start-date>Invoice From:</label><date-input ng-model=vm.billStart format=\"\'dd.MM.yyyy\'\" ng-if=vm.bill.pendingTransaction ng-required=false></date-input><date-input ng-model=vm.noDate notenabled=true format=\"\'dd.MM.yyyy\'\" ng-if=!vm.bill.pendingTransaction ng-disabled=true ng-readonly=true></date-input></div><div class=form-group><label for=end-date>To:</label><date-input ng-model=vm.billEnd format=\"\'dd.MM.yyyy\'\" ng-if=vm.bill.pendingTransaction ng-required=false></date-input><date-input notenabled=true ng-model=vm.noDate format=\"\'dd.MM.yyyy\'\" ng-if=!vm.bill.pendingTransaction ng-disabled=true ng-readonly=true></date-input></div><div class=\"form-group row-fluid bill-group-height\"><div class=\"span6 pull-left\"><button id=calculate class=\"btn btn-success\" title=\"Sums up all invoice items of type other than \'invoice\'.\" ng-click=vm.calculateBill()>Calculate</button></div></div></div><div class=form-group><label for=amount>Amount</label><div class=input-group uib-tooltip=\"If user has paid, please insert a negative value\" tooltip-placement=bottom tooltip-trigger=\"\'click mouseenter\'\" tooltip-class=bill-tooltip><span class=input-group-addon>€</span> <input class=form-control type=number step=0.01 ng-model=vm.bill.amountNumber></div><div class=\"span6 pull-right\"><input id=booked type=checkbox class=form-check-input ng-model=vm.bill.pendingTransaction ng-true-value=false ng-false-value=true ng-click=vm.checkBookedClick() ng-class=\"{\'disabled\': vm.bill.type !== \'invoice\'}\" ng-disabled=\"vm.bill.type !== \'invoice\'\"><label class=form-check-label for=booked>&nbsp;Booked&nbsp;&nbsp;&nbsp;</label></div></div><div class=form-group><label for=bookingText>Booking text</label><input id=bookingText type=text class=form-control ng-model=vm.bill.bookingText ng-readonly=!vm.userIsAdmin></div><div class=form-group><label for=invoice-date>Invoice date</label><date-input notenabled=true format=\"\'dd.MM.yyyy\'\" ng-disabled=true ng-model=vm.bill.invoiceDate ng-readonly=true ng-if=!vm.bill.pendingTransaction></date-input><date-input notenabled=false format=\"\'dd.MM.yyyy\'\" ng-model=vm.bill.invoiceDate ng-if=vm.bill.pendingTransaction></date-input></div><div class=form-group><label for=payment-date>Transaction date</label><date-input ng-model=vm.bill.transactionDate notenabled=false format=\"\'dd.MM.yyyy\'\" ng-if=!vm.bill.pendingTransaction></date-input><date-input notenabled=true ng-model=vm.noDate format=\"\'dd.MM.yyyy\'\" ng-if=vm.bill.pendingTransaction ng-disabled=true ng-readonly=true></date-input></div><div class=form-group><button id=save class=\"btn btn-success\" ng-click=vm.saveBill()>{{vm.saveButtonText}}</button> <button id=cancel class=\"btn btn-danger\" ui-sref=billing.list>Cancel</button></div></form></div></div></div></div></div>");
$templateCache.put("app/admin/bill/bill-graphic.view.html","<div class=bill-view><div class=row><div class=col-md-12><h1 class=\"page-header header-adjustments-lists\"><a ng-click=vm.getBillingData() class=main-title title=Refresh>Billing Statistics</a> <small><si-loading-indicator loading=vm.displayLoadingIcon></si-loading-indicator></small></h1></div><!-- delete payment view--><div class=col-md-12><div class=\"billing-statistics-toolbar toolbar-left btn-group btn-group-right\"><a title=\"Return to list\" ng-click=vm.closeGraphic() class=\"btn btn-default cancel-button\"><span class=\"icon icon-left-big\"></span></a></div></div></div><div class=\"panel panel-default panel-first-graphic\"><div class=panel-body><div class=row><div class=col-md-6><div class=form-group ng-if=\"vm.billing!==null\"><label>Athlete days for {{vm.selectedUser.displayName}} in {{vm.selectedYear}}</label><br>{{vm.billing.total.athleteDays}} athlete day<span ng-if=\"vm.billing.total.athleteDays != 1\">s</span> ({{vm.billing.total.bill | currency:\'\'}} €)</div></div></div><div class=row ng-if=\"vm.billing!==null && vm.billing.total.athleteDays!==0\"><div class=col-md-6><div google-chart chart=vm.yearChart style=\"height: 600px; width: 90%\"></div></div><div class=col-md-6><div google-chart chart=vm.eventChart style=\"height: 600px; width: 100%\"></div></div></div><div ng-if=\"vm.billing===null\">There are no billing statistics available for the year {{vm.selectedYear}}.</div></div></div></div>");
$templateCache.put("app/admin/bill/bill-list.view.html","<div class=bill-view><div class=row><div class=col-md-12><h1 class=\"page-header header-adjustments-lists\"><a ng-click=vm.refreshBills() class=main-title title=\"Refresh list\">Billing</a><div class=list-item-count uib-tooltip-html=vm.getBillCountTooltipHtml() tooltip-placement=right-top tooltip-trigger=\"\'click mouseenter\'\" tooltip-class=bill-tooltip><span>{{vm.bills.totalCount}}</span></div><a title=\"Toggle filters\" ng-click=\"vm.toggleActive(\'showfilters\')\" class=\"btn btn-default show-hide-menu-btn\" ng-class=\"{active: vm.showToolbar === true, primary: vm.showToolbar === true}\"><span class=\"icon icon-filter\"></span></a> <small><si-loading-indicator loading=vm.displayLoadingIcon></si-loading-indicator></small></h1></div></div><div class=row><div class=col-md-12><div ng-class=\"{\'toolbar-right-admin\': vm.userIsAdmin,\'toolbar-right-user\': !vm.userIsAdmin, \'float-left\': !vm.userIsAdmin }\"><!-- default view--><div class=\"btn-group-right toolbar-all-bill\"><div class=event-toolbar ng-class=\"{\'hide-toolbar\': vm.showToolbar === false, \'show-toolbar\': vm.showToolbar === true}\"><div class=toolbar-left><div class=\"btn-group btn-group-left select-user-box-bill margin-between-toolbar-elements hidden\" ng-class=\"{\'toolbar-selectboxes-admin\': vm.userIsAdmin,\'toolbar-selectboxes-user\': !vm.userIsAdmin}\" has-authority=\"\'ROLE_ADMIN\'\" principal=vm.principal><dropdown-component model=vm.selectedUser callback=vm.getUsers placeholder=\"\'Search for user...\'\" on-select-item=vm.selectedUserChanged></dropdown-component></div><div class=\"btn-group btn-group-left clear-user-button-margin hidden\" has-authority=\"\'ROLE_ADMIN\'\" principal=vm.principal><a title=\"Show all users\" ng-click=vm.selectedUserChanged() class=\"btn btn-default\"><span class=\"icon icon-cancel\"></span></a></div><div class=\"btn-group btn-group-left margin-between-toolbar-elements\"><a class=\"btn btn-default\" ng-click=vm.showUserYear(0) ng-class=\"{active: vm.yearToShow === vm.currentYear}\">{{vm.currentYear}} </a><a class=\"btn btn-default\" ng-click=vm.showUserYear(1) ng-class=\"{active: vm.yearToShow === vm.currentYear - 1}\">{{vm.currentYear - 1}} </a><a class=\"btn btn-default\" ng-click=vm.showUserYear(2) ng-class=\"{active: vm.yearToShow === vm.currentYear - 2}\">{{vm.currentYear - 2}}</a></div><div ng-if=\"!(vm.yearToShow === undefined)\" class=\"btn-group btn-group-left margin-between-toolbar-elements\"><a title=\"Billing statistics\" ng-click=vm.showGraphic() class=\"btn btn-default\"><span class=\"icon icon-chart-bar\"></span></a></div></div><div class=toolbar-right><div ng-if=\"vm.toggleState === \'all\'\" class=\"btn-group btn-group-right toolbar-all hidden\" has-authority=\"\'ROLE_ADMIN\'\" principal=vm.principal><a title=\"Delete Transaction\" class=\"btn btn-default\" ng-click=\"vm.toggleActive(\'deleteinvoice\')\"><span class=\"icon icon-trash\"></span></a> <a title=\"New Transaction\" class=\"btn btn-success new-icon\" ui-sref=\"billing.payment.edit({billId: \'new\'})\" aria-label=\"New Transaction\"><span class=\"icon icon-plus\"></span></a></div><!-- delete payment view--><div ng-if=\"vm.toggleState === \'deleteinvoice\'\" class=\"btn-group btn-group-right toolbar-delete\"><a title=\"Delete Transaction\" class=\"btn btn-default disable-list\" ng-click=\"vm.toggleActive(\'delete\')\"><span class=\"icon icon-trash\"></span></a> <a title=Confirm ng-click=vm.confirmDeleteDialog() class=\"btn btn-default check-button-green\"><span class=\"icon icon-ok\"></span></a> <a title=Cancel ng-click=\"vm.toggleActive(\'closeall\')\" class=\"btn btn-default cancel-button-red\"><span class=\"icon icon-cancel\"></span></a></div></div></div></div></div></div></div><div class=\"row top-margin-row\"><div class=\"col-md-12 list-bottom-padding\"><div class=\"panel panel-default\" ng-if=!vm.initialLoading><div ng-if=\"(vm.bills.totalCount === undefined || vm.bills.totalCount === 0) && vm.yearToShow === undefined\" class=panel-body><p>There is no billing information available for {{vm.selectedUser.firstName}} {{vm.selectedUser.lastName}}. <span ng-if=\"vm.yearToShow === vm.currentYear\">If you are looking to start a SPORTident Orienteering App subscriptions, please go to <a ui-sref=subscription>Subscription</a>.</span></p></div><div ng-if=\"(vm.bills.totalCount === undefined || vm.bills.totalCount === 0) && vm.yearToShow !== undefined\" class=panel-body><p>There is no billing information available for {{vm.selectedUser.firstName}} {{vm.selectedUser.lastName}} for {{vm.yearToShow}}. <span ng-if=\"vm.yearToShow === vm.currentYear\">If you are looking to start a SPORTident Orienteering App subscription, please go to <a ui-sref=subscription>Subscription</a>.</span></p></div><div class=list-group ng-if=\"!(vm.selectedUser.firstName === \'All\') && vm.bills.length > 0\"><div ng-repeat=\"m in vm.bills\" ng-click=vm.editView(m) ng-class=\"{\'list-group-item selected\' : m.selected === true, \'list-group-item\': m.selected === false, \'select-cursor\': vm.toggleState !== \'all\', \'nonclickable\': vm.toggleState === \'all\', \'annoced\': m.pendingTransaction}\"><div class=row><div class=col-sm-2><div class=\"list-group-item-text overflow-ellipsis\">{{m.transactionDate}}</div></div><div class=\"col-sm-3 state-list\" ng-if=\"m.type === \'billed_data\'\"><div class=\"list-group-item-text overflow-ellipsis\"><a title=\"Event: {{vm.getEventNameTitle(m)}}\" ui-sref=\"events({event: m.eventId})\" ng-if=\"!(vm.toggleState === \'deleteinvoice\')\" ng-class=\"{\'icon icon-flag\' : m.eventName && 0 < m.eventName.length}\"><span>{{vm.getEventName(m)}}</span> </a><span ng-if=\"vm.toggleState === \'deleteinvoice\'\" ng-class=\"{\'icon icon-flag\' : m.eventName && 0 < m.eventName.length}\">{{m.eventName}}</span></div></div><div class=state-list ng-class=\"{\'col-sm-2\' : m.type === \'billed_data\', \'col-sm-5\' : m.type !== \'billed_data\'}\"><div class=\"list-group-item-text overflow-ellipsis\" title={{m.bookingText}} ng-class=\"{\'icon icon-pitch\' : m.type === \'billed_data\', \'icon icon-calendar\' : m.type === \'billed_subscription\'}\">{{m.bookingText}}</div></div><div class=\"col-sm-2 state-right\"><div ng-if=\"m.amount < 0\" class=\"list-group-item-text overflow-ellipsis green\" title=\"Amount {{m.amount/vm.billDayAmount | number:0}} ({{m.amount}} €)\"><span ng-if=\"m.type === \'invoice\' && !m.pendingTransaction && m.amount < 0\" class=\"icon icon-ok\"></span> {{m.amount}}&nbsp;€</div><div ng-if=\"m.amount >= 0\" class=\"list-group-item-text overflow-ellipsis\" title=\"Amount {{m.amount/vm.billDayAmount | number:0}} ({{m.amount}} €)\">{{m.amount}}&nbsp;€</div></div><div class=\"col-sm-2 state-right\"><div ng-if=\"!m.pendingTransaction && m.balance < 0\" class=\"list-group-item-text overflow-ellipsis green\" title=\"Balance {{m.balance/vm.billDayAmount | number:0}} ({{m.balance}} €)\"><span class=\"icon icon-sum\">{{m.balance}}&nbsp;€</span></div><div ng-if=\"!m.pendingTransaction && m.balance >= 0\" class=\"list-group-item-text overflow-ellipsis\" title=\"Balance {{m.balance/vm.billDayAmount | number:0}} ({{m.balance}} €)\"><span class=\"icon icon-sum\">{{m.balance}}&nbsp;€</span></div></div><div ng-if=\"(m.type === \'invoice\' || m.type === \'adjustment\') && vm.principal.account.authorities.indexOf(\'ROLE_ADMIN\') > -1\" class=\"col-sm-1 state-list\"><a ng-if=\"vm.toggleState == \'all\'\" ui-sref=\"billing.payment.edit({billId: m.id})\" class=\"edit-select-icons-bill editbox-bills-icons clickable align-middle\"><span class=\"icon icon-pencil\"></span></a><div ng-if=\"vm.toggleState !== \'all\' && m.selected === false\" class=\"editbox-bills-icons clickable align-middle\"><span class=\"icon icon-check-empty edit-select-icons-bill\"></span></div><div ng-if=\"vm.toggleState !== \'all\' && m.selected === true\" class=\"editbox-bills-icons clickable align-middle\"><span class=\"icon icon-check edit-select-icons-bill checkbox-selected\"></span></div></div></div></div></div></div><div class=footer ng-if=\"vm.hidePagination === false\"><div class=container><si-pagination sref=\"\'bills\'\" pagination=vm.bills.pagination go-to-page-callback=vm.navigationChange></si-pagination></div></div></div></div></div>");
$templateCache.put("app/admin/bill/bill-sum.view.html","<div class=bill-view><div class=row><div class=col-md-12><h1 class=\"page-header header-adjustments-lists\"><a ng-click=vm.refreshBills() class=main-title title=\"Refresh list\">Billing</a><div class=list-item-count uib-tooltip-html=vm.getBillCountTooltipHtml() tooltip-placement=right-top tooltip-trigger=\"\'click mouseenter\'\" tooltip-class=bill-tooltip><span>{{vm.bills.totalCount}}</span></div><a title=\"Toggle filters\" ng-click=\"vm.toggleActive(\'showfilters\')\" class=\"btn btn-default show-hide-menu-btn\" ng-class=\"{active: vm.showToolbar === true, primary: vm.showToolbar === true}\"><span class=\"icon icon-filter\"></span></a> <small><si-loading-indicator loading=vm.displayLoadingIcon></si-loading-indicator></small></h1></div></div><div class=row><div class=col-md-12><div ng-class=\"{\'toolbar-right-admin\': vm.userIsAdmin,\'toolbar-right-user\': !vm.userIsAdmin, \'float-left\': !vm.userIsAdmin && vm.toggleState === \'assignevent\'}\"><!-- default view--><div ng-if=\"vm.toggleState === \'all\'\" class=\"btn-group-right toolbar-all-bill\"><div class=event-toolbar ng-class=\"{\'hide-toolbar\': vm.showToolbar === false, \'show-toolbar\': vm.showToolbar === true}\"><div class=toolbar-left><div class=\"btn-group btn-group-left margin-between-toolbar-elements\"><a title=\"Sort by day of last bill or payment\" class=\"btn btn-default\" ng-click=\"vm.sortSums(\'date\')\" ng-class=\"{active: vm.sumsort === undefined }\">Date </a><a title=\"Sort by last name\" class=\"btn btn-default last-activity-margin\" ng-click=\"vm.sortSums(\'lastName\')\" ng-class=\"{active: vm.sumsort === \'lastName\'}\">Last name </a><a title=\"Sort by total cost\" class=\"btn btn-default last-activity-margin\" ng-click=\"vm.sortSums(\'amount\')\" ng-class=\"{active: vm.sumsort === \'amount\'}\"><span class=\"icon icon-pitch\"></span> </a><a title=\"Sort by balance\" class=\"btn btn-default last-activity-margin\" ng-click=\"vm.sortSums(\'balance\')\" ng-class=\"{active: vm.sumsort === \'balance\'}\"><span class=\"icon icon-sum\"></span></a></div><div class=\"btn-group btn-group-left select-user-box-bill margin-between-toolbar-elements hidden\" ng-class=\"{\'toolbar-selectboxes-admin\': vm.userIsAdmin,\'toolbar-selectboxes-user\': !vm.userIsAdmin}\" has-authority=\"\'ROLE_ADMIN\'\" principal=vm.principal><dropdown-component model=vm.selectedUser callback=vm.getUsers placeholder=\"\'Search for user...\'\" on-select-item=vm.selectedUserChanged></dropdown-component></div><div class=\"btn-group btn-group-left margin-between-toolbar-elements\"><a class=\"btn btn-default\" ng-click=vm.showYear() ng-class=\"{active: vm.yearToShow === undefined }\">All </a><a class=\"btn btn-default\" ng-click=vm.showYear(0) ng-class=\"{active: vm.yearToShow === vm.currentYear}\">{{vm.currentYear}} </a><a class=\"btn btn-default\" ng-click=vm.showYear(1) ng-class=\"{active: vm.yearToShow === vm.currentYear - 1}\">{{vm.currentYear - 1}} </a><a class=\"btn btn-default\" ng-click=vm.showYear(2) ng-class=\"{active: vm.yearToShow === vm.currentYear - 2}\">{{vm.currentYear - 2}}</a></div></div><div class=toolbar-right><div ng-if=\"vm.toggleState === \'all\' && !(vm.selectedUser.firstName === \'All\')\" class=\"btn-group btn-group-right toolbar-all hidden\" has-authority=\"\'ROLE_ADMIN\'\" principal=vm.principal><a title=\"Delete payment\" class=\"btn btn-default\" ng-click=\"vm.toggleActive(\'deleteinvoice\')\"><span class=\"icon icon-trash\"></span></a> <a title=New class=\"btn btn-success new-icon\" ui-sref=\"billing.payment.edit({billId: \'new\'})\" aria-label=New><span class=\"icon icon-plus\"></span></a></div></div></div></div></div></div></div><div class=\"row top-margin-row\"><div class=\"col-md-12 list-bottom-padding\"><div class=\"panel panel-default\" ng-if=!vm.initialLoading><div ng-if=\"vm.bills.totalCount === undefined\" class=panel-body><p>There is no data transmission billing information available. If you are looking for SPORTident Orienteering App subscriptions and related billing, please go to <a ui-sref=subscriptions>Subscriptions</a>.</p></div><div class=list-group ng-if=\"vm.principal.account.authorities.indexOf(\'ROLE_ADMIN\') > -1\"><div ng-repeat=\"m in vm.bills\" ng-class=\"{\'list-group-item selected\' : m.selected === true, \'list-group-item\': m.selected === false, \'select-cursor\': vm.toggleState !== \'all\', \'nonclickable\': vm.toggleState === \'all\'}\"><div class=row><div class=\"col-sm-5 state-list\"><div class=\"list-group-item-text overflow-ellipsis\"><a title=\"User: {{m.firstName}} {{m.lastName}}\" ng-click=vm.selectedUserChanged(m.userId) style=\"cursor: pointer\"><span class=\"icon icon-user\"></span> {{m.firstName}} {{m.lastName}}</a></div></div><div class=col-sm-3><div class=\"list-group-item-text overflow-ellipsis\" title=\"Day of last bill or payment\">{{m.transactionDate}}</div></div><div class=\"col-sm-2 state-list\"><div ng-if=\"m.amount < 0\" class=\"list-group-item-text overflow-ellipsis green\" title=\"Total cost {{m.amount/vm.billDayAmount | number:0}} ({{m.amount}} €)\"><span class=\"icon icon-pitch\">{{m.amount}}&nbsp;€</span></div><div ng-if=\"m.amount >= 0\" class=\"list-group-item-text overflow-ellipsis\" title=\"Total cost {{m.amount/vm.billDayAmount | number:0}} ({{m.amount}} €)\"><span class=\"icon icon-pitch\">{{m.amount}}&nbsp;€</span></div></div><div class=\"col-sm-2 state-list\"><div ng-if=\"m.balance < 0\" class=\"list-group-item-text overflow-ellipsis green\" title=\"Balance {{m.balance/vm.billDayAmount}} ({{m.balance}} €)\"><span class=\"icon icon-sum\">{{m.balance}}&nbsp;€</span></div><div ng-if=\"m.balance >= 0\" class=\"list-group-item-text overflow-ellipsis\" title=\"Balance {{m.balance/vm.billDayAmount}} ({{m.balance}} €)\"><span class=\"icon icon-sum\">{{m.balance}}&nbsp;€</span></div></div></div></div></div></div><div class=footer ng-if=\"vm.hidePagination === false\"><div class=container><si-pagination sref=\"\'bills\'\" pagination=vm.bills.pagination go-to-page-callback=vm.navigationChange></si-pagination></div></div></div></div></div>");
$templateCache.put("app/admin/competitor-dbs/competitor-db-upload.view.html","<div class=page-competitor-dbs-upload><div class=row><div class=col-md-12><h1 class=\"page-header header-adjustments-lists\"><span class=main-title-no-hover>Competitor Database</span></h1></div></div><div class=row><div class=col-md-12 has-authority=\"\'ROLE_ADMIN\'\" principal=vm.principal><div class=competitor-dbs-toolbar><div class=toolbar-left><div class=btn-group><dropdown-component model=vm.selectedUser callback=vm.getUsers placeholder=\"\'Search for user...\'\" on-select-item=vm.selectedUserChanged></dropdown-component></div><div class=\"btn-group clear-filters\"><a title=\"Clear filters\" ng-click=vm.clearParams() class=\"btn btn-default\"><span class=\"icon icon-cancel\"></span></a></div></div></div></div></div><div class=\"panel panel-default upload-competitor-db-form-panel\"><div class=panel-heading><h3 class=panel-title>Competitor database</h3></div><div class=panel-body><div class=row ng-if=vm.isDeleting><div class=col-sm-12>Deleting ...</div></div><div class=row ng-if=\"!vm.isDeleting && !vm.database\"><div class=col-sm-12>No database imported.</div></div><div class=row ng-if=\"!vm.isDeleting && vm.database\"><div class=col-sm-6><div class=form-group><label>Database name</label><div>{{ vm.database.name }}</div></div><div class=form-group><label>Last modified</label><div>{{ vm.database.lastModification }}</div></div><div class=form-group><label>Number of competitors</label><div>{{ vm.database.competitorsTotalCount }}</div></div><div class=form-group><a class=\"btn btn-default\" href=\"{{ vm.configBackendUrl }}/users/{{ vm.userId }}/competitordbs/{{ vm.database.uuid }}/competitors?format=csv\" ng-class=\"{\'disabled\' : vm.isUploading || vm.isDeleting}\">Export CSV</a> <button class=\"btn btn-danger\" ng-click=vm.confirmDeleteCompetitorDatabase(vm.database) ng-class=\"{\'disabled\' : vm.isUploading || vm.isDeleting}\">Delete database</button></div></div></div></div></div><div class=\"panel panel-default upload-competitor-db-form-panel\"><div class=panel-heading><h3 class=panel-title>Import database from file</h3></div><div class=panel-body><div class=row ng-if=vm.isUploading><div class=col-sm-12>Uploading ...</div></div><div class=row ng-if=!vm.isUploading><div class=col-sm-6><form><div class=\"form-group file-input-container\"><label class=select-file-label for=file>Database file</label><label class=\"btn btn-default\">Select file<file-input ng-model=vm.importFile ng-change=vm.importFileChanged()></file-input></label><span class=file-selected-message>{{ vm.importFileSelectedMessage }}</span><div ng-if=\"vm.fileContent && !vm.fileFormatDetected\" style=\"margin-top: 5px\">Unable to automatically detect file format. Please check if you selected the right file.</div></div><div class=form-group><label for=fileFormat>File format</label><select id=fileFormat class=form-control ng-disabled=vm.fileFormatDetected ng-model=vm.fileFormat ng-options=\"fileFormat.value as fileFormat.label for fileFormat in vm.fileFormats\"></select></div><div class=form-group><label for=name>Database name</label><input id=name type=text class=form-control ng-model=vm.databaseName required></div><div class=form-group ng-if=vm.database><label for=importMode>Import mode</label><select id=importMode class=form-control ng-model=vm.importMode ng-options=\"importMode.value as importMode.label for importMode in vm.importModes\"></select></div><div class=form-group ng-if=!vm.database><label for=importMode>Import mode</label><input id=importMode type=text class=form-control value=\"Create new database\" disabled></div><div><button class=\"btn btn-success\" type=button ng-click=vm.upload() ng-class=\"{\'disabled\' : vm.isUploading || vm.isDeleting}\">Upload and import</button></div></form></div></div></div></div><div class=\"panel panel-default upload-competitor-db-form-panel\"><div class=panel-heading><h3 class=panel-title>Notes</h3></div><div class=panel-body><div class=row><div class=col-sm-12><p>Please note that this feature has Alpha status. It is available for testing, but not yet officially supported.</p><p>By uploading a competitor database you can facilitate registration of competitors in the Orienteering App. On registration and readout, the app will automatically match competitors by their SI-Card number or present a list of competitors from the database if no match is found. Competitor databases uploaded to Center are automatically synchronised to your Android phone if you are signed in with your SPORTident Center account in the app.</p><p>If you upload a database file, the following competitor data is stored in SPORTident Center on AWS: member ID, card number, name, year of birth, club and town. Other data included in the uploaded file is discarded. The uploaded data is linked to your account and cannot be accessed by other users. Deleting a database removes all imported records permanently.</p><p>CSV format \"Orienteering App\" (UTF-8 encoded):</p><pre>\n              ID;CardNumber;FirstName;LastName;Sex;YearOfBirth;Organisation;City\n              X-12271;8000001;John;Smith;M;1981;Fantastic Runners;London\n              X-13422;8000002;Jane;Smith;F;1980;Fantastic Runners;London\n          </pre><p>Other supported CSV formats (ISO-8859-1 encoded):</p><ul><li>SportSoftware OE10</li><li>SportSoftware OE11</li><li>VELPOZ Schweiz / ORware</li></ul><p>Supported XML formats (UTF-8 encoded):</p><ul><li>IOF XML 3.0 CompetitorList</li></ul></div></div></div></div></div>");
$templateCache.put("app/admin/event/event-edit-correction.view.html","<div class=row><div class=col-md-12><h1 class=page-header>{{vm.event.name}}</h1></div></div><div class=\"panel panel-default event-edit-correction-panel\"><div class=panel-heading><h3 class=panel-title>Correction (Revision: {{vm.revision}})</h3></div><div class=panel-body><div class=row><div class=col-md-12><form><div class=form-group><label for=correction-data>Data</label><textarea id=correction-text class=form-control ng-model=vm.correctionData></textarea></div><div class=form-group><label for=correction-format>Format</label><input id=correction-format type=text class=form-control ng-model=vm.correctionFormat></div><div class=form-group><button id=save class=\"btn btn-success\" ng-click=vm.save()>Save</button> <button id=cancel class=\"btn btn-danger\" ui-sref=\"event.edit({event: vm.event.id})\">Cancel</button><div class=\"form-group file-input-container\"><label class=\"btn btn-default\">Import from file<file-input ng-model=vm.importFile ng-change=vm.importFileChanged()></file-input></label></div></div></form></div></div></div></div>");
$templateCache.put("app/admin/event/event-edit-eventdef.view.html","<div class=row><div class=col-md-12><h1 class=page-header>{{vm.event.name}}</h1></div></div><div class=\"panel panel-default event-edit-eventdef-panel\"><div class=panel-heading><h3 class=panel-title>Event definition (Revision: {{vm.revision}})</h3></div><div class=panel-body><div class=row><div class=col-md-12><form><div class=form-group><label for=eventdef-data>Data</label><textarea id=eventdef-data class=form-control ng-model=vm.eventdefData></textarea></div><div class=form-group><label for=eventdef-format>Format</label><input id=eventdef-format type=text class=form-control ng-model=vm.eventdefFormat></div><div class=form-group><button id=save class=\"btn btn-success\" ng-click=vm.save()>Save</button> <button id=cancel class=\"btn btn-danger\" ui-sref=\"event.edit({event: vm.event.id})\">Cancel</button><div class=\"form-group file-input-container\"><label class=\"btn btn-default\">Import from file<file-input ng-model=vm.importFile ng-change=vm.importFileChanged()></file-input></label></div></div></form></div></div></div></div>");
$templateCache.put("app/admin/event/event-edit-results-logs.view.html","<div class=row><div class=col-md-12><h1 class=page-header>{{ vm.event.name }} <small><si-loading-indicator loading=vm.displayLoadingIcon></si-loading-indicator></small></h1></div></div><div class=\"panel panel-default event-edit-result-logs-panel\"><div class=panel-heading><h3 class=panel-title>Result-Logs</h3></div><div class=panel-body><div class=row><div class=col-md-12><form><div class=\"form-group col-md-12\"><textarea id=result-logs-text class=form-control ng-model=vm.ResultsLogsData readonly></textarea></div><div class=col-md-12><a class=\"btn btn-success\" href=\"{{ vm.configBackendUrl }}/events/{{\n                vm.event.id\n              }}/resultsprocessor/logs/{{\n                vm.selectedHist.taskAwsId\n              }}?maxLogs=10000\" download=\"logs_results_processor_event_{{ vm.event.id }}.txt\" target=new>Save to file</a> <button id=cancel class=\"btn btn-danger\" ui-sref=\"event.edit({event: vm.event.id})\">Back</button> <button class=\"btn btn-success\" ng-click=vm.reload()>Reload</button><div class=\"btn btn-select\"><dropdown-component id=results-processor-history placeholder=\"\'Select history\'\" model=vm.selectedHist local-callback=vm.getHist on-select-item=(vm.selectedHistChanged)></dropdown-component></div></div></form></div></div></div></div>");
$templateCache.put("app/admin/event/event-edit-simulation-logs.view.html","<div class=row><div class=col-md-12><h1 class=page-header>{{ vm.event.name }} <small><si-loading-indicator loading=vm.displayLoadingIcon></si-loading-indicator></small></h1></div></div><div class=\"panel panel-default event-edit-simulation-logs-panel\"><div class=panel-heading><h3 class=panel-title>Simulation-Logs</h3></div><div class=panel-body><div class=row><div class=col-md-12><form><div class=form-group><textarea id=simulation-logs-text class=form-control ng-model=vm.SimulationLogsData readonly></textarea></div><div class=form-group><a class=\"btn btn-success\" href=\"{{ vm.configBackendUrl }}/events/{{\n                vm.event.id\n              }}/simulationprocessor/logs/{{\n                vm.selectedHist.taskAwsId\n              }}?maxLogs=10000\" download=\"logs_simulation_event_{{ vm.event.id }}.txt\" target=new>Save to file</a> <button id=cancel class=\"btn btn-danger\" ui-sref=\"event.edit({event: vm.event.id})\">Back</button> <button class=\"btn btn-success\" ng-click=vm.reload()>Reload</button><div class=\"btn btn-select\"><dropdown-component id=simulation-processor-history placeholder=\"\'Select history\'\" model=vm.selectedHist local-callback=vm.getHist on-select-item=(vm.selectedHistChanged)></dropdown-component></div></div></form></div></div></div></div>");
$templateCache.put("app/admin/event/event-edit-startlist.view.html","<div class=row><div class=col-md-12><h1 class=page-header>{{vm.event.name}}</h1></div></div><div class=\"panel panel-default event-edit-startlist-panel\"><div class=panel-heading><h3 class=panel-title>Start list (Revision: {{vm.revision}})</h3></div><div class=panel-body><div class=row><div class=col-md-12><form><div class=form-group><label for=startlist-data>Data</label><textarea id=startlist-text class=form-control ng-model=vm.startlistData></textarea></div><div class=form-group><label for=startlist-format>Format</label><input id=startlist-format type=text class=form-control ng-model=vm.startlistFormat></div><div class=form-group><button id=save class=\"btn btn-success\" ng-click=vm.save()>Save</button> <button id=cancel class=\"btn btn-danger\" ui-sref=\"event.edit({event: vm.event.id})\">Cancel</button><div class=\"form-group file-input-container\"><label class=\"btn btn-default\">Import from file<file-input ng-model=vm.importFile ng-change=vm.importFileChanged()></file-input></label></div></div></form></div></div></div></div>");
$templateCache.put("app/admin/event/event-edit.view.html","<div class=row><div class=col-md-10><h1 class=page-header>{{ vm.eventTitle }} <small><si-loading-indicator></si-loading-indicator></small></h1></div></div><div class=\"panel panel-default\" ng-if=\"vm.event.id !== \'new\' && vm.event.eventType == \'orienteering\' && vm.event.hasPublishedResults\"><div class=panel-heading><h3 class=panel-title>Export results</h3></div><div class=row><div class=col-md-10><div class=panel-body><form><a class=\"btn btn-default\" href=\"{{ vm.configBackendUrl }}/events/{{\n              vm.event.id\n            }}/results?format=xml\">Export XML (IOF XML 3.0)</a> <a class=\"btn btn-default\" href=\"{{ vm.configBackendUrl }}/events/{{\n              vm.event.id\n            }}/results?format=csv&projection=oe2003\">Export CSV (OE2003)</a> <a class=\"btn btn-default\" ng-if=vm.userIsAdmin href=\"{{ vm.configBackendUrl }}/events/{{\n              vm.event.id\n            }}/results?format=csv&projection=compact\">Export CSV (compact)</a> <a class=\"btn btn-default\" ng-if=vm.userIsAdmin href=\"{{ vm.configBackendUrl }}/events/{{\n              vm.event.id\n            }}/results?format=json\">View JSON</a></form></div></div></div></div><div class=\"panel panel-default\"><div class=panel-heading><h3 class=panel-title>Event</h3></div><div class=panel-body><div class=row><div class=col-md-10><form><div class=form-group><label for=name>Name</label><input id=name type=text class=form-control ng-change=vm.nameChanged() ng-model=vm.event.name required placeholder=\"\"><!--autofocus si-focus-me--></div><div class=form-group ng-if=vm.userIsAdmin><label for=event-type>Event type</label><select id=event-type style=\"padding-left: 8px\" class=form-control ng-model=vm.event.eventType ng-change=vm.eventTypeChanged() ng-options=\"c for c in vm.eventTypes\" required></select></div><div class=form-group><label for=orgName>Organisation</label><dropdown-component id=selorganisation model=vm.selectedOrganisation callback=vm.getOrganisations placeholder=vm.orgPlaceholder on-select-item=(vm.selectedOrganisationChanged)></dropdown-component></div><div class=form-group><label for=start-date style=\"margin-top: 15px\">Start date</label><date-input ng-model=vm.event.startDateViewValue format=\"\'dd.MM.yyyy\'\" ng-change=vm.startDateChanged()></date-input></div><div class=form-group><label for=end-date>End date</label><date-input ng-model=vm.event.endDateViewValue format=\"\'dd.MM.yyyy\'\"></date-input></div><div class=row><div class=\"form-group col-md-12\" style=\"margin: 0\"><label for=slug>Slug</label></div></div><div class=row><div class=\"form-group col-sm-4 col-xs-10\"><input id=orgslug type=text class=form-control ng-model=vm.event.slugorg required placeholder=\"\" readonly></div><span class=\"col-sm-1 col-xs-2\" style=\"padding: 0; width: 1pt; font-size: 25px\">/</span><div class=\"form-group col-sm-3 col-xs-10\"><input id=yearslug type=text class=form-control ng-model=vm.event.slugyear placeholder=\"\" readonly></div><span class=\"col-sm-1 col-xs-2\" style=\"padding: 0; width: 1pt; font-size: 25px\">/</span><div class=\"form-group col-sm-4 col-xs-12\"><input type=text title=\"allowed only characters a-z, 0-9 and \'-\'\" placeholder=\"{{ vm.nameSlugPlaceholder }}\" class=form-control required ng-change=vm.updateSlugLink() ng-model=vm.event.slugevent></div></div><div class=row ng-if=\"vm.event.eventType == \'orienteering\'\"><div class=\"form-group col-md-12\" style=\"margin: 0\"><label for=result>Results</label><div ng-if=!vm.event.hasPublishedResults>{{ vm.noResultsMessage }}</div><p id=result style=\"overflow-x: hidden\"><a ng-class=\"{\'inactive-results-link\': !vm.event.hasPublishedResults}\" href=\"{{ vm.event.sluglink }}\">{{ vm.event.sluglink }}</a></p></div></div><div class=form-group><label for=isPublic>Show event in public lists</label><div><span class=icon ng-class=\"{\'icon-check-empty\': !vm.event.isPublic, \'icon-check\': vm.event.isPublic}\" ng-click=vm.changePublic()>&nbsp;Show event in public lists</span></div></div><div class=form-group><label for=timezone-continent>Timezone<span class=sr-only> (Continent)</span></label><select id=timezone-continent class=form-control ng-model=vm.continent ng-change=vm.continentChanged() ng-options=\"c for c in vm.continents\" required></select></div><div class=form-group><label for=timezone-city class=sr-only>Timezone (City)</label><select id=timezone-city class=form-control ng-model=vm.city ng-options=\"c for c in vm.timezones[vm.continent]\" required></select></div><div><label for=statusNotification>Receive status notifications by email</label><div><span class=icon ng-class=\"{\'icon-check-empty\': !vm.checkStatus(\'MODEM_ON_OFF\'), \'icon-check\': vm.checkStatus(\'MODEM_ON_OFF\')}\" ng-click=\"vm.changeStatus(\'MODEM_ON_OFF\')\">&nbsp;Modem goes online/offline</span><br><span class=icon ng-class=\"{\'icon-check-empty\': !vm.checkStatus(\'RESULTS_PROCESSOR_START_STOP\'), \'icon-check\': vm.checkStatus(\'RESULTS_PROCESSOR_START_STOP\')}\" ng-click=\"vm.changeStatus(\'RESULTS_PROCESSOR_START_STOP\')\">&nbsp;Results-Processor start/stop</span><br><span class=icon ng-class=\"{\'icon-check-empty\': !vm.checkStatus(\'SIMULATION_PROCESSOR_START_STOP\'), \'icon-check\': vm.checkStatus(\'SIMULATION_PROCESSOR_START_STOP\')}\" ng-click=\"vm.changeStatus(\'SIMULATION_PROCESSOR_START_STOP\')\">&nbsp;Simulation-Processor start/stop</span></div><br><button id=save class=\"btn btn-success\" ng-if=\"vm.saveButtonText !== undefined\" ng-click=vm.save()>{{ vm.saveButtonText }}</button> <button id=cancel class=\"btn btn-danger\" ui-sref=events>Cancel</button></div></form></div></div></div></div><div class=\"panel panel-default\" ng-if=\"vm.event.id !== \'new\' && vm.event.eventType == \'trail\'\"><div class=panel-heading><h3 class=panel-title>Results processing</h3></div><div class=row><div class=col-md-10><div class=panel-body><form><div class=form-group><label for=resultsStatusText>Status</label><input id=resultsStatusText type=text value=\"{{ vm.resultsStatusText }}\" class=form-control readonly></div><div class=\"btn-group btn-group-right toolbar-all form-group\"><a title=\"Administrator can start resultsprocessor\" class=btn ng-click=vm.startResultsProcessor() has-authority=\"\'ROLE_ADMIN\'\" principal=vm.principal ng-class=\"{\'btn-default disabled\': !vm.userIsAdmin, \'btn-success\': vm.userIsAdmin}\">Start</a> <a title=\"Get status of resultsprocessor\" class=\"btn btn-default\" ng-click=vm.getResultsProcessorStatus()>&nbsp?&nbsp</a> <a title=\"Administrator can stop resultsprocessor\" class=btn ng-click=vm.stopResultsProcessor() has-authority=\"\'ROLE_ADMIN\'\" principal=vm.principal ng-class=\"{\'btn-default disabled\': !vm.userIsAdmin, \'btn-danger\': vm.userIsAdmin}\">Stop</a> <button class=\"btn btn-default\" ui-sref=\"event.edit-results-logs({event: ev.id})\" ng-click=vm.stopRefresh>Logs</button></div><br><div class=form-group>Only Administrator can start and stop</div><span class=icon ng-class=\"{\'icon-check-empty\': !vm.resultsProcessorRestart, \'icon-check\': vm.resultsProcessorRestart}\" ng-click=vm.changeResultsProcessorRestart() title=\"Max 100 restarts. Is to be set before start\">&nbsp;Automatic restart</span><div class=form-group>Process is restarted max 100 times</div><div><label for=resultsfiles>Files</label><br><button id=resultsfiles class=\"btn btn-default\" ui-sref=\"event.edit-eventdef({event: ev.id})\">Edit event definition</button> <button class=\"btn btn-default\" ui-sref=\"event.edit-startlist({event: ev.id})\">Edit start list</button> <button class=\"btn btn-default\" ui-sref=\"event.edit-correction({event: ev.id})\">Edit corrections</button> <button class=\"btn btn-success\" ui-sref=\"event.files({event: vm.event.id, prefix: \'private/rp\'})\">Show result files</button></div></form></div></div></div></div><div class=\"panel panel-default\" ng-if=\"vm.event.id !== \'new\' && vm.event.eventType == \'trail\'\"><div class=panel-heading><h3 class=panel-title>Simulation</h3></div><div class=row><div class=col-md-10><div class=panel-body><form><div class=form-group><label for=simulationStatusText>Status</label><input id=simulationStatusText type=text value=\"{{ vm.simulationStatusText }}\" class=form-control readonly></div><div class=\"btn-group btn-group-right toolbar-all form-group\"><a title=\"Start simulation processor\" class=\"btn btn-success\" ng-click=vm.startSimulationProcessor() has-authority=\"\'ROLE_ADMIN\'\" principal=vm.principal ng-class=\"{\'active\': vm.simulationStatusText === \'STOPPED\'}\">Start</a> <a title=\"Get status of simulation processor\" class=\"btn btn-default\" ng-click=vm.getSimulationProcessorStatus()>&nbsp?&nbsp</a> <a title=\"Stop simulation processor\" class=\"btn btn-danger\" ng-click=vm.stopSimulationProcessor() has-authority=\"\'ROLE_ADMIN\'\" principal=vm.principal ng-class=\"{\'active\': vm.simulationStatusText === \'RUNNING\'}\">Stop</a> <button class=\"btn btn-default\" ui-sref=\"event.edit-simulation-logs({event: ev.id})\">Logs</button></div><br><span class=\"icon form-group\" ng-class=\"{\'icon-check-empty\': !vm.simulationProcessorRestart, \'icon-check\': vm.simulationProcessorRestart}\" ng-click=vm.changeSimulationProcessorRestart() title=\"Max 100 restarts. Is to be set before start\">&nbsp;Automatic restart</span><br><span class=form-group>Process is restarted max 100 times</span><div class=form-group><br><label for=speed-factor>Simulation speed factor</label><input id=speed-factor type=text title=\"allowed 1-100\" placeholder=1 class=form-control required ng-change=vm.speedFactorChanged() ng-model=vm.speedFactor></div><div><label for=simulation-data>Simulation data</label><div class=row id=simulation-data><div class=\"col-sm-3 col-xs-10\"><label class=\"btn btn-default\">Import from file<file-input ng-model=vm.simulationFiles ng-change=vm.simulationFilesChanged() hidden></file-input></label></div><div class=\"col-sm-4 col-xs-10\"><input type=text class=form-control ng-model=vm.simulationFile.source readonly></div></div></div></form></div></div></div></div><div class=\"panel panel-default\" ng-if=\"vm.event.id !== \'new\'\"><div class=panel-heading><h3 class=panel-title>Additional information</h3></div><div class=row><div class=col-md-5><div class=panel-body><form><div class=form-group><label for=event-id>Event ID</label><input id=event-id type=text value=\"{{ vm.event.id }}\" class=form-control readonly></div><div class=\"form-group non-mobile\" ng-if=vm.userIsAdmin><label for=api-key>Event GUID</label><input id=api-key type=text value=\"{{ vm.event.guid }}\" class=form-control readonly></div><div class=\"form-group mobile\" ng-if=vm.userIsAdmin><label>Event GUID</label><p class=form-control-static>{{ vm.event.guid }}</p></div><div class=\"form-group non-mobile\" ng-if=vm.userIsAdmin><label for=url-key>Event short URL</label><input id=url-key type=text value=\"{{ vm.event.shortUrl }}\" class=form-control readonly></div><div class=\"form-group mobile\" ng-if=vm.userIsAdmin><label>Event short URL</label><p class=form-control-static>{{ vm.event.shortUrl }}</p></div><div ng-if=vm.userIsAdmin><div class=\"form-group non-mobile\"><label for=event-owner>Event owner</label><input id=event-owner type=text value=\"{{ vm.event.owner.displayName }}\" class=form-control readonly></div><div class=\"form-group mobile\"><label>Event owner</label><p class=form-control-static>{{ vm.event.owner.displayName }}</p></div><div class=non-mobile><label for=api-key>Event owner\'s API key</label><input id=api-key type=text value=\"{{ vm.event.owner.apiKey }}\" class=form-control readonly></div><div class=mobile><label>Event owner\'s API key</label><p class=form-control-static>{{ vm.event.owner.apiKey }}</p></div></div><div ng-if=!vm.userIsAdmin><div class=non-mobile><label for=api-key>SOAP API key</label><input id=api-key type=text value=\"{{ vm.user.apiKey }}\" class=form-control readonly></div><div class=mobile><label>SOAP API key</label><p class=form-control-static>{{ vm.user.apiKey }}</p></div></div></form></div></div></div></div><div class=\"panel panel-default\" ng-if=\"vm.event.id !== \'new\'\"><div class=panel-heading><h3 class=panel-title>Punches</h3></div><div class=row><div class=col-md-10><div class=panel-body><form><div><button class=\"btn btn-success\" ui-sref=\"monitor({event: vm.event.id})\">Monitor</button> <a class=\"btn btn-default\" href=\"{{ vm.configBackendUrl }}/events/{{\n                vm.event.id\n              }}/punches/csv\" download=\"punches_from_event_{{ vm.event.id }}.csv\" target=new>Export CSV</a> <a class=\"btn btn-default\" href=\"{{ vm.configBackendUrl }}/events/{{\n                vm.event.id\n              }}/punches/csv?projection=simpledtm\" download=\"punches_dtm_from_event_{{ vm.event.id }}.csv\" target=new>Export CSV Date-Time-Ms</a> <button class=\"btn btn-danger\" ng-click=vm.confirmDeleteDialog()>Delete all</button></div></form></div></div></div></div><div class=\"panel panel-default\" ng-if=vm.showEventFilesPanel><div class=panel-heading><h3 class=panel-title>Event files</h3></div><div class=row><div class=col-md-5><div class=panel-body><form><button class=\"btn btn-success\" ui-sref=\"event.files({event: vm.event.id})\">Show event files</button></form></div></div></div></div>");
$templateCache.put("app/admin/event/event-files.view.html","<div class=event-files><div class=\"row event-files-list-panel\"><div class=col-md-12><h1 class=\"page-header header-adjustments-lists\"><a ng-click=vm.refreshEventFiles() class=main-title title=\"Refresh list\">{{ vm.title }}</a><div class=list-item-count><span>{{ vm.eventfiles.totalCount }}</span></div><a title=\"Toggle filters\" ng-click=\"vm.toggleActive(\'showfilters\')\" class=\"btn btn-default show-hide-menu-btn\" ng-class=\"{active: vm.showToolbar === true, primary: vm.showToolbar === true}\"><span class=\"icon icon-filter\"></span></a> <small ng-if=vm.displayLoadingIcon><si-loading-indicator loading=vm.displayLoadingIcon></si-loading-indicator></small></h1></div></div><div class=\"col-md-12 no-horizontal-padding\" ng-if=\"vm.userIsAdmin || true\"><ol class=breadcrumb><li ng-class=\"{ active: $last }\"><a ui-sref=\"event.files({event: vm.event.id ,prefix : \'\'})\">..&nbsp;</a></li><li ng-repeat=\"item in vm.prefixArray\" ng-class=\"{ active: $last }\"><a ui-sref=\"event.files({event: vm.event.id ,prefix : item.prefix})\" ng-if=!$last>{{ item.name }}&nbsp;</a><span ng-show=$last>{{ item.name }}</span></li></ol></div><div class=row><div class=\"col-md-12 no-horizontal-padding\"><div class=\"col-sm-11 event-files-toolbar\" ng-class=\"{\'hide-toolbar\': vm.showToolbar === false, \'show-toolbar\': vm.showToolbar === true}\"><div class=form-group><button class=\"btn btn-default\" ui-sref=\"event.edit({event: vm.event.id})\">Go to event</button> <button class=\"btn btn-danger\" ng-click=vm.confirmDeleteDialog() ng-disabled=\"vm.eventFiles.length == 0 || vm.hideDeleteAllBox\">Delete selected</button></div></div><div class=\"col-sm-1 hidden-xs delete-all-checkbox-container\"><span title=\"Select/Deselect all }\" ng-if=\"vm.eventFiles.length > 0 && !vm.hideDeleteAllBox\" class=icon ng-class=\"{\'icon-check-empty\': !vm.selected, \'icon-check\': vm.selected}\" ng-click=vm.toggleSelectionAll(vm)>&nbsp;</span></div></div></div><div class=\"row top-margin-row\"><div class=\"col-md-12 list-bottom-padding\"><div class=\"panel panel-default\" ng-if=!vm.initialLoading><div ng-if=\"vm.eventFiles.length === 0\" class=panel-body><p>There are no files matching the criteria.</p></div><div class=list-group><div ng-repeat=\"m in vm.eventFiles\" ng-class=\"{\'list-group-item selected\' : m.selected === true || m.showRevision === true, \'list-group-item\': m.selected === false && m.showRevision === false, \'select-cursor\': true, \'nonclickable\': false}\"><div class=\"row row-padding\"><div class=col-sm-6 ng-click=vm.showRevisions(m)><div class=\"list-group-item-text overflow-ellipsis\"><div><a ng-if=\"m.directory === false\" title=\"On click -> Show revisions and download&#13;&#10;File: {{\n                        m.name\n                      }}&#13;&#10;Revision: {{ m.revisionId }}\"><span>&nbsp;</span>{{ m.name }} </a><a ng-if=\"m.directory === true\" title=\"On click -> Go into\"><span class=\"icon icon-folder-open\">&nbsp;</span> {{ m.name }}</a></div></div></div><div class=col-sm-2 ng-if=!m.showRevision><div ng-if=\"m.directory === true\"><span title=\"{{ m.size }} Files\">{{ m.size }}</span></div><div ng-if=\"m.directory === false\"><span title=\"Size {{ m.size }} Bytes\">{{ vm.getSizeString(m.size) }}</span></div></div><div class=col-sm-2 ng-if=m.showRevision ng-click=vm.showRevisions(m)><div><span title=\"{{ vm.eventFileRevisions.length }} Revisions\">Revisions: {{ vm.eventFileRevisions.length }}</span></div></div><div class=col-sm-3 ng-click=vm.showRevisions(m)><div><span title=\"Last modified {{ m.lastModification }}\" ng-if=!m.showRevision>{{ m.lastModification }}</span> <span title=\"Last modified {{ m.lastModification }}\" ng-if=m.showRevision>&nbsp</span></div></div><div class=col-sm-1 ng-if=\"!m.showRevision && m.prefix !== \'..\'\"><span class=icon ng-class=\"{\'icon-check-empty\': !m.selected, \'icon-check\': m.selected}\" ng-click=vm.toggleSelection(m)>&nbsp;</span></div><div class=col-sm-1 ng-if=m.showRevision><span title=\"Select/Deselect all revisions\" class=icon ng-class=\"{\'icon-check-empty\': !vm.selectedRevisions, \'icon-check\': vm.selectedRevisions}\" ng-click=vm.toggleRevisionSelectionAll()>&nbsp;</span></div></div><div class=revisions-block ng-if=\"m.showRevision === true\"><div ng-repeat=\"mv in vm.eventFileRevisions\" ng-class=\"{\'list-group-item selected\' : mv.selected === true, \'list-group-item\': !mv.selected, \'select-cursor\': true, \'nonclickable\': false}\" class=list-group-item><div class=\"row row-padding\"><div class=col-sm-6><div class=\"list-group-item-text overflow-ellipsis\"><div><a title=\"On click -> Download&#13;&#10;File: {{\n                          mv.name\n                        }}&#13;&#10;Revision: {{\n                          vm.getRevisionMarkedAsLatest(mv)\n                        }}\" href=\"{{ vm.getDownloadLink(mv) }}\" download=\"{{ mv.name }}\">{{ mv.name }}</a></div></div></div><div class=col-sm-2><div><span title=\"Size {{ mv.size }} Byte\">{{ vm.getSizeString(mv.size) }}</span></div></div><div class=col-sm-3><div><span title=\"Last modified {{ mv.lastModification }}\">{{ mv.lastModification }}</span></div></div><div class=\"col-sm-1 delete-revision-checkbox-container\"><span class=icon ng-class=\"{\'icon-check-empty\': !mv.selected, \'icon-check\': mv.selected}\" ng-click=vm.toggleSelection(mv)>&nbsp;</span></div></div></div></div></div></div></div><div class=footer><div class=container><si-pagination sref=\"\'eventfiles\'\" pagination=vm.eventfiles.pagination go-to-page-callback=vm.navigationChange></si-pagination></div></div></div></div></div>");
$templateCache.put("app/admin/event/event-list.view.html","<div class=row><div class=col-md-12><h1 class=\"page-header header-adjustments-lists\"><a ng-click=vm.refreshEvents() class=main-title title=\"Refresh list\">Events</a><div class=list-item-count uib-tooltip-html=vm.getEventCountTooltipHtml() tooltip-placement=right-top tooltip-trigger=\"\'click mouseenter\'\" tooltip-class=event-tooltip><span>{{vm.events.totalCount}}</span></div><a title=\"Toggle filters\" ng-click=\"vm.toggleActive(\'showfilters\')\" class=\"btn btn-default show-hide-menu-btn-events\" ng-class=\"{active: vm.showToolbar === true, primary: vm.showToolbar === true}\"><span class=\"icon icon-filter\"></span></a> <small><si-loading-indicator loading=vm.displayLoadingIcon></si-loading-indicator></small></h1></div></div><div class=row><div class=\"col-md-12 list-bottom-padding\"><div class=event-toolbar ng-class=\"{\'hide-toolbar\': vm.showToolbar === false, \'show-toolbar\': vm.showToolbar === true}\"><div class=toolbar-left><div class=\"btn-group btn-group-left event-button-alignment\"><a class=\"btn btn-default\" ng-click=vm.showAllEvents() ng-class=\"{\'active\': vm.activeState === undefined }\">All </a><a class=\"btn btn-default\" ng-click=vm.showActiveEvents() ng-class=\"{\'active\': vm.activeState == \'active\'}\">Active</a></div><div class=\"btn-group btn-group-left selectbox-events selectbox-events-event margin-between-toolbar-elements\"><div><dropdown-component model=vm.selectedEvent callback=vm.getEvents placeholder=\"\'Search for event\'\" on-select-item=vm.selectedEventChanged></dropdown-component></div></div><div class=\"btn-group btn-group-left selectbox-events selectbox-events-user\"><div><dropdown-component model=vm.selectedUser callback=vm.getUsers placeholder=\"\'Search for user\'\" on-select-item=vm.selectedUserChanged></dropdown-component></div></div><div class=\"btn-group btn-group-left clear-filters-events event-clear-button-alignment\"><a title=\"Clear filters\" ng-click=vm.clearParams() class=\"btn btn-default\"><span class=\"icon icon-cancel\"></span></a></div></div><div class=\"toolbar-right event-right-toolbar-alignment\" ng-class=\"{\'admin-toolbar\' : vm.userIsAdmin === true}\"><!-- default view--><div><div ng-if=\"vm.toggleState === \'all\'\" class=\"btn-group btn-group-right toolbar-all\"><a title=\"Delete event\" class=\"btn btn-default\" ng-click=\"vm.toggleActive(\'deleteevent\')\" has-authority=\"\'ROLE_ADMIN\'\" principal=vm.principal><span class=\"icon icon-trash\"></span></a> <a title=\"Assign event to user\" class=\"btn btn-default hidden\" ng-click=\"vm.toggleActive(\'assignuser\')\" has-authority=\"\'ROLE_ADMIN\'\" principal=vm.principal><span class=\"icon icon-user\"></span></a> <a title=New class=\"btn btn-success new-icon\" ui-sref=\"event.edit({eventId: \'new\'})\" aria-label=New><span class=\"icon icon-plus\"></span></a></div><!-- delete event view--><div ng-if=\"vm.toggleState === \'deleteevent\'\" class=\"btn-group btn-group-right toolbar-delete\"><a title=\"Delete event\" class=\"btn btn-default disable-list\"><span class=\"icon icon-trash\"></span></a> <a title=Confirm ng-click=vm.confirmDeleteDialog() class=\"btn btn-default check-button-green\"><span class=\"icon icon-ok\"></span></a> <a title=Cancel ng-click=\"vm.toggleActive(\'closeall\')\" class=\"btn btn-default cancel-button-red\"><span class=\"icon icon-cancel\"></span></a></div><!-- asign event to user view--><div class=assign-user-state-events><div class=hidden ng-if=\"vm.toggleState === \'assignuser\'\" has-authority=\"\'ROLE_ADMIN\'\" principal=vm.principal><div class=input-group><div class=input-group-btn><a title=\"Assign event to user\" class=\"btn btn-default disable-list\"><span class=\"icon icon-user\"></span></a></div><dropdown-component model=vm.assignedUser callback=vm.getUsersForAssignment placeholder=\"\'Select user...\'\" on-select-item=\"\"></dropdown-component><div class=input-group-btn><a title=Confirm ng-click=vm.confirmOwnership() class=\"btn btn-default check-button-green\"><span class=\"icon icon-ok\"></span></a> <a title=Cancel ng-click=\"vm.toggleActive(\'closeall\')\" class=\"btn btn-default cancel-button-red\"><span class=\"icon icon-cancel\"></span></a></div></div></div></div></div></div></div><div class=\"panel panel-default\" ng-if=!vm.initialLoading><div ng-if=\"vm.events.length==0\" class=panel-body><p>There are no events that match the search criteria.</p></div><div class=list-group><div ng-repeat=\"ev in vm.events\" ng-click=\"vm.toggleSelect(ev, \'events\')\" ng-class=\"{\'event-active\': ev.active, \'selected\': ev.selected, \'select-cursor\': vm.toggleState !== \'all\'}\" class=list-group-item><div class=row><div class=col-sm-3><h4 class=\"list-group-item-heading overflow-ellipsis\">{{ev.name}}</h4></div><div class=col-sm-5><!-- Date --><div ng-if=\"ev.startDate!=ev.endDate\" class=list-group-item-text><span title=\"Event date: {{ev.startDate}} &ndash; {{ev.endDate}}\"><span class=\"icon icon-calendar\"></span> {{ev.startDate}} &ndash; {{ev.endDate}}</span></div><div ng-if=\"ev.startDate==ev.endDate\" class=list-group-item-text><span title=\"Event date: {{ev.startDate}}\"><span class=\"icon icon-calendar\"></span> {{ev.startDate}}</span></div><!-- Results --><div ng-if=\"ev.eventType !== \'orienteering\'\" class=list-group-item-text><span title=\"This event type does not support online results with Center\" style=\"color: lightgray\"><span class=\"icon icon-podium\" style=\"color: lightgray\"></span> No results</span></div><div ng-if=\"ev.eventType === \'orienteering\'\" class=list-group-item-text><div ng-if=ev.hasPublishedResults><a href={{vm.resultPath}}{{ev.eventType}}/{{ev.slug}} title=\"Published results are available\"><span title=\"Published results are available\"><span class=\"icon icon-podium\"></span> Results</span></a></div><div ng-if=!ev.hasPublishedResults><a href={{vm.resultPath}}{{ev.eventType}}/{{ev.slug}} title=\"No results have been published yet\"><span title=\"No results have been published yet\"><span class=\"icon icon-podium\"></span> No results yet</span></a></div></div><!-- User --><div ng-if=vm.userIsAdmin class=list-group-item-text><div ng-if=\"ev.info.owner !== undefined && ev.info.owner !== null\"><a href=\"\" title=\"User: {{ev.info.owner.firstName+\' \'+ev.info.owner.lastName}}\" ui-sref=\"users({user: ev.info.owner.id})\"><span title=\"User: {{ev.info.owner.firstName+\' \'+ev.info.owner.lastName}} ({{ev.info.owner.login}})\"><span class=\"icon icon-user\"></span> {{ev.info.owner.firstName+\" \"+ev.info.owner.lastName}}</span></a></div><div ng-if=\"ev.info.owner === undefined || ev.info.owner === null\"><span title=\"User: None\"><span class=\"icon icon-user\"></span> No user</span></div></div></div><div class=col-sm-3><!-- Stamps --><div ng-if=\"ev.info.stampCount !== undefined && ev.info.stampCount > 0\" class=list-group-item-text><div ng-if=\"vm.toggleState === \'all\'\"><a href=\"\" title=\"Punches: {{ev.info.stampCount}}\" ui-sref=\"monitor({event: ev.id})\"><span class=\"icon icon-braille\"></span> Monitor punches</a></div><div ng-if=\"vm.toggleState !== \'all\'\"><span class=\"icon icon-braille\"></span> Monitor punches</div></div><div ng-if=\"ev.info.stampCount === undefined || ev.info.stampCount < 1\" class=list-group-item-text><a href=\"\" title=\"Punches: None\" ui-sref=\"monitor({event: ev.id})\"><span class=\"icon icon-braille\"></span> Monitor punches</a></div><div class=list-group-item-text><span></span></div><!-- Modem --><div ng-if=\"ev.info.boxCount !== undefined && ev.info.boxCount > 0\" class=list-group-item-text><div ng-if=\"vm.toggleState === \'all\'\"><a href=\"\" title=\"Modems: {{ev.info.boxCount}}\" ui-sref=\"modems({event: ev.id})\"><span class=\"icon icon-blank\"></span> {{ev.info.boxCount}} modem<span ng-if=\"ev.info.boxCount>1\">s</span></a></div><div ng-if=\"vm.toggleState !== \'all\'\"><span class=\"icon icon-blank\"></span> {{ev.info.boxCount}} modem<span ng-if=\"ev.info.boxCount>1\">s</span></div></div><div ng-if=\"ev.info.boxCount === undefined || ev.info.boxCount < 1\" class=list-group-item-text><a href=\"\" title=\"Modems: None\" ui-sref=\"modems({event: ev.id})\"><span class=\"icon icon-blank\"></span> No modems</a></div></div><div class=\"col-sm-1 editbox-events\"><a ng-if=\"vm.toggleState == \'all\'\" ui-sref=\"event.edit({eventId: ev.id})\" class=clickable><span class=\"icon icon-pencil edit-select-icons\" ng-class=\"{\'editbox-events-icons\': (u.getAuthority!==1 && vm.userIsAdmin === true), \'editbox-events-icons-no-admin\': vm.userIsAdmin === false}\"></span></a><div ng-if=\"vm.toggleState !== \'all\' && ev.selected === false\" ng-class=\"{\'editbox-events-icons\': vm.userIsAdmin === true, \'editbox-events-icons-no-admin\': vm.userIsAdmin === false}\" class=clickable><span class=\"icon icon-check-empty edit-select-icons\"></span></div><div ng-if=\"vm.toggleState !== \'all\' && ev.selected === true\" ng-class=\"{\'editbox-events-icons\': vm.userIsAdmin === true, \'editbox-events-icons-no-admin\': vm.userIsAdmin === false}\" class=clickable><span class=\"icon icon-check edit-select-icons checkbox-selected\"></span></div></div></div></div></div></div><div class=footer ng-if=!vm.hidePagination><div class=container><si-pagination sref=\"\'events\'\" pagination=vm.events.pagination go-to-page-callback=vm.navigationChange></si-pagination></div></div></div></div>");
$templateCache.put("app/admin/modem/modem-edit.view.html","<div class=row><div class=col-md-12><h1 class=page-header>{{vm.modemTitle}} <small><si-loading-indicator></si-loading-indicator></small></h1></div></div><div class=\"panel panel-default\"><div class=panel-heading><h3 class=panel-title>Modem</h3></div><div class=panel-body><div class=row><div class=col-md-5><form><div class=form-group><label for=boxType>Device</label><select id=boxTypeSelect class=form-control ng-model=vm.modem.type ng-options=\"modem.id as modem.name for modem in vm.modemTypes\" ng-disabled=!vm.userIsAdmin></select></div><div class=form-group><label for=externId>Identifier</label><input id=externId type=text class=form-control ng-model=vm.modem.externId ng-readonly=!vm.userIsAdmin> <span class=help-block>Serial number or MAC address</span></div><div class=form-group><label for=label>Label</label><input id=label type=text class=form-control ng-model=vm.modem.label> <span class=help-block>Custom label to easily identify the modem</span></div><div class=form-group><label for=label>Additional information</label><textarea id=label class=form-control ng-model=vm.modem.info>\n            </textarea></div><button id=save class=\"btn btn-success\" ng-click=vm.saveModem()>{{vm.saveButtonText}}</button> <button id=cancel class=\"btn btn-danger\" ui-sref=modems>Cancel</button></form></div></div></div></div>");
$templateCache.put("app/admin/modem/modem-list.view.html","<div class=row><div class=col-md-12><h1 class=\"page-header header-adjustments-lists\"><a ng-click=vm.refreshModems() class=main-title title=\"Refresh list\">Modems</a><div class=list-item-count uib-tooltip-html=vm.getModemCountTooltipHtml() tooltip-placement=right-top tooltip-trigger=\"\'click mouseenter\'\" tooltip-class=modem-tooltip><span>{{vm.modems.totalCount}}</span></div><a title=\"Toggle filters\" ng-click=\"vm.toggleActive(\'showfilters\')\" class=\"btn btn-default show-hide-menu-btn\" ng-class=\"{active: vm.showToolbar === true, primary: vm.showToolbar === true}\"><span class=\"icon icon-filter\"></span></a> <small><si-loading-indicator loading=vm.displayLoadingIcon></si-loading-indicator></small></h1></div></div><div class=row><div class=col-md-12><div class=modem-toolbar ng-class=\"{\'hide-toolbar\': vm.showToolbar === false, \'show-toolbar\': vm.showToolbar === true}\"><div class=toolbar-left><div class=\"btn-group btn-group-left vertical-super margin-between-toolbar-elements\"><a class=\"btn btn-default\" ng-click=vm.sortExternalId() ng-class=\"{active: vm.activesort === \'externId\' || vm.activesort === undefined}\">ID </a><a class=\"btn btn-default last-activity-margin\" ng-click=vm.sortLastActivity() ng-class=\"{active: vm.activesort === \'lastActivity\'}\">Last Activity </a><a class=\"btn btn-default last-activity-margin\" ng-click=vm.sortLabel() ng-class=\"{active: vm.activesort === \'label\'}\">Label</a></div><div class=\"btn-group btn-group-left filters vertical-super left-margin-between-toolbar-elements\"><a class=\"btn btn-default\" ng-click=vm.showAllModems() ng-class=\"{active: vm.activestate === undefined }\">All </a><a class=\"btn btn-default\" ng-click=vm.showOnlineModems() ng-class=\"{active: vm.activestate === \'true\'}\">Online </a><a class=\"btn btn-default inactive-state-margin\" ng-click=vm.showOfflineModems() ng-class=\"{active: vm.activestate === \'false\'}\">Offline</a></div><div class=\"btn-group btn-group-left vertical-super select-user-box-modem margin-between-toolbar-elements left-margin-between-toolbar-elements hidden\" ng-class=\"{\'toolbar-selectboxes-admin\': vm.userIsAdmin,\'toolbar-selectboxes-user\': !vm.userIsAdmin}\" has-authority=\"\'ROLE_ADMIN\'\" principal=vm.principal><dropdown-component model=vm.selectedUser callback=vm.getUsers placeholder=\"\'Search for user...\'\" on-select-item=vm.selectedUserChanged></dropdown-component></div><div class=\"btn-group btn-group-left vertical-super select-event-box-modem\" ng-class=\"{\'toolbar-selectboxes-admin margin-between-toolbar-elements\': vm.userIsAdmin,\'toolbar-selectboxes-user left-margin-between-toolbar-elements\': !vm.userIsAdmin}\"><dropdown-component model=vm.selectedEvent callback=vm.getEvents placeholder=\"\'Search for event...\'\" on-select-item=vm.selectedEventChanged></dropdown-component></div><div class=\"btn-group btn-group-left vertical-super select-event-box-modem after-break-margin\" ng-class=\"{\'toolbar-selectboxes-admin\': vm.userIsAdmin,\'toolbar-selectboxes-user\': !vm.userIsAdmin}\"><dropdown-component model=vm.selectedModem callback=vm.getModems placeholder=\"\'Search for modem\'\" on-select-item=vm.selectedModemChanged></dropdown-component></div><div class=\"btn-group btn-group-left vertical-super clear-filters-modems left-margin-between-toolbar-elements\"><a title=\"Clear filters\" ng-click=vm.clearParams() class=\"btn btn-default\"><span class=\"icon icon-cancel\"></span></a></div></div><div class=toolbar-right ng-class=\"{\'toolbar-right-admin\': vm.userIsAdmin,\'toolbar-right-user\': !vm.userIsAdmin, \'float-left\': !vm.userIsAdmin && vm.toggleState === \'assignevent\'}\"><!-- default view--><div ng-if=\"vm.toggleState === \'all\'\" ng-class=\"{\'btn-group\': vm.userIsAdmin}\" class=\"btn-group-right toolbar-all-modem\"><!--<a class=\"btn btn-default\" title=\"Select All\"><span class=\"fa fa-check-square-o\"></span></a>--> <a title=\"Delete modem\" class=\"btn btn-default\" ng-click=\"vm.toggleActive(\'deletemodem\')\" class=hidden has-authority=\"\'ROLE_ADMIN\'\" principal=vm.principal><span class=\"icon icon-trash\"></span></a> <a title=\"Assign modem to user\" class=\"btn btn-default\" ng-click=\"vm.toggleActive(\'assignuser\')\" class=hidden has-authority=\"\'ROLE_ADMIN\'\" principal=vm.principal><span class=\"icon icon-user\"></span></a> <a title=\"Assign modem to event\" class=\"btn btn-default\" ng-click=\"vm.toggleActive(\'assignevent\')\"><span class=\"icon icon-flag\"></span></a> <a title=New class=\"btn btn-default new-icon\" ui-sref=\"modem.edit({modemId: \'new\'})\" class=hidden has-authority=\"\'ROLE_ADMIN\'\" principal=vm.principal><span class=\"icon icon-plus\"></span></a></div><!-- delete modem view--><div ng-if=\"vm.toggleState === \'deletemodem\'\" class=\"btn-group btn-group-right toolbar-delete\"><a title=\"Delete modem\" class=\"btn btn-default disable-list\" ng-click=\"vm.toggleActive(\'deletemodem\')\"><span class=\"icon icon-trash\"></span></a> <a title=Confirm ng-click=vm.confirmDeleteDialog() class=\"btn btn-default check-button-green\"><span class=\"icon icon-ok\"></span></a> <a title=Cancel ng-click=\"vm.toggleActive(\'closeall\')\" class=\"btn btn-default cancel-button-red\"><span class=\"icon icon-cancel\"></span></a></div><!-- asign modem to user view--><div class=toolbar-assign-user-adminmode ng-if=\"vm.toggleState === \'assignuser\'\"><div class=\"input-group screen-padding\"><div class=input-group-btn><a title=\"Assign modem to user\" class=\"btn btn-default disable-list\"><span class=\"icon icon-user\"></span></a></div><dropdown-component model=vm.assignedUser callback=vm.getUsersForAssignment placeholder=\"\'Select user...\'\" on-select-item=\"\"></dropdown-component><div class=input-group-btn><a title=Confirm ng-click=vm.confirmOwnershipUser() class=\"btn btn-default check-button-green\"><span class=\"icon icon-ok\"></span></a> <a title=Cancel ng-click=\"vm.toggleActive(\'closeall\')\" class=\"btn btn-default cancel-button-red\"><span class=\"icon icon-cancel\"></span></a></div></div></div><!-- assign modem to event view--><div ng-if=\"vm.toggleState === \'assignevent\'\" ng-class=\"{\'toolbar-assign-user-adminmode\': vm.userIsAdmin,\'toolbar-assign-user-usermode\': !vm.userIsAdmin}\"><div class=input-group><div class=input-group-btn><a title=\"Assign modem to event\" class=\"btn btn-default disable-list\" ng-click=\"vm.toggleActive(\'assignevent\')\"><span class=\"icon icon-flag\"></span></a></div><dropdown-component model=vm.assignedEvent callback=vm.getEventsForAssignment placeholder=\"\'Select event...\'\" on-select-item=\"\"></dropdown-component><div class=input-group-btn><a title=Confirm ng-click=vm.confirmOwnershipEvents() class=\"btn btn-default check-button-green\"><span class=\"icon icon-ok\"></span></a> <a title=Cancel ng-click=\"vm.toggleActive(\'closeall\')\" class=\"btn btn-default cancel-button-red\"><span class=\"icon icon-cancel\"></span></a></div></div></div></div></div></div></div><div class=\"row top-margin-row\"><div class=\"col-md-12 list-bottom-padding\"><div class=\"panel panel-default\" ng-if=!vm.initialLoading><div ng-if=\"vm.modems.length===0\" class=panel-body><p>There are no existing modems that match the search criteria.</p></div><div class=list-group><div ng-repeat=\"m in vm.modems\" ng-click=vm.editView(m) ng-class=\"{\'list-group-item selected\' : m.selected === true, \'list-group-item\': m.selected === false, \'select-cursor\': vm.toggleState !== \'all\', \'nonclickable\': vm.toggleState === \'all\'}\"><div class=row><div class=col-sm-3><h3 class=\"list-group-item-heading zeromarginbottom\" ng-class=\"{\'externalid-modems-margin\': m.label==null, \'externalid-modems-with-label\': m.label!==null}\">{{m.externId}}</h3><h5 ng-if=\"m.label!==null && m.label.length <= 32\" class=zeromargin title={{m.label}}>{{m.label}}</h5><h5 ng-if=\"m.label!==null && m.label.length > 32\" class=zeromargin title={{m.label}}>{{m.label | limitTo:32 }}...</h5><h5 ng-if=\"m.label==null || m.label==\'\'\" class=\"zeromargin zero-label-adjustment\">&nbsp;</h5></div><div class=col-sm-2><div class=modem-status-topmargin><span title=\"Modem online\" ng-if=m.status.active class=\"icon icon-circle modem-active-indicator\"></span> <span title=\"Modem offline\" ng-if=!m.status.active class=\"icon icon-circle modem-non-active-indicator\"></span><signal-indicator signal=m.status.conQual size=30></signal-indicator><battery-indicator battery=m.status.batQual hover=m.status.batVoltVal></battery-indicator></div></div><div class=col-sm-3><div class=\"list-group-item-text overflow-ellipsis\"><div ng-if=\"vm.toggleState === \'all\' && vm.userIsAdmin\"><a title=\"User: {{m.user.firstName+\' \'+m.user.lastName}} ({{m.user.login}})\" ui-sref=\"users({user: m.user.id})\"><span class=\"icon icon-user\"></span> {{m.user.firstName+\" \"+ m.user.lastName}}</a></div><div ng-if=\"!(vm.toggleState === \'all\' && vm.userIsAdmin)\"><span class=\"icon icon-user\"></span> {{m.user.firstName+\" \"+m.user.lastName}}</div></div><div class=\"list-group-item-text overflow-ellipsis\"><div ng-if=\"vm.toggleState === \'all\' && (vm.userIsAdmin || m.event.id !== vm.unassigned)\"><a title=\"Event: {{m.event.name}}\" ui-sref=\"events({event: m.event.id})\"><span class=\"icon icon-flag\"></span> {{m.event.name}}</a></div><div ng-if=\"!(vm.toggleState === \'all\' && (vm.userIsAdmin || m.event.id !== vm.unassigned))\"><span class=\"icon icon-flag\"></span> {{m.event.name}}</div></div></div><div class=col-sm-2><div ng-show=!m.isnull class=overflow-ellipsis><span title=\"Last activity: {{m.status.lastActivity}}\"><span class=\"icon icon-upload-cloud\"></span> {{m.lastUpdateDisplay}}</span></div><div ng-show=m.isnull class=overflow-ellipsis><span title=\"Last activity: Never\"><span class=\"icon icon-upload-cloud\"></span> Never</span></div><div ng-show=\"m.status.runtime !== null\" class=overflow-ellipsis><span title=\"Session time: {{m.runtimeTooltip}}\"><span class=\"icon icon-hourglass-2\"></span> {{m.runtimeDisplay}}</span></div><div ng-show=\"m.status.runtime === null\" class=overflow-ellipsis><span title=\"Session time: None\"><span class=\"icon icon-hourglass-2\"></span> None</span></div></div><div class=\"col-sm-2 editbox-modems\"><a ng-if=\"vm.toggleState == \'all\'\" ui-sref=\"modem.edit({modemId: m.id})\" class=\"clickable align-middle\"><span class=\"icon icon-pencil edit-select-icons\" ng-class=\"{\'editbox-modems-icons\': u.getAuthority!==1, \'editbox-modems-icons-admin\': u.getAuthority===1}\"></span></a><div ng-if=\"vm.toggleState !== \'all\' && m.selected === false\" class=\"editbox-modems-icons clickable align-middle\"><span class=\"icon icon-check-empty edit-select-icons\"></span></div><div ng-if=\"vm.toggleState !== \'all\' && m.selected === true\" class=\"editbox-modems-icons clickable align-middle\"><span class=\"icon icon-check edit-select-icons checkbox-selected\"></span></div></div></div></div></div></div><div class=footer><div class=container><si-pagination sref=\"\'modems\'\" pagination=vm.modems.pagination go-to-page-callback=vm.navigationChange></si-pagination></div></div></div></div>");
$templateCache.put("app/admin/processors/processor-list.view.html","<div class=processor-view><div class=\"row processor-list-panel\"><div class=col-md-12><h1 class=\"page-header header-adjustments-lists\"><a ng-click=vm.refreshProcessors() class=main-title title=\"Refresh list\">Processors</a><div class=list-item-count><span>{{ vm.processors.totalCount }}</span></div><a title=\"Toggle filters\" ng-click=\"vm.toggleActive(\'showfilters\')\" class=\"btn btn-default show-hide-menu-btn\" ng-class=\"{active: vm.showToolbar === true, primary: vm.showToolbar === true}\"><span class=\"icon icon-filter\"></span></a> <small><si-loading-indicator loading=vm.displayLoadingIcon></si-loading-indicator></small></h1></div></div><div class=row><div class=col-md-12><div class=processor-toolbar ng-class=\"{\'hide-toolbar\': vm.showToolbar === false, \'show-toolbar\': vm.showToolbar === true}\"><div class=toolbar-left><div class=\"btn-group btn-group-left filters vertical-super\"><a class=\"btn btn-default\" ng-click=\"vm.showProcessors(\'ALL\')\" ng-class=\"{active: vm.stateVisibility(\'ALL\')}\">All </a><a class=\"btn btn-default\" ng-click=\"vm.showProcessors(\'START\')\" ng-class=\"{active: vm.stateVisibility(\'START\')}\">Running </a><a class=\"btn btn-default inactive-state-margin\" ng-click=\"vm.showProcessors(\'STOP\')\" ng-class=\"{active: vm.stateVisibility(\'STOP\')}\">Stopped</a></div><div class=\"btn-group btn-group-left vertical-super select-event-processor toolbar-selectboxes-admin margin-between-toolbar-elements\"><dropdown-component model=vm.selectedEvent callback=vm.getEvents placeholder=\"\'Search for event...\'\" on-select-item=(vm.selectedEventChanged)></dropdown-component></div><div class=\"processor-family btn-group btn-group-left\" ng-class=\"{\'toolbar-selectboxes-admin margin-between-toolbar-elements\': vm.userIsAdmin,\'toolbar-selectboxes-user margin-between-toolbar-elements\': !vm.userIsAdmin}\" ng-if=vm.userIsAdmin><select class=form-control title=\"Select processor family\" ng-model=vm.processorFamily ng-change=vm.selectedFamilyChanged(vm.processorFamily) ng-options=\"pt for pt in vm.processorFamilys\"></select></div><div class=\"btn-group btn-group-left vertical-super clear-filters-processors margin-between-toolbar-elements\"><a title=\"Clear filters\" ng-click=vm.clearParams() class=\"btn btn-default\"><span class=\"icon icon-cancel\"></span></a></div></div><div class=toolbar-right ng-class=\"{\'toolbar-right-admin\': vm.userIsAdmin}\"></div></div></div></div><div class=\"row top-margin-row\"><div class=\"col-md-12 list-bottom-padding\"><div class=\"panel panel-default\" ng-if=!vm.initialLoading><div ng-if=\"vm.processors.length===0\" class=panel-body><p>There are no existing processors that match the search criteria.</p></div><div class=list-group><div ng-repeat=\"m in vm.processors\" ng-click=vm.showHistory(m) ng-class=\"{\'list-group-item selected\' : m.selected === true, \'list-group-item\': m.selected === false, \'select-cursor\': true, \'nonclickable\': false}\"><div class=\"row row-padding\"><div class=col-sm-3><div class=\"list-group-item-text overflow-ellipsis\"><div ng-if=vm.userIsAdmin><a title=\"Event: {{ m.eventName }}\" ui-sref=\"event.edit({eventId: m.eventId})\"><span class=\"icon icon-flag\"></span> {{ m.eventName }}</a></div><div ng-if=\"!(vm.userIsAdmin || m.eventId !== vm.unassigned)\"><span class=\"icon icon-flag\"></span> {{ m.eventName }}</div></div><div class=\"list-group-item-text overflow-ellipsis\"><div ng-if=vm.userIsAdmin><a title=\"Owner: {{ m.ownerName }}\" ui-sref=\"users({user: m.ownerId})\"><span class=\"icon icon-user\"></span> {{ m.ownerName }}</a></div><div ng-if=!(vm.userIsAdmin)><span class=\"icon icon-user\"></span> {{ m.ownerName }}</div></div></div><div class=col-sm-2><div><span title=\"Processor {{ m.status }}\" ng-if=\"m.status === \'RUNNING\' || m.status === \'STARTING\' || m.status === \'STOPPING\'\" class=\"icon icon-circle processor-active-indicator\">{{ m.status }}</span> <span title=\"Processor {{ m.status }}\" ng-if=\"m.status === \'STOPPED\'\" class=\"icon icon-circle processor-non-active-indicator\">{{ m.status }}</span><br><span class=restart-leftmargin title=\"Restart count\">Restarts: {{ m.restartCount }}</span></div></div><div class=col-sm-3><h5 class=\"list-group-item-heading margin-family\" title=\"Processor family\">{{ m.family }}</h5></div><div class=col-sm-4><div class=overflow-ellipsis><span title=\"Started at: {{ m.startupDateTime }}\"><span class=\"icon icon-play\"></span> {{ m.startupDateTime }}</span></div><div ng-show=\"m.status === \'STOPPED\'\" class=overflow-ellipsis><span title=\"Stopped at: {{ m.stoppedDateTime }}\"><span class=\"icon icon-stop\"></span> {{ m.stoppedDateTime }}</span></div><div ng-show=\"m.stoppedDateTime === null\" class=overflow-ellipsis><span title=\"Stopped at: None\"><span class=\"icon icon-stop\"></span> None</span></div></div></div><div ng-repeat=\"mh in vm.processorsHist\" class=\"list-group-item nonclickable\" ng-if=\"m.selected === true\"><div class=\"row row-padding\"><div class=col-sm-1>&nbsp</div><div class=col-sm-3><div><span title=\"Processor {{ mh.status }}\" ng-if=\"mh.status === \'RUNNING\' || mh.status === \'STARTING\' || mh.status === \'STOPPING\'\" class=\"icon icon-circle processor-active-indicator\">{{ mh.status }}</span> <span title=\"Processor {{ mh.status }}\" ng-if=\"mh.status === \'STOPPED\'\" class=\"icon icon-circle processor-inactive-indicator\">{{ mh.status }}</span><br><span class=restart-leftmargin title=\"Restart count\">Restarts: {{ mh.restartCount }}</span></div></div><div class=col-sm-4><h5 class=\"list-group-item-heading margin-family\" title=\"Processor family\">{{ mh.family }}</h5></div><div class=col-sm-4><div class=overflow-ellipsis><span title=\"Started at: {{ mh.startupDateTime }}\"><span class=\"icon icon-play\"></span> {{ mh.startupDateTime }}</span></div><div ng-show=\"mh.status === \'STOPPED\'\" class=overflow-ellipsis><span title=\"Stopped at: {{ mh.stoppedDateTime }}\"><span class=\"icon icon-stop\"></span> {{ mh.stoppedDateTime }}</span></div><div ng-show=\"mh.stoppedDateTime === null\" class=overflow-ellipsis><span title=\"Stopped at: None\"><span class=\"icon icon-stop\"></span> None</span></div></div></div></div></div></div></div><div class=footer><div class=container><si-pagination sref=\"\'processors\'\" pagination=vm.processors.pagination go-to-page-callback=vm.navigationChange></si-pagination></div></div></div></div></div>");
$templateCache.put("app/admin/subscription/promo-code-edit.view.html","<div class=page-subscription-new><div class=row><div class=col-md-12><h1 class=\"page-header header-adjustments-lists\"><span ng-if=vm.addNew class=main-title-no-hover>Add Promo Code</span> <span ng-if=!vm.addNew class=main-title-no-hover>Edit Promo Code</span></h1></div></div><div class=\"panel panel-default\"><div class=panel-heading><h3 class=panel-title>Promotion Code</h3></div><div class=panel-body><div class=row><div class=col-sm-6><form novalidate><div class=form-group><label for=promo-code-type>Type</label><input id=promo-code-type type=text class=form-control value=\"{{ vm.promoCodeType.name }}\" ng-readonly=true notenabled=true></div><div class=form-group ng-if=vm.addNew><label for=promo-code-code>Code</label><input id=promo-code-code type=text class=form-control ng-model=vm.promoCode.code></div><div class=form-group ng-if=!vm.addNew><label for=promo-code-code>Code</label><input id=promo-code-code type=text class=form-control value=\"{{ vm.promoCode.code }}\" ng-readonly=true notenabled=true></div><div class=form-group><label for=promo-code-expiration-date>Expiration date</label><date-input ng-model=vm.expirationDate format=\"\'yyyy-MM-dd\'\" ng-change=vm.expirationDateChanged()></date-input></div><div class=form-group><label for=promo-code-customer-name>Customer name</label><input id=promo-code-customer-name type=text class=form-control ng-model=vm.promoCode.customerName></div><div class=form-group><label for=promo-code-customer-email>Customer email</label><input id=promo-code-customer-email type=text class=form-control ng-model=vm.promoCode.customerEmail></div><div class=form-group><label for=promo-code-comment>Comment</label><input id=promo-code-comment type=text class=form-control ng-model=vm.promoCode.comment></div><button ng-if=vm.addNew class=\"btn btn-success\" type=button ng-click=vm.insert()>Add Code</button> <button ng-if=!vm.addNew class=\"btn btn-success\" type=button ng-click=vm.update()>Save</button> <button class=\"btn btn-danger\" ui-sref=subscription.promocodes.list>Cancel</button></form></div><div class=col-sm-6></div></div></div></div></div>");
$templateCache.put("app/admin/subscription/promo-code-list.view.html","<div class=page-promo-code-list><div class=row><div class=col-md-12><h1 class=\"page-header header-adjustments-lists\"><span class=main-title-no-hover>Promo Codes</span> <small><si-loading-indicator loading=vm.displayLoadingIcon></si-loading-indicator></small></h1></div></div><div class=row><div class=col-md-12 has-authority=\"\'ROLE_ADMIN\'\" principal=vm.principal><div class=promo-code-toolbar><div class=toolbar-left><div class=\"btn-group add-promo-code\"><a title=\"Add subscription\" class=\"btn btn-success new-icon\" ui-sref=\"subscription.promocodes.edit({promoCodeId: \'new\', type: \'1\'})\"><span class=\"icon icon-plus\"></span> Orienteering 50</a></div><div class=\"btn-group add-promo-code\"><a title=\"Add subscription\" class=\"btn btn-success new-icon\" ui-sref=\"subscription.promocodes.edit({promoCodeId: \'new\', type: \'2\'})\"><span class=\"icon icon-plus\"></span> Orienteering 100</a></div><div class=\"btn-group add-promo-code\"><a title=\"Add subscription\" class=\"btn btn-success new-icon\" ui-sref=\"subscription.promocodes.edit({promoCodeId: \'new\', type: \'4\'})\"><span class=\"icon icon-plus\"></span> Orienteering 100 for 5 years</a></div></div></div></div></div><div class=\"row top-margin-row\"><div class=\"col-md-12 list-bottom-padding\"><div class=\"panel panel-default\" ng-if=!vm.initialLoading><div ng-if=\"vm.promoCodes.length === 0\" class=panel-body><p>There are no existing promo codes.</p></div><div class=list-group><div ng-repeat=\"pc in vm.promoCodes\" class=list-group-item><div class=row><div class=col-sm-3><h4 class=\"list-group-item-heading overflow-ellipsis\">{{ pc.code }}</h4>{{ pc.typeId === 1 ? \'Orienteering 50\' : \'Orienteering 100\' }}</div><div class=col-sm-4><div class=list-group-item-text><span class=\"icon icon-calendar\"></span> Issued on {{ pc.issuanceDateDisplayValue }}</div><div class=list-group-item-text><span class=\"icon icon-calendar\"></span> Expires on {{ pc.expirationDateDisplayValue }}</div></div><div class=col-sm-4><div class=list-group-item-text ng-if=\"pc.customerName || pc.customerEmail\"><span class=\"icon icon-user\"></span> {{ pc.customerName }} {{ pc.customerEmail ? \'&lt;\' + pc.customerEmail + \'&gt;\' : \'\' }}</div><div class=list-group-item-text ng-if=\"!(pc.customerName || pc.customerEmail) && (pc.comment.indexOf(\'SPORTident Printer\') === 0 || pc.comment.indexOf(\'SI Printer\') === 0)\"><span class=\"icon icon-circle\"></span> {{ pc.comment }}</div><div class=list-group-item-text><span class=\"icon icon-blank\" ng-class=\"{\'not-redeemed-indicator\': !pc.isRedeemed, \'redeemed-indicator\': pc.isRedeemed}\"></span> {{ pc.isRedeemed === true ? \'redeemed\' : \'not redeemed\' }}</div></div><div class=\"col-sm-1 col-edit\"><div class=edit-icon-container><a ui-sref=\"subscription.promocodes.edit({promoCodeId: pc.id})\" class=clickable><span class=\"icon icon-pencil\"></span></a></div></div></div></div></div></div><div class=footer ng-if=!vm.hidePagination><div class=container><si-pagination sref=\"\'subscription.promocodes.list\'\" pagination=vm.promoCodes.pagination go-to-page-callback=vm.goToPage></si-pagination></div></div></div></div></div>");
$templateCache.put("app/admin/subscription/subscription-edit.view.html","<div class=page-subscription-edit><div class=row><div class=col-md-12><h1 class=\"page-header header-adjustments-lists\"><span class=main-title-no-hover>Edit Subscription</span></h1></div></div><div class=\"panel panel-default edit-subscription-form-panel\"><div class=panel-heading><h3 class=panel-title>Subscription details</h3></div><div class=panel-body><div class=row><div class=col-sm-6><form novalidate><div class=panel-row><div class=field-label>Subscription type</div><select id=subscriptionType class=form-control ng-model=vm.subscription.subscriptionTypeId ng-options=\"subscriptionType.id as subscriptionType.prettyName for subscriptionType in vm.subscriptionTypes\"></select></div><div class=panel-row><label for=start-date>Start date</label><date-input ng-model=vm.startDate format=\"\'yyyy-MM-dd\'\" ng-change=vm.startDateChanged()></date-input></div><div class=panel-row><label for=start-date>End date</label><date-input ng-model=vm.endDate format=\"\'yyyy-MM-dd\'\" ng-change=vm.endDateChanged()></date-input></div><div class=form-group><div class=field-label>Options</div><div><span class=icon class=icon ng-class=\"{\'icon-check-empty\': !vm.subscription.autoRenew, \'icon-check\': vm.subscription.autoRenew}\" ng-click=vm.changeAutoRenew()><span ng-if=!vm.subscription.subscriptionType.isTrial>&nbsp;Enable automatic renewal</span> <span ng-if=vm.subscription.subscriptionType.isTrial>&nbsp;Convert to a full subscription after trial period ends</span></span></div><div><span class=icon class=icon ng-class=\"{\'icon-check-empty\': !vm.subscription.activated, \'icon-check\': vm.subscription.activated}\" ng-click=vm.changeActivated()><span>&nbsp;Subscription is activated</span></span></div></div><div><button class=\"btn btn-success\" type=button ng-click=vm.save()>Save</button> <button id=cancel class=\"btn btn-danger\" ui-sref=subscription>Cancel</button></div></form></div></div></div></div></div>");
$templateCache.put("app/admin/subscription/subscription-list.view.html","<div class=page-subscription-list><div class=row><div class=col-md-12><h1 class=\"page-header header-adjustments-lists\"><span class=main-title-no-hover><span ng-if=!vm.userIsAdmin>Subscription</span> <span ng-if=vm.userIsAdmin>Subscriptions</span> </span><small><si-loading-indicator loading=vm.displayLoadingIcon></si-loading-indicator></small></h1></div></div><div class=row><div class=col-md-12 has-authority=\"\'ROLE_ADMIN\'\" principal=vm.principal><div class=subscription-toolbar><div class=toolbar-left><div class=\"btn-group btn-group-left active-button-alignment\"><a class=\"btn btn-default\" ng-disabled=vm.selectedUser ng-click=\"vm.setActiveState(\'true\')\" ng-class=\"{\'active\': vm.activeState === \'true\'}\">Active </a><a class=\"btn btn-default\" ng-disabled=vm.selectedUser ng-click=\"vm.setActiveState(\'false\')\" ng-class=\"{\'active\': vm.activeState !== \'true\'}\">Inactive</a></div><div class=btn-group><dropdown-component model=vm.selectedUser callback=vm.getUsers placeholder=\"\'Search for user...\'\" on-select-item=vm.selectedUserChanged></dropdown-component></div><div class=\"btn-group clear-filters\"><a title=\"Clear filters\" ng-click=vm.clearParams() class=\"btn btn-default\"><span class=\"icon icon-cancel\"></span></a></div><div class=\"btn-group add-subscription\"><a title=\"Start subscription\" class=\"btn btn-success new-icon\" ui-sref=\"subscription.new({user: vm.selectedUser.id})\"><span class=\"icon icon-plus\"></span></a></div><div class=btn-group><button class=\"btn btn-default promo-codes-button\" ui-sref=subscription.promocodes.list>Promo codes</button></div></div></div></div></div><div class=\"row top-margin-row\" ng-if=!vm.selectedUser><div class=\"col-md-12 list-bottom-padding\"><div class=\"panel panel-default\" ng-if=!vm.initialLoading><div ng-if=\"vm.users.length === 0\" class=panel-body><p>There are no users with an {{ vm.activeState === \'true\' ? \'active\' : \'inactive\' }} subscription.</p></div><div class=list-group><div ng-repeat=\"u in vm.users\" class=list-group-item><div class=row ui-sref=\"subscription.list({user: u.id})\" style=\"cursor: pointer\"><div class=col-sm-4><h4 class=\"list-group-item-heading overflow-ellipsis\">{{ u.firstName }} {{ u.lastName }}</h4><h5 class=zeromargin><span>{{ u.login }}</span></h5></div><div class=col-sm-8><div class=list-group-item-text><div class=list-group-item-text><span class=\"icon icon-blank\" ng-class=\"{\'active-indicator\': u.subscription.active}\"></span> <span><strong>{{ u.subscription.subscriptionTypeDisplayText }}</strong> valid until {{ u.subscription.endDateDisplayText }} </span><span ng-if=!u.subscription.activated>(deactivated)</span> <span ng-if=\"u.subscription.activated && !u.subscription.active\">(inactive)</span></div><div class=list-group-item-text><span class=\"icon icon-blank\" ng-class=\"{\'active-indicator\': u.subscription.autoRenew}\"></span> <span ng-if=u.subscription.autoRenew>Automatic renewal enabled</span> <span ng-if=!u.subscription.autoRenew>Automatic renewal disabled</span></div></div></div></div></div></div></div><div class=footer ng-if=!vm.hidePagination><div class=container><si-pagination sref=\"\'subscription.list\'\" pagination=vm.users.pagination go-to-page-callback=vm.goToPage></si-pagination></div></div></div></div><div class=\"row top-margin-row\" ng-if=vm.selectedUser><div class=\"col-md-12 list-bottom-padding\"><div class=\"panel panel-default\" ng-if=!vm.initialLoading><div ng-if=!vm.subscription.subscriptionType class=panel-body><p>There is no existing subscription for user {{ vm.selectedUser.login }}.</p></div><div ng-if=vm.subscription.subscriptionType class=list-group><div class=list-group-item><div class=row><div class=col-sm-3><h4 class=\"list-group-item-heading overflow-ellipsis\">Orienteering {{ vm.subscription.subscriptionType.prettyName }}</h4></div><div class=col-sm-6><div class=list-group-item-text><span class=\"icon icon-calendar\"></span> {{ vm.subscription.startDateDisplayText }} &ndash; {{ vm.subscription.endDateDisplayText }} <span ng-if=!vm.subscription.activated>(deactivated)</span></div><div class=list-group-item-text><span class=\"icon icon-blank\" ng-class=\"{\'active-indicator\': vm.subscription.autoRenew}\"></span> {{ vm.subscription.subscriptionType.isTrial === true ? \' Automatic renewal to full subscription\' : \'Automatic renewal\' }} {{ vm.subscription.autoRenew === true ? \' enabled\' : \'disabled\' }}</div></div><div class=col-sm-2><div class=list-group-item-text><span class=\"icon icon-blank\" ng-class=\"{\'active-indicator\': vm.subscription.active}\"></span> {{ vm.subscription.active === true ? \'active\' : \'inactive\' }}</div></div><div class=\"col-sm-1 col-edit\"><div ng-if=vm.userIsAdmin class=edit-icon-container><a ui-sref=\"subscription.edit({user: vm.selectedUser.id, subscriptionId: vm.subscription.id})\" class=clickable><span class=\"icon icon-pencil\"></span></a></div></div><div class=col-sm-12 style=\"margin-top: 10px\"><a class=\"btn btn-default\" ng-class=\"{\'disabled\': !vm.subscription.endsInLessThanAYear}\" ui-sref=\"subscription.new({user: vm.selectedUser.id})\">Renew subscription</a> <a class=\"btn btn-default\" ng-class=\"{\'disabled\': !vm.upgradeAvailable}\" ui-sref=\"subscription.upgrade({user: vm.selectedUser.id})\">Upgrade subscription</a> <a class=\"btn btn-default\" ng-if=vm.subscription.autoRenew ng-click=vm.disableAutoRenew() ng-class=\"{\'disabled\': !vm.subscription.active}\">Disable automatic renewal</a> <a class=\"btn btn-default\" ng-if=!vm.subscription.autoRenew ng-click=vm.enableAutoRenew() ng-class=\"{\'disabled\': !vm.subscription.active}\">Enable automatic renewal</a></div></div></div></div></div></div></div><div class=\"panel panel-default\" ng-if=\"vm.userIsAdmin && !vm.initialLoading && vm.selectedUser\"><div class=panel-heading><h3 class=panel-title>Competitor database</h3></div><div class=row><div class=col-md-10><div class=panel-body><form><a class=\"btn btn-default\" ui-sref=\"competitordbs({user: vm.selectedUser.id})\">Manage competitor database</a></form></div></div></div></div></div>");
$templateCache.put("app/admin/subscription/subscription-new.view.html","<div class=page-subscription-new><div class=row><div class=col-md-12><h1 class=\"page-header header-adjustments-lists\"><span class=main-title-no-hover><span ng-if=vm.isUpgradeAction>Upgrade Subscription</span> <span ng-if=\"!vm.isUpgradeAction && !vm.existingSubscription.subscriptionType\">Start Subscription</span> <span ng-if=\"!vm.isUpgradeAction && vm.existingSubscription.subscriptionType\">Renew Subscription</span> <span ng-if=vm.userIsAdmin>for User {{ vm.selectedUser.login }}</span></span></h1></div></div><div ng-if=!vm.subscriptionAction><div class=\"row top-margin-row\"><div ng-repeat=\"st in vm.subscriptionTypes\"><div class=\"col-xs-12 col-sm-4\"><div class=subscription-box><div class=subscription-title>Orienteering</div><div class=subscription-name>{{ st.prettyName }}</div><div class=subscription-description>Premium features for<br>up to {{ st.featuresMaximumAthletes }} athletes</div><div class=subscription-features><div ng-repeat=\"f in st.featureList\">{{ f }}</div></div><div class=subscription-price ng-if=\"st.price === 0\"><span class=subscription-price-number>Free trial</span><br>({{ st.period }} months)</div><div class=subscription-price ng-if=\"st.price !== 0\"><span class=subscription-price-number>{{ st.price }} €</span><br>({{ st.period }} months)</div><div ng-if=!vm.isUpgradeAction><div ng-if=\"st.trialId !== undefined && vm.trialAvailable\"><buttton class=\"btn btn-warning\" ui-sref=\"subscription.new({user: vm.selectedUserId, type: st.trialId})\">Start free trial</buttton></div><div><button class=\"btn btn-success\" ui-sref=\"subscription.new({user: vm.selectedUserId, type: st.id})\">Select</button></div></div><div ng-if=vm.isUpgradeAction><div ng-if=\"st.trialId !== undefined && vm.trialAvailable\"><buttton class=\"btn btn-warning\" ui-sref=\"subscription.upgrade({user: vm.selectedUserId, type: st.trialId})\">Start free trial</buttton></div><div><button class=\"btn btn-success\" ui-sref=\"subscription.upgrade({user: vm.selectedUserId, type: st.id})\" ng-disabled=!st.isAvailable><span ng-if=st.isAvailable>Select</span> <span ng-if=\"!st.isAvailable && (st.id == vm.existingSubscription.subscriptionType.id)\">Active subscription</span></button></div></div></div></div></div><div class=\"col-xs-12 col-sm-4\"><div class=subscription-box><div class=subscription-title>Orienteering</div><div class=subscription-name>100+</div><div class=subscription-description>Premium features for<br>more than 100 athletes</div><div class=subscription-features><div>OCAD import</div><div>Competitor database</div><div>Publish results online</div><div>Export results</div></div><a class=\"btn btn-success\" ng-class=\"{\' btn-contact-us\': vm.trialAvailable, \' btn-contact-us-no-trial-available\':!vm.trialAvailable}\" href=mailto:support@sportident.com>Contact us</a></div></div></div><div class=\"row subscription-details\"><div class=col-xs-12><h4>Subscription details</h4></div></div><div class=\"row subscription-details\"><div class=\"col-xs-12 col-sm-6\"><p>All listed prices are end customer prices for customers worldwide and include applicable taxes.</p><p>SPORTident Orienteering App Subscriptions (\"Orienteering\" above) provide premium features for use with the SPORTident Orienteering App, <a href=\"https://play.google.com/store/apps/details?id=com.sportident.apps.orienteering\">available in the Google Play Store</a>.</p><p>The number of athletes is counted per event.</p><p>Premium features are only available as long as the maximum number of athletes of your plan is not exceeded for an event.</p><p>Each subscription can only have one active event and one active device (i.e. one running app) at the same time.</p><p>You may only use a free trial once.</p></div><div class=\"col-xs-12 col-sm-6\"><p>The subscription period of a new subscription starts on the first day of the next calendar month (the current month is free of charge).</p><p>Once started, a subscription always runs to the end of its subscription period.</p><p>A past event’s online results and export features remain available even after the subscription period ends.</p><p>The SPORTident Orienteering App Subscriptions do not include data transmission for the SPORTident GSM modem, SPORTident Reader or via Center APIs (article number 95012).</p><p>For requirements that are not covered by the available plans, for example large one-time events, please <a href=mailto:support@sportident.com>contact us</a>.</p></div></div></div><div ng-if=\"vm.subscriptionAction !== null && (vm.step === 1 || vm.step === 3)\" class=\"panel panel-default start-subscription-form-panel\"><div class=panel-heading><h3 ng-if=\"vm.step === 1\" class=panel-title>Step 1 of 3: Subscription details</h3><h3 ng-if=\"vm.step === 3\" class=panel-title>Step 3 of 3: Summary & confirmation</h3></div><div class=panel-body><div class=row><div class=col-sm-6><form novalidate><div class=panel-row><div class=field-label ng-if=vm.existingSubscription.active>Current subscription</div><div class=field-label ng-if=!vm.existingSubscription.active>Expired subscription</div><div>Orienteering {{ vm.existingSubscription.subscriptionType.prettyName }} active until {{ vm.existingSubscription.endDateDisplayText }}</div></div><div class=panel-row><div class=field-label>New subscription</div><div>Orienteering {{ vm.subscriptionType.prettyName }}</div></div><div class=panel-row><div class=field-label>Start date</div><div>{{ vm.subscriptionAction.startDateDisplayText }}</div></div><div class=panel-row><div class=field-label>End date</div><div>{{ vm.subscriptionAction.endDateDisplayText }}</div></div><div class=panel-row><div class=field-label>Price</div><div>{{ vm.subscriptionAction.priceDisplayText }}</div></div><div class=form-group ng-if=\"!vm.subscriptionType.isTrial && vm.step === 1\"><label for=subscription-promo-code>Promo code</label><input id=subscription-promo-code type=text class=form-control ng-change=vm.updateSubscriptionAction() ng-model=vm.promoCode></div><div class=panel-row ng-if=\"vm.step === 3 && vm.promoCode\"><div class=field-label>Promo code</div><div>{{ vm.promoCode }}</div></div><div class=panel-row ng-if=\"vm.step === 3\"><div class=field-label>Billing address</div><div>{{ vm.billingContact.firstName }} {{ vm.billingContact.lastName }}</div><div>{{ vm.billingContact.organisation }}</div><div>{{ vm.billingContact.addressLine1 }}</div><div>{{ vm.billingContact.addressLine2 }}</div><div>{{ vm.billingContact.zip }} {{ vm.billingContact.city }}<span ng-if=vm.billingContact.state>, {{ vm.billingContact.state }}</span></div><div>{{ vm.billingContact.country }}</div></div><div class=panel-row ng-if=\"vm.step === 3\"><div class=field-label>Email address</div><div>{{ vm.billingContact.email }}</div></div><div class=form-group><div class=field-label>Options</div><div><span class=icon class=icon ng-class=\"{\'icon-check-empty\': !vm.autoRenew, \'icon-check\': vm.autoRenew}\" ng-click=vm.changeAutoRenew()><span ng-if=!vm.subscriptionType.isTrial>&nbsp;Enable automatic renewal</span> <span ng-if=vm.subscriptionType.isTrial>&nbsp;Convert to a full subscription after trial period</span></span></div></div><div class=form-group ng-if=\"vm.step === 3\"><div class=field-label>Terms and conditions</div><div><span class=icon class=icon ng-class=\"{\'icon-check-empty\': !vm.termsAccepted, \'icon-check\': vm.termsAccepted}\" ng-click=vm.changeTermsAccepted()><span>&nbsp;I accept the <a href=https://www.sportident.com/legal-information.html target=_blank>Terms and Conditions</a> and <a href=https://www.sportident.com/legal-information.html#datenschutzerklaerung target=_blank>Privacy Policy</a></span></span></div></div><div ng-if=\"vm.step === 1\"><button class=\"btn btn-success\" type=button ng-click=vm.continueToStep2()>Continue</button></div><div ng-if=\"vm.step === 3\"><button class=\"btn btn-success\" type=button ng-click=vm.confirmSubscription()>Confirm</button> <button class=\"btn btn-danger\" type=button ng-click=vm.continueToStep2()>Back</button></div></form></div><div class=col-sm-6></div></div></div></div><div ng-if=\"vm.subscriptionType !== null && vm.step === 2\"><billing-address-form user-id=vm.selectedUserId panel-title=\"Step 2 of 3: Billing address\" save-button-label=Continue on-save=vm.continueToStep3() cancel-button-label=Back on-cancel=vm.backToStep1()></billing-address-form></div></div>");
$templateCache.put("app/admin/user/user-edit.view.html","<div class=row><div class=col-md-12><h1 class=page-header>{{vm.userTitle}} <small><si-loading-indicator></si-loading-indicator></small></h1></div></div><div class=\"panel panel-default\" ng-if=\"vm.user.id != \'new\'&& !vm.user.activated\"><div class=panel-heading><h3 class=panel-title>Activation</h3></div><div class=panel-body><div class=row><div class=col-md-12 style=\"margin-bottom: 12px\">This user account has not yet been activated.</div></div><div class=row><div class=col-md-12><button id=save class=\"btn btn-success\" ng-click=vm.sendActivationEmail()>Resend activation email</button></div></div></div></div><div class=\"panel panel-default\"><div class=panel-heading><h3 class=panel-title>Account</h3></div><div class=panel-body><div class=row><div class=col-md-5><form name=myForm><div class=form-group><label for=login>Login</label><input id=login type=text class=form-control ng-model=vm.user.login required><!--autofocus si-focus-me--></div><div class=form-group><label for=firstName>First name</label><input id=firstName type=text class=form-control ng-model=vm.user.firstName></div><div class=form-group><label for=lastName>Last name</label><input id=lastName type=text class=form-control ng-model=vm.user.lastName></div><div class=form-group><label for=email>E-mail</label><input id=email type=email class=form-control ng-model=vm.user.email></div><div class=form-group><label for=role>User role</label><br><div class=btn-group><button type=button class=\"btn btn-default\" ng-click=\"vm.setAuthority(\'user\')\" ng-class=\"{active: vm.authorityClass === \'user\'}\">User</button> <button type=button class=\"btn btn-default\" ng-click=\"vm.setAuthority(\'admin\')\" ng-class=\"{active: vm.authorityClass === \'admin\'}\">Admin</button></div></div><div><div class=form-group><label for=orgName>Select organisation</label><dropdown-component id=selorganisation model=vm.selectedOrganisation callback=vm.getOrganisations placeholder=\"\'Search for or insert organisation\'\" on-select-item=vm.selectedOrganisationChanged></dropdown-component></div><div class=form-group><label for=orgName>Organisation name</label><input type=text class=form-control ng-model=vm.shownUserOrganisation.organisation.name ng-change=vm.showSlugPlaceholder() ng-disabled=vm.disableOrganisation></div><div class=form-group><label for=orgSlug>Organisation slug</label><input type=text title=\"allowed only characters a-z, 0-9 and \'-\'\" ng-attr-placeholder={{vm.slugPlaceholder}} class=form-control ng-model=vm.shownUserOrganisation.organisation.slug ng-disabled=vm.disableOrganisation></div><input type=hidden ng-model=vm.shownUserOrganisation.organisation.email></div><button id=save class=\"btn btn-success\" ng-click=vm.saveUser()>{{vm.saveButtonText}}</button> <button id=cancel class=\"btn btn-danger\" ui-sref=users>Cancel</button></form></div></div></div></div><div ng-if=\"vm.user.id != \'new\' && vm.user.activated\"><billing-address-form user-id=vm.user.id></billing-address-form></div><div class=\"panel panel-default\" ng-if=\"vm.user.id != \'new\' && vm.user.activated\"><div class=panel-heading><h3 class=panel-title>API key</h3></div><div class=panel-body><div class=row><div class=col-md-6><form novalidate><div class=\"form-group non-mobile\"><label for=apiKey>API key</label><div class=input-group><input id=apiKey type=text class=form-control ng-model=vm.user.apiKey readonly> <span class=input-group-btn><button id=reset-apikey-btn1 class=\"btn btn-success\" ng-click=vm.resetApiKey()>Reset API key</button></span></div></div><div class=\"form-group mobile\"><br><label for=apiKey>API key</label><p class=form-control-static>{{vm.user.apiKey}}</p><button id=reset-apikey-btn2 class=\"btn btn-success\" ng-click=vm.resetApiKey()>Reset API key</button></div></form></div></div></div></div>");
$templateCache.put("app/admin/user/user-list.view.html","<div class=row><div class=col-md-12><h1 class=\"page-header header-adjustments-lists\"><a ng-click=vm.getAllUsers() class=main-title title=\"Refresh list\">Users</a><div class=list-item-count uib-tooltip-html=vm.getUserCountTooltipHtml() tooltip-placement=right-top tooltip-trigger=\"\'click mouseenter\'\" tooltip-class=user-tooltip><span>{{vm.users.totalCount}}</span></div><a title=\"Toggle filters\" ng-click=\"vm.toggleActive(\'showfilters\')\" class=\"btn btn-default show-hide-menu-btn\" ng-class=\"{active: vm.showToolbar === true, primary: vm.showToolbar === true}\"><span class=\"icon icon-filter\"></span></a> <small><si-loading-indicator loading=vm.displayLoadingIcon></si-loading-indicator></small></h1></div></div><div class=row><div class=\"col-md-12 list-bottom-padding\"><div class=user-toolbar ng-class=\"{\'hide-toolbar\': vm.showToolbar === false, \'show-toolbar\': vm.showToolbar === true}\"><div class=toolbar-left><div class=\"btn-group btn-group-left filters margin-between-toolbar-elements\"><a class=\"btn btn-default\" ng-click=\"vm.toggleSort(\'login\')\" ng-class=\"{active: vm.activesort === \'login\' || vm.activesort === undefined}\">Login <span class=hide-for-screens-smaller-than-992px>name</span> </a><a class=\"btn btn-default\" ng-click=\"vm.toggleSort(\'lastName\')\" ng-class=\"{active: vm.activesort === \'lastName\'}\">Last <span class=hide-for-screens-smaller-than-992px>name</span></a></div><div class=\"btn-group btn-group-left filters-activated margin-between-toolbar-elements\" has-authority=\"\'ROLE_ADMIN\'\" principal=vm.principal><a class=\"btn btn-default\" ng-click=vm.toggleActivatedFilter() ng-class=\"{active: vm.activatedFilter }\">Act<span class=hide-for-screens-smaller-than-440px>ivated</span></a></div><div class=\"btn-group btn-group-left filters-roles after-break-margin\" has-authority=\"\'ROLE_ADMIN\'\" principal=vm.principal><a class=\"btn btn-default\" ng-click=\"vm.toggleRoleFilter(\'allroles\')\" ng-class=\"{active: vm.activefilter === \'allroles\' || vm.activefilter === undefined}\">All </a><a class=\"btn btn-default\" ng-click=\"vm.toggleRoleFilter(\'admin\')\" ng-class=\"{active: vm.activefilter === \'admin\'}\">Admin </a><a class=\"btn btn-default\" ng-click=\"vm.toggleRoleFilter(\'user\')\" ng-class=\"{active: vm.activefilter === \'user\'}\">User</a></div><div class=\"btn-group btn-group-left select-user-box-users left-margin-between-toolbar-elements after-break-margin\"><dropdown-component model=vm.selectedUser callback=vm.getUsers placeholder=\"\'Select user...\'\" on-select-item=vm.selectedUserChanged></dropdown-component></div><div class=\"btn-group btn-group-left left-margin-between-toolbar-elements after-break-margin clear-filters-btn\"><a title=\"Clear filters\" ng-click=vm.clearParams() class=\"btn btn-default\"><span class=\"icon icon-cancel\"></span></a></div></div><div ng-class=\"{\'toolbar-right-all\': vm.toggleState === \'all\', \'toolbar-right-delete\': vm.toggleState === \'deleteuser\'}\"><!-- default view--><div has-authority=\"\'ROLE_ADMIN\'\" principal=vm.principal><div class=all-button-state-users><div ng-if=\"vm.toggleState === \'all\'\" class=\"btn-group btn-group-right\"><a title=\"Delete user\" class=\"btn btn-default\" ng-click=\"vm.toggleActive(\'deleteuser\')\"><span class=\"icon icon-trash\"></span></a> <a title=New class=\"btn btn-default new-icon\" ui-sref=\"user.edit({userId: \'new\'})\"><span class=\"icon icon-plus\"></span></a></div></div><!-- delete user view--><div class=delete-state-users><div ng-if=\"vm.toggleState === \'deleteuser\'\" class=\"btn-group btn-group-right\"><a title=\"Delete user\" class=\"btn btn-default disable-list\"><span class=\"icon icon-trash\"></span></a> <a ng-model=vm.confirmState title=Confirm ng-click=vm.confirmDeleteDialog() class=\"btn btn-default check-button-green\"><span class=\"icon icon-ok\"></span></a> <a title=Cancel ng-click=\"vm.toggleActive(\'closeall\')\" class=\"btn btn-default cancel-button-red\"><span class=\"icon icon-cancel\"></span></a></div></div></div></div></div><div ng-class=\"{\'panel panel-default\': !vm.initialLoading}\"><div ng-if=\"vm.users.length===0\" class=panel-body><p>There are no existing users that match the search criteria.</p></div><div class=list-group><div ng-repeat=\"u in vm.users\" ng-click=vm.editView(u) class=list-group-item ng-class=\"{\'select-cursor\':vm.toggleState !== \'all\', selected: u.selected === true}\"><div class=row><div class=\"col-sm-3 col-lg-3 col-md-4 user-collumn-override\"><div class=overflow-ellipsis><h4 class=\"list-group-item-heading inline-block\">{{u.firstName+\" \"+u.lastName}}</h4></div><h5 class=zeromargin><span title=Administrator ng-if=\"u.getAuthority===1\" class=\"icon icon-crown\"></span> <span>{{u.login}}</span></h5></div><div class=\"col-sm-2 col-lg-2 col-md-2\"><div ng-if=\"u.status.eventCount===0\" class=list-group-item-text><span title=\"Events: None\"><span class=\"icon icon-flag\"></span> None</span></div><div ng-if=\"u.status.eventCount>0\" class=\"list-group-item-text overflow-ellipsis\"><div ng-if=\"vm.toggleState === \'all\'\"><a href=\"\" title=\"Events: {{u.status.eventCount}}\" ui-sref=\"events({user: u.id})\"><span title=\"Events: {{u.status.eventCount}}\"><span class=\"icon icon-flag\"></span> {{u.status.eventCount}} event<span ng-if=\"u.status.eventCount>1\">s</span></span></a></div><div ng-if=\"vm.toggleState !== \'all\'\"><span class=\"icon icon-flag\"></span> {{u.status.eventCount}} event<span ng-if=\"u.status.eventCount>1\">s</span></div></div><div ng-if=\"u.status.boxCount===0\" class=list-group-item-text><span title=\"Modems: None\"><span class=\"icon icon-blank\"></span> None</span></div><div ng-if=\"u.status.boxCount>0\" class=\"list-group-item-text overflow-ellipsis\"><div ng-if=\"vm.toggleState === \'all\'\"><a href=\"\" title=\"Modems: {{u.status.boxCount}}\" ui-sref=\"modems({user: u.id})\"><span title=\"Modems: {{u.status.boxCount}}\"><span class=\"icon icon-blank\"></span> {{u.status.boxCount}} modem<span ng-if=\"u.status.boxCount>1\">s</span></span></a></div><div ng-if=\"vm.toggleState !== \'all\'\"><span class=\"icon icon-blank\"></span> {{u.status.boxCount}} modem<span ng-if=\"u.status.boxCount>1\">s</span></div></div></div><div class=\"col-sm-3 col-lg-2 col-md-3\"><div ng-if=\"u.status.stampCount===0\" class=list-group-item-text><span title=\"Stamps: None\"><span class=\"icon icon-braille\"></span> None</span></div><div ng-if=\"u.status.stampCount>0\" class=\"list-group-item-text overflow-ellipsis\"><span title=\"Stamps: {{u.status.stampCount}}\"><span class=\"icon icon-braille\"></span> {{u.status.stampCount}} stamp<span ng-if=\"u.status.stampCount>1\">s</span></span></div><div ng-if=\"u.status.athleteDays!==0\" class=\"list-group-item-text overflow-ellipsis\"><span title=\"Athlete days: {{u.status.athleteDays}}\"><span class=\"icon icon-clock\"></span> {{u.status.athleteDays}} athlete days</span></div><div ng-if=\"u.status.athleteDays===0\" class=list-group-item-text><span title=\"Athlete days: None\"><span class=\"icon icon-clock\"></span> None</span></div></div><div class=\"col-sm-3 col-lg-2 col-md-2\"><div ng-if=\"u.status.lastLogin!==null\" class=\"list-group-item-text overflow-ellipsis\"><span title=\"Last login: {{u.status.lastLoginHover}}\"><span class=\"icon icon-login\"></span> {{u.status.lastLoginDisplay}}</span></div><div ng-if=\"u.status.lastLogin===null\" class=list-group-item-text><span title=\"Last login: Never\"><span class=\"icon icon-login\"></span> Never</span></div><div ng-if=\"u.status.lastStampActivity!==null\" class=\"list-group-item-text overflow-ellipsis\"><span title=\"Last activity: {{u.status.lastStampActivityHover}}\"><span class=\"icon icon-upload-cloud\"></span> {{u.status.lastStampActivityDisplay}}</span></div><div ng-if=\"u.status.lastStampActivity===null\" class=list-group-item-text><span title=\"Last activity: None\"><span class=\"icon icon-upload-cloud\"></span> None</span></div></div><div class=\"col-sm-1 col-lg-3 col-md-1 editbox-users\"><a ng-if=\"vm.toggleState == \'all\'\" ui-sref=\"user.edit({userId: u.id})\" class=\"clickable align-middle\"><span class=\"icon icon-pencil edit-select-icons\" ng-class=\"{\'editbox-users-icons\': u.getAuthority!==1, \'editbox-users-icons-admin\': u.getAuthority===1}\"></span></a><div ng-if=\"vm.toggleState !== \'all\' && u.selected === false\" class=\"clickable align-middle\" ng-class=\"{\'editbox-users-icons\': u.getAuthority!==1, \'editbox-users-icons-admin\': u.getAuthority===1}\"><span class=\"icon icon-check-empty edit-select-icons\"></span></div><div ng-if=\"vm.toggleState !== \'all\' && u.selected === true\" class=\"clickable align-middle\" ng-class=\"{\'editbox-users-icons\': u.getAuthority!==1, \'editbox-users-icons-admin\': u.getAuthority===1}\"><span class=\"icon icon-check edit-select-icons checkbox-selected\"></span></div></div></div></div></div></div><div class=footer><div class=container><si-pagination sref=\"\'users\'\" pagination=vm.users.pagination go-to-page-callback=vm.gotToPage></si-pagination></div></div></div></div>");
$templateCache.put("app/components/battery-indicator/battery-indicator.directive.html","<div class=battery-indicator-container><span title=\"Battery information not available\" ng-if=\"vm.returnBattery === -1\" class=\"icon icon-battery-0 size-2 batteryproblem\"></span> <span title=\"Battery information not available\" ng-if=\"vm.returnBattery === -1\" class=\"icon icon-help batteryproblem-question\"></span> <span class=\"icon icon-battery-{{vm.returnBattery}} size-2\" title=\"Voltage: {{vm.hoverValue/1000 | number:2}}V &#013;Percentage: {{vm.batteryDisplay}}%\"></span></div>");
$templateCache.put("app/components/billing-address-form/billing-address-form.directive.html","<div class=\"panel panel-default billing-address-form-panel\"><div class=panel-heading><h3 class=panel-title>{{ vm.panelTitle !== undefined ? vm.panelTitle : \'Billing address\' }}</h3></div><div ng-if=\"vm.contact === null\" class=panel-body><si-loading-indicator loading=true></si-loading-indicator></div><div ng-if=\"vm.contact !== null\" class=panel-body><div class=row><div class=col-sm-6><form novalidate><div class=form-group><label for=billing-address-first-name>First name *</label><input id=billing-address-first-name type=text class=form-control ng-model=vm.contact.firstName required></div><div class=form-group><label for=billing-address-last-name>Last name *</label><input id=billing-address-last-name type=text class=form-control ng-model=vm.contact.lastName required></div><div class=form-group><label for=billing-address-organisation>Company / Club</label><input id=billing-address-organisation type=text class=form-control ng-model=vm.contact.organisation></div><div class=form-group><label for=billing-address-addressn-line1>Address line 1 *</label><input id=billing-address-address-line1 type=text class=form-control ng-model=vm.contact.addressLine1 required></div><div class=form-group><label for=billing-address-address-line2>Address line 2</label><input id=billing-address-address-line2 type=text class=form-control ng-model=vm.contact.addressLine2></div><div class=form-group><label for=billing-address-zip>Zip *</label><input id=billing-address-zip type=text class=form-control ng-model=vm.contact.zip required></div><div class=form-group><label for=billing-address-city>City *</label><input id=billing-address-city type=text class=form-control ng-model=vm.contact.city required></div><div class=form-group><label for=billing-address-state>State / Region</label><input id=billing-address-state type=text class=form-control ng-model=vm.contact.state></div><div class=form-group><label for=billing-address-country>Country *</label><dropdown-component id=billing-address-country placeholder=\"\'Select country\'\" model=vm.selectedCountry local-callback=vm.getCountries on-select-item=vm.selectedCountryChanged></dropdown-component></div><div class=form-group><label for=billing-address-phone>Phone</label><input id=billing-address-phone type=text class=form-control ng-model=vm.contact.phone></div><div class=form-group><label for=billing-address-email>Email *</label><input id=billing-address-email type=text class=form-control ng-model=vm.contact.email required></div><button id=billing-address-save class=\"btn btn-success\" ng-click=vm.save()>{{ vm.saveButtonLabel !== undefined ? vm.saveButtonLabel : \'Save\' }}</button> <button ng-if=vm.onCancel id=billing-address-cancel class=\"btn btn-danger\" ng-click=vm.cancel()>{{ vm.cancelButtonLabel !== undefined ? vm.cancelButtonLabel : \'Cancel\' }}</button></form></div><div class=col-sm-6></div></div></div></div>");
$templateCache.put("app/components/confirmation-dialog/confirmation-dialog.directive.html","<div class=modal-header><h3 class=modal-title>{{vm.title}}</h3></div><div class=modal-body>{{vm.message}}</div><div class=modal-footer><button class=\"btn {{vm.firstButtonClass}}\" ng-click=vm.ok()>{{vm.firstButtonText}}</button> <button class=btn ng-click=vm.cancel()>{{vm.secondButtonText}}</button></div>");
$templateCache.put("app/components/date-input/date-input.directive.html","<div class=input-group><input type=text class=form-control uib-datepicker-popup={{vm.formatDisplay}} ng-model=vm.ngModel ng-change=updateModel(vm.ngModel) is-open=vm.popup.opened datepicker-options=vm.dateOptions ng-required=true close-text=Close ng-readonly=vm.disabled> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=vm.open()><span class=\"icon icon-calendar\"></span></button></span></div>");
$templateCache.put("app/components/dropdown-component/dropdown-component.directive.html","<ui-select tagging ng-model=vm.model theme=bootstrap class=\"ui-select-width selection-box\" tooltip-enable=vm.tooltipIsOpen uib-tooltip=\"No results found!\" tooltip-is-open=vm.tooltipIsOpen tooltip-placement=bottom ng-click=vm.focusOnThis($event) on-select=\"vm.selectItem($select.selected.id, vm.inputtype)\"><ui-select-match placeholder={{vm.placeholder}}>{{$select.selected.displayName}}</ui-select-match><ui-select-choices repeat=\"item in vm.displayData | filter : vm.getSelect($select) track by item.id\" refresh=vm.refreshResults($select) refresh-delay=0><div ng-bind-html=vm.getHighlightDisplayName(item.displayName,$select)></div></ui-select-choices></ui-select>");
$templateCache.put("app/components/loading-indicator/loading-indicator.directive.html","<span class=si-loading-indicator ng-class=\"(vm.isLoading?\'loading\':\'\')\"><span class=\"icon icon-spin5 fa-spin-custom\"></span> </span>");
$templateCache.put("app/components/login/login.directive.html","<div class=contain-absolute><div class=\"row login\"><div class=\"col-sm-offset-5 resize-panel\"><div class=\"panel panel-default transparent\"><div class=panel-body><img src=assets/images/si_center_logo_new-4e9f31cdc0.png class=\"img-responsive logo col-sm-12\"><form novalidate><div class=\"form-group col-sm-12\"><label for=username>Username</label><input id=username type=text class=form-control ng-model=vm.username required autofocus si-focus-me></div><div class=\"form-group col-sm-12\"><label for=password>Password</label><input id=password type=password class=form-control ng-model=vm.password required><div class=forgot-password><a ui-sref=password-reset-request>Forgot your password?</a></div></div><div class=\"form-group col-sm-12\"><button id=login class=\"btn btn-success col-sm-12\" ng-click=vm.login()>Sign in</button><br><br></div></form><div class=col-sm-12 style=\"text-align: center\"><a ui-sref=register-request>Register</a> | <a ui-sref=about>About</a> | <a href=http://sportident.com>SPORTident Home</a></div></div></div></div></div></div>");
$templateCache.put("app/components/monitor/monitor.directive.html","<div class=row><div class=col-md-12><h1 class=\"page-header header-adjustments-lists\"><a ng-click=vm.refreshMonitor() class=main-title title=\"Reload stamps\">Monitor</a><div class=list-item-count uib-tooltip-html=vm.getStampCountTooltipHtml() tooltip-placement=bottom tooltip-trigger=\"\'click mouseenter\'\" tooltip-class=monitor-tooltip><span>{{vm.stampsTotalCount}}</span></div><a title=\"Toggle filters\" ng-click=\"vm.toggleActive(\'showfilters\')\" class=\"btn btn-default show-hide-menu-btn-monitor\" ng-class=\"{active: vm.showToolbar === true, primary: vm.showToolbar === true}\"><span class=\"icon icon-filter\"></span></a> <small><si-loading-indicator loading=vm.displayLoadingIcon></si-loading-indicator></small></h1><div class=monitor-toolbar ng-class=\"{\'hide-toolbar-monitor\': vm.showToolbar === false, \'show-toolbar-monitor\': vm.showToolbar === true}\"><div class=toolbar-left><form class=form-inline ng-submit=vm.applyFilters()><div class=\"btn-group monitor-filter-show-duplicates-button-group\"><a title=\"Hide duplicate records\" class=\"btn btn-default\" ng-click=vm.setShowDuplicates(false) ng-class=\"{\'active\': !vm.showDuplicates }\">&#9679; </a><a title=\"Show duplicate records\" class=\"btn btn-default\" ng-click=vm.setShowDuplicates(true) ng-class=\"{\'active\': vm.showDuplicates}\">&#9679;&#9679;</a></div><div class=\"form-group select-event-box-modem after-break-margin monitor-search-dropdown margin-between-toolbar-elements\"><dropdown-component model=vm.selectedEvents callback=vm.getEvents placeholder=\"\'Search for event...\'\" on-select-item=vm.selectedEventChanged></dropdown-component></div><div class=\"form-group select-event-box-modem after-break-margin monitor-search-dropdown margin-between-toolbar-elements\"><dropdown-component model=vm.selectedModems callback=vm.getModems placeholder=\"\'Search for modem...\'\" on-select-item=vm.selectedModemChanged></dropdown-component></div><div class=\"form-group margin-between-toolbar-elements monitor-filter-card-text-input\"><label for=cardTextInput class=sr-only>Card</label><input id=cardTextInput type=text class=form-control placeholder=Card inputmode=numeric minlength=5 maxlength=7 size=7 pattern=^\\d+$ ng-model=vm.selectedCard ng-blur=vm.applyFilters()></div><div class=\"form-group margin-between-toolbar-elements monitor-filter-control-text-input\"><label for=controlTextInput class=sr-only>Control</label><input id=controlTextInput type=text class=form-control placeholder=Control inputmode=numeric minlength=1 maxlength=3 size=3 pattern=^\\d+$ ng-model=vm.selectedControl ng-blur=vm.applyFilters()></div><div class=\"btn-group btn-group-left\"><a title=\"Clear filters\" ng-click=vm.clearParams() class=\"btn btn-default\"><span class=\"icon icon-cancel\"></span></a></div><div class=\"form-group sr-only\"><button type=submit class=\"btn btn-default\">Filter</button></div></form></div><div class=toolbar-right><form class=form-inline><!-- Date selection --><div class=\"form-group form-group-date margin-between-toolbar-elements\"><div class=input-group><span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vm.previousDay()>&laquo;</button> </span><input type=text title=\"Displaying stamps on the day of {{vm.viewDateString}}\" class=form-control ng-class=\"{inactive: !vm.dateSelectionActive}\" placeholder=dd.MM.yyyy uib-datepicker-popup=dd.MM.yyyy is-open=vm.isDatepickerOpen datepicker-options=\"{formatYear:\'yyyy\',startingDay:1, customClass: vm.getStampCountForDay}\" close-text=Close ng-model=vm.viewDateObject ng-change=vm.viewDateChanged()> <span class=\"form-control-clear icon-cancel\" ng-click=vm.makeDateAndTimeSelectionInactive()></span> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=vm.openDatepicker()><span class=\"icon icon-calendar\"></span></button> <button class=\"btn btn-default\" type=button ng-click=vm.nextDay()>&raquo;</button></span></div></div><!-- Hour selection --><div class=\"form-group form-group-hour\"><div class=input-group><span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vm.previousHour()>&laquo;</button> </span><input type=text title=\"Displaying stamps within the time range from {{vm.viewTimeMinusOneHour}} to {{vm.viewTime}}\" class=form-control ng-class=\"{inactive: !vm.timeSelectionActive}\" placeholder=HH:mm size=5 maxlength=5 ng-model=vm.viewTime ng-change=vm.viewTimeChanged()> <span class=\"form-control-clear icon-cancel\" ng-click=vm.makeTimeSelectionInactive()></span> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vm.nextHour()>&raquo;</button></span></div></div></form></div></div><div ng-if=\"vm.stampsOfHourCount==0 && vm.stampsOfDayCount>0\"><p>No results within the time range from {{vm.viewTimeMinusOneHour}} to {{vm.viewTime}}.</p><p>Still, we have a total of <a href=\"\" ng-click=vm.makeTimeSelectionInactive()>{{vm.stampsOfDayCount}} matching <span ng-pluralize count=vm.stampsOfDayCount when=\"{one: \'stamp\', other: \'stamps\'}\"></span> </a>on the day of {{vm.viewDateString}}.</p></div><div ng-if=\"vm.stampsOfHourCount==0 && vm.stampsOfDayCount==0 && vm.stampsTotalCount>0\"><p>No results on the day of {{vm.viewDateString}}.</p><p>Still, we have a total of <a href=\"\" ng-click=vm.makeDateAndTimeSelectionInactive()>{{vm.stampsTotalCount}} matching <span ng-pluralize count=vm.stampsTotalCount when=\"{one: \'stamp\', other: \'stamps\'}\"></span> </a>on other days.</p></div><div ng-if=\"vm.stampsOfHourCount==0 && vm.stampsOfDayCount==0 && vm.stampsTotalCount==0\"><p>No results match the current filter settings.</p></div><div class=table-responsive><table ng-if=\"vm.stamps.length>0\" class=\"table table-hover\"><thead><tr><th>Event</th><th>Modem</th><th>Card</th><th>Control</th><th>Punch Time</th><th>Readout Time</th></tr></thead><tbody><tr ng-repeat=\"stamp in vm.stamps\" ng-class=\"{\'monitor-duplicate-table-row\': stamp.duplicate}\"><td>{{stamp.event.name}}</td><td>{{stamp.box.externId}}</td><td>{{stamp.stampSiid}}</td><td>{{stamp.stampCode}}</td><td>{{vm.formatDate(stamp.stampTime)}}</td><td>{{vm.formatDateLocal(stamp.stampReadoutDatetime)}}</td></tr></tbody></table></div><div ng-if=\"vm.stamps.length<vm.stampsOfHourCount\"><p>Showing {{vm.stamps.length}} of {{vm.stampsOfHourCount}} stamps in this hour. Please adjust the selected time to see earlier stamps in this hour.</p></div></div></div>");
$templateCache.put("app/components/navbar/navbar.directive.html","<div class=si-header-wrapper><div class=\"navbar navbar-sportident\" role=navigation><div class=container><div class=navbar-header><button type=button class=navbar-toggle ng-click=vm.toggleCollapse()><span class=sr-only>Toggle navigation</span> <span class=\"icon icon-bar\"></span> <span class=\"icon icon-bar\"></span> <span class=\"icon icon-bar\"></span></button> <a class=navbar-brand><img alt=\"SPORTident Center\" src=assets/images/si_center_logo_new-4e9f31cdc0.png></a></div><div class=navbar-collapse uib-collapse=vm.isCollapsed><ul class=\"nav navbar-nav\"><li ng-repeat=\"page in vm.pages\" ng-class=\"(page.active?\'active\':\'\')\" has-authority=page.requiredRole principal=vm.principal><a ui-sref=\"{{ page.state }}\" class=desktop-collapse>{{ page.titleIfAdmin && vm.principal.hasAuthority(\"ROLE_ADMIN\") ? page.titleIfAdmin : page.title }} </a><a ui-sref=\"{{ page.state }}\" class=mobile-collapse ng-click=vm.toggleCollapse()>{{ page.titleIfAdmin && vm.principal.hasAuthority(\"ROLE_ADMIN\") ? page.titleIfAdmin : page.title }}</a></li></ul><ul ng-switch=vm.principal.isAuthenticated() class=\"nav navbar-nav navbar-right\"><li ng-switch-when=false ui-sref-active=active><a ui-sref=login>Login</a></li><li ng-switch-when=true uib-dropdown class=dropdown><a uib-dropdown-toggle href=# class=dropdown-toggle role=button aria-haspopup=true aria-expanded=false><span class=\"icon icon-user\"></span> <span class=caret></span></a><ul class=dropdown-menu><li><a ui-sref=settings>Settings</a></li><li has-authority=\"\'ROLE_ADMIN\'\" principal=vm.principal><a ui-sref=processors>Processors</a></li><li><a ui-sref=about>About</a></li><!--<li><a ui-sref=\"billing\">Billing</a></li>--><li><a ui-sref=logout>Sign out</a></li></ul></li></ul></div></div></div></div>");
$templateCache.put("app/components/pagination/pagination.directive.html","<nav ng-if=\"vm.pages.length>1 && vm.pages.length<=10\" class=pagination-container><ul class=pagination><!-- Previous page --><li ng-if=\"vm.currentPage<=0\" class=disabled><span aria-hidden=true>&laquo;</span></li><li ng-if=\"vm.currentPage>0\"><a href=\"\" ng-click=vm.goToPage(vm.currentPage-1) aria-label=Previous><span aria-hidden=true>&laquo;</span></a></li><!-- List of all pages --><li ng-repeat=\"p in vm.pages\" ng-class=\"(p==vm.currentPage)?\'active\':\'\'\"><a href=\"\" ng-click=vm.goToPage(p)>{{p+1}}</a></li><!-- Next page --><li ng-if=\"vm.currentPage>=vm.pages.length-1\" class=disabled><span aria-hidden=true>&raquo;</span></li><li ng-if=\"vm.currentPage<vm.pages.length-1\"><a href=\"\" ng-click=vm.goToPage(vm.currentPage+1) aria-label=Next><span aria-hidden=true>&raquo;</span></a></li></ul></nav><nav ng-if=\"vm.pages.length>10\" class=pagination-container><form class=\"form-inline form-pagination\"><div class=input-group><!-- Previous page --> <span ng-if=\"vm.currentPage<=0\" class=input-group-btn><button class=\"btn btn-default\" type=button aria-label=Previous disabled>&laquo;</button> </span><span ng-if=\"vm.currentPage>0\" class=input-group-btn><button class=\"btn btn-default\" type=button aria-label=Previous ng-click=vm.goToPage(vm.currentPage-1)>&laquo;</button> </span><!-- Select for all pages --><select class=form-control ng-model=vm.selectedPage ng-change=vm.goToPage(vm.selectedPage) ng-options=\"p as ((p+1).toString() + \' of \' + vm.pages.length.toString()) for p in vm.pages\"></select><!-- Next page --> <span ng-if=\"vm.currentPage>=vm.pages.length-1\" class=input-group-btn><button class=\"btn btn-default\" type=button aria-label=Next disabled>&raquo;</button> </span><span ng-if=\"vm.currentPage<vm.pages.length-1\" class=input-group-btn><button class=\"btn btn-default\" type=button aria-label=Next ng-click=vm.goToPage(vm.currentPage+1)>&raquo;</button></span></div></form></nav>");
$templateCache.put("app/components/password-reset/password-reset.directive.html","<div class=row><div class=\"col-sm-4 col-sm-offset-4\"><h4>Reset your password</h4><div class=\"panel panel-default\"><div class=panel-body><form novalidate><div class=form-group><label for=new-password>New password</label><input id=new-password type=password class=form-control ng-model=vm.newPassword required> <span class=help-block><password-strength-indicator password=vm.newPassword></password-strength-indicator></span></div><button id=login class=\"btn btn-success\" ng-click=vm.reset()>Reset password</button></form></div></div></div></div>");
$templateCache.put("app/components/password-reset-request/password-reset-request.directive.html","<div class=row><div class=\"col-sm-4 col-sm-offset-4\"><h4>Reset your password</h4><div class=\"panel panel-default\"><div class=panel-body><form novalidate><div class=form-group><label for=email>Email</label><input id=email type=text class=form-control ng-model=vm.email required autofocus si-focus-me></div><button id=login class=\"btn btn-success\" ng-click=vm.requestReset()>Reset</button></form></div></div></div></div>");
$templateCache.put("app/components/password-strength-indicator/password-strength-indicator.directive.html","<ul class=password-indicator-list ng-class=vm.strengthClass aria-hidden=true><li><span></span></li><li><span></span></li><li><span></span></li></ul>");
$templateCache.put("app/components/register/register.directive.html","<div class=row><div class=\"col-sm-4 col-sm-offset-4\"><h4>Activating your SPORTident account</h4><div class=\"panel panel-default\"><div class=panel-body><form novalidate><p>{{vm.message}}&nbsp;&nbsp;&nbsp;</p><a ui-sref=login ng-if=vm.success>Please login</a> <input id=userId type=hidden ng-model=vm.activationKey> <input id=activationKey type=hidden ng-model=vm.activationKey> <button id=activatebtn class=\"btn btn-success\" ng-click=vm.activateBtn() ng-if=false>Activate</button><br><p>If you have problems activating your account, please <a href=mailto:center@sportident.com title=\"Contact Us\">contact us</a>.</p></form><div class=col-sm-12 style=\"text-align: center\"><a ui-sref=login>Login</a> | <a ui-sref=about>About</a> | <a href=http://sportident.com>SPORTident Home</a></div></div></div></div></div>");
$templateCache.put("app/components/register-request/register-request.directive.html","<div class=row><div class=col-md-12><h1 class=page-header>{{vm.registerTitle}} <small><si-loading-indicator></si-loading-indicator></small></h1></div></div><div class=\"panel panel-default\"><div class=panel-heading><h3 class=panel-title>Account</h3></div><div class=panel-body><div class=row><div class=col-md-5><form name=myForm><div class=form-group><label for=login>Username</label><input id=login type=text class=form-control ng-model=vm.user.login required><!--autofocus si-focus-me--></div><div class=form-group><label for=password>Password</label><input id=password type=password class=form-control ng-model=vm.user.password required> <span class=help-block><password-strength-indicator password=vm.user.password></password-strength-indicator></span></div><div class=form-group><label for=repeat-password>Repeat password</label><input id=repeat-password type=password class=form-control ng-model=vm.user.repeatPassword required></div><div class=form-group><label for=firstName>First name</label><input id=firstName type=text class=form-control ng-model=vm.user.firstName required></div><div class=form-group><label for=lastName>Last name</label><input id=lastName type=text class=form-control ng-model=vm.user.lastName required></div><div class=form-group><label for=email>E-mail</label><input id=email type=email class=form-control ng-model=vm.user.email required></div><button id=register class=\"btn btn-success\" ng-click=vm.saveUser()>Register</button> <button id=cancel class=\"btn btn-danger\" ui-sref=users>Cancel</button></form></div></div></div></div>");
$templateCache.put("app/components/search/search.directive.html","<form ng-submit=vm.submit() role=search><input type=text ng-model=vm.searchString class=form-control placeholder={{vm.placeholder}}> <button type=button class=clear-input ng-click=vm.clear()><span class=\"glyphicon glyphicon-remove-circle\"></span></button></form>");
$templateCache.put("app/components/settings/settings.directive.html","<div class=row><div class=col-sm-12><div class=\"panel panel-default panel-first\"><div class=panel-heading><h3 class=panel-title>Account settings</h3></div><div class=panel-body><div class=row><div class=col-sm-6><form novalidate><div class=form-group><label>Username</label><p class=form-control-static>{{vm.user.login}}</p></div><div class=form-group><label for=firstname>First name</label><input id=firstname type=text class=form-control ng-model=vm.user.firstName required autofocus si-focus-me></div><div class=form-group><label for=lastname>Last name</label><input id=lastname type=text class=form-control ng-model=vm.user.lastName required></div><div class=form-group><label for=email>Email</label><input id=email type=text class=form-control ng-model=vm.user.email required></div><div><div class=form-group><label for=orgName>Select organisation</label><dropdown-component id=selorganisation model=vm.selectedOrganisation callback=vm.getOrganisations placeholder=\"\'Search for or insert organisation\'\" on-select-item=vm.selectedOrganisationChanged></dropdown-component></div><div class=form-group><label for=orgName>Organisation name</label><input type=text class=form-control ng-model=vm.shownUserOrganisation.organisation.name ng-change=vm.showSlugPlaceholder() ng-disabled=vm.disableOrganisation></div><div class=form-group><label for=orgSlug>Organisation slug</label><input type=text title=\"allowed only characters a-z, 0-9 and \'-\'\" ng-attr-placeholder={{vm.slugPlaceholder}} class=form-control ng-model=vm.shownUserOrganisation.organisation.slug ng-disabled=vm.disableOrganisation></div><input type=hidden ng-model=vm.shownUserOrganisation.organisation.email></div><button id=save class=\"btn btn-success\" ng-click=vm.save()>Save</button></form></div><div class=col-sm-6></div></div></div></div><billing-address-form user-id=vm.user.id></billing-address-form><div class=\"panel panel-default\"><div class=panel-heading><h3 class=panel-title>Change password</h3></div><div class=panel-body><div class=row><div class=col-sm-6><form novalidate><div class=form-group><label for=old-password>Old password</label><input id=old-password type=password class=form-control ng-model=vm.oldPassword required></div><div class=form-group><label for=new-password>New password</label><input id=new-password type=password class=form-control ng-model=vm.newPassword required> <span class=help-block><password-strength-indicator password=vm.newPassword></password-strength-indicator></span></div><button id=changepassword class=\"btn btn-success\" ng-click=vm.changePassword()>Change password</button></form></div><div class=col-sm-6></div></div></div></div><div class=\"panel panel-default\"><div class=panel-heading><h3 class=panel-title>SOAP API key</h3></div><div class=panel-body><div class=row><div class=col-md-6><form novalidate><div class=\"form-group non-mobile\"><label for=apiKey>API key</label><div class=input-group><input id=apiKey type=text class=form-control ng-model=vm.user.apiKey readonly> <span class=input-group-btn><button id=reset-apikey-btn1 class=\"btn btn-success\" ng-click=vm.regenerateToken()()>Reset API key</button></span></div></div><div class=\"form-group mobile\"><br><label for=apiKey>API key</label><p class=form-control-static>{{vm.user.apiKey}}</p><button id=reset-apikey-btn2 class=\"btn btn-success\" ng-click=vm.regenerateToken()()>Reset API key</button></div></form></div><div class=col-sm-6></div></div></div></div></div></div>");
$templateCache.put("app/components/sidebar/sidebar.directive.html","<div class=si-sidebar><ul class=nav><li ng-repeat=\"page in vm.pages\" role=presentation ng-class=\"(page.active?\'active\':\'\')\"><a ng-if=!page.disabled ui-sref={{page.state}}>{{page.title}}</a> <span ng-if=page.disabled>{{page.title}}</span></li></ul></div>");
$templateCache.put("app/components/signal-indicator/signal-indicator.directive.html","<div class=signal-indicator-container style=\"font-size: {{vm.size}}px\"><span class=\"signal signal-under icon-signal\" title=\"Signal Level: {{vm.signalLevelTooltip}}%\"></span> <span ng-if=\"vm.signalDisplay<6 && vm.signalLevel !== null\" class=\"signal signal-{{vm.signalDisplay}} icon-signal\" title=\"Signal Level: {{vm.signalLevelTooltip}}%\"></span> <span ng-if=\"vm.signalDisplay===6\" title=\"Signal information not available\" class=\"signal signal-6 icon-cancel\" style=\"font-size:{{vm.size - (vm.size/3)}}px\"></span></div>");}]);